/* cache-bust 2026-07-21T17:22 MESZ — siehe Commit-Message: Die Auslieferung fiel
 * nach dem Push von 17:11 auf den Stand von 13:58 zurück, obwohl MAIN nachweislich
 * korrekt war. Diese Zeile macht den Inhalt echt neu, damit Shopify einen frischen
 * Asset-Schlüssel vergibt statt den vergifteten Cache-Eintrag zu treffen.
 * Darf bei der nächsten inhaltlichen Änderung ersatzlos raus. */
/*
 * ttg-engine.js — TTG Personalization Engine (Kern)
 * ---------------------------------------------------------------------------
 * PRODUKTUNABHÄNGIG. Enthält KEINE produktspezifische Logik
 * (kein `if (product === "Warnweste")`). Alles kommt aus `config`, die der
 * Theme/Section aus Shopify (Metafields, Metaobjects, Varianten) rendert.
 *
 * Verantwortung:
 *   - Zentraler State
 *   - Kleines Event-Pub/Sub (colorChanged, motifChanged, … cartAdded)
 *   - Layer-Renderer für die Live-Vorschau (Base + Overlays + Text), der nur
 *     den betroffenen Layer aktualisiert (nie ganze PNGs tauscht)
 *   - Geführter Flow (Progressive Disclosure), datengetrieben aus config
 *   - Variantenauflösung Farbe × Größe über config.options/config.variants
 *
 * Theme-Kopplung (Cart-Handover, Varianten-Event) ist NICHT hier, sondern im
 * Theme-Adapter. Die Engine ruft nur den injizierten Hook `hooks.onSubmit`.
 *
 * Positions-Konvention der Layer (customizer_layout):
 *   xPercent      = horizontale MITTE des Layers (% der Base-Breite)
 *   yPercent      = OBERE Kante des Layers     (% der Base-Höhe)
 *   widthPercent  = Breite des Layers          (% der Base-Breite)
 *   heightPercent = Höhe (nur Motiv)           (% der Base-Höhe)
 *   fontSizePercent = Schriftgröße bzw. MAX-Größe bei fit (% der Base-Breite)
 *   minFontSizePercent = Untergrenze bei fit (optional)
 *   align         = Textausrichtung
 *   fit           = 'width' → Schrift skaliert auf die Layer-Breite
 *                   (kurzer Text groß, langer Text kleiner). Sonst feste Größe.
 *   nowrap        = true → einzeilig (kein Umbruch). Default (unset) = mehrzeilig.
 *   source        = Step-id, die diese Ebene füllt (optional, Schema v1.17).
 *                   Fehlt sie, gilt wie bisher der Layer-Key. Mehrere Ebenen
 *                   dürfen denselben Motiv-Step nennen (Doppelmotiv Handtuch);
 *                   da es je Config genau EINEN Motiv-Step gibt, speist er ALLE
 *                   type-"motif"-Ebenen — ein Motivwechsel wechselt alle zugleich.
 *   mirrorX       = true → Grafik horizontal gespiegelt (nur Bild-Ebenen:
 *                   Motiv/Deko; Text ignoriert das Flag). Wirkt identisch in
 *                   Live-Vorschau UND Bestell-Snapshot (Vorschau = Druckbild).
 * ---------------------------------------------------------------------------
 */

const NAME_HEX_FALLBACK = {
  neongelb: '#e3ec1b', gelb: '#e3ec1b', orange: '#ff7a18', lime: '#7fd400',
  neongrün: '#7fd400', neongruen: '#7fd400', türkis: '#1fc3c3', tuerkis: '#1fc3c3',
  pink: '#ff4fa3', blau: '#1f93e0', rot: '#d6271f', grün: '#1f9d55', gruen: '#1f9d55',
  schwarz: '#1a1a1a', weiß: '#ffffff', weiss: '#ffffff'
};

function swatchHex(name, provided) {
  if (provided) return provided;
  const key = String(name || '').trim().toLowerCase();
  return NAME_HEX_FALLBACK[key] || '#cccccc';
}

/*
 * Einfärbbare Emoji-Glyphen (druckkritisch, Schema v1.1 charFilter):
 * Erlaubte Emojis werden in Live-Vorschau und Canvas-Snapshot durch diese
 * einfarbigen Ein-Pfad-Glyphen ersetzt und in der aktiven Druck-/Textfarbe
 * gefüllt (System-Emojis sind Farb-Glyphen und lassen sich nicht umfärben).
 * In der Line-Item-Property bleibt das ECHTE Emoji-Zeichen erhalten.
 * Jedes in allowedEmojis zugelassene Emoji braucht hier eine Glyphe;
 * ohne Glyphe wird es normal (als System-Emoji) dargestellt.
 * Ein Pfad je Glyphe (24×24), damit derselbe String in <path d> UND Path2D läuft.
 */
const TTG_EMOJI_GLYPHS = {
  '❤️': 'M12 21.35C6.4 17.36 2 13.8 2 9.6 2 6.5 4.42 4 7.5 4c1.74 0 3.41.81 4.5 2.09A5.99 5.99 0 0 1 16.5 4C19.58 4 22 6.5 22 9.6c0 4.2-4.4 7.76-10 11.75z',
  '🐾': 'M16.12 21.2Q15.59 21.2 15.25 20.81Q14.9 20.43 14.9 19.83Q14.9 19.03 15.32 18.36Q15.74 17.69 16.45 17.29Q17.17 16.89 18.03 16.89Q18.77 16.89 19.42 17.18Q20.07 17.48 20.48 17.95Q20.88 18.43 20.88 18.99Q20.88 19.54 20.48 19.82Q20.08 20.11 19.39 20.11Q18.73 20.11 18.27 20.27Q17.81 20.44 17.46 20.65Q17.11 20.87 16.79 21.03Q16.47 21.2 16.12 21.2ZM12.94 18.9Q12.53 18.9 12.17 18.64Q11.81 18.37 11.58 17.96Q11.35 17.55 11.35 17.12Q11.35 16.69 11.58 16.41Q11.82 16.13 12.24 16.13Q12.67 16.13 13.04 16.39Q13.4 16.64 13.63 17.05Q13.85 17.46 13.85 17.91Q13.85 18.36 13.6 18.63Q13.34 18.9 12.94 18.9ZM4 9.41Q3.62 9.41 3.28 9.17Q2.93 8.92 2.72 8.53Q2.5 8.13 2.5 7.7Q2.5 7.22 2.78 6.91Q3.05 6.61 3.47 6.61Q3.84 6.61 4.2 6.84Q4.56 7.07 4.79 7.47Q5.02 7.86 5.02 8.32Q5.02 8.79 4.73 9.1Q4.45 9.41 4 9.41ZM6.63 12.19Q6.03 12.19 5.78 11.84Q5.53 11.48 5.53 10.98Q5.53 10.27 5.96 9.59Q6.39 8.9 7.1 8.45Q7.8 8 8.62 8Q9.27 8 9.94 8.29Q10.61 8.57 11.06 9.05Q11.52 9.53 11.52 10.11Q11.52 11.27 9.77 11.27Q9.03 11.27 8.59 11.41Q8.15 11.54 7.86 11.73Q7.57 11.91 7.29 12.05Q7.02 12.19 6.63 12.19ZM14.8 16.51Q14.4 16.51 14.05 16.25Q13.7 16 13.48 15.6Q13.27 15.2 13.27 14.78Q13.27 14.28 13.55 13.96Q13.84 13.64 14.28 13.64Q14.69 13.64 15.04 13.9Q15.39 14.15 15.6 14.55Q15.82 14.94 15.82 15.37Q15.82 15.84 15.54 16.18Q15.26 16.51 14.8 16.51ZM6.24 7.41Q5.72 7.41 5.31 6.87Q4.9 6.33 4.9 5.62Q4.9 5.03 5.19 4.65Q5.48 4.26 5.92 4.26Q6.28 4.26 6.58 4.51Q6.89 4.77 7.08 5.18Q7.27 5.59 7.27 6.06Q7.27 6.63 6.98 7.02Q6.68 7.41 6.24 7.41ZM17.46 15.4Q16.94 15.4 16.61 14.9Q16.28 14.4 16.28 13.8Q16.28 13.26 16.55 12.83Q16.82 12.39 17.31 12.39Q17.84 12.39 18.17 12.9Q18.5 13.41 18.5 14.01Q18.5 14.54 18.22 14.97Q17.95 15.4 17.46 15.4ZM9.14 6.78Q8.63 6.78 8.28 6.33Q7.92 5.88 7.92 5.24Q7.92 4.64 8.23 4.22Q8.53 3.8 8.96 3.8Q9.47 3.8 9.83 4.25Q10.19 4.7 10.19 5.33Q10.19 5.93 9.88 6.36Q9.57 6.78 9.14 6.78ZM11.86 7.7Q11.4 7.7 11.09 7.31Q10.77 6.92 10.77 6.35Q10.77 5.75 11.13 5.31Q11.48 4.87 11.96 4.87Q12.42 4.87 12.73 5.26Q13.04 5.65 13.04 6.21Q13.04 6.82 12.69 7.26Q12.35 7.7 11.86 7.7ZM20.43 15.83Q19.91 15.83 19.58 15.39Q19.25 14.94 19.25 14.39Q19.25 13.84 19.57 13.43Q19.88 13.03 20.36 13.03Q20.87 13.03 21.18 13.47Q21.5 13.92 21.5 14.47Q21.5 15.01 21.19 15.42Q20.89 15.83 20.43 15.83Z',
};
/*
 * Fußmatten-Pfote (25.08.2026): DEKORATION, kein Zeichen — deshalb eine eigene
 * Konstante und bewusst NICHT der Glyph aus TTG_EMOJI_GLYPHS.
 *
 * Der Glyph dort bildet ein getipptes Zeichen ab und muss ihm folgen: U+1F43E
 * heißt PAW PRINTS, Mehrzahl, und zeigt in jeder Systemschrift zwei Abdrücke.
 * Er teilt sich außerdem die feste Vorschubbreite px * 0.95 mit jedem anderen
 * Zeichen — zwei Pfoten in einem Em machen jede Einzelform kleiner (auf der
 * Matte gemessen: kleinster Zehenballen von rund 7 auf rund 3 CSS-Pixel).
 *
 * Auf der Matte steht die Pfote aber für nichts, was jemand getippt hätte. Sie
 * ist Bildschmuck an der kleinsten Stelle der ganzen Szene, und dort gewinnt
 * Lesbarkeit gegen Zeichentreue. Wer den Glyphen oben wieder ändert, ändert
 * hier NICHTS mit — das ist der Zweck der Trennung.
 */
const TTG_MATTEN_PFOTE = 'M2.2 10.2a2.4 2.4 0 1 0 4.8 0a2.4 2.4 0 1 0-4.8 0M6.9 6.3a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0M12.1 6.3a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0M17 10.2a2.4 2.4 0 1 0 4.8 0a2.4 2.4 0 1 0-4.8 0M6.6 16.6a5.4 4.6 0 1 0 10.8 0a5.4 4.6 0 1 0-10.8 0';
/*
 * VOREINSTELLUNG des Zeichenfilters (24.08.2026): print-safe ist der STANDARD,
 * nicht das Opt-in. Ein Text-Step ohne eigenen charFilter wird gefiltert.
 *
 * Warum, gemessen: Alle 97 Textfelder aller 90 Configs sind DRUCKfelder — es gibt
 * keines, in dem ein rohes System-Emoji gewollt wäre. Den Filter je Step zu
 * schalten hätte 84 Vollüberschreibungen lebender Configs gekostet, für einen
 * überall identischen Wert. Vor allem aber stünde die Regel weiter in DATEN statt
 * im VERHALTEN: der nächste neue Konfigurator fiele wieder durch, still und ohne
 * dass es jemandem auffällt, bis es gedruckt ist.
 *
 * Wer das später auf Opt-in zurückdreht, dreht genau das zurück — dann braucht
 * jede Config den Schalter wieder, und eine vergessene druckt Emojis.
 *
 * Der Ausstieg bleibt trotzdem möglich und ist wörtlich: `charFilter: false` oder
 * `charFilter: {mode:"off"}` am Text-Step. Heute nutzt ihn niemand; ohne ihn wäre
 * ein künftiges Nicht-Druckfeld nur noch mit einer Codeänderung machbar.
 *
 * Die Emoji-Liste ist bewusst dieselbe wie die Schlüsselmenge von
 * TTG_EMOJI_GLYPHS: nur was eine einfarbige Glyphe hat, darf durch (sonst käme
 * ein Farb-Emoji auf die Druckvorlage, das sich nicht einfärben lässt).
 */
const TTG_CHARFILTER_STANDARD = { mode: 'print-safe', allowedEmojis: ['❤️', '🐾'] };
// print-safe: Buchstaben (inkl. Umlaute/ß, alle Sprachen), Zahlen, übliche Satzzeichen.
// < und > seit 26.08.2026 (Foto-Fußmatte, Vorgabetext „>>> Hier wohnt <<<"):
// alle neun Theme-Schriften führen die Glyphen (fontTools-cmap gemessen).
// ‹ › bewusst NICHT — ungebraucht, Abdeckung ungemessen.
const TTG_PRINT_SAFE = /[\p{L}\p{N} .,:;!?'"„“‚‘’«»<>()\-–—_&+*\/@#%€°]/u;
// Variation Selector-16 (U+FE0F): iOS/Android hängen ihn an Emojis an — beim
// Matchen tolerieren und auf die konfigurierte Form normalisieren.
const TTG_VS16 = /\uFE0F/g;
/*
 * Herz-Schreibweisen, die auf das konfigurierte Herz abgebildet werden
 * (Entscheidung Jens 24.08.2026). Alle drucken einfarbig — eine Unterscheidung
 * wäre für den Kunden nur verwirrend, und ohne Abbildung fielen sie ersatzlos
 * aus dem Text, ohne dass er erfährt warum.
 *
 * EINZELN aufgezählt, ausdrücklich KEIN Codepoint-Bereich: U+1F493…U+1F49F ist
 * kein sauberer Block. Mittendrin liegt 💔 GEBROCHENES HERZ — das bedeutet das
 * Gegenteil und steht deshalb bewusst NICHT hier. Es fällt in den normalen
 * Emoji-Zweig und löst damit die Kundenmeldung aus; das ist gewollt. Wer die
 * Liste erweitert: nicht „aufrunden", jedes Zeichen einzeln entscheiden.
 *
 * „<3" wird NICHT abgebildet (Entscheidung Jens 24.08.2026): „Welpe <3 Monate"
 * würde zu „Welpe ❤️ Monate" und landete so auf der Druckvorlage. Auch die
 * Sonderregel „nur wenn kein Buchstabe folgt" rettet genau diesen Fall nicht,
 * weil nach der 3 ein Leerzeichen steht. Es bleibt beim heutigen Verhalten
 * („Wir <3 Hunde" → „Wir 3 Hunde") plus Meldung — der Kunde merkt es und kann
 * ein echtes Herz setzen.
 */
const TTG_HERZ_VARIANTEN = new Set([
  '\u2665', '\u2661',                                   // ♥ ♡ Kartenfarbe
  '\u{1F5A4}', '\u{1F499}', '\u{1F49A}', '\u{1F49B}',   // 🖤 💙 💚 💛
  '\u{1F49C}', '\u{1F9E1}', '\u{1F90D}', '\u{1F90E}',   // 💜 🧡 🤍 🤎
  '\u{1F493}', '\u{1F495}', '\u{1F496}', '\u{1F497}',   // 💓 💕 💖 💗
  '\u{1F498}', '\u{1F49D}', '\u{1F49E}', '\u{1F49F}',   // 💘 💝 💞 💟
]);
/** Zeilenh\u00F6he der Text-Ebenen. EINE Quelle f\u00FCr beide Zeichenpfade: der DOM setzt sie
 *  in _fitText als line-height, der Snapshot leitet daraus die Kastenh\u00F6he ab, um die
 *  er dreht (_drawSnapshotText). Liefen die beiden Werte auseinander, s\u00E4\u00DFe gedrehter
 *  Text im Druckbild um die halbe Differenz versetzt \u2014 genau der Fehler, wegen dem
 *  die Textdrehung bis 05.08.2026 gesperrt war. Nicht einzeln \u00E4ndern. */
/**
 * Standard-Zeilenhöhe der Textebene (Vielfaches der Schriftgröße).
 *
 * Sie ist ein VERTRAG ZWISCHEN ZWEI WEGEN, nicht bloß eine CSS-Zahl:
 *   · das DOM setzt sie als `line-height` der Ebene (_fitText),
 *   · der Snapshot spannt mit demselben Faktor seine Dreh-Ersatzbox auf
 *     (_drawSnapshotText, `lineH`) — sonst läge der Drehpunkt im Druck auf der
 *     Oberkante und im DOM in der Zeilenmitte, und der Versatz wüchse mit dem
 *     Winkel (s. Kommentar an _layerRotateDeg).
 * Wer den Wert einseitig ändert, verschiebt gedrehten Text gegen die Vorschau.
 * Deshalb geht JEDE Änderung über _lineHeightFor() — die beide Seiten bedient.
 */
const TEXT_LINE_HEIGHT = 1.05;

function escapeHtml(s) {
  return String(s == null ? '' : s).replace(/[&<>"]/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]
  ));
}

/* Handy-INP 13.10.2026 (Briefing Handy-Korrekturen, Teil 2): renderSteps() setzte bei jeder Aktion
   refs.steps.innerHTML neu. Damit war der angetippte Knopf nach dem Klick nicht mehr im DOM (Feld:
   INP-Ziel „(null)“, 15 % des INP-Überhangs < 768) und der Browser musste die komplette Schrittliste neu
   aufbauen und layouten. morphSteps gleicht das neue HTML stattdessen auf das bestehende DOM ab:
   gleiche Knoten (Tag + Schlüsselattribute an derselben Stelle) bleiben erhalten, Attribute, Text und
   Formularwerte werden auf den neuen Stand gebracht; alles andere wird ersetzt bzw. entfernt. Das Ergebnis
   ist derselbe DOM-Stand wie nach innerHTML — nur ohne die unveränderten Knoten wegzuwerfen. Alle
   Schritt-Ereignisse hängen per Delegation an refs.steps (nicht an den Kindern), deshalb bleibt die
   Verdrahtung gleich. Gemountete Fremdinhalte (Foto-Schritt) fallen wie bisher weg und werden danach
   von _mountPhotoStep neu eingehängt (deren Mount-Marke ist ein Attribut und wird mit abgeglichen). */
const MORPH_SCHLUESSEL = ['id', 'type', 'name', 'data-action', 'data-v', 'data-id', 'data-i', 'data-c', 'data-def-id', 'data-field', 'data-step', 'data-ttg', 'data-opt'];
function morphGleich(a, b) {
  if (a.nodeType !== b.nodeType) return false;
  if (a.nodeType !== 1) return true;
  if (a.tagName !== b.tagName) return false;
  for (const k of MORPH_SCHLUESSEL) if (a.getAttribute(k) !== b.getAttribute(k)) return false;
  return true;
}
function morphKnoten(a, b) {
  if (a.nodeType !== 1) { if (a.nodeValue !== b.nodeValue) a.nodeValue = b.nodeValue; return; }
  for (let i = a.attributes.length - 1; i >= 0; i--) { const n = a.attributes[i].name; if (!b.hasAttribute(n)) a.removeAttribute(n); }
  for (const at of Array.from(b.attributes)) if (a.getAttribute(at.name) !== at.value) a.setAttribute(at.name, at.value);
  const tag = a.tagName;
  if (tag === 'TEXTAREA') { if (a.value !== b.value) a.value = b.value; return; }
  if (tag === 'INPUT') {
    if (a.value !== b.value) a.value = b.value;
    if (a.checked !== b.checked) a.checked = b.checked;
    if (a.indeterminate !== b.indeterminate) a.indeterminate = b.indeterminate;
  }
  morphKinder(a, b);
  if (tag === 'SELECT' && a.selectedIndex !== b.selectedIndex) a.selectedIndex = b.selectedIndex;
}
function morphKinder(alt, neu) {
  const a = Array.from(alt.childNodes), n = Array.from(neu.childNodes);
  for (let i = 0; i < n.length; i++) {
    if (i >= a.length) alt.appendChild(n[i]);
    else if (morphGleich(a[i], n[i])) morphKnoten(a[i], n[i]);
    else alt.replaceChild(n[i], a[i]);
  }
  for (let i = n.length; i < a.length; i++) alt.removeChild(a[i]);
}
export function morphSteps(container, html) {
  if (!container) return;
  // Ohne <template> (Node-Tests ohne DOM) bleibt es beim bisherigen Ersetzen.
  if (typeof document === 'undefined' || typeof document.createElement !== 'function' || !container.childNodes) { container.innerHTML = html; return; }
  const t = document.createElement('template');
  if (!t.content) { container.innerHTML = html; return; }
  t.innerHTML = html;
  morphKinder(container, t.content);
}

/* Wunschtext-Randbereinigung. Die Live-Vorschau IST die Druckvorlage — ein
   führendes Leerzeichen verschiebt zentrierten Druck sichtbar und ging bislang
   so an die Druckerei (belegt an 10 von 22 Bestellungen mit Wunschtext,
   14.–21.07.). Bereinigt werden AUSSCHLIESSLICH die Ränder: Mehrfach-
   Leerzeichen INNERHALB des Textes („Dagmar  &  Sky") sind Kundeneingabe und
   bleiben unangetastet. trim() erfasst dabei auch Tabs/Zeilenumbrüche am Rand
   (Zeilenumbrüche können nur über Deep-Link-Parameter hereinkommen — das
   <input type="text"> selbst kann keine tragen). */
function ttgTrimEdges(s) {
  return typeof s === 'string' ? s.trim() : s;
}

/* #18: URLs aus Merchant-Config (helpLink/raceRequest/sizeGuide) fürs href
   absichern. Erlaubt sind http/https und relative Pfade/Anker; alles mit anderem
   Schema (javascript:, data:, vbscript:, …) fällt auf '#'. Steuerzeichen/Whitespace
   werden für die Schema-Prüfung entfernt (Browser ignorieren z. B. "java\tscript:").
   Rückgabe ist attribut-escaped. Quelle ist vertrauenswürdiger als Endnutzer-Input,
   daher niedrige Schwere — der Helper schließt die Lücke trotzdem sauber. */
function sanitizeUrl(u) {
  const raw = String(u == null ? '' : u).trim();
  if (!raw) return '#';
  // Für die Schema-Erkennung Steuerzeichen/Whitespace strippen und kleinschreiben.
  const probe = raw.replace(/[\u0000-\u0020\u00a0]+/g, '').toLowerCase();
  // Relativ / Anker / Query / protokoll-relativ (//) → erlaubt.
  const c0 = probe.charAt(0);
  if (c0 === '/' || c0 === '#' || c0 === '?' || c0 === '.') return escapeHtml(raw);
  // Trägt der Wert ein Schema? Dann nur http/https zulassen.
  const scheme = probe.match(/^([a-z][a-z0-9+.-]*):/);
  if (scheme && scheme[1] !== 'http' && scheme[1] !== 'https') return '#';
  return escapeHtml(raw);
}

/* Inline-SVGs für die Schritt-Karten (Farbe per CSS über currentColor).
   Die Liquid-Icons liegen in snippets/ttg-icon.liquid — die Engine baut ihre
   Karten aber in JS, deshalb hier als Konstanten. */
const ICON_PENCIL = `<svg class="ttg-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 20.2l4-.9L19 8.3a1.9 1.9 0 0 0 0-2.7l-.6-.6a1.9 1.9 0 0 0-2.7 0L4.9 16.2 4 20.2z"/><path d="M14.4 6.8l2.8 2.8"/></svg>`;
const ICON_SPARK = `<svg class="ttg-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 3l1.9 4.6L19 8l-3.4 3.4.9 5-4.5-2.5L7.5 16.4l.9-5L5 8l5.1-.4L12 3z"/></svg>`;
/* Ab wie vielen Vorschlägen _normSuggestions laut warnt. KEINE Kappung — die
 * frühere `.slice(0, 12)` hat still gekürzt, und genau diese Fehlerklasse
 * (Konfiguration sieht vollständig aus, Ergebnis ist es nicht) räumen wir ab.
 * Der Wert liegt über jeder sinnvollen Liste (Design 4 hat 22), schlägt also
 * nur bei einem echten Konfigurationsfehler an. */
const SUGGEST_WARN_AB = 40;
// Scroll-Weg in px, ab dem ein offenes Vorschlags-Panel schliesst (31.08.2026).
const SUGGEST_SCROLL_SCHWELLE = 8;
// Gnadenfrist nach dem Oeffnen, in der weder Scrollen noch Groessenaenderung das
// Panel anfassen. GEMESSEN noetig, nicht vorsichtshalber gesetzt: Ein
// programmatisch ausgeloestes Scrollen (`scroll-behavior: smooth`) gleitet nach
// dem Klick noch nach — im Messlauf 981 -> 995 px in 17 ms, also weit ueber der
// Schwelle. Das Panel ging auf und im selben Wimpernschlag wieder zu. Dieselbe
// Klasse Fall auf Mobilgeraeten: Der Knopf nimmt dem Textfeld den Fokus, die
// Bildschirmtastatur faehrt ein, und deren Reflow trifft ein Panel, das gerade
// erst aufgegangen ist.
const SUGGEST_RUHE_MS = 300;

function formatMoneyEUR(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

// Suche: robuste Normalisierung — Kleinschreibung, ß→ss, Akzente/Umlaute auf
// Grundbuchstaben (ä→a, ö→o, ü→u), alles Nicht-Alphanumerische raus (Binde-
// striche/Leerzeichen). ae/oe/ue matchen die Umlautform per Tippfehler-Toleranz.
function ttgNorm(s) {
  return String(s == null ? '' : s)
    .toLowerCase()
    .replace(/ß/g, 'ss')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]/g, '');
}
// Levenshtein-Distanz mit Obergrenze (früher Abbruch) — für Tippfehler-Toleranz.
function ttgLev(a, b, max) {
  const la = a.length, lb = b.length;
  if (Math.abs(la - lb) > max) return max + 1;
  if (la === 0) return lb;
  if (lb === 0) return la;
  let prev = new Array(lb + 1);
  for (let j = 0; j <= lb; j++) prev[j] = j;
  for (let i = 1; i <= la; i++) {
    const cur = [i];
    let best = i;
    for (let j = 1; j <= lb; j++) {
      const cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
      if (cur[j] < best) best = cur[j];
    }
    if (best > max) return max + 1;
    prev = cur;
  }
  return prev[lb];
}

/*
 * Rasse-Familienschlüssel (Motiv-Bonus / Cross-Sell) — SHARED UTIL.
 * ---------------------------------------------------------------------------
 * Kanonische Ableitung des Familienschlüssels `rasse` aus einem Motiv:
 * scripts/build-motifs.mjs importiert sie für den Katalog-Export (Feld
 * "rasse" an Motiven der Hunderassen-Kategorien), ttg-crosssell.js für
 * Motive, die NICHT aus dem Katalog kommen (die metaobject-referenzierten
 * Stilportrait/PopArt-Motive der Klingeln-Fußmatte). EINE Implementierung —
 * beide Seiten müssen identisch ableiten, sonst matcht das Cross-Sell-
 * Element Rassen falsch oder gar nicht.
 *
 * Ableitung: slugify(Label) — die Labels sind über alle drei Design-
 * Kategorien hinweg DEUTSCH und konsistent („Malinois" hr == „Malinois"
 * PopArt), während die Handles divergieren (popart-belgian-malinois vs.
 * malinois-hr). Handle nur als Fallback ohne Label. Varianten-Suffixe
 * werden gestrippt (Zahlen „(2)"/„6b", Posen stehend/sitzend/liegend,
 * Design-Suffixe -hr/-stilportrait/-popart), dann normalisiert eine
 * KONSERVATIVE Alias-Tabelle fachlich identische Rassen mit abweichender
 * Benennung (Sheltie → Shetland Sheepdog). Fachlich eigenständige Rassen
 * werden NIE automatisch gemerged (Malinois bleibt Malinois, Deutsch
 * Kurzhaar/Drahthaar/Langhaar bleiben getrennt).
 */
const TTG_RASSE_STRIP_TOKENS = new Set([
  // Posen (Varianten desselben Motivs, keine eigene Rasse)
  'stehend', 'sitzend', 'liegend',
  // Design-Kennungen aus Handles (malinois-hr, mops-stilportrait, popart-…)
  'hr', 'stilportrait', 'popart',
]);

// Fachlich DIESELBE Rasse, andere Benennung → auf einen kanonischen Schlüssel.
// Bewusst kurz und handkuratiert (Review-Liste an Jens vor Live-Gang des
// Matchings); Zweifelsfälle (Cocker-Spaniel-Varianten, Spitz-Familie) bleiben
// GETRENNT statt spekulativ gemerged.
const TTG_RASSE_ALIASES = {
  'schaeferhund': 'deutscher-schaeferhund',            // Stilportrait-Label „Schäferhund"
  'labrador': 'labrador-retriever',                    // Stilportrait-Label „Labrador"
  'englischer-mastiff': 'mastiff',                     // PopArt-Label „Englischer Mastiff"
  'irischer-wolfshund': 'irish-wolfhound',             // PopArt-Label „Irischer Wolfshund"
  'sheltie': 'shetland-sheepdog',                      // PopArt-Label „Sheltie"
  'zwergspitz': 'pomeranian',                          // PopArt-Label „Zwergspitz" (= Pomeranian)
  'daenische-dogge': 'deutsche-dogge',                 // Stilportrait-Label „Dänische Dogge" (= Great Dane)
  'englischer-springer-spaniel': 'english-springer-spaniel',
  // Dackel-Haararten: eine Familie (Briefing) — heute keine eigenen Einträge,
  // zukunftssicher für später angelegte Varianten.
  'dackel-kurzhaar': 'dackel',
  'dackel-langhaar': 'dackel',
  'dackel-rauhaar': 'dackel',
};

/** slugify wie die Motiv-Handles: Umlaute ae/oe/ue, ß→ss, Akzente weg, Rest zu '-'. */
export function ttgRasseSlug(s) {
  return String(s == null ? '' : s)
    .toLowerCase()
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')   // é→e, ñ→n … (Combining Marks)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * Familienschlüssel eines Motivs — oder null (kein Label/Handle, leerer Rest).
 * @param {{label?:string, id?:string, handle?:string}} motif  Katalog-/Inline-Eintrag
 *        (Katalog: id = Metaobjekt-Handle) oder rohes {label, handle}.
 * @returns {string|null}
 */
export function ttgRasseFamilie(motif) {
  if (!motif) return null;
  const label = typeof motif.label === 'string' ? motif.label.trim() : '';
  const handle = (typeof motif.id === 'string' && motif.id)
    || (typeof motif.handle === 'string' && motif.handle) || '';
  let slug = ttgRasseSlug(label || handle);
  if (!slug) return null;
  let tokens = slug.split('-');
  // Handle-Fallback: Design-Präfix (popart-…) vorn strippen — nie das ganze Wort.
  while (tokens.length > 1 && TTG_RASSE_STRIP_TOKENS.has(tokens[0])) tokens.shift();
  // Varianten-Suffixe hinten strippen: reine Zahlen („2"), Zahl+Buchstabe („6b"),
  // Posen, Design-Kennungen. Nie das letzte verbleibende Token.
  for (;;) {
    if (tokens.length <= 1) break;
    const last = tokens[tokens.length - 1];
    if (TTG_RASSE_STRIP_TOKENS.has(last) || /^\d+[a-z]?$/.test(last)) { tokens.pop(); continue; }
    break;
  }
  // Angeklebte Zahl am letzten Token („terrier2", Handle-Stil) — nur wenn danach
  // noch ein lesbarer Rest bleibt.
  const lastIdx = tokens.length - 1;
  const stripped = tokens[lastIdx].replace(/\d+$/, '');
  if (stripped.length >= 2) tokens[lastIdx] = stripped;
  slug = tokens.join('-');
  if (!slug) return null;
  return TTG_RASSE_ALIASES[slug] || slug;
}

/**
 * Design-Kennung eines Rasse-Motivs für designPriority des Cross-Sell-Mappings:
 * 'hr' (handgezeichnet) | 'stilportrait' | 'popart' | null. Primär aus der
 * Kategorie, Fallback Handle-Suffix/-Präfix.
 */
export function ttgRasseDesign(motif) {
  if (!motif) return null;
  const kat = ttgRasseSlug(motif.kategorie || '');
  if (kat.indexOf('stilportrait') !== -1) return 'stilportrait';
  if (kat.indexOf('popart') !== -1) return 'popart';
  if (kat.indexOf('handgezeichnet') !== -1 || kat === 'hunderasse' || kat === 'hunderassen') return 'hr';
  const h = String(motif.id || motif.handle || '');
  if (/-stilportrait$/.test(h)) return 'stilportrait';
  if (/^popart-|-popart$/.test(h)) return 'popart';
  if (/-hr$/.test(h)) return 'hr';
  return null;
}

/*
 * Größenratgeber-Overlay — Inhalts-Renderer je sizeGuide.type.
 * Der RAHMEN (Slide-in-Panel von rechts, Lazy-Aufbau erst beim Klick) ist
 * typoffen: neue Inhaltstypen docken hier an, ohne den Rahmen umzubauen.
 * v1.1: 'overlay' = Größentabelle(n) aus custom.size_table (Ein-Block-Objekt
 * ODER Array von Blöcken {title, columns, rows, note, image}).
 * Reserviert (Schritt 2): 'doormat-visualizer' — interaktives Fußmatten-SVG.
 * Ein Renderer bekommt (engine, sizeGuideConfig) und liefert entweder direkt
 * das innerHTML des Inhaltsbereichs (String) ODER ein Objekt
 * { html, init(contentEl, engine, sg), hideHead } für interaktive Inhalte —
 * init wird nach dem Einhängen genau einmal aufgerufen, hideHead unterdrückt
 * den Bild-Kopfbereich. Unbekannte Typen rendern nichts (kein Crash).
 */
export const TTG_SIZE_OVERLAY_RENDERERS = {
  overlay(engine, sg) {
    let raw = sg.data;
    // size_table v2 (schnitt-abhängig): flaches Default-Objekt {columns,rows,note,…}
    // + overrides[optionName][wert], per Property flach drübergemergt — dieselbe
    // Merge-Mechanik wie beim Layout. Gelesen wird der AKTUELL gewählte Optionswert
    // (z. B. Geschlecht=Damen). v1 bleibt unverändert: ein Array von Blöcken ODER ein
    // flaches Objekt OHNE `overrides` läuft unten unangetastet durch (Warnweste/
    // Fußmatte hängen daran). `_openSizeOverlay` rendert diesen Inhalt bei jedem
    // Öffnen neu, damit ein Schnitt-Wechsel zwischen zwei Öffnungen greift.
    if (raw && !Array.isArray(raw) && raw.overrides && typeof raw.overrides === 'object') {
      const merged = Object.assign({}, raw);
      delete merged.overrides;
      delete merged.version;
      for (const optName in raw.overrides) {
        const bucket = raw.overrides[optName];
        const val = engine._selectedOptionValue(optName);
        if (bucket && val != null && bucket[val] && typeof bucket[val] === 'object') {
          Object.assign(merged, bucket[val]);   // rows/note/columns … je Property überschreiben
        }
      }
      raw = merged;
    }
    const blocks = (Array.isArray(raw) ? raw : raw ? [raw] : []).filter(
      (b) => b && Array.isArray(b.columns) && Array.isArray(b.rows)
    );
    if (!blocks.length) return '<p class="ttg-ovl__empty">Keine Größendaten hinterlegt.</p>';
    // REIHENFOLGE (Jens 22.07.): erst der beschreibende Text, dann das Bild, dann
    // die Tabelle — also note → image → columns/rows. Vorher: image (im Kopf) →
    // Tabelle → note. Der Block-Titel bleibt vorn, er beschriftet den ganzen Block
    // und ist keine der vier size_table-Angaben.
    // Das Mess-Schema wird jetzt IMMER hier im Inhalt gerendert, auch das
    // Top-Level-image flacher Tabellen (das früher in den Overlay-Kopf wanderte) —
    // nur so steht es unterhalb des Textes. _buildSizeOverlay lässt den Kopf für
    // solche Tabellen entsprechend leer, das Produkt-Mockup bleibt dort wie bisher
    // unterdrückt.
    // Fehlende Felder erzeugen KEIN leeres Element und damit keine Lücke: ohne
    // note/image/title entfällt der jeweilige Knoten vollständig.
    return blocks.map((b) => `
      <section class="ttg-ovl__block">
        ${b.title ? `<h4 class="ttg-ovl__blocktitle">${escapeHtml(b.title)}</h4>` : ''}
        ${b.note ? `<p class="ttg-ovl__note">${escapeHtml(b.note)}</p>` : ''}
        ${b.image ? `<img class="ttg-ovl__sketch" src="${escapeHtml(b.image)}" alt="Messanleitung" loading="lazy" decoding="async">` : ''}
        <div class="ttg-ovl__tablewrap"><table class="ttg-ovl__table">
          <thead><tr>${b.columns.map((c) => `<th>${escapeHtml(c)}</th>`).join('')}</tr></thead>
          <tbody>${b.rows.map((r) => `<tr>${(Array.isArray(r) ? r : [r]).map((c) => `<td>${escapeHtml(c)}</td>`).join('')}</tr>`).join('')}</tbody>
        </table></div>
      </section>`).join('');
  },

  /**
   * Fußmatten-Größen-Visualizer (Schritt 2): maßstabsgetreue SVG-Szene,
   * 1 SVG-Einheit = 1 cm. Tür immer 205 cm hoch, Breite wählbar (80–120 cm);
   * Matte quer (Langseite horizontal), mittig, direkt an der Tür anliegend.
   * Rein clientseitig — die zwei Mattengrößen und fünf Türbreiten sind fest,
   * keine Metafeld-Datenquelle nötig. Empfehlungstext statisch (O-Ton Jens).
   */
  'doormat-visualizer'(engine, sg) {
    const MATS = [
      { key: '40x60', label: '40 × 60 cm', w: 60, d: 40 },
      { key: '50x75', label: '50 × 75 cm', w: 75, d: 50 },
    ];
    const DOORS = [80, 90, 100, 110, 120];
    const RECO = 'Unsere Faustregel: Bis 1 Meter Türbreite passt die 40 × 60 cm wie gemacht. Zwischen 1,0 und 1,1 Metern hast Du freie Wahl – die kleine wirkt dezent und lässt rundherum etwas Luft, die 50 × 75 cm füllt den Eingang großzügiger und heißt schon von Weitem willkommen. Ab 1,1 Metern nimm die 50 × 75 cm, damit Dein Willkommensgruß richtig zur Geltung kommt.';
    const state = { mat: MATS[0], door: 90 };

    // Szene in cm-Einheiten: Proportionen stimmen per Konstruktion exakt.
    // KONSTANTE Leinwand (ausgelegt auf die breiteste Tür): der cm→Pixel-
    // Maßstab bleibt über alle Auswahlen identisch — die Tür bleibt beim
    // Breitenwechsel gleich hoch und wird nur breiter/schmaler. Die
    // ANZEIGE-Größe steuert allein style="height:238px" am SVG; viewBox und
    // cm-Koordinaten bleiben unangetastet (1 Einheit = 1 cm).
    const FRAME = 6, H_DOOR = 205, MARGIN = 26;
    const MAX_DOOR = DOORS[DOORS.length - 1];
    const FLOOR_H = MATS[MATS.length - 1].d + 26;     // Boden fasst die tiefste Matte
    const W = MAX_DOOR + 2 * (MARGIN + FRAME);
    const H = FRAME + H_DOOR + FLOOR_H;
    const PAW = TTG_MATTEN_PFOTE;
    const WOOD = ['#e3d2ac', '#dcc9a1', '#e6d6b1', '#d8c398'];

    // Holzdielen mit Fugen + dezenter Maserung (leinwandfest, ruhiges Bild).
    const floorBoards = (floorY) => {
      let s = '', i = 0;
      const bw = 24;
      for (let x = 0; x < W; x += bw) {
        const w = Math.min(bw, W - x), tone = WOOD[i % WOOD.length];
        s += '<rect x="' + x + '" y="' + floorY + '" width="' + w + '" height="' + FLOOR_H + '" fill="' + tone + '"/>';
        s += '<line x1="' + (x + w) + '" y1="' + floorY + '" x2="' + (x + w) + '" y2="' + H + '" stroke="#c2a879" stroke-width="0.7" opacity="0.55"/>';
        s += '<path d="M' + (x + w * 0.32) + ' ' + (floorY + 2) + ' Q' + (x + w * 0.5) + ' ' + (floorY + FLOOR_H * 0.5) + ' ' + (x + w * 0.36) + ' ' + H + '" fill="none" stroke="#c6ae82" stroke-width="0.6" opacity="0.4"/>';
        s += '<path d="M' + (x + w * 0.7) + ' ' + (floorY + 2) + ' Q' + (x + w * 0.58) + ' ' + (floorY + FLOOR_H * 0.55) + ' ' + (x + w * 0.72) + ' ' + H + '" fill="none" stroke="#c6ae82" stroke-width="0.5" opacity="0.3"/>';
        i++;
      }
      return s;
    };
    // Kassetten-Panel mit Licht-/Schattenkante (plastischer als reine Rahmen).
    const panel = (x, y, w, h) => (
      '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="2.5" fill="#e9dec7"/>'
      + '<rect x="' + (x + 2.5) + '" y="' + (y + 2.5) + '" width="' + (w - 5) + '" height="' + (h - 5) + '" rx="1.5" fill="#f5edda"/>'
      + '<path d="M' + (x + 2) + ' ' + (y + h - 2) + ' L' + (x + 2) + ' ' + (y + 2) + ' L' + (x + w - 2) + ' ' + (y + 2) + '" fill="none" stroke="#fffdf7" stroke-width="1.1"/>'
      + '<path d="M' + (x + w - 2) + ' ' + (y + 2) + ' L' + (x + w - 2) + ' ' + (y + h - 2) + ' L' + (x + 2) + ' ' + (y + h - 2) + '" fill="none" stroke="#d2c19d" stroke-width="1.1"/>'
    );

    const scene = () => {
      const doorW = state.door, mat = state.mat;
      const doorX = W / 2 - doorW / 2, doorY = FRAME;
      const floorY = FRAME + H_DOOR;
      const matX = W / 2 - mat.w / 2;
      const matY = floorY;                            // direkt anliegend, kein Abstand
      const pw = doorW * 0.64, plx = doorX + doorW * 0.18;
      const pawSize = mat.d * 0.42, pawScale = pawSize / 24;

      // Responsiv & zentriert: width koppelt die Höhen-Grenze über das feste
      // Seitenverhältnis (W/H), height:auto hält es ein (kein Abschneiden).
      // Der vh-Deckel kommt aus der CSS (--ttg-dv-maxh: mobil 40vh, ab 750px
      // 55vh), damit Faustregel + Buttons + Grafik zusammen sichtbar bleiben.
      return '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" style="display:block;margin-inline:auto;width:min(100%, calc(var(--ttg-dv-maxh, 40vh) * ' + (W / H).toFixed(4) + '));height:auto;filter:drop-shadow(0 7px 16px rgba(74,63,51,0.18))" role="img" aria-label="Matte ' + escapeHtml(mat.label) + ' vor einer ' + doorW + ' cm breiten Tür, maßstabsgetreu">'
        + '<defs>'
        + '<linearGradient id="w2wall" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#f6f0e6"/><stop offset="1" stop-color="#ebe0ce"/></linearGradient>'
        + '<linearGradient id="w2door" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#fefcf6"/><stop offset="0.5" stop-color="#f6eede"/><stop offset="1" stop-color="#efe5d1"/></linearGradient>'
        + '<linearGradient id="w2mat" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#52463a"/><stop offset="1" stop-color="#3e3327"/></linearGradient>'
        + '<radialGradient id="w2light" cx="0.5" cy="0.12" r="0.9"><stop offset="0" stop-color="#fff7e8" stop-opacity="0.55"/><stop offset="0.55" stop-color="#fff7e8" stop-opacity="0"/></radialGradient>'
        + '<radialGradient id="w2vin" cx="0.5" cy="0.42" r="0.75"><stop offset="0.62" stop-color="#4a3f2f" stop-opacity="0"/><stop offset="1" stop-color="#4a3f2f" stop-opacity="0.13"/></radialGradient>'
        + '<pattern id="w2weave" width="4" height="4" patternUnits="userSpaceOnUse"><rect width="4" height="4" fill="none"/><line x1="0" y1="0" x2="0" y2="4" stroke="#5c4e3d" stroke-width="0.5" opacity="0.32"/><line x1="0" y1="0" x2="4" y2="0" stroke="#372c20" stroke-width="0.5" opacity="0.3"/></pattern>'
        + '</defs>'
        + '<rect x="0" y="0" width="' + W + '" height="' + floorY + '" fill="url(#w2wall)"/>'
        + floorBoards(floorY)
        + '<rect x="0" y="0" width="' + W + '" height="' + floorY + '" fill="url(#w2light)"/>'
        + '<rect x="0" y="' + (floorY - 6) + '" width="' + W + '" height="6" fill="#f7f1e6"/>'
        + '<rect x="0" y="' + (floorY - 6) + '" width="' + W + '" height="1.4" fill="#fffdf7"/>'
        + '<rect x="0" y="' + (floorY - 0.6) + '" width="' + W + '" height="1.6" fill="#c3ac83" opacity="0.7"/>'
        + '<ellipse cx="' + (doorX + doorW / 2) + '" cy="' + (floorY + 2.5) + '" rx="' + (doorW / 2 + 9) + '" ry="4.5" fill="#4a3f2f" opacity="0.13"/>'
        + '<rect x="' + (doorX - FRAME) + '" y="0" width="' + (doorW + 2 * FRAME) + '" height="' + (H_DOOR + FRAME) + '" rx="2.5" fill="#c7b696"/>'
        + '<rect x="' + (doorX - FRAME + 1.6) + '" y="1.2" width="' + (doorW + 2 * FRAME - 3.2) + '" height="' + (H_DOOR + FRAME - 1.2) + '" fill="#d7c8a8"/>'
        + '<rect x="' + (doorX - 2.4) + '" y="' + doorY + '" width="' + (doorW + 4.8) + '" height="' + H_DOOR + '" fill="#b6a582"/>'
        + '<rect x="' + doorX + '" y="' + doorY + '" width="' + doorW + '" height="' + H_DOOR + '" fill="url(#w2door)"/>'
        + '<rect x="' + doorX + '" y="' + doorY + '" width="3.5" height="' + H_DOOR + '" fill="#fffdf7" opacity="0.6"/>'
        + '<rect x="' + (doorX + doorW - 3) + '" y="' + doorY + '" width="3" height="' + H_DOOR + '" fill="#cabb99" opacity="0.7"/>'
        + panel(plx, doorY + 20, pw, 82)
        + panel(plx, doorY + 116, pw, 66)
        + '<circle cx="' + (doorX + doorW - 12) + '" cy="' + (doorY + 108) + '" r="5" fill="#d7c8a8"/>'
        + '<circle cx="' + (doorX + doorW - 12) + '" cy="' + (doorY + 108) + '" r="3.7" fill="#bda067"/>'
        + '<circle cx="' + (doorX + doorW - 13.2) + '" cy="' + (doorY + 106.6) + '" r="1.3" fill="#f2e6c8"/>'
        + '<ellipse cx="' + (W / 2) + '" cy="' + (matY + mat.d + 1.5) + '" rx="' + (mat.w / 2 + 6) + '" ry="5" fill="#4a3f2f" opacity="0.18"/>'
        + '<rect x="' + matX + '" y="' + matY + '" width="' + mat.w + '" height="' + mat.d + '" rx="4" fill="url(#w2mat)"/>'
        + '<rect x="' + matX + '" y="' + matY + '" width="' + mat.w + '" height="' + mat.d + '" rx="4" fill="url(#w2weave)"/>'
        + '<rect x="' + (matX + 1.5) + '" y="' + (matY + 1.5) + '" width="' + (mat.w - 3) + '" height="' + (mat.d - 3) + '" rx="3" fill="none" stroke="#5f5142" stroke-width="2"/>'
        + '<rect x="' + (matX + 4) + '" y="' + (matY + 4) + '" width="' + (mat.w - 8) + '" height="' + (mat.d - 8) + '" rx="2" fill="none" stroke="#efe9dd" stroke-width="1.3" stroke-dasharray="3.8 2.8"/>'
        + (PAW ? '<path d="' + PAW + '" fill="#ece3d2" opacity="0.9" transform="translate(' + (W / 2 - pawSize / 2) + ' ' + (matY + mat.d / 2 - pawSize / 2) + ') scale(' + pawScale + ')"/>' : '')
        + '<rect x="0" y="0" width="' + W + '" height="' + H + '" fill="url(#w2vin)"/>'
        + '</svg>';
    };

    // Reihenfolge: Empfehlungstext → Mattengröße → Türbreite → Szene.
    const html = `
      <p class="ttg-ovl__note">${escapeHtml(RECO)}</p>
      <div class="ttg-dv__group" role="group" aria-label="Mattengröße">
        <span class="ttg-dv__grouplabel">Mattengröße</span>
        ${MATS.map((m) => `<button type="button" class="ttg-dv__btn" data-ttg-dv-mat="${m.key}" aria-pressed="${m.key === state.mat.key}">${m.label}</button>`).join('')}
      </div>
      <div class="ttg-dv__group" role="group" aria-label="Türbreite">
        <span class="ttg-dv__grouplabel">Türbreite</span>
        ${DOORS.map((d) => `<button type="button" class="ttg-dv__btn" data-ttg-dv-door="${d}" aria-pressed="${d === state.door}">${d} cm</button>`).join('')}
      </div>
      <div class="ttg-dv__scene" data-ttg-dv-scene>${scene()}</div>`;
    return {
      html,
      hideHead: true,
      init(contentEl) {
        // Höhen-Deckel exakt aus dem real verfügbaren Platz unter Kopf/
        // Faustregel/Buttons messen (die CSS-vh-Werte sind nur Fallback bis
        // zur ersten Messung): mobil variiert der Platz stark mit der
        // Textumbruch-Höhe, ein fester vh-Wert schneidet sonst die Matte ab.
        // Obergrenze 55 % Viewport = bewusst identisch zum Desktop-Fallback.
        const sceneEl = contentEl.querySelector('[data-ttg-dv-scene]');
        const fit = () => {
          const avail = window.innerHeight - sceneEl.getBoundingClientRect().top - 28; // 24px Panel-Polster + Luft
          if (avail > 0) {
            const capped = Math.max(150, Math.min(avail, window.innerHeight * 0.55));
            sceneEl.style.setProperty('--ttg-dv-maxh', Math.round(capped) + 'px');
          }
        };
        fit();
        requestAnimationFrame(fit);                    // nach Layout/Font-Swap
        window.addEventListener('resize', fit, { passive: true });  // Panel lebt einmalig pro Seite
        contentEl.addEventListener('click', (e) => {
          const mb = e.target.closest('[data-ttg-dv-mat]');
          const db = e.target.closest('[data-ttg-dv-door]');
          if (!mb && !db) return;
          if (mb) state.mat = MATS.find((m) => m.key === mb.dataset.ttgDvMat) || state.mat;
          if (db) state.door = parseInt(db.dataset.ttgDvDoor, 10) || state.door;
          contentEl.querySelectorAll('[data-ttg-dv-mat]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.ttgDvMat === state.mat.key)));
          contentEl.querySelectorAll('[data-ttg-dv-door]').forEach((b) => b.setAttribute('aria-pressed', String(parseInt(b.dataset.ttgDvDoor, 10) === state.door)));
          contentEl.querySelector('[data-ttg-dv-scene]').innerHTML = scene();
        });
      },
    };
  },
};

// Darstellungsmodus der erledigten Schritte (reine UI, keine Kern-Logik):
//  'inline' → Controls bleiben sichtbar & direkt bedienbar (kompakt).
//  'panel'  → schrumpft zu klickbarer Kompaktzeile (Mini-Vorschau), Klick öffnet wieder.
const STEP_MODE = { base: 'inline', color: 'inline', motif: 'panel', text: 'panel', font: 'inline', print: 'panel', size: 'inline', vo: 'inline', photo: 'panel' };

export class TTGEngine {
  /**
   * @param {object} config  Produktkonfiguration aus Shopify (siehe Section).
   * @param {object} hooks   Theme-Hooks: { onSubmit({variantId, properties, state}) }
   */
  constructor(config, hooks = {}) {
    // Basis- und Größen-Achse auf DERSELBEN Option (Schema v1.34, 20.10.2026, Geldbörse Groß/Klein: „Größe“
    // ist die Basis-Achse): Die Section liefert size.optionName per Standard „Größe“. Dann gibt es keine
    // eigene Größen-Achse — sonst verlangte resolveVariant zusätzlich eine leere Größe und fände keine
    // Variante. Nur OHNE eigenen Größen-Schritt: Mit Größen-Schritt bleibt die bekannte Kante (Fotomatte,
    // 26.08.2026, test/foto-matte.mjs „Phase-6-Kante“) unverändert. So nutzt kein Bestandsprodukt diese Kombination.
    // Nur eine AUSDRÜCKLICHE Schrittliste ohne 'size' zählt — ohne Liste gilt die Standard-Reihenfolge mit Größe.
    const ohneGroessenSchritt = !!(config && Array.isArray(config.steps) && config.steps.length
      && !config.steps.some((x) => String(x).trim() === 'size'));
    if (config && config.base && config.size && config.base.optionName && ohneGroessenSchritt
      && config.size.optionName === config.base.optionName) {
      config.size = Object.assign({}, config.size, { optionName: null });
    }
    this.config = config;
    this.hooks = hooks;
    this.listeners = new Map();
    // Fokus-Modalität (siehe _bind): nur Tastatur-Navigation zieht den Autofokus
    // in den neu aktivierten Schritt. Startwert false → kein Autofokus beim Mount.
    this._kbNav = false;

    // Options-Aufpreise (Schema: choice-Option mit surcharge). Die Section liefert
    // sie als Map { swatch-hex → {variantId, priceLabel} }; hier auf die
    // Options-Objekte gemergt, damit die Mechanik am Objekt hängt (generisch —
    // jede Options-Liste kann surcharge direkt am Eintrag tragen).
    if (config.printSurcharges) {
      (config.printColors || []).forEach((p) => {
        const sc = config.printSurcharges[(p.hex || '').toLowerCase()];
        if (sc && sc.variantId) p.surcharge = sc;
      });
    }

    // Text-Schritte normalisieren: config.texts (Mehrfach-Text, Schema v1.4) ODER
    // synthetisierter Einzel-Def aus dem Alt-Format (config.text) — Engine-Kern
    // arbeitet ab hier NUR noch auf this.texts (Array von Defs).
    this.texts = this._normalizeTexts();

    // Zusätzliche Varianten-Optionen (config.extraOptions, Schema v1.7): jede
    // mittlere variant_option (zwischen Farb- und Größen-Rolle, z. B. „Geschlecht"
    // beim T-Shirt) wird ein eigener Wizard-Schritt 'vo:<id>'. Der gewählte Wert
    // fließt in Variantenauflösung, Layout-Overrides (v2), defaultBy und die
    // Line-Item-Properties. Ohne extraOptions (Warnweste/Fußmatte) alles wie bisher.
    this.extraOptions = Array.isArray(config.extraOptions)
      ? config.extraOptions.filter((o) => o && o.id && o.optionName)
      : [];

    // Zusatzartikel (config.addons, Schema v1.31, 19.10.2026, Nijens-Gürtelverlängerung): je
    // addon-Schritt eine Variante eines ANDEREN Produkts, die als eigene Warenkorbzeile mitgeht.
    // Optional, Vorbelegung „Keine“ (state.addons[id] = null), eigener Schritt 'addon:<id>'.
    // Die Section liefert Preis/Bestand/Bild zur Renderzeit. Ohne config.addons alles wie bisher.
    this.addons = Array.isArray(config.addons)
      ? config.addons.filter((a) => a && a.id && Array.isArray(a.items))
      : [];

    // Rasse-Varianten als Motive (Schema v1.28, s. _variantMotifsBauen): MUSS vor jeder
    // Motiv-Auflösung laufen (Default, ?ttg-motif, Titel-Ableitung lesen config.motifs).
    this._variantMotifsBauen();
    // excludeMotifs (Schema v1.35, s. _motifAusgeschlossen): ausgeschlossene Motive verlassen
    // die Liste, bevor Default, ?ttg-motif oder Grid sie sehen. Ohne den Schlüssel: No-Op.
    if (this._hatExcludeMotifs() && Array.isArray(config.motifs)) {
      config.motifs = config.motifs.filter((m) => !this._motifAusgeschlossen(m));
    }

    const baseValues = this._optionValues(config.base.optionName);
    // Werte der Größen-Achse — gebraucht für die Vorbelegung bei genau EINEM Wert
    // (s. unterhalb von this.state). config.size fehlt in keiner emittierten Config;
    // der Guard hält die Engine für Test-/Teil-Configs am Leben.
    const sizeValues = this._optionValues(config.size && config.size.optionName);
    const defaults = config.defaults || {};

    // Phase 2: Default-Motiv aus dem Produkttitel ableiten — nur wenn die geteilte
    // Config es freischaltet (config.deriveMotifFromTitle, Section emittiert das Flag
    // ausschließlich im Metaobjekt-Modus) UND weder Override noch Schema-/Section-
    // Default gesetzt ist: defaults.motif gewinnt IMMER (Präzedenz: custom.default_motif
    // > Titel-Ableitung > Schema-/Section-Default > null). Läuft synchron VOR dem
    // ersten Render — der Picker malt direkt eingeklappt, kein Aufblitzen.
    let defaultMotifId = defaults.motif;
    if (!defaultMotifId && config.deriveMotifFromTitle === true) {
      const derived = this._deriveDefaultMotifFromTitle();
      if (derived) defaultMotifId = derived.id;
    }

    // Motivbuch-Deep-Link (?ttg-motif=<handle>, optional &ttg-bild=<1-basiert>):
    // überschreibt das Default-Motiv (gewinnt über Override/Titel-Ableitung/Schema-
    // Default) — synchron VOR dem ersten Render, kein Aufblitzen des Standardmotivs.
    // Ungültige Werte (unbekanntes Handle, Kategorie nicht von der Produkt-Config
    // referenziert) fallen still aufs Standardverhalten zurück (nur console.warn).
    // Ohne Parameter ist der gesamte Block ein No-Op (rein additiv).
    this._urlMotifPending = null;   // Handle, das erst der globale Katalog auflösen kann
    this._urlMotifBild = 0;         // gewünschte Bildvariante (0-basiert); greift nur wenn vorhanden
    this._urlMotifScroll = false;   // mount() soll zur Motiv-Karte springen (nur bei ?ttg-motif inline)
    this._motifFromUrl = false;     // aktives Motiv stammt aus einem Deep-Link → seine Gruppe schlägt defaultGroup
    let urlMotifInline = null;      // im Konstruktor aufgelöstes Deep-Link-Motiv
    const urlP = this._readUrlMotifParams();
    // ?ttg-motif=none — Deep-Link auf ein blankes Produkt: kein Motiv, kein Text.
    // `none` ist als Sentinel sicher: der Katalog fuehrt 633 Motive, keines mit
    // dieser id (15.08.2026 geprueft). Trotzdem wird der Wert VOR _resolveMotif
    // abgefangen, damit ein spaeter angelegtes Motiv `none` den Deep-Link nicht
    // still uebernehmen kann — der Sentinel gewinnt immer.
    if (urlP && String(urlP.handle).toLowerCase() === 'none') {
      this._urlNoMotif = true;
      defaultMotifId = null;          // kein Startmotiv aufloesen
    } else if (urlP) {
      this._urlMotifBild = urlP.bild;
      const um = this._resolveMotif(urlP.handle);
      if (um && this._urlMotifAllowed(um)) {
        urlMotifInline = um;
        defaultMotifId = urlP.handle;
        this._motifFromUrl = true;
        // Inline aufgelöst heißt: das Motiv IST das Default-Motiv und steht schon
        // beim ersten Rendern — es gibt kein späteres apply, das scrollen könnte.
        // mount() holt den Sprung deshalb nach (Flag, nicht Aufruf: hier existiert
        // noch kein DOM). Ohne das landet ein Kunde aus einer Mail oben auf der
        // Seite und sieht das vorgewählte Motiv nicht.
        this._urlMotifScroll = true;
      } else if (!um && config.motifsCatalog && config.motifsCatalog.url) {
        // Ziel liegt evtl. im (lazy geladenen) globalen Katalog: Default-Motiv
        // unterdrücken (die Vorschau zeigt bis zur Auflösung nur die Basis — nie
        // das falsche Motiv), Handle parken. mount() zieht den Katalog sofort vor;
        // _afterCatalogLoaded wendet an ODER fällt still auf den Standardpfad
        // zurück (die Late-Default-/Titel-Blöcke sehen dann ein unberührtes Motiv).
        this._urlMotifPending = urlP.handle;
        defaultMotifId = null;
      } else {
        console.warn('[ttg] ?ttg-motif ungültig: ' + urlP.handle);
      }
    }

    // Motivbuch-Deep-Link, zweite Achse (?ttg-farbe=<Optionswert>): Basis-/Westenfarbe
    // vorwählen. Rein additiv und UNABHÄNGIG von ?ttg-motif — eigene Lese-Funktion,
    // weil _readUrlMotifParams() ohne ?ttg-motif sofort mit null aussteigt und ein
    // alleinstehendes ?ttg-farbe damit verschluckt würde. Ergebnis ist der KANONISCHE
    // Optionswert (nie die Roheingabe): resolveVariant() und baseImages[…] treffen
    // exakt, „sahara" fände sonst weder Variante noch Basisbild. Unbekannt → null
    // (stiller Fallback auf den Standard, nur console.warn). Ohne Parameter No-Op.
    const urlColor = this._resolveUrlColor(baseValues);

    // Zwei weitere Startquellen für die Varianten-Achsen, beide rein additiv:
    //
    //  urlOptBase/urlOptSize — der generische Optionswert-Deep-Link
    //    ?ttg-<paramId>=<Wert> (s. _resolveUrlOptionValue). Die 40 Weiterleitungen
    //    der abgelösten Klett-Einzelprodukte zeigen auf ?ttg-design=<Design>; ohne
    //    Handler landete der Kunde zwar auf dem richtigen Produkt, aber auf dem
    //    Standarddesign — der Motivbezug des alten Produkts ging verloren.
    //
    //  urlVariant — Shopifys ?variant=<id> (s. _variantParamValues). Gilt für ALLE
    //    Achsen zugleich und ist die schwächste der drei Quellen: ein ausdrücklich
    //    gesetzter TTG-Parameter beschreibt die Absicht genauer als die Varianten-ID,
    //    die an vielen Links nur mitläuft.
    //
    // Präzedenz je Achse: ?ttg-farbe > ?ttg-<paramId> > ?variant= > defaults > erster
    // Optionswert. Ohne jeden Parameter sind alle drei No-Ops (null) und der
    // Startzustand ist byte-identisch zu vorher.
    const urlOptBase = this._resolveUrlOptionValue(config.base && config.base.paramId, baseValues);
    const urlOptSize = this._resolveUrlOptionValue(config.size && config.size.paramId, sizeValues);
    const urlVariant = this._variantParamValues();

    // Pro Text-Def: Wert (mit default vorbelegt) + „Kein Text"-Flag.
    const textValues = {};
    const noTexts = {};
    for (const t of this.texts) {
      textValues[t.id] = t.default || '';
      noTexts[t.id] = !!t.defaultNoText;   // vorbelegtes „Kein Text gewünscht"
    }

    // Cross-Sell-Deep-Links (Motiv-Bonus): ?ttg-name=<text> befüllt ein Text-Feld
    // vor, ?ttg-xsell=1 markiert den späteren Add-to-Cart als Bonus-Linie
    // (_ttg_xsell: "1" — die 15 % vergibt ausschließlich die Discount Function,
    // server-seitig an den Anker gebunden; der Parameter allein rabattiert nichts).
    // Ziel-Feld: explizit per &ttg-text-def=<id>, sonst das erste Text-Def OHNE
    // default (= das „Namens"-Feld: Hier-wohnt zeile2, Klingeln name, Weste text),
    // Fallback erstes Def. VALIDIERUNG wie die Eingabe selbst: charFilter, dann
    // maxLength — ein zu langer Text wird NIE still gekürzt, sondern verworfen;
    // das Feld bleibt leer und der Schritt zeigt einen Hinweis (kein stiller
    // Datenverlust, der Kunde entscheidet selbst über die Kurzform).
    this._xsellFlag = false;
    this._deepLinkTextHint = null;   // { defId } — Hinweis „Text zu lang" im Text-Schritt
    let deepLinkFont = null;         // &ttg-font: Schrift der Erstwahl (Cross-Sell)
    const xp = this._readUrlXsellParams();
    this._xsellSrc = null;           // &ttg-xsrc: Quell-Motiv der Bonuszeile (nur mit ttg-xsell=1)
    if (xp) {
      this._xsellFlag = xp.xsell;
      this._xsellSrc = xp.xsell ? (xp.src || null) : null;
      // Schrift der Erstwahl (&ttg-font): nur übernehmen, wenn DIESES Produkt die
      // Schrift-ID kennt — sonst bleibt der Produkt-Default (sauberer Fallback,
      // gleiche Regel wie composeXsellLine/Karte).
      if (xp.font && (config.fonts || []).some((f) => f.id === xp.font)) deepLinkFont = xp.font;
      if (xp.name) {
        const def = (xp.defId && this.texts.find((t) => t.id === xp.defId))
          || this.texts.find((t) => !t.default)
          || this.texts[0];
        if (def) {
          const filtered = this._filterText(xp.name, def);
          // Umbrüche gemäß maxLines falten (bei maxLines === 1 zu Leerzeichen —
          // das verliert nichts, genau so wird gedruckt), DANACH wie bisher auf
          // Länge prüfen. Zu lang wird verworfen, nie still gekürzt; die Länge
          // gilt bei mehrzeiligen Feldern je Zeile.
          const roh = String(filtered).replace(/\r\n?/g, '\n');
          const maxL = this._maxLines(def);
          const zeilen = maxL === 1 ? [roh.split('\n').join(' ')] : roh.split('\n');
          const wert = zeilen.join('\n');
          const passt = zeilen.length <= maxL && zeilen.every((z) => z.length <= (def.maxLength || 30));
          if (wert.trim() && passt) {
            textValues[def.id] = wert;
            noTexts[def.id] = false;
          } else if (xp.name.trim()) {
            this._deepLinkTextHint = { defId: def.id };
          }
        }
      }
    }

    // Zusätzliche Optionen: erster Optionswert vorbelegt (wie die Farbe) —
    // gilt als vollständige Wahl, bleibt aber inline umschaltbar.
    const extraValues = {};
    for (const xo of this.extraOptions) {
      const vals = this._optionValues(xo.optionName);
      // Gleiche Präzedenz wie bei Farbe/Größe: eigener Deep-Link (?ttg-<id>),
      // dann ?variant=, dann wie bisher der erste Optionswert.
      extraValues[xo.optionName] = this._resolveUrlOptionValue(xo.id, vals)
        || (urlVariant && urlVariant.options[xo.optionName])
        || vals[0] || null;
    }

    this.state = {
      // Präzedenz: ?ttg-farbe > defaults.color > erster Optionswert. Die Farbe steht
      // damit VOR _applyPrintDefaultBy() und _deriveBaseImages() — das richtige Blanko
      // steht sofort, kein Aufblitzen der Standardfarbe.
      color: urlColor || urlOptBase || (urlVariant && urlVariant.color) || defaults.color || baseValues[0] || null,
      // Größe: OHNE Deep-Link weiterhin null (der Schritt bleibt unbeantwortet).
      // Mit ?ttg-<paramId> oder ?variant= steht der Wert sofort — der Schritt gilt
      // damit aber NICHT als erledigt (done.size bleibt false, s. u.): der Kunde
      // bestätigt seine Größe wie bisher selbst, der Deep-Link setzt nur die Anzeige.
      size: urlOptSize || (urlVariant && urlVariant.size) || null,
      options: extraValues,   // { optionName → gewählter Wert } der extraOptions
      quantity: 1,
      // Vorbelegtes Startmotiv (defaults.motif = id/handle, ggf. titel-abgeleitet, s. o.)
      // → Bühne wirkt „fertig". Gilt wie Farbe erst nach Bestätigung als erledigt.
      motif: this._resolveMotif(defaultMotifId),   // {id,label,kategorie,bild,bilder,...} oder null
      motifVariant: 0,    // Index in motif.bilder (Bildvariante) — Default = Bild 1
      noMotif: false,
      texts: textValues,
      noTexts,
      // Kundenfoto (Schema v1.18, nur Produkte mit config.photo): { url, localUrl,
      // srcW, srcH, crop:{x,y,w,h}, name }. url = hochgeladene Server-URL (erst
      // damit ist der Schritt erfüllt, s. _photoSatisfied); localUrl = Objekt-URL
      // des clientseitig verkleinerten Bildes (Vorschau + Snapshot, CORS-frei).
      // crop in Quell-Pixeln des VERKLEINERTEN Bildes — dieselben Pixel, die der
      // Druck-Renderer aus url lädt (kein zweiter Maßstab).
      photo: null,
      font: deepLinkFont || defaults.font || (config.fonts[0] && config.fonts[0].id),
      // Bei genau EINER Palettenfarbe gewinnt diese Farbe — nicht defaults.druckfarbe.
      // Sonst könnte eine Ein-Farb-Palette (z. B. nur Weiß) von einem abweichenden
      // Default (schwarz) überstimmt werden: Vorschau und Cart-Property zeigten dann
      // eine Farbe, die gar nicht druckbar ist. Bei mehreren Farben unverändert.
      druckfarbe: (config.printColors && config.printColors.length === 1)
        ? config.printColors[0].hex
        : (defaults.druckfarbe || (config.printColors[0] && config.printColors[0].hex)),
      // Motivseite (config.sides): Vorder-/Rückseite — EINE Seite, kein Varianten-Split
      // (dieselbe SKU, nur ein anderer Druckort). Default (Vorderseite) ist eine
      // vollständige Wahl → der Schritt startet erledigt (_isPreSatisfied). Ohne
      // config.sides null → keine zweite Achse (Warnweste/Fußmatte unverändert).
      side: config.sides ? (config.sides.default || (config.sides.values && config.sides.values[0]) || null) : null,
      // Zusatzartikel (config.addons): gewählte variantId je addon-Schritt, null = „Keine“.
      addons: {},
      // Aktiver Motiv-Bucket im Finder (Absichtsgruppe ODER Kategorie). Bei genau
      // EINEM befüllten Bucket direkt gesetzt → die Dialog-Ebene entfällt. Sonst: null.
      bucket: this._soleBucket(),
      // Reine Darstellungs-Flags des Motiv-Finders (keine Auswahl-Logik):
      motifExpandedFor: null,  // Bucket, in dem „Alle N anzeigen" geklickt wurde (sonst nur erste N)
      motifCollapsed: false,   // true = nur das gewählte Mehrbild-Motiv zeigen (Grid aus); transient,
                               // wird bei jedem Wieder-Betreten des Motiv-Schritts zurückgesetzt
      baseChoice: 0,      // Index der gewählten Base-Vorlage (config.baseOptions), Default = erste
      // Strikt sequenziell: alle Schritte starten offen. Defaults (Farbe, Schrift,
      // Druckfarbe) sind vorbelegt, gelten aber erst nach Bestätigung als erledigt.
      done: { base: false, color: false, motif: false, text: false, font: false, print: false, size: false, photo: false }
    };
    // Akzentfarbe (Schema v1.35, s. _akzentFarben): eigener Zustand, vorbelegt mit default-value
    // oder der ersten Farbe. Ohne config.accent kein Schlüssel im Zustand (getState byte-gleich).
    const akz = this._akzentFarben();
    if (akz.length) {
      const d = akz.find((c) => c.value && c.value === config.accent.default) || akz[0];
      this.state.akzentfarbe = d.hex;
    }

    // Ausverkaufte Werte der Farb-/Basis-Achse ausblenden (Schema v1.32, 19.10.2026,
    // config.base.hideSoldOut, Opt-in je Config): Steht die Vorwahl (Deep-Link, Default
    // oder erster Wert) auf einem Wert ohne verfügbare Variante, springt sie auf den
    // ersten verfügbaren — noch VOR Blanko-Ableitung und erstem Render. Ohne Schalter
    // keine Wirkung, Bestandsprodukte byte-gleich im Verhalten.
    if (this._baseHideSoldOut() && this.state.color != null && !this._baseWertVerfuegbar(this.state.color)) {
      this.state.color = this._baseWerteSichtbar()[0] || null;
    }

    // Genau EINE Größe: vorbelegen, damit resolveVariant() trifft und die Property
    // „Größe" trägt, obwohl der Schritt nicht angeboten wird (_sizeSingleOption).
    // Steht NACH dem State-Aufbau, weil die Prüfung state.color braucht (die eine
    // Größe kann je Farbe verschieden verfügbar sein).
    // AUSVERKAUFT: dann NICHT vorbelegen — _sizeSingleOption ist dieselbe Bedingung,
    // der Schritt bleibt also sichtbar und der Kauf blockiert wie bisher. Ohne diese
    // Kopplung wäre ein ausverkauftes Ein-Größen-Produkt scheinbar kaufbar
    // (_ready() prüft keine Verfügbarkeit).
    if (sizeValues.length === 1 && this._sizeSingleOption()) this.state.size = sizeValues[0];

    // Rasse-Varianten als Motive: ?variant= (Rasseseiten-Links) wählt das passende Motiv vor,
    // ein Motiv (Default/?ttg-motif) setzt Achse und Ausführung. Ohne motifVariantAxis No-Op.
    if (this._motifAchse()) {
      if (!this.state.motif && urlVariant && urlVariant.color) {
        this.state.motif = this._motifFuerAchsenwert(urlVariant.color);
        // Deep-Link wie ?ttg-motif: die Gruppe des Motivs schlägt defaultGroup (_openDefaultMotifBucket).
        // Sonst öffnete ?variant= Flyball die Gruppe „Hunderasse“ (Leinengarderobe, Schema v1.30, 19.10.2026).
        if (this.state.motif) this._motifFromUrl = true;
      }
      // ?variant= einer AUSVERKAUFTEN Variante: _variantParamValues() verwirft sie (kein Vorwählen) — die Hunderasse
      // soll trotzdem stehen, damit der Kunde den Ausverkauft-Hinweis sieht statt eines leeren Rasters.
      let urlVariantAusverkauft = false;
      if (!this.state.motif && !urlVariant && this.config.motifVariantHideSoldOut === true) {
        const vid = this._readUrlParam('variant');
        const rv = vid ? (this.config.variants || []).find((x) => String(x.id) === String(vid)) : null;
        if (rv) { this.state.motif = this._motifFuerAchsenwert(rv.options[this._optionIndex(this.config.base.optionName)]); urlVariantAusverkauft = !!this.state.motif; if (this.state.motif) this._motifFromUrl = true; }
      }
      this._syncMotifVariant();
      // Kein Personalisierungs-Produkt: eine per Link (?ttg-motif / ?variant=, Hunderasseseiten)
      // gesetzte Rasse und eine dazu eindeutige Ausführung sind fertige Wahlen — der Kunde soll
      // nicht erst bestätigen müssen, was der Link schon festlegt. Ändern bleibt jederzeit möglich.
      if (this.state.motif && (this._motifFromUrl || urlVariant || urlVariantAusverkauft)) this.state.done.motif = true;
      if (this.state.motif && this.state.size != null && (urlVariant || this._motifAusfuehrungen().length === 1)) this.state.done.size = true;
    }

    // ?ttg-motif=none (s. oben): blankes Produkt. Motiv-Schritt angehakt und
    // erledigt, dazu jeder OPTIONALE Text auf „Kein Text" — Pflichttexte bleiben
    // unangetastet, sonst waere der Kaufweg mit einem Deep-Link zu umgehen.
    // Bewusst NACH dem State-Aufbau: `noMotif` und `noTexts` existieren erst hier,
    // und `_motifTouched` bleibt aus — ein Deep-Link ist keine Kundeninteraktion,
    // nachgelagerte Katalog-Defaults duerfen also weiter greifen.
    if (this._urlNoMotif && this._allowNoMotif()) {
      this.state.motif = null;
      this.state.noMotif = true;
      this.state.done.motif = true;
      for (const def of this.texts) {
        if (def && def.optional) this.state.noTexts[def.id] = true;
      }
    } else if (this._urlNoMotif) {
      // allowNoMotif:false — der Deep-Link darf die Pflichtwahl nicht aushebeln.
      console.warn('[ttg] ?ttg-motif=none ignoriert: dieses Produkt verlangt ein Motiv.');
      this._urlNoMotif = false;
    }

    // defaultBy (Schema v1.7, choice-Schritt Druckfarbe): Druckfarbe je Wert
    // einer Varianten-Option vorbelegen (dunkles Shirt → weißer Druck). Gilt
    // NUR, solange der Kunde die Druckfarbe nicht selbst angefasst hat — danach
    // gewinnt seine Wahl dauerhaft. Fallback ohne Map-Treffer: defaults.druckfarbe.
    this._printTouched = false;
    this._applyPrintDefaultBy();
    // ?ttg-druckfarbe (09.10.2026): NACH ?ttg-motif/?ttg-farbe und defaultBy — schlägt beide.
    this._applyUrlPrint();

    // &ttg-bild: gewünschte Bildvariante des Deep-Link-Motivs — NUR übernehmen,
    // wenn der Index existiert (sonst bleibt Bild 1). Nur für das inline aufgelöste
    // Deep-Link-Motiv; der geparkte Katalog-Fall setzt sie in _afterCatalogLoaded.
    if (urlMotifInline && this.state.motif === urlMotifInline && this._urlMotifBild > 0) {
      const v = this._urlBildIndex(urlMotifInline, this._urlMotifBild);
      if (v > 0) this.state.motifVariant = v;
    }

    // Eingeklappter Motiv-Start: mit gesetztem (und auflösbarem) Start-Motiv zeigt
    // der Motiv-Schritt zunächst nur das vorausgewählte Motiv + die Frage als
    // „anderes Motiv?"-Prompt; Klick öffnet den vollen Picker. Opt-out pro Produkt
    // über config.motifStartExpanded (Section-Setting/Schema-Feld) — die Fußmatten
    // behalten damit ihren offenen Picker.
    this.state.motifIntro = !!(defaultMotifId && this.state.motif) && this.config.motifStartExpanded !== true;

    // Mit inline auflösbarem Default-Motiv (Override/Schema) + startExpanded (Gruppen-
    // Modus) beim Laden direkt den Bucket der Default-Gruppe öffnen. Muss VOR der
    // Vorbelegungs-Schleife laufen (setzt _motifOpenDefault, das _isPreSatisfied liest).
    // Katalog-Modus (Titel-Ableitung): läuft nachgelagert in _applyLateDefaultMotif.
    this._openDefaultMotifBucket();

    // Schritte mit gültiger Vorauswahl gelten sofort als erledigt (kein Pflicht-Klick, um
    // fortzufahren). Generisch & rückwärtskompatibel: nur Schritte, deren Vorauswahl eine
    // vollständige, sinnvolle Wahl ist (z. B. „Anzahl"-Umschalter mit Default-Index).
    for (const d of this._stepDefs()) {
      if (!(d.key in this.state.done)) this.state.done[d.key] = false;   // z. B. 'text:<id>'
      if (this._isPreSatisfied(d.key)) this.state.done[d.key] = true;
    }

    // Cross-Sell-Deep-Link (?ttg-xsell=1): vorbefüllte Schritte gelten als
    // BESTÄTIGT, nicht als offen — der Kunde kann ändern, muss aber nicht durch
    // jeden Wizard-Schritt klicken. Bewusst NUR hinter dem xsell-Flag (der
    // normale Wizard bleibt byte-gleich) und NUR für Werte, die tatsächlich
    // valide vorliegen; die Submit-Validierung selbst bleibt unangetastet.
    if (this._xsellFlag) this._applyXsellPrefillDone();

    // Color → Base-Bild-URL aus den Varianten ableiten (generisch)
    this.baseImages = this._deriveBaseImages();
    this.refs = {};
    // UI-Zustand der „stillen" vorbelegten Text-Zeilen (optional + default):
    // true = Editor aufgeklappt. Reiner Darstellungszustand — der Schritt selbst
    // bleibt dauerhaft erfüllt und blockiert den Flow nie.
    this._quietOpen = {};
    // Vom Kunden aktiv (wieder-)geöffnete, eigentlich vorbelegte Schritte: sie
    // dürfen NICHT automatisch als erledigt zurückmarkiert werden (sonst klappen
    // sie sofort wieder zu). Siehe renderSteps-Nachmarkierung + reopen-Aktion.
    this._reopened = new Set();
    // UI-Zustand sekundärer Text-Slots: true = Eingabefeld aufgeklappt (leerer
    // Slot zeigt sonst nur den dezenten „+ …"-Link). Gefüllte Slots sind immer offen.
    this._slotOpen = {};
  }

  /* ---------------------------------------------------------------- Pub/Sub */
  on(evt, cb) {
    if (!this.listeners.has(evt)) this.listeners.set(evt, new Set());
    this.listeners.get(evt).add(cb);
    return () => this.listeners.get(evt).delete(cb);
  }
  emit(evt, data) {
    const set = this.listeners.get(evt);
    if (set) set.forEach((cb) => { try { cb(data); } catch (e) { console.error('[ttg]', e); } });
  }

  /* --------------------------------------------------- Varianten-Hilfsmittel */
  _optionIndex(optionName) {
    const opt = this.config.options.find((o) => o.name === optionName);
    return opt ? this.config.options.indexOf(opt) : -1;
  }
  _optionValues(optionName) {
    const opt = this.config.options.find((o) => o.name === optionName);
    return opt ? opt.values.slice() : [];
  }
  /**
   * Basisbild je Optionswert (Blanko für die Vorschau).
   *
   * ZWECKTRENNUNG (Schema v1.14, 05.08.2026): Bis hierher war das Basisbild IMMER
   * das Variantenbild. Damit trug ein Feld zwei Zwecke — Konfigurator-Blanko
   * (muss unbedruckt sein) und Kachel-/Galerie-Ansicht (sollte bedruckt sein).
   * Solange beides dasselbe Feld ist, zeigt die Kollektionskachel nach einem
   * Farbklick die leere Ware.
   *
   * Ist `config.baseImages` gesetzt (aus dem Produkt-Metafeld, s. Section), gewinnt
   * diese Map: Optionswert → Blanko-URL. Die Variantenbilder sind dann frei für
   * bedruckte Fotos. Fehlt das Metafeld, bleibt der Variantenweg unverändert —
   * jedes Bestandsprodukt rendert damit byte-gleich wie bisher.
   *
   * ACHTUNG, zweite Stelle: Das SSR-Erstbild baut die Section selbst
   * (`_ssr_baseimg`). Beide Quellen MÜSSEN dieselbe Wahl treffen, sonst tauscht
   * renderPreview() das Bild direkt nach dem Mount aus — sichtbarer Flash plus
   * zweiter Fetch. Die Section liest deshalb dasselbe Metafeld.
   */
  _deriveBaseImages() {
    const eigen = this.config.baseImages;
    if (eigen && typeof eigen === 'object' && !Array.isArray(eigen) && Object.keys(eigen).length) {
      return Object.assign({}, eigen);
    }
    const idx = this._optionIndex(this.config.base.optionName);
    const map = {};
    if (idx < 0) return map;
    for (const v of this.config.variants) {
      const val = v.options[idx];
      if (val && !map[val] && v.image) map[val] = v.image;
    }
    return map;
  }
  /**
   * Phase 2 — Default-Motiv aus dem Produkttitel ableiten (config.productTitle),
   * gegen die assemblierte PRODUKT-Motivliste (config.motifs — klein & kuratiert,
   * nicht die globale Bibliothek: die Liste selbst ist der Guardrail, ein produkt-
   * fremdes Motiv kann nie gepinnt werden). SICHER by construction: gepinnt wird
   * nur bei EINDEUTIGEM Treffer, sonst null → der Motiv-Schritt öffnet wie bisher.
   *
   * Guardrails (adversarial verifiziert — jede Regel schließt eine echte,
   * reproduzierte Falsch-Pin-Klasse):
   *  - PAGINIERTE Listen (>250 Motive, config.motifsPagination.pages > 1): keine
   *    Ableitung. Der Konstruktor sieht nur Seite 1 — Eindeutigkeit über die
   *    Restliste ist nicht prüfbar, und genau die Groß-Listen-Produkte (Master/
   *    Galerie) sind die Hauptangriffsfläche generischer Treffer.
   *  - Alle Vergleiche WORTGRENZEN-treu (Wortverbund-Gleichheit, nie Substring
   *    der konkatenierten Titel-Norm): «SPITZenqualität» pinnte sonst den Spitz,
   *    «geschenkBOX ERste» den Boxer, «warnWESTEn» via «westie» den Westie.
   *  - Stufen 2+3 (Synonyme/Tippfehler) laufen NUR mit konfigurierter Stopword-
   *    Liste (config.titleStopwords, aus der geteilten Config): ohne sie pinnen
   *    generische Katalog-Synonyme auf Boilerplate-Titel («Größe XL» → Dogge via
   *    „grosse", „Black Edition" → Coonhound, Markenwort „tierisch" → Dogwalker,
   *    'weste'≈'westie' per Levenshtein). Default ist also Stufe-1-only.
   *
   * Stufen (die erste mit eindeutigem Ergebnis entscheidet, Mehrdeutigkeit ist
   * terminal — nie in die nächste Stufe „raten"):
   *  1. Label-Norm exakt gleich einem Wortverbund des Titels (1–6 Wörter); das
   *     LÄNGSTE Label gewinnt («Deutsch Langhaar» schlägt «Deutsch»). Die Fell-
   *     Suffix-Regel („Strip nur, wenn der Rest selbst ein Exact-Label ist") ist
   *     damit inhärent erfüllt: verglichen wird immer gegen echte Labels.
   *  2. suchbegriffe-Token (≥4 Zeichen) exakt gegen Titel-Wörter/Verbünde
   *     («Afghane» → Afghanischer Windhund). Eindeutig nur, wenn alle Treffer
   *     DASSELBE Label tragen — Kategorie-Stichworte («mantrailing» auf 20
   *     Motiven) bleiben so offen.
   *  3. Tippfehler-Toleranz: Titel-Wortfenster (1–3 Wörter) gegen Label +
   *     suchbegriffe per ttgLev («Bernhadiner» → Bernhardiner). Läuft nur, wenn
   *     Stufe 1+2 GAR KEIN Signal hatten (Null-Treffer, nicht Mehrdeutigkeit).
   */
  _deriveDefaultMotifFromTitle() {
    const motifs = Array.isArray(this.config.motifs) ? this.config.motifs : [];
    if (!motifs.length) return null;
    const pg = this.config.motifsPagination;
    if (pg && pg.pages > 1) return null;             // Liste unvollständig sichtbar → nie raten
    const nt = ttgNorm(this.config.productTitle);
    if (!nt) return null;

    // Stopword-Liste (geteilte Config): Boilerplate-Wörter, die für die Synonym-/
    // Fuzzy-Stufen aus dem Titel gestrichen werden. Nur eine NICHT-leere Liste
    // schaltet die Stufen 2+3 frei (bewusstes Config-Opt-in).
    const stopRaw = Array.isArray(this.config.titleStopwords) ? this.config.titleStopwords : [];
    const stop = Object.create(null);
    for (const s of stopRaw) { const n = ttgNorm(s); if (n) stop[n] = true; }
    const fuzzyStages = stopRaw.length > 0;

    // Titel-Wörter (Zahlen raus) + Wortverbund-Mengen. Stufe 1 matcht gegen ALLE
    // Wörter (Labels wie «Golden Retriever» enthalten legitime Attribut-Wörter);
    // Stufen 2+3 nur gegen die Stopword-bereinigten.
    const allWords = String(this.config.productTitle || '')
      .split(/[^0-9A-Za-zÀ-ɏ]+/).map(ttgNorm)
      .filter((w) => w && !/^[0-9]+$/.test(w));
    const joinSet = (ws, span) => {
      const set = Object.create(null);
      for (let i = 0; i < ws.length; i++) {
        let w = '';
        for (let s = 0; s < span && i + s < ws.length; s++) { w += ws[i + s]; set[w] = true; }
      }
      return set;
    };
    const labelSet = joinSet(allWords, 6);           // Labels bis 6 Wörter («Bin im Training – Nicht stören»)

    // Stufe 1: Label-Norm == Wortverbund — längstes Label gewinnt, Gleichstand
    // verschiedener Labels = mehrdeutig (terminal null).
    const hits = [];
    for (const m of motifs) {
      const nl = ttgNorm(m.label);
      if (nl.length >= 3 && labelSet[nl] === true) hits.push({ m, nl });
    }
    if (hits.length) {
      let max = 0;
      for (const h of hits) if (h.nl.length > max) max = h.nl.length;
      const top = hits.filter((h) => h.nl.length === max);
      for (const h of top) if (h.nl !== top[0].nl) return null;   // zwei verschiedene Labels
      return top[0].m;
    }
    if (!fuzzyStages) return null;                   // ohne Stopword-Liste: Stufe-1-only

    const words = allWords.filter((w) => stop[w] !== true);
    const wordSet = joinSet(words, 3);

    // Stufe 2: suchbegriffe-Token exakt gegen Titel-Wörter — nur eindeutig je Label.
    const byLabel = Object.create(null);
    let labelCount = 0;
    for (const m of motifs) {
      if (!m.suchbegriffe) continue;
      for (const t of String(m.suchbegriffe).split(/[\s,]+/)) {
        const ntk = ttgNorm(t);
        if (ntk.length >= 4 && stop[ntk] !== true && wordSet[ntk] === true) {
          const key = ttgNorm(m.label);
          if (byLabel[key] === undefined) { byLabel[key] = m; labelCount++; }
          break;
        }
      }
    }
    if (labelCount === 1) for (const k in byLabel) return byLabel[k];
    if (labelCount > 1) return null;                               // mehrdeutig → offen lassen

    // Stufe 3: Tippfehler-Toleranz über Titel-Wortfenster (1–3 Wörter, ohne Stopwords).
    const fuzzy = Object.create(null);
    let fuzzyCount = 0;
    for (const m of motifs) {
      const cands = [ttgNorm(m.label)];
      if (m.suchbegriffe) for (const t of String(m.suchbegriffe).split(/[\s,]+/)) {
        const n = ttgNorm(t); if (n) cands.push(n);
      }
      let hit = false;
      for (const c of cands) {
        if (c.length < 5 || stop[c] === true) continue;            // kurz/Boilerplate: kollisionsanfällig
        const maxD = c.length <= 8 ? 1 : 2;                        // konservativ: erst lange Wörter dürfen 2 Fehler
        for (let i = 0; i < words.length && !hit; i++) {
          let w = '';
          for (let span = 0; span < 3 && i + span < words.length; span++) {
            w += words[i + span];
            if (ttgLev(w, c, maxD) <= maxD) { hit = true; break; }
          }
        }
        if (hit) break;
      }
      if (hit) {
        const key = ttgNorm(m.label);
        if (fuzzy[key] === undefined) { fuzzy[key] = m; fuzzyCount++; }
      }
    }
    if (fuzzyCount === 1) for (const k in fuzzy) return fuzzy[k];
    return null;
  }

  /** Motiv per id/handle (oder gid) aus config.motifs auflösen — für das Default-Startmotiv. */
  /** id/gid → Motiv-Index (Map) neu aufbauen — nach jeder Änderung an config.motifs
   *  (Konstruktor, Seiten-Nachladen, Katalog-Merge). INP: ersetzt Array.find in den
   *  Hot-Paths (Auflösung, Kachel-Klick). */
  _rebuildMotifIndex() {
    this._motifById = new Map();
    for (const m of (this.config.motifs || [])) {
      if (!m) continue;
      if (m.id != null && !this._motifById.has(m.id)) this._motifById.set(m.id, m);
      if (m.gid != null && !this._motifById.has(m.gid)) this._motifById.set(m.gid, m);
    }
  }
  _resolveMotif(idOrHandle) {
    if (!idOrHandle || !Array.isArray(this.config.motifs)) return null;
    if (!this._motifById) this._rebuildMotifIndex();
    return this._motifById.get(idOrHandle) || null;
  }

  /**
   * Rasse-Varianten als Motive (Schema v1.28, 18.10.2026 — Ringclip Startnummernhalter).
   *
   * config.motifVariantAxis = Name einer Shopify-Option (z. B. „Hunderasse"). Dann entsteht
   * die Motivliste aus den VARIANTEN dieses Produkts statt aus motiv-Metaobjekten: je
   * Optionswert genau ein Motiv, Bild = Variantenbild (bevorzugt einer verfügbaren Variante),
   * Kategorie config.motifVariantCategory (Default „Hunderasse"; je Wert überschreibbar über
   * config.motifVariantCategories, Schema v1.30), id = Slug des Werts
   * (?ttg-motif=<slug>). config.motifVariantSearch ergänzt je Wert Suchbegriffe.
   *
   * Das gewählte Motiv STEUERT die Achse: config.base.optionName wird die Achse, state.color
   * folgt dem Motiv (_syncMotifVariant), der Farb-Schritt entfällt (_stepDefs). Die Bühne
   * zeigt das Bild der aufgelösten Variante — Ausführungen derselben Rasse (handbemalt,
   * versilbert, vergoldet) haben eigene Fotos — und der Warenkorb bekommt genau diese
   * Variante (Bestand je Variante). Ein Katalog (ttg-motifs.json) wird nicht geladen.
   * Ohne den Schlüssel: No-Op, jede Bestands-Config byte-gleich.
   */
  _motifAchse() {
    const ax = this.config && this.config.motifVariantAxis;
    return (typeof ax === 'string' && ax && this._optionIndex(ax) >= 0) ? ax : null;
  }
  _variantMotifsBauen() {
    const roh = this.config && this.config.motifVariantAxis;
    if (!roh) return;
    const ax = this._motifAchse();
    if (!ax) {
      console.warn(`[ttg] motifVariantAxis "${roh}" ist keine Option dieses Produkts — Rasse-Motive aus.`);
      return;
    }
    const xi = this._optionIndex(ax);
    const kat = this.config.motifVariantCategory || 'Hunderasse';
    // Schema v1.30 (19.10.2026, Leinengarderobe): Kategorie je Wert (z. B. Flyball → „Hundesport“) für eine zweite Gruppe.
    const katJe = (this.config.motifVariantCategories && typeof this.config.motifVariantCategories === 'object') ? this.config.motifVariantCategories : {};
    const such = this.config.motifVariantSearch || {};
    const motive = [];
    const proWert = new Map();
    for (const v of (this.config.variants || [])) {
      const val = v.options[xi];
      if (val == null || val === '') continue;
      let m = proWert.get(val);
      if (!m) {
        m = { id: ttgRasseSlug(val), gid: null, label: val, kategorie: katJe[val] || kat,
              suchbegriffe: such[val] || null, bild: '', bilder: [], _achsenwert: val, _verfuegbar: false };
        proWert.set(val, m);
        motive.push(m);
      }
      // Kachelbild: erste VERFÜGBARE Variante des Werts, sonst die erste mit Bild.
      if (v.image && (!m.bild || (!m._verfuegbar && v.available))) {
        m.bild = v.image; m.bilder = [{ url: v.image, id: null }];
      }
      if (v.available) m._verfuegbar = true;
    }
    // Komplett ausverkaufte Hunderassen (Schema v1.29, 18.10.2026, config.motifVariantHideSoldOut): bleiben in der
    // Liste (Deep-Links lösen weiter auf), fehlen aber in Raster, Suche und Zählung (_motifsInBucket). Kommt Bestand
    // zurück, ist available wieder true — sie erscheinen ohne Pflege.
    for (const m of motive) m._ausverkauft = !m._verfuegbar;
    const ohneBild = motive.filter((m) => !m.bild).map((m) => m.label);
    if (ohneBild.length) console.warn('[ttg] Rasse-Motive ohne Variantenbild: ' + ohneBild.join(', '));
    this.config.motifs = motive.filter((m) => m.bild);
    // Katalog und Paginierung gehören zur Metaobjekt-Liste — hier gibt es keine.
    delete this.config.motifsCatalog;
    delete this.config.motifsPagination;
    this.config.base = Object.assign({}, this.config.base, { optionName: ax });
    this._motifById = null;
    this._rebuildMotifIndex();
  }
  _motifFuerAchsenwert(val) {
    return (this.config.motifs || []).find((m) => m._achsenwert === val) || null;
  }
  /** Ausführungen (Größen-Achse), die es zum aktuellen Achsenwert gibt — vorhanden UND verfügbar. */
  _motifAusfuehrungen() {
    const si = this._optionIndex(this.config.size && this.config.size.optionName);
    const ci = this._optionIndex(this.config.base.optionName);
    // Produkt OHNE Größen-Achse (Teelichthalter, 19.10.2026): genau eine „Ausführung“ (null), wenn die Rasse lieferbar
    // ist — sonst zählte jede Rasse als ausverkauft (_motifAusverkauft) und ?variant= auf Ausverkauftes bliebe kaufbar.
    if (si < 0) return this.config.variants.some((v) => v.options[ci] === this.state.color && v.available) ? [null] : [];
    const out = [];
    for (const v of this.config.variants) {
      if (v.options[ci] !== this.state.color || !v.available) continue;
      if (out.indexOf(v.options[si]) === -1) out.push(v.options[si]);
    }
    return out;
  }
  /** Gewählte Hunderasse komplett ausverkauft (nur mit motifVariantHideSoldOut)? Dann Hinweis statt Ausführungswahl. */
  _motifAusverkauft() {
    return !!(this._motifAchse() && this.config.motifVariantHideSoldOut === true && this.state && this.state.motif
      && this.state.motif._achsenwert != null && this._motifAusfuehrungen().length === 0);
  }
  _ausverkauftText() {
    // motifVariantSoldOutText (Schema v1.31, 19.10.2026, Nijens): Wortlaut je Produkt, z. B. „Dieses Design …“.
    if (this.config.motifVariantSoldOutText) return String(this.config.motifVariantSoldOutText);
    return 'Diese Hunderasse ist gerade ausverkauft.';
  }
  /** Motiv → Achse (state.color) und Ausführung (state.size). Läuft vor jedem Render. */
  _syncMotifVariant() {
    if (!this._motifAchse() || !this.state) return;
    const m = this.state.motif;
    if (!m || m._achsenwert == null) return;
    if (this.state.color !== m._achsenwert) this.state.color = m._achsenwert;
    const ausf = this._motifAusfuehrungen();
    if (this.state.size != null && ausf.indexOf(this.state.size) === -1) {
      this.state.size = null;
      this.state.done.size = false;
    }
    // Genau eine Ausführung lieferbar → keine Wahl, sondern Ansage (s. _sizeSingleOption).
    if (this.state.size == null && ausf.length === 1) this.state.size = ausf[0];
  }

  /* ----------------------------------------------------- Text-Schritt-Defs */
  /**
   * Normalisiert die Text-Schritte auf EIN Format (Array von Defs):
   *  - config.texts (Schema v1.4, ein Eintrag pro Text-Schritt in Wizard-
   *    Reihenfolge): {id, label, question, default, placeholder, maxLength,
   *    font, color, placeholderDimmed, optional, layer, property, charFilter}
   *  - sonst (Alt-Format, Ein-Text-Produkte): synthetisierter Legacy-Def mit
   *    id 'text' aus config.text + strings — Verhalten byte-nah wie bisher
   *    (u. a. „Kein Text" immer erlaubt, Property 'Kein Text' statt weglassen).
   */
  _normalizeTexts() {
    const cfg = this.config;
    const S = cfg.strings || {};
    if (Array.isArray(cfg.texts) && cfg.texts.length) {
      this._multiText = true;
      return cfg.texts.map((t, i) => ({
        id: t.id || ('text' + (i + 1)),
        label: t.label || S.step_text || 'Wunschtext',
        question: t.question || '',
        default: t.default || '',
        placeholder: t.placeholder || '',        // Vorschau-Platzhalter
        inputPlaceholder: t.placeholder || '',   // Eingabefeld-Platzhalter
        maxLength: t.maxLength || 30,
        // maxLines (Schema v1.16): erlaubte Zeilenzahl. 1 = heutiges Verhalten —
        // einzeiliges <input>, ein hereingereichter Umbruch wird zum Leerzeichen
        // (genau das zeigen Vorschau UND Canvas heute schon, siehe _clampLines).
        // >1 gibt ein <textarea> frei; maxLength gilt dann JE ZEILE, nicht gesamt.
        // Fehlt das Feld, ist jedes Verhalten byte-gleich zu vorher.
        maxLines: Math.max(1, parseInt(t.maxLines, 10) || 1),
        font: t.font || null,                    // Engine-Schrift-ID oder null = state.font
        color: t.color || null,                  // fixe Layer-Farbe oder null = Druckfarbe
        placeholderDimmed: t.placeholderDimmed !== false,
        // optional: explizit ODER als Synonym required:false (Schema-Toleranz).
        optional: t.optional === true || t.required === false,
        // defaultNoText: optionaler Text startet vorbelegt als „Kein Text gewünscht"
        // (Schritt gilt sofort als erledigt, kein Klick nötig — One-Click-Ziel).
        defaultNoText: t.defaultNoText === true,
        // Sekundärer Slot: KEIN eigener Wizard-Schritt — dezenter Zusatz-Slot in
        // der Sektion des vorangehenden (primären) Text-Schritts. Immer optional.
        secondary: t.secondary === true,
        // position:'before' (Phase 7): der Slot rendert VOR dem Hauptfeld seines
        // Primären und bindet vorwärts an den NÄCHSTEN nicht-sekundären Def.
        position: t.position === 'before' ? 'before' : null,
        // noTextCta (Phase 9): true = der SECONDARY-Slot zeigt die „Kein Text
        // gewünscht"-Checkbox wie ein Hauptfeld (statt beim Leeren zum
        // „+ …"-Link zu kollabieren). Nur für optionale Slots sinnvoll; ohne
        // das Feld bleiben Bestands-Slots (Warnwesten-Zusatztexte) unverändert.
        noTextCta: t.noTextCta === true,
        // hideNext (Schema v1.19): unterdrueckt die „Weiter"-Affordance an
        // diesem Schritt. Nur sinnvoll, wo die Karte offen bleibt und der Kauf
        // nicht an der Bestaetigung haengt — der Knopf loest sonst genau den
        // Fall, in dem ein Schritt unerreichbar bliebe (s. _textNextBtn).
        hideNext: t.hideNext === true,
        // Entscheidungs-Pflicht (Schema v1.36, 23.10.2026, Wörterbuch-Kissen „Punkt 4“): ein
        // OPTIONALER Text, der trotzdem eine Wahl verlangt — eigener Text ODER das „Kein Text“-
        // Kästchen. Leer und ohne Haken sperrt er Weiter und Kauf (_textStepSatisfied). Ohne
        // das Feld bleibt jeder optionale Text, was er war: leer = übersprungen.
        decide: t.decide === true,
        // Eigene Beschriftung des „Kein Text“-Kästchens bzw. eigener Property-Wert für diese
        // Wahl (statt strings.no_text_cta / strings.no_text). Fehlt das Feld: wie bisher.
        noTextLabel: (typeof t.noTextLabel === 'string' && t.noTextLabel.trim()) ? t.noTextLabel.trim() : null,
        noTextValue: (typeof t.noTextValue === 'string' && t.noTextValue.trim()) ? t.noTextValue.trim() : null,
        // Sperrzeichen (Schema v1.36): steht eines dieser Zeichen im Text (z. B. „[]“ aus den
        // Platzhaltern der Vorschläge — „passt perfekt zu den [Name]“), sperrt das den Kauf mit
        // blockMessage am Feld. Die Zeichen passieren dafür den Zeichenfilter (_filterText),
        // sonst verschwänden sie still und die Prüfung griffe nie. Ohne das Feld: unverändert.
        blockChars: (typeof t.blockChars === 'string' && t.blockChars) ? t.blockChars : null,
        blockMessage: (typeof t.blockMessage === 'string' && t.blockMessage.trim()) ? t.blockMessage.trim() : null,
        // cardTitle (Phase 7): Karten-Überschrift getrennt vom Feld-Label —
        // die Karte kann „Deine Texte auf der Matte" heißen, während das Feld
        // sein eigenes Label („Wunschname") behält. Fehlt es: label wie bisher.
        cardTitle: t.cardTitle || null,
        // Aufschlag (wie Farbaufschlag): greift, sobald der Text NICHT leer ist.
        surcharge: (t.surcharge && t.surcharge.variantId) ? t.surcharge : null,
        layer: t.layer || t.id || null,          // Key in layout.layers
        // values (Schema v1.10): feste Auswahlwerte statt Freitext. Nur ein
        // nicht-leeres Array zählt — alles andere (fehlend, null, String,
        // leeres Array) bleibt null und der Schritt ist unverändert Freitext.
        values: (Array.isArray(t.values) && t.values.length) ? t.values.slice() : null,
        // valueImages (Schema v1.11): Map Wert → Bild-URL. Gesetzt → der Schritt
        // ist BILDGETRIEBEN: die Auswahl legt kein Textzeichen, sondern eine
        // Grafik auf die (deco-)Ebene aus def.layer. Nur ein Objekt mit
        // mindestens einem Eintrag zählt.
        valueImages: (t.valueImages && typeof t.valueImages === 'object' && !Array.isArray(t.valueImages)
          && Object.keys(t.valueImages).length) ? Object.assign({}, t.valueImages) : null,
        // Bildkacheln + Basisbild je Wert (Schema v1.34, 20.10.2026, Zepto-Rest Bau 9, Geldbörse):
        // tiles:"image" zeigt die Werte als Bildkacheln (Bild aus tileImages, sonst baseImages).
        // baseImages: Map Wert → URL oder Wert → {Achsenwert → URL} (Achse = baseImagesBy, ein
        // Optionsname wie „Größe“): der gewählte Wert BESTIMMT das Basisbild (Vorschau + Warenkorbbild),
        // der Schritt legt keinen Text auf Bühne und Druck. Ohne die Schlüssel: null, Verhalten wie bisher.
        tiles: t.tiles === 'image' ? 'image' : null,
        tileImages: (t.tileImages && typeof t.tileImages === 'object' && !Array.isArray(t.tileImages)
          && Object.keys(t.tileImages).length) ? Object.assign({}, t.tileImages) : null,
        baseImages: (t.baseImages && typeof t.baseImages === 'object' && !Array.isArray(t.baseImages)
          && Object.keys(t.baseImages).length) ? Object.assign({}, t.baseImages) : null,
        baseImagesBy: (typeof t.baseImagesBy === 'string' && t.baseImagesBy.trim()) ? t.baseImagesBy : null,
        property: t.property || null,
        // `false` muss überleben: es ist der ausdrückliche Ausstieg aus dem Filter,
        // seit der Filter Voreinstellung ist (_charFilter). `|| null` hätte ihn zu
        // „nicht gesetzt" eingeebnet — und damit ausgerechnet in die Voreinstellung
        // zurückgedreht, also das Gegenteil dessen bewirkt, was dort steht.
        charFilter: t.charFilter === undefined ? null : t.charFilter,
        // emojiColor (Schema v1.18): 'print' färbt die Glyphen-Emojis (❤️🐾) in der
        // DRUCKFARBE statt in der Textfarbe — für Produkte mit fest weißem Text,
        // deren Schmuckfarbe die Druckfarbe ist (Foto-Fußmatte). Fehlt das Feld,
        // erben Glyphen unverändert die Text-/Druckfarbe der Ebene (currentColor).
        emojiColor: t.emojiColor === 'print' ? 'print' : null,
        // Optionaler Hilfe-Link unter dem Feld ({label,url}) — z. B. „Textinspiration".
        helpLink: (t.helpLink && t.helpLink.url) ? { label: t.helpLink.label || '', url: t.helpLink.url } : null,
        // suggestions (Phase 8, Foto-Fußmatte): Textvorschläge unterm Feld —
        // Button „Inspiration" öffnet ein kleines Overlay (Hover auf Desktop,
        // Tipp auf Mobil), Klick übernimmt den Vorschlag WIE GETIPPT (charFilter
        // + Zeichenrahmen laufen mit). Nur ein nicht-leeres String-Array zählt;
        // ohne das Feld rendert nichts (Bestands-Configs byte-identisch).
        // Seit 29.08.2026 sind ZWEI Formen erlaubt (Schema v1.21):
        //   flach:   ["…", "…"]                         (Bestand, unverändert)
        //   Gruppen: [{label:"Frech", items:["…","…"]}]  (Design 4, 22 in 3 Gruppen)
        // Beides normalisiert _normSuggestions auf die Gruppenform; ein flaches
        // Array wird zu genau einer Gruppe ohne Überschrift und rendert damit
        // exakt wie bisher.
        //
        // Die frühere `.slice(0, 12)` ist WEG. Sie hat still gekürzt — bei einer
        // 22er-Liste wären zehn Vorschläge spurlos verschwunden, und genau diese
        // Fehlerklasse räumen wir hier gerade ab. Statt dessen warnt
        // _normSuggestions ab SUGGEST_WARN_AB laut in der Konsole und rendert
        // trotzdem alles: eine zu lange Liste ist ein Konfigurationsfehler, aber
        // keiner, für den eine Produktseite kaputtgehen darf.
        suggestions: this._normSuggestions(t.suggestions, t.id),
        suggestionsLabel: t.suggestionsLabel || null,
        // Lesbarkeits-Kontur (dezenter dunkler Schatten): Default an, sobald die
        // Ebene eine feste color trägt (helle Schrift auf hellen Hintergründen);
        // per textShadow true/false explizit übersteuerbar.
        shadow: t.textShadow === false ? false : (t.textShadow === true || !!t.color),
        _legacy: false,
      }));
    }
    this._multiText = false;
    const t = cfg.text || {};
    return [{
      id: 'text',
      label: S.step_text || 'Wunschtext',
      question: '',                              // legacy: live aus strings (Singular/Plural)
      default: '',
      placeholder: t.placeholder || '',
      inputPlaceholder: S.text_ph || 'z. B. Bella',
      maxLength: t.maxLength || 30,
      maxLines: Math.max(1, parseInt(t.maxLines, 10) || 1),   // s. Multi-Text-Zweig
      // Feste Schrift auch im Ein-Text-Pfad (Schema v1.17): ID ODER Familienname
      // (_fontDef löst beides). Bestehende Ein-Text-Produkte liefern kein
      // text.font → null → state.font wie bisher.
      font: t.font || null,
      color: null,
      placeholderDimmed: t.placeholderDimmed !== false,
      // required:true macht den Ein-Text-Schritt zur PFLICHT — leerer Text blockiert
      // dann Kauf UND Verlassen (greift automatisch in _canLeave/_stepSatisfied). Fehlt
      // required (bestehende Ein-Text-Produkte: Leckerlidose, Thermosflasche, T-Shirt —
      // alle required nicht gesetzt), bleibt der Schritt optional wie bisher; optional:false
      // wird ebenfalls als Pflicht gelesen. Bis 23.07. war hier `optional: true` hart
      // verdrahtet — der Pflichtcharakter der Fußmatte (customizer_fields required:true)
      // ging verloren. Das Feld muss die Section mitliefern: der Ein-Text-„text"-Block in
      // ttg-customizer.liquid emittierte `required` bislang NICHT (nur der Multi-Text-Zweig).
      optional: !(t.required === true || t.optional === false),
      // defaultNoText auch im Ein-Text-Legacy-Pfad: optionaler Text startet als
      // „Kein Text gewünscht" (Schritt sofort erledigt, kein Blocker). Fehlt das
      // Feld (bestehende Ein-Text-Produkte), bleibt es false → Verhalten unverändert.
      defaultNoText: t.defaultNoText === true,
      secondary: false,
      surcharge: null,
      layer: null,
      property: null,
      charFilter: t.charFilter === undefined ? null : t.charFilter,   // `false` überlebt (s. o.)
      helpLink: (t.helpLink && t.helpLink.url) ? { label: t.helpLink.label || '', url: t.helpLink.url } : null,
      shadow: false,
      _legacy: true,
    }];
  }
  /** Schritt-Key eines Text-Defs: 'text' (Alt-Format) bzw. 'text:<id>' (Mehrfach-Text). */
  _stepKeyForDef(def) {
    return this._multiText ? 'text:' + def.id : 'text';
  }
  /** Text-Def zu einem Schritt-Key ('text' oder 'text:<id>') — sonst null. */
  _textDef(key) {
    if (typeof key !== 'string') return null;
    if (key.indexOf('text:') === 0) {
      const id = key.slice(5);
      return this.texts.find((t) => t.id === id) || null;
    }
    if (key === 'text') return this.texts[0] || null;
    return null;
  }
  /** Text-Def per id (für data-def-id aus dem DOM). */
  _textDefById(id) {
    return this.texts.find((t) => t.id === id) || this.texts[0] || null;
  }
  /** „Stiller" Text-Schritt: optional UND vorbelegt (default) — startet als kompakte
   *  Wert-Zeile mit „Ändern", gilt dauerhaft als erfüllt und fordert nie zur Eingabe auf. */
  _isQuietDef(def) {
    return !!(def && def.optional && def.default && String(def.default).trim());
  }
  /** Sekundäre Slots eines primären Text-Defs — in Anzeige-Reihenfolge
   *  (erst die „before"-Slots, dann das Hauptfeld, dann die restlichen).
   *  Sie rendern in dessen Sektion und haben keinen eigenen Wizard-Schritt.
   *  Zuordnung:
   *   - direkt FOLGENDE secondary-Defs OHNE position:'before' → hinter dem Feld
   *     (bisheriges Verhalten, byte-identisch für alle Bestands-Configs)
   *   - direkt VORANGEHENDE secondary-Defs MIT position:'before' → vor dem Feld
   *     (Phase 7, Foto-Fußmatte: Zeile 1 ÜBER dem Namensfeld — die Karte folgt
   *     damit der Matten-Reihenfolge) */
  _secondariesFor(def) {
    return this._secondariesVor(def).concat(this._secondariesNach(def));
  }
  _secondariesNach(def) {
    const out = [];
    if (!def || def.secondary) return out;
    const i = this.texts.indexOf(def);
    for (let j = i + 1; j < this.texts.length; j++) {
      if (!this.texts[j].secondary) break;
      if (this.texts[j].position !== 'before') out.push(this.texts[j]);
    }
    return out;
  }
  _secondariesVor(def) {
    const out = [];
    if (!def || def.secondary) return out;
    const i = this.texts.indexOf(def);
    for (let j = i - 1; j >= 0; j--) {
      if (!this.texts[j].secondary) break;
      if (this.texts[j].position === 'before') out.unshift(this.texts[j]);
    }
    return out;
  }
  /** Schrift-Def zu einer Kennung (Schema v1.17) — Auflösungsreihenfolge:
   *  1) config.fonts-ID (bisheriger Weg — byte-identisch für alle Bestands-
   *     Configs und für state.font, das immer eine gültige ID trägt),
   *  2) Font-FAMILIENNAME gegen die erste Familie der Stacks (z. B.
   *     "TTG Handschrift" → Eintrag "handschrift"): ein text-Step darf seine
   *     feste Schrift als Familie nennen, ohne dass die Section sie vorher
   *     auf eine ID heruntermappen muss,
   *  3) synthetischer Def aus dem rohen Namen (Stack = nur diese Familie):
   *     rendert, wenn die Familie im Theme geladen ist — sonst hält das
   *     Schrift-Gate im Snapshot den Druck an (KEIN Bild statt Ersatzschrift,
   *     s. _ensureSnapshotFonts), genau wie vorgesehen.
   *  null nur bei leerer/fehlender Kennung. */
  /**
   * Zeilenhöhe FÜR EINE SCHRIFT (Vielfaches der Schriftgröße).
   *
   * Hintergrund (gemessen 19.08.2026): Die Textebene läuft auf `overflow: hidden`
   * und einer Zeilenbox von 1,05 × Schriftgröße. Schriften mit kräftigen
   * Oberlängen passen da nicht hinein — „Fiete" verlor bei Pacifico oben 14 px,
   * das große F sah aus wie ein kleines. Der Faktor 1,05 stimmt aber NICHT nur
   * für Schreibschriften nicht: gemessen schneiden auch TTG Klassisch (8 px),
   * Handschrift (16), Modern (23), Comic (17) und Amatic (10) bei „Ägidius" ab —
   * jedes Versal mit Umlaut ist betroffen. Einzig TTG Verspielt passt.
   *
   * DER DRUCK IST NICHT BETROFFEN (belegt, s. test/messstand/drive-oberlaengen.mjs):
   * `_drawSnapshotText` zeichnet mit `ctx.fillText` auf den Produkt-Canvas, und im
   * gesamten Zeichenpfad steht kein `clip()`. Was überläuft, wird trotzdem gemalt.
   * Es ist also ein Vorschau-Fehler, kein Produktionsfehler.
   *
   * Der Faktor ist deshalb JE SCHRIFT einstellbar statt global — ein globaler
   * Sprung verschöbe die vertikale Lage auf allen Bestandsprodukten (und über die
   * Dreh-Ersatzbox auch im Druck). Präzedenz:
   *   1) `lineHeightFactor` am config.fonts-Eintrag (Section/Config),
   *   2) sonst TEXT_LINE_HEIGHT — damit bleibt jede Bestands-Config unverändert.
   * Unbrauchbare Werte (nicht endlich, ≤ 0) fallen auf den Standard zurück.
   */
  _lineHeightFor(fontDef) {
    const f = Number(fontDef && fontDef.lineHeightFactor);
    return (Number.isFinite(f) && f > 0) ? f : TEXT_LINE_HEIGHT;
  }
  _fontDef(fontId) {
    const list = this.config.fonts || [];
    const byId = list.find((f) => f.id === fontId);
    if (byId) return byId;
    if (typeof fontId !== 'string' || !fontId.trim()) return null;
    const fam = fontId.trim();
    const famLc = fam.toLowerCase();
    const byFamily = list.find((f) => String(f.stack || '').split(',')[0].trim()
      .replace(/^['"]|['"]$/g, '').toLowerCase() === famLc);
    if (byFamily) return byFamily;
    return { id: fam, label: fam, stack: `'${fam.replace(/'/g, '')}'` };
  }
  /** Ist der Schrift-Schritt gerade relevant? Nur wenn mindestens eine Text-Ebene
   *  OHNE eigene feste Schrift Inhalt hat (leere/„Kein Text"-Ebenen zählen nicht) —
   *  ohne Text gibt es nichts, worauf die Schrift wirken könnte. Produkte ohne
   *  Text-Schritte behalten einen konfigurierten Schrift-Schritt unverändert. */
  _fontRelevant() {
    if (!this.texts.length) return true;
    return this.texts.some((t) => !t.font && !this.state.noTexts[t.id] && (this.state.texts[t.id] || '').trim());
  }
  /** Konfigurierte Schritt-Reihenfolge (mit Standard-Fallback). */
  _stepOrder() {
    return (Array.isArray(this.config.steps) && this.config.steps.length)
      ? this.config.steps
      : ['color', 'motif', 'text', 'font', 'print', 'size'];
  }
  /** Enthält die konfigurierte Schritt-Reihenfolge überhaupt einen Schrift-Schritt? */
  _fontStepConfigured() {
    return this._stepOrder().indexOf('font') !== -1;
  }
  /** Schritt-Liste neu rendern, wenn sich die Schrift-Relevanz seit dem letzten
   *  Render geändert hat (Text hinzugefügt/geleert) — Schrift-Schritt taucht
   *  reaktiv auf bzw. verschwindet, der Flow geht sauber zum nächsten Schritt. */
  _syncFontStep() {
    if (this._fontStepConfigured() && this._fontRelevant() !== this._fontShown) this.renderSteps();
  }

  /**
   * Ist die Druckfarbe für das aktuell gewählte Motiv überhaupt wirksam?
   * Vollfarb-Motive (config.fullColorCategories) werden als fertiges Bild
   * gezeichnet, nicht als eingefärbte Maske — die Druckfarbe hat auf sie keine
   * Wirkung. Ohne Motiv bzw. bei „Kein Motiv" bleibt sie relevant: sie färbt
   * weiterhin Text- und Deko-Ebenen ohne eigene Farbe. Fail-safe wie
   * _fontRelevant: im Zweifel sichtbar lassen.
   */
  _printRelevant() {
    if (!this.state.motif || this.state.noMotif) return true;
    return !this._isFullColorMotif(this.state.motif);
  }
  /**
   * Swatch-Schritt mit genau EINER wählbaren Option? Dann ist er keine Auswahl,
   * sondern eine Ansage — „Druckfarbe ändern" mit einer einzigen Kachel ist für den
   * Kunden sinnfrei. Der Schritt wird deshalb nicht angeboten; die eine Farbe gilt
   * trotzdem (state.druckfarbe steht seit dem Konstruktor auf printColors[0].hex,
   * s. o.) und landet unverändert als Property „Druckfarbe" im Warenkorb.
   *
   * GENERISCH, kein Produkt-Sonderfall: Kriterium ist allein die Palettengröße.
   * Der Swatch-Schritt IST im Engine-Modell der print-Schritt (die Section
   * übersetzt type:"choice" + display:"swatch" → "print" + config.printColors);
   * jede Config mit mehr als einer Farbe verhält sich unverändert.
   *
   * Bewusst NICHT über _printRelevant() gelöst: dessen false-Fall (Vollfarb-Motiv)
   * unterdrückt in getProperties zusätzlich die Property — dort ist das richtig
   * (ein vollfarbiges Motiv hat keine Druckfarbe), hier wäre es falsch: die
   * Produktion muss wissen, in welcher Farbe gedruckt wird.
   */
  _printSingleOption() {
    const cols = this.config && this.config.printColors;
    return Array.isArray(cols) && cols.length === 1;
  }
  /**
   * Farb-Achse (config.base.optionName) mit genau EINEM Wert, der gewählt und
   * in der aktuellen Auswahl verfügbar ist (sizeAvailable)? Dann fällt der Farb-Schritt
   * weg — Begründung und Ausnahmen wie _sizeSingleOption (keine Achse → 0 Werte, Regel
   * greift nicht; ausverkauft → Schritt bleibt sichtbar).
   */
  /** Schema v1.32 (config.base.hideSoldOut): ausverkaufte Werte der Farb-/Basis-Achse
   *  erscheinen nicht. Ein Wert gilt als ausverkauft, wenn KEINE seiner Varianten
   *  available ist. Nur mit dem Schalter; ohne ihn liefert _baseWerteSichtbar exakt
   *  _optionValues (gleiche Liste, gleiche Reihenfolge). */
  _baseHideSoldOut() {
    return !!(this.config.base && this.config.base.hideSoldOut === true);
  }
  _baseWertVerfuegbar(v) {
    const ci = this._optionIndex(this.config.base && this.config.base.optionName);
    if (ci < 0) return true;
    return (this.config.variants || []).some((x) => x.options[ci] === v && x.available);
  }
  _baseWerteSichtbar() {
    const vals = this._optionValues(this.config.base && this.config.base.optionName);
    return this._baseHideSoldOut() ? vals.filter((v) => this._baseWertVerfuegbar(v)) : vals;
  }
  /** Alle Werte ausverkauft (nur mit hideSoldOut)? Dann Hinweis statt Kacheln, Kauf gesperrt, Knopf weg. */
  _baseAllesAusverkauft() {
    return this._baseHideSoldOut() && this._optionValues(this.config.base.optionName).length > 0
      && this._baseWerteSichtbar().length === 0;
  }
  _colorSingleOption() {
    const name = this.config.base && this.config.base.optionName;
    const vals = this._optionValues(name);
    if (vals.length !== 1 || this.state.color !== vals[0]) return false;
    // Verfügbarkeit über den bestehenden Leser (aktuelle Farbe + Größe + Zusatzoptionen) —
    // kein neuer Leser von available (Wächter test/huefttasche-textonly-properties.mjs).
    return this.sizeAvailable(this.state.size);
  }
  /**
   * Größen-Achse mit genau EINEM Wert, der auch verfügbar ist? Dann ist der Schritt
   * keine Auswahl, sondern eine Ansage — dieselbe Begründung wie _printSingleOption.
   * Der Schritt wird nicht angeboten; der Wert gilt trotzdem (state.size ist im
   * Konstruktor vorbelegt) und landet unverändert als Property „Größe" im Warenkorb,
   * die Variante bleibt auflösbar.
   *
   * GENERISCH, kein Produkt-Sonderfall: Kriterium ist die Wertezahl der Achse.
   * Zwei bewusste Ausnahmen:
   *  - Achse existiert nicht (Title/Default Title) → Liste LEER (0), Regel greift
   *    nicht; dort gibt es auch nichts auszublenden.
   *  - Die eine Größe ist AUSVERKAUFT → Schritt bleibt sichtbar (und der Kauf
   *    blockiert wie bisher). Sonst sähe ein ausverkauftes Produkt kaufbar aus,
   *    denn _ready() prüft keine Verfügbarkeit — heute schützt allein der
   *    deaktivierte Größen-Knopf.
   */
  _sizeSingleOption() {
    if (this._motifAchse()) {
      // Rasse-Motive: zählt, was es für DIESE Rasse gibt. Ohne Motiv bleibt der Schritt stehen.
      if (!this.state || !this.state.motif) return false;
      const ausf = this._motifAusfuehrungen();
      return ausf.length === 1 && this.state.size === ausf[0];
    }
    const vals = this._optionValues(this.config.size && this.config.size.optionName);
    if (vals.length !== 1) return false;
    const v = this.resolveVariant(this.state.color, vals[0]);
    return !!(v && v.available);
  }
  /** Enthält die konfigurierte Schritt-Reihenfolge überhaupt einen Druckfarben-Schritt? */
  _printStepConfigured() {
    return this._stepOrder().indexOf('print') !== -1;
  }
  /** Gegenstück zu _syncFontStep: Schritt-Liste neu rendern, wenn sich die
   *  Druckfarben-Relevanz seit dem letzten Render geändert hat (Wechsel zwischen
   *  Vollfarb- und einfarbigem Motiv). */
  _syncPrintStep() {
    if (this._printStepConfigured() && this._printRelevant() !== this._printShown) this.renderSteps();
  }

  /** Aktuell gewählter Wert einer Varianten-Option (per Options-NAME) — Quelle
   *  für Layout-Overrides (v2) und defaultBy. Farb-/Größen-Rolle aus dem State,
   *  zusätzliche Optionen (config.extraOptions, z. B. Geschlecht) aus state.options. */
  _selectedOptionValue(optionName) {
    // Schema v1.27 (06.10.2026): Pseudo-Option "_motif" — Layout-Overrides je MOTIV,
    // Bucket-Key = Motiv-Handle (z. B. eigene Namensposition für ein Motiv mit
    // Freifläche in der Mitte). Kein Motiv / „Kein Motiv" → undefined → Default-Layout.
    // Der Unterstrich hält den Namen frei von echten Shopify-Optionsnamen.
    if (optionName === '_motif') return (this.state.motif && !this.state.noMotif) ? this.state.motif.id : undefined;
    if (this.config.base && optionName === this.config.base.optionName) return this.state.color;
    if (this.config.size && optionName === this.config.size.optionName) return this.state.size;
    // Motivseite ist keine echte Varianten-Option, wirkt aber wie eine für Layout-
    // Overrides & defaultBy: ihr gewählter Wert kommt aus state.side. Damit greift der
    // bestehende _layoutLayers-Merge zweiachsig (Geschlecht × Motivseite) ohne Sonderweg.
    if (this.config.sides && optionName === this.config.sides.optionName) return this.state.side;
    return this.state.options ? this.state.options[optionName] : undefined;
  }
  /** Override-Wert zu einem overrides-Gruppennamen (Layout v2): Einzeloption →
   *  _selectedOptionValue unverändert. Kombi-Gruppe "OptA+OptB" (Trenner `+`,
   *  Leerraum um `+` im NAMEN erlaubt) → Join der gewählten Teilwerte in
   *  Gruppen-Reihenfolge; Lookup dann overrides["OptA+OptB"]["wertA+wertB"] —
   *  der WERT-Key muss exakt so gejoint sein, ohne Leerraum. Fehlt ein Teilwert
   *  (Option unbekannt/nichts gewählt), greift die Gruppe nicht.
   *  ACHTUNG: `+` ist damit reserviert. Ein Options-NAME mit echtem `+` wird ab
   *  jetzt als Kombi gedeutet, ein Options-WERT mit `+` macht den Join-Key
   *  mehrdeutig ("a+b"+"c" == "a"+"b+c"). Heute trägt kein Name und kein Wert
   *  ein `+` (Damen/Herren, Vorderseite/Rückseite) — vor Einführung solcher
   *  Werte Trenner wechseln oder escapen. */
  _overrideValue(optName) {
    if (optName.indexOf('+') < 0) return this._selectedOptionValue(optName);
    const parts = optName.split('+').map((n) => this._selectedOptionValue(n.trim()));
    return parts.some((v) => v == null) ? undefined : parts.join('+');
  }
  /** Effektive Layout-Ebenen: layers als Default, darüber FLACH (per Layer, per
   *  Property) der Override des aktuell gewählten Optionswerts aus
   *  layout.overrides[optionName][wert] (Schema v2; optionName darf eine
   *  Kombi-Gruppe "A+B" sein — s. _overrideValue). v1-Configs ohne overrides
   *  geben das layers-Objekt IDENTISCH zurück (kein Kopieren — der Layout-Editor
   *  mutiert es live und bestehende Produkte bleiben byte-identisch). */
  _layoutLayers() {
    // Schema v1.19: Kunden-Overlay auf Ebenen-GRUPPEN (verschiebbares,
    // skalierbares Namensfeld). Dritte Schicht über derselben Naht, durch die
    // schon die Overrides laufen — deshalb folgen Vorschau, Snapshot UND
    // Druckvertrag automatisch, ohne dass einer von ihnen etwas davon weiß.
    return this._applySizeClass(this._applyGroupAdjust(this._layoutLayersRaw()));
  }
  /** Größenklasse je Motiv (Schema v1.35, Silhouetten-Shirt C, 23.10.2026): Motiv-Ebene mit
   *  `sizeClass: {klein: 0.55, mittel: 0.75, gross: 1}` skaliert ihre Box nach motif.groesse
   *  (Katalogfeld). Die Unterkante bleibt (Fußlinie), waagerecht hält `sizeClassAnchorX`
   *  ('left' | 'right', sonst Mitte) die Kante. Ohne sizeClass-Ebene: dasselbe Objekt zurück.
   *  Läuft nach Overrides und Gruppen-Overlay → Vorschau, Snapshot, Leine, Aussparung und
   *  Druckvertrag folgen ohne eigenes Wissen. */
  _applySizeClass(layers) {
    const m = this.state && this.state.motif;
    const kl = m && !this.state.noMotif && typeof m.groesse === 'string' ? m.groesse : '';
    if (!kl) return layers;
    let out = null;
    for (const k in layers) {
      const l = layers[k];
      if (!l || l.type !== 'motif' || !l.sizeClass || typeof l.sizeClass !== 'object') continue;
      const f = Number(l.sizeClass[kl]);
      if (!(f > 0) || f === 1) continue;
      if (!out) out = Object.assign({}, layers);
      const w = Number(l.widthPercent) || 0, h = Number(l.heightPercent != null ? l.heightPercent : 0) || 0;
      const n = Object.assign({}, l, { widthPercent: w * f, heightPercent: h * f, yPercent: (Number(l.yPercent) || 0) + h * (1 - f) });
      if (l.sizeClassAnchorX === 'left') n.xPercent = (Number(l.xPercent) || 0) - (w * (1 - f)) / 2;
      else if (l.sizeClassAnchorX === 'right') n.xPercent = (Number(l.xPercent) || 0) + (w * (1 - f)) / 2;
      out[k] = n;
    }
    return out || layers;
  }
  /** Blatt des Druckvertrags je Option (Schema v1.35, Druckbreite je Größe): layout.overrides
   *  [<Option oder Kombi>][<Wert>]._blatt wird flach über config.print.blatt gelegt
   *  (buehneBreiteMm setzt den Maßstab, dazu Blattmaß und -lage). Die Bühne bleibt unberührt —
   *  _layoutLayersRaw überspringt den Schlüssel. Ohne _blatt: dasselbe Objekt. */
  _blattNachOption(bl) {
    const ov = this.config.layout && this.config.layout.overrides;
    if (!ov || typeof ov !== 'object') return bl;
    let out = bl;
    for (const optName in ov) {
      const val = this._overrideValue(optName);
      const e = (val != null && ov[optName]) ? ov[optName][val] : null;
      if (e && e._blatt && typeof e._blatt === 'object') out = Object.assign({}, out, e._blatt);
    }
    return out;
  }
  /** Ebenen NACH den Options-Overrides, aber OHNE das Gruppen-Overlay. Basis
   *  für die Klemmung: sie muss einen hypothetischen Zustand durchrechnen,
   *  bevor er übernommen wird. */
  _layoutLayersRaw() {
    const lay = this.config.layout || {};
    const base = lay.layers || {};
    const ovAll = lay.overrides;
    let out = null;
    if (ovAll && typeof ovAll === 'object') {
      for (const optName in ovAll) {
        const val = this._overrideValue(optName);
        const ov = (val != null && ovAll[optName]) ? ovAll[optName][val] : null;
        if (!ov || typeof ov !== 'object') continue;
        if (!out) {
          out = {};
          for (const k in base) out[k] = Object.assign({}, base[k]);
        }
        for (const lk in ov) {
          if (!ov[lk] || typeof ov[lk] !== 'object') continue;
          if (lk === '_blatt') continue;   // Druckblatt je Option (_blattNachOption), keine Ebene
          out[lk] = Object.assign({}, out[lk] || {}, ov[lk]);
        }
      }
    }
    return out || base;
  }
  /** Gruppen-Definitionen (`layout.groups`) — {} bei Configs ohne Gruppen. */
  _groupDefs() {
    const g = this.config.layout && this.config.layout.groups;
    return (g && typeof g === 'object') ? g : {};
  }
  /** Aktueller Kundenzustand einer Gruppe, auf die Definition zurückfallend.
   *  {xPercent, yPercent, scale} — der Anker ist die Gruppen-MITTE. */
  _groupState(gid) {
    const def = this._groupDefs()[gid];
    if (!def) return null;
    const a = def.anchor || {};
    const st = (this.state.groupAdjust && this.state.groupAdjust[gid]) || null;
    return {
      xPercent: st && st.xPercent != null ? st.xPercent : (Number(a.xPercent) || 50),
      yPercent: st && st.yPercent != null ? st.yPercent : (Number(a.yPercent) || 50),
      scale: st && st.scale != null ? st.scale : 1,
    };
  }
  /**
   * Gruppen-Overlay auf die Ebenen rechnen. Jede Ebene mit `group:"<id>"` wird
   * gegen den DEFINIERTEN Anker verschoben und skaliert:
   *   x' = zustand.x + (x − anker.x) · s        w' = w · s
   * Ohne `layout.groups` oder ohne abweichenden Zustand wird das Objekt
   * unverändert zurückgegeben — Bestands-Configs sind damit byte-gleich.
   */
  _applyGroupAdjust(layers) {
    const defs = this._groupDefs();
    let out = null;
    for (const gid in defs) {
      const def = defs[gid];
      const a = def.anchor || {};
      const ax = Number(a.xPercent) || 0, ay = Number(a.yPercent) || 0;
      const st = this._groupState(gid);
      // Nichts zu tun, solange der Kunde den Standard nicht verlassen hat.
      if (st.scale === 1 && st.xPercent === ax && st.yPercent === ay) continue;
      for (const key in layers) {
        const l = layers[key];
        if (!l || l.group !== gid) continue;
        if (!out) { out = {}; for (const k in layers) out[k] = Object.assign({}, layers[k]); }
        const b = layers[key], s = st.scale;
        const n = out[key];
        n.xPercent = st.xPercent + ((Number(b.xPercent) || 0) - ax) * s;
        n.yPercent = st.yPercent + ((Number(b.yPercent) || 0) - ay) * s;
        if (b.widthPercent != null) n.widthPercent = Number(b.widthPercent) * s;
        if (b.heightPercent != null) n.heightPercent = Number(b.heightPercent) * s;
        if (b.fontSizePercent != null) n.fontSizePercent = Number(b.fontSizePercent) * s;
        if (b.minFontSizePercent != null) n.minFontSizePercent = Number(b.minFontSizePercent) * s;
      }
    }
    return out || layers;
  }
  /** Signatur der Gruppen-Zustände — wie _layoutSignature, aber für das
   *  Kunden-Overlay. `null` (kein Nachschreiben) bei Configs ohne Gruppen,
   *  damit Bestandsprodukte den Block gar nicht erst betreten. */
  _groupSignature() {
    const defs = this._groupDefs();
    let leer = true, sig = '';
    for (const gid in defs) {
      leer = false;
      const st = this._groupState(gid);
      sig += gid + '|' + st.xPercent + ',' + st.yPercent + ',' + st.scale + '#';
    }
    return leer ? null : sig;
  }
  /** Bedruckbare Fläche in Bühnen-Prozent. Die Bühne ist quadratisch (600 mm
   *  Kante); die Matte liegt darin als 600×`designHeightMm` zentriert — bei
   *  400 mm also y 16,67…83,33 %. */
  _matBoundsPct() {
    const DW = 600;
    const DH = Number((this.config.photo || {}).designHeightMm) || 400;
    const off = ((DW - DH) / 2 / DW) * 100;
    return { x0: 0, y0: off, x1: 100, y1: 100 - off };
  }
  /**
   * Sicherheitszone in Bühnen-Prozent — die Fläche, in der Tinte landen DARF.
   * Die äußersten Millimeter der Matte sind Gummirand und Anschnitt: was dort
   * liegt, verschwindet im Rand oder wird angeschnitten. Die Mattenfläche
   * (_matBoundsPct) ist deshalb NICHT die bedruckbare Fläche.
   *
   * Vorgabe 20 mm (Layout-Prüfung 31.08.2026). Auf der 600-mm-Bühne sind
   * 20 mm = 3,333 % — daraus x 3,33…96,67 % und, bei 400 mm Mattenhöhe,
   * y 20…80 %. Je Produkt über `customizer_layout.safeInsetMm` änderbar;
   * 0 schaltet die Zone ab und stellt das bisherige Verhalten (Mattenkante)
   * wieder her.
   *
   * Der Deckel auf die halbe Mattenfläche fängt einen absurden Wert ab: ohne
   * ihn schlüge die Zone um, und die Klemmung setzte jede Gruppe kommentarlos
   * in die Mitte.
   */
  _safeBoundsPct() {
    const m = this._matBoundsPct();
    const roh = (this.config.layout || {}).safeInsetMm;
    const n = Number(roh);
    const mm = (roh != null && Number.isFinite(n) && n >= 0) ? n : 20;
    const p = (mm / 600) * 100;
    const px = Math.min(p, (m.x1 - m.x0) / 2 - 0.01);
    const py = Math.min(p, (m.y1 - m.y0) / 2 - 0.01);
    return { x0: m.x0 + px, y0: m.y0 + py, x1: m.x1 - px, y1: m.y1 - py };
  }
  /**
   * Umschließendes Rechteck einer Gruppe (Bühnen-%) für einen HYPOTHETISCHEN
   * Zustand. Bewusst die Vereinigung ALLER Mitglieder: der Name darf breiter
   * sein als das Banner, und dann zählt der Name.
   * Zwei Feinheiten, ohne die die Klemmung falsch klemmt:
   *  · Text hat keine `heightPercent` — seine Höhe ist die Zeilenhöhe
   *    (fontSizePercent × _lineHeightFor), genau wie im Vertrag.
   *  · `inkInset` (Ränder der sichtbaren Tinte in % der Box) zieht die Box auf
   *    das ein, was man WIRKLICH sieht. Ohne das könnte ein PNG mit viel
   *    transparentem Rand — wie das Banner: nur 50,6 % der Höhe sind Tinte —
   *    nie an den Mattenrand geschoben werden.
   */
  _groupUnionPct(gid, st) {
    const layers = this._layoutLayersRaw();
    const def = this._groupDefs()[gid];
    if (!def) return null;
    const a = def.anchor || {};
    const ax = Number(a.xPercent) || 0, ay = Number(a.yPercent) || 0;
    const s = st.scale;
    let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    for (const key in layers) {
      const b = layers[key];
      if (!b || b.group !== gid) continue;
      const cx = st.xPercent + ((Number(b.xPercent) || 0) - ax) * s;
      const cy = st.yPercent + ((Number(b.yPercent) || 0) - ay) * s;
      const w = (Number(b.widthPercent) || 0) * s;
      let h;
      if (b.type === 'text') {
        const font = this._fontDef(b.font || this.state.font);
        h = (Number(b.fontSizePercent) || 0) * s * this._lineHeightFor(font);
      } else {
        h = (Number(b.heightPercent) || 0) * s;
      }
      const top = (b.valign === 'middle') ? cy - h / 2 : cy;
      let bx0 = cx - w / 2, bx1 = cx + w / 2, by0 = top, by1 = top + h;
      const ins = b.inkInset;
      if (ins && typeof ins === 'object') {
        bx0 += ((Number(ins.left) || 0) / 100) * w;
        bx1 -= ((Number(ins.right) || 0) / 100) * w;
        by0 += ((Number(ins.top) || 0) / 100) * h;
        by1 -= ((Number(ins.bottom) || 0) / 100) * h;
      }
      if (bx0 < x0) x0 = bx0;
      if (bx1 > x1) x1 = bx1;
      if (by0 < y0) y0 = by0;
      if (by1 > y1) y1 = by1;
    }
    return (x0 === Infinity) ? null : { x0, y0, x1, y1 };
  }
  /** Zustand auf Skalierungsgrenzen UND auf die Mattenfläche klemmen. Passt die
   *  Gruppe nicht mehr hinein (sehr große Skalierung), wird sie mittig gesetzt —
   *  Überstand nach beiden Seiten ist besser als einseitig abgeschnitten. */
  _clampGroupAdjust(gid, want) {
    const def = this._groupDefs()[gid];
    if (!def) return null;
    const a = def.anchor || {};
    const min = Number(def.minScale) > 0 ? Number(def.minScale) : 0.5;
    const max = Number(def.maxScale) > 0 ? Number(def.maxScale) : 2;
    const num = (v, fb) => (Number.isFinite(Number(v)) ? Number(v) : fb);
    const st = {
      xPercent: num(want && want.xPercent, Number(a.xPercent) || 50),
      yPercent: num(want && want.yPercent, Number(a.yPercent) || 50),
      scale: Math.max(min, Math.min(max, num(want && want.scale, 1))),
    };
    if (def.clamp === false) return st;
    const u = this._groupUnionPct(gid, st);
    if (!u) return st;
    // Geklemmt wird gegen die SICHERHEITSZONE, nicht gegen die Mattenkante:
    // sonst darf der Kunde die Gruppe bis auf 0 mm an den Rand schieben (am
    // Live-Layout gemessen, 31.08.2026), und der Renderer-Guard fällt das erst
    // bei der Bestellung auf.
    const m = this._safeBoundsPct();
    const schieben = (u0, u1, m0, m1) => {
      if (u1 - u0 > m1 - m0) return (m0 + m1) / 2 - (u0 + u1) / 2;
      if (u0 < m0) return m0 - u0;
      if (u1 > m1) return m1 - u1;
      return 0;
    };
    st.xPercent += schieben(u.x0, u.x1, m.x0, m.x1);
    st.yPercent += schieben(u.y0, u.y1, m.y0, m.y1);
    return st;
  }
  /**
   * ÖFFENTLICH (Bedienmodul ttg-namensfeld.js): Zustand einer Gruppe setzen.
   * Klemmt immer, schreibt in den State und zeichnet die Vorschau neu.
   * Rückgabe: der tatsächlich übernommene (geklemmte) Zustand — das Modul
   * richtet seinen Griff danach aus, statt den Wunschwert zu glauben.
   */
  setGroupAdjust(gid, want) {
    if (!this._groupDefs()[gid]) return null;
    const st = this._clampGroupAdjust(gid, want);
    if (!this.state.groupAdjust) this.state.groupAdjust = {};
    this.state.groupAdjust[gid] = st;
    // Headless nutzbar (wie composeXsellLine): ohne Mount gibt es nichts zu
    // zeichnen — die Rechnung oben ist der eigentliche Zweck.
    if (this.refs && this.refs.base) this.renderPreview();
    this.emit('groupAdjusted', { group: gid, state: Object.assign({}, st) });
    return st;
  }
  /** ÖFFENTLICH: Zustand einer Gruppe lesen (Standard, solange nichts gesetzt). */
  getGroupAdjust(gid) { return this._groupState(gid); }
  /** ÖFFENTLICH: Gruppe auf den konfigurierten Standard zurücksetzen. */
  resetGroupAdjust(gid) {
    if (this.state.groupAdjust) delete this.state.groupAdjust[gid];
    if (this.refs && this.refs.base) this.renderPreview();
    this.emit('groupAdjusted', { group: gid, state: this._groupState(gid) });
    return this._groupState(gid);
  }
  /** Signatur der aktuell override-relevanten Optionswerte (Layout v2). Ändert
   *  sie sich, muss renderPreview die Layer-Boxen einmal nachschreiben; bleibt sie
   *  gleich (jeder Text-Tastenanschlag), entfällt jeder Box-Write. v1-Configs ohne
   *  overrides → null → renderPreview überspringt das Nachschreiben komplett. */
  _layoutSignature() {
    const ov = this.config.layout && this.config.layout.overrides;
    const gk = this._sizeClassSignature();
    if (!ov || typeof ov !== 'object') return gk || null;
    // Trenner |/# gegen Wert-Kollisionen ("AB|C" vs "A|BC").
    let sig = '';
    for (const optName in ov) sig += optName + '|' + this._overrideValue(optName) + '#';
    return sig + gk;
  }
  /** Teil-Signatur der Größenklasse (Schema v1.35): '' ohne sizeClass-Ebene (Bestand unverändert),
   *  sonst die Klasse des gewählten Motivs — ein Rassewechsel schreibt die Boxen dann neu. */
  _sizeClassSignature() {
    const ls = this.config.layout && this.config.layout.layers;
    if (!ls) return '';
    for (const k in ls) {
      if (ls[k] && ls[k].type === 'motif' && ls[k].sizeClass) {
        const m = this.state && this.state.motif;
        return 'gk|' + ((m && !this.state.noMotif && m.groesse) || '') + '#';
      }
    }
    return '';
  }

  /** Primärer Def zu einem (ggf. sekundären) Def — für „gehören zur selben Sektion?". */
  _primaryFor(def) {
    if (!def || !def.secondary) return def || null;
    const i = this.texts.indexOf(def);
    // position:'before' bindet VORWÄRTS an den nächsten primären Def —
    // spiegelbildlich zu _secondariesVor (Phase 7).
    if (def.position === 'before') {
      for (let j = i + 1; j < this.texts.length; j++) {
        if (!this.texts[j].secondary) return this.texts[j];
      }
      return null;
    }
    for (let j = i - 1; j >= 0; j--) {
      if (!this.texts[j].secondary) return this.texts[j];
    }
    return null;
  }
  /** Layout-Ebene eines Text-Defs: layers[def.layer] → layers[def.id] →
   *  erste text-Ebene mit source == def.id (Schema v1.17: der Layer-Key darf
   *  vom Step abweichen, source nennt dann den speisenden Step) → (Ein-Text)
   *  erste type-'text'-Ebene. */
  /** Schema v1.28 (14.10.2026, Tassen Engine Teil 3): Schrift je Text-EBENE. Eine Text-Ebene darf
   *  `textFont` (Font-ID oder Familienname wie def.font) tragen — gesetzt über layout.overrides._motif
   *  (je Motiv) oder overrides[<Option>] (je Design). Reihenfolge: Ebene vor Text-Schritt vor globaler
   *  Auswahl. Ohne textFont exakt wie bisher (def.font || state.font). Bewusst ein eigener Schlüssel:
   *  `color` an Text-Ebenen gibt es im Bestand (Fußmatte Foto-Banner) und darf nichts umschalten. */
  _textFontId(def) {
    const l = (def && this.state) ? this._textLayer(def) : null;   // Konstruktor: state fehlt noch
    return (l && l.textFont) || (def && def.font) || (this.state && this.state.font);
  }
  /** Schema v1.28: aufgelöste Schrift der Text-Ebene (textFont, s. o.). `textLineHeight` (> 0) an der
   *  Ebene überschreibt den lineHeightFactor der Schrift nur für diese Ebene — so bleibt die Zeilenhöhe
   *  je Design die der freigegebenen Probe, auch wenn sich mehrere Designs eine Schrift teilen. */
  _textFont(def) {
    const l = (def && this.state) ? this._textLayer(def) : null;
    const fd = this._fontDef(this._textFontId(def));
    const lh = l ? Number(l.textLineHeight) : NaN;
    return (fd && Number.isFinite(lh) && lh > 0) ? Object.assign({}, fd, { lineHeightFactor: lh }) : fd;
  }
  /** Schema v1.28: Schriftfarbe je Text-Ebene (`textColor`), sonst def.color — wie textFont. */
  _textColorOf(def) {
    const l = (def && this.state) ? this._textLayer(def) : null;
    return (l && l.textColor) || (def && def.color) || null;
  }
  _textLayer(def) {
    const layers = this._layoutLayers();
    if (def.layer && layers[def.layer]) return layers[def.layer];
    if (layers[def.id] && layers[def.id].type === 'text') return layers[def.id];
    for (const key in layers) {
      const l = layers[key];
      if (l && l.type === 'text' && l.source === def.id) return l;
    }
    if (def._legacy || this.texts.length === 1) return this._findLayer(layers, 'text');
    return null;
  }
  /** Matcht eine Variante gegen die gewählten Werte ALLER extraOptions
   *  (z. B. Geschlecht). Ohne extraOptions immer true — Warnweste unberührt. */
  _extraMatch(v) {
    for (const xo of this.extraOptions) {
      const val = this.state.options ? this.state.options[xo.optionName] : null;
      const xi = this._optionIndex(xo.optionName);
      if (xi >= 0 && val != null && v.options[xi] !== val) return false;
    }
    return true;
  }
  /** extraOptions-Definition zu einem Schritt-Key 'vo:<id>' (oder null). */
  _extraDef(key) {
    if (typeof key !== 'string' || key.indexOf('vo:') !== 0) return null;
    const id = key.slice(3);
    return this.extraOptions.find((o) => o.id === id) || null;
  }
  /** Zusatzartikel-Definition zu einem Schritt-Key 'addon:<id>' (oder null). */
  _addonDef(key) {
    if (typeof key !== 'string' || key.indexOf('addon:') !== 0) return null;
    const id = key.slice(6);
    return this.addons.find((a) => a.id === id) || null;
  }
  /** Angebotene Zusatzartikel: mit hideSoldOut nur lieferbare (ausverkaufte Farben ausgeblendet). */
  _addonItems(ad) {
    return (ad.items || []).filter((it) => it && it.variantId != null && (ad.hideSoldOut !== true || it.available !== false));
  }
  /**
   * Gewählte Zusatzartikel als Warenkorbzeilen [{variantId, quantity, addonId}]. „Keine“ (null)
   * und inzwischen nicht mehr angebotene Varianten liefern nichts. Der Theme-Adapter legt sie nach
   * dem Haupt-Add als EIGENE Zeilen ohne _ttg_group an — die Konfigurationszeile bleibt unberührt.
   */
  getAddons() {
    const out = [];
    for (const ad of this.addons) {
      const vid = this.state.addons ? this.state.addons[ad.id] : null;
      if (vid == null || vid === '') continue;
      const it = this._addonItems(ad).find((x) => String(x.variantId) === String(vid));
      if (!it) continue;
      out.push({ variantId: it.variantId, quantity: 1, addonId: ad.id, label: it.label || '' });
    }
    return out;
  }
  /** Kachelreihe eines Zusatzartikel-Schritts: „Keine“ + je Variante Bild, Name, Preis (Streichpreis). */
  _addonRow(ad) {
    const cur = this.state.addons ? this.state.addons[ad.id] : null;
    const none = `
        <button type="button" class="ttg-vc ttg-addon__none" data-action="addon" data-addon="${escapeHtml(ad.id)}" data-v="" aria-pressed="${cur == null}">
          <span class="ttg-vc__dot" style="background:#fff"></span>
          <small>${escapeHtml(ad.noneLabel || 'Keine')}</small>
        </button>`;
    const tiles = this._addonItems(ad).map((it) => {
      const marke = it.image
        ? `<img class="ttg-vc__img" src="${escapeHtml(it.image)}" alt="" loading="lazy" decoding="async">`
        : `<span class="ttg-vc__dot" style="background:#ddd"></span>`;
      const preis = it.price != null
        ? `<small class="ttg-addon__price">${escapeHtml(formatMoneyEUR(it.price))}${it.compareAt && it.compareAt > it.price ? ` <s>${escapeHtml(formatMoneyEUR(it.compareAt))}</s>` : ''}</small>`
        : '';
      return `
        <button type="button" class="ttg-vc" data-action="addon" data-addon="${escapeHtml(ad.id)}" data-v="${escapeHtml(String(it.variantId))}" aria-pressed="${String(cur) === String(it.variantId)}">
          ${marke}
          <small>${escapeHtml(it.label || '')}</small>${preis}
        </button>`;
    }).join('');
    return `<div class="ttg-swrow ttg-swrow--img ttg-addon">${none}${tiles}</div>`;
  }
  _bodyAddon(ad) {
    const q = ad.question ? `<div class="ttg-q">${escapeHtml(ad.question)}</div>` : '';
    return q + this._addonRow(ad);
  }
  /** Findet die Variante zur aktuellen Farbe+Größe (Optionsreihenfolge dynamisch). */
  resolveVariant(color = this.state.color, size = this.state.size) {
    const ci = this._optionIndex(this.config.base.optionName);
    const si = this._optionIndex(this.config.size.optionName);
    // Fehlt eine Option (Index < 0), wird sie beim Matching übersprungen —
    // z. B. Produkte ohne Farboption werden nur über die Größe aufgelöst.
    // Zusätzliche Optionen (Geschlecht etc.) müssen ebenfalls passen.
    return this.config.variants.find((v) => (
      (ci < 0 || v.options[ci] === color) && (si < 0 || v.options[si] === size) && this._extraMatch(v)
    )) || null;
  }
  /** Verfügbarkeit einer Größe bei aktueller Farbe. */
  sizeAvailable(size) {
    const v = this.resolveVariant(this.state.color, size);
    return !!(v && v.available);
  }
  currentPriceCents() {
    const v = this.resolveVariant();
    if (v) return v.price;
    // Fallback: günstigste Variante der Farbe / des Produkts
    const any = this.resolveVariant(this.state.color, this._optionValues(this.config.size.optionName)[0])
      || this.config.variants[0];
    return any ? any.price : 0;
  }

  /* ------------------------------------------------------------ Preislogik */
  // Alle (für die aktuelle Farbe relevanten) Variantenpreise. Generisch aus config.variants.
  _relevantVariants() {
    const ci = this._optionIndex(this.config.base.optionName);
    let vs = (ci < 0 || !this.state.color)
      ? this.config.variants.slice()
      : this.config.variants.filter((v) => v.options[ci] === this.state.color);
    // Zusätzliche Optionen einengen (z. B. nur Damen-Varianten) — ohne
    // extraOptions ist _extraMatch immer true (kein Verhaltensdrift).
    if (this.extraOptions.length) vs = vs.filter((v) => this._extraMatch(v));
    return vs;
  }
  _pricesUniform() {
    const ps = this._relevantVariants().map((v) => v.price);
    return ps.length === 0 || ps.every((p) => p === ps[0]);
  }
  _minPriceVariant() {
    const vs = this._relevantVariants();
    return vs.reduce((min, v) => (min == null || v.price < min.price ? v : min), null);
  }
  /** Preis-HTML (Verkaufspreis + optionaler Streichpreis) für einen Cent-Betrag. */
  _priceHtml(cents, compareCents) {
    const price = formatMoneyEUR(cents);
    if (compareCents && compareCents > cents) {
      return `<span class="ttg__price ttg__price--sale">${price}</span> <s class="ttg__compare">${formatMoneyEUR(compareCents)}</s>`;
    }
    return `<span class="ttg__price">${price}</span>`;
  }
  /** Header-Preis: gewählte Variante, sonst „ab [Minimum]" bei unterschiedlichen Preisen. */
  _renderPrice() {
    if (!this.refs.price) return;
    const sel = this.resolveVariant();
    let html;
    if (sel) {
      html = this._priceHtml(sel.price, sel.compareAtPrice);
    } else if (this._pricesUniform()) {
      const v = this._minPriceVariant() || this.config.variants[0];
      html = v ? this._priceHtml(v.price, v.compareAtPrice) : '';
    } else {
      const v = this._minPriceVariant();
      if (this.config.priceStartCheapest) {
        // Startpreis = günstigste Variante inkl. Streichpreis (kein „ab").
        html = v ? this._priceHtml(v.price, v.compareAtPrice) : '';
      } else {
        // Default: „ab [Minimum]" bei unterschiedlichen Preisen.
        const prefix = (this.config.strings && this.config.strings.price_from) || 'ab ';
        html = v ? `<span class="ttg__price">${escapeHtml(prefix)}${formatMoneyEUR(v.price)}</span>` : '';
      }
    }
    this.refs.price.innerHTML = html;
  }

  /* ------------------------------------------------------------------ Mount */
  mount(root) {
    this.root = root;
    const previewHtml = this._previewLayersHtml();

    const pv = root.querySelector('[data-ttg-preview]');
    const st = root.querySelector('[data-ttg-steps]');
    const by = root.querySelector('[data-ttg-buy]');
    const sk = root.querySelector('[data-ttg-sticky]');

    if (pv && st) {
      // Skeleton-Modus: die Section liefert das Layout, die Engine füllt nur die
      // Mount-Punkte (Vorschau, Schritte, Kaufbereich, optionaler Sticky-CTA).
      // Teil 3 (SSR-LCP): Hat die Section das Basis-<img> bereits server-gerendert
      // (Preload-Scanner sieht das LCP-Bild beim HTML-Parsing, nicht erst nach dem
      // Mount), NUR die Overlay-Ebenen dazusetzen und das vorhandene <img> ADOPTIEREN
      // — nie ersetzen (sonst Doppel-Fetch/Flash). renderPreview lässt es dank
      // passendem data-ttg-basesrc unangetastet. Sonst (kein SSR) alle Ebenen bauen.
      const ssrBase = pv.querySelector('[data-ttg="base"]');
      if (ssrBase) ssrBase.insertAdjacentHTML('afterend', this._overlayLayersHtml());
      else pv.innerHTML = previewHtml;
      if (by) by.innerHTML = this._buyHtml();
      if (sk) sk.innerHTML = this._stickyHtml();
      this.refs = {
        base: pv.querySelector('[data-ttg="base"]'),
        motif: pv.querySelector('[data-ttg="motif"]'),
        steps: st, buy: by || null, sticky: sk || null
      };
      this._collectTextRefs(pv);
    } else {
      // Fallback: komplette Standard-Schale (zweispaltig).
      root.innerHTML = `
        <div class="ttg">
          <div class="ttg__preview-col"><div class="ttg__preview" data-ttg-preview>${previewHtml}</div></div>
          <div class="ttg__main-col">
            <div class="ttg__steps" data-ttg-steps></div>
            <div class="ttg__buy" data-ttg-buy>${this._buyHtml()}</div>
          </div>
        </div>`;
      this.refs = {
        base: root.querySelector('[data-ttg="base"]'),
        motif: root.querySelector('[data-ttg="motif"]'),
        steps: root.querySelector('[data-ttg-steps]'),
        buy: root.querySelector('[data-ttg-buy]'), sticky: null
      };
      this._collectTextRefs(root);
    }

    this.refs.addBtn = (this.refs.buy || root).querySelector('[data-ttg="add"]');
    this.refs.qtyInput = (this.refs.buy || root).querySelector('[data-ttg="qty"]');
    this.refs.stickyBtn = this.refs.sticky ? this.refs.sticky.querySelector('[data-ttg="add"]') : null;
    // Optionaler Preis-Mount im Header (Section) — Engine aktualisiert ihn variantenabhängig.
    this.refs.price = root.querySelector('[data-ttg-price]');

    const live = document.createElement('div');
    live.className = 'visually-hidden';
    live.setAttribute('aria-live', 'polite');
    root.appendChild(live);
    this.refs.live = live;

    this._bind();
    this.renderSteps();
    this.renderPreview();

    // Deep-Link ?ttg-motif, inline aufgelöst (Flag aus dem Konstruktor): erst hier
    // gibt es refs.steps, also erst hier kann gescrollt werden. Einmalig — das Flag
    // wird verbraucht, ein späterer Re-Mount springt nicht erneut.
    if (this._urlMotifScroll) { this._urlMotifScroll = false; this._scrollToMotifCard(); }

    // Motiv-Seiten 2..n nachladen (Liquid rendert max. 250 Referenzen pro Seite),
    // danach Deep-Links anwenden (?motiv=<handle> / ?intent=<gruppe>) — deren Ziel
    // kann auf einer Nachlade-Seite liegen. Fehlertolerant: jeder Fehlschlag fällt
    // still auf den normalen Dialog zurück.
    this._loadMoreMotifs()
      .then(() => this._applyDeepLink())
      .catch((e) => console.warn('[ttg] Motiv-Nachladen/Deep-Link:', e && e.message));

    // Druckschriften früh anfordern (ohne zu warten): der Snapshot prüft sie vor
    // dem Zeichnen: ist sie dann schon da, kostet der Gate 0 ms und die
    // bestehende 1,5-s-Schranke beim Add-to-Cart bleibt unberührt.
    this._warmSnapshotFonts();

    // Globaler Motiv-Katalog (#14): lazy — NACH dem load-Event + Idle vorgeladen, damit
    // die 229-KB-Datei nie mit kritischen Ressourcen (Fonts, LCP-Bild, engine.js) um
    // Bandbreite/Main-Thread konkurriert (raus aus dem kritischen Pfad). Das auto-offene
    // Grid malt derweil aus den Inline-Motiven (Default + Featured, _bodyMotif); eine
    // frühere Interaktion (Suche/„alle anzeigen") stößt den Katalog sofort an. Der
    // Kaufpfad wartet NIE auf ihn: Default-Motiv inline, Add-to-Cart/Vorschau unabhängig.
    if (this.config.motifsCatalog && this.config.motifsCatalog.url && typeof window !== 'undefined') {
      const prefetch = () => {
        // {timeout} deckelt die Idle-Wartezeit: unter Dauerlast / im Hintergrund-Tab
        // kann requestIdleCallback sonst beliebig lange aufgeschoben werden und der
        // Katalog bliebe (ohne Interaktion) ungeladen. Nach spätestens 2 s zieht er.
        if (window.requestIdleCallback) window.requestIdleCallback(() => this._ensureCatalog(), { timeout: 2000 });
        else setTimeout(() => this._ensureCatalog(), 400);
      };
      if (document.readyState === 'complete') prefetch();
      else window.addEventListener('load', prefetch, { once: true });
      // Motivbuch-Deep-Link wartet auf den Katalog (?ttg-motif geparkt, Default
      // unterdrückt): sofort laden statt load+idle, damit das Zielmotiv schnellst-
      // möglich in der Vorschau steht. Nur param-gated — ohne Parameter unverändert.
      if (this._urlMotifPending) this._ensureCatalog();
    }

    // Vorschau-Backend (Railway) beim Laden leise vorwärmen, damit der spätere
    // Hintergrund-Upload nach dem Add nicht der Aufwärm-Fall ist (Cold-Start).
    this._prewarmPreviewBackend();

    // Mobile: schwebende Mini-Vorschau, wenn die Bühne aus dem Viewport scrollt.
    // Nice-to-have, hart isoliert: ein Fehler hier darf den Mount NIE nach außen
    // propagieren — die Engine gilt auch ohne Mini-Vorschau als gemountet, der
    // Kaufpfad (Personalisierungs-Payload) hängt nicht an ihr.
    try { this._initMiniPreview(); } catch (e) {
      console.warn('[ttg] Mini-Vorschau deaktiviert (Mount unberührt):', e && e.message);
    }
  }

  /* --------------------------------------- Mobile: schwebende Mini-Vorschau */
  /**
   * Scrollt die große Bühne auf Mobile aus dem Viewport, wandert der LIVE-
   * Vorschau-Knoten (dieselbe DOM-Instanz — kein Klon, keine zweite Engine)
   * per appendChild in einen fixierten PiP-Wrapper und beim Zurückscrollen
   * wieder an seinen Platz. Der ResizeObserver aus _bind() beobachtet genau
   * diesen Knoten und rechnet das Text-Fitting im kleinen Container neu.
   *
   * - Auslöser: IntersectionObserver auf dem STATIONÄREN Eltern-Element der
   *   Vorschau (die Vorschau selbst wandert ja — sie zu beobachten ergäbe eine
   *   Endlosschleife). Hysterese: raus erst bei 0 % Sichtbarkeit, rein erst ab
   *   35 % — plus Debounce gegen Flackern am Schwellwert.
   * - Drag: Pointer Events + setPointerCapture; während des Ziehens ändert sich
   *   ausschließlich transform (translate3d), nie top/left/width/height.
   * - Pinch-Peek: zwei Finger zoomen die Kachel temporär (max. 2,5×) — reines
   *   transform: scale() auf dem Wrapper, KEINE width/height-Änderung: bleibt
   *   auf der Compositor-Ebene und triggert bewusst NICHT den ResizeObserver
   *   bzw. das Text-Fitting (kein Layout-Thrashing). Beim Loslassen federt die
   *   Kachel auf 1× zurück; Pointer-Anzahl trennt Drag (1) und Pinch (2), der
   *   Drag pausiert währenddessen.
   * - Loslassen: horizontal an den nächstgelegenen Rand einrasten, vertikal
   *   innerhalb sicherer Grenzen clampen (--ttg-mini-inset-top hält die Kachel
   *   unter dem Sticky-Header; setzt der Theme-Adapter). Position überlebt das
   *   Umhängen in sessionStorage.
   * - Nur Mobile (< 750px, gleicher Breakpoint wie das CSS-Grid).
   */
  _initMiniPreview() {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;
    const preview = this.refs.base && this.refs.base.parentElement;
    const home = preview && preview.parentElement;   // .ttg__stage — bleibt im Fluss
    if (!preview || !home) return;

    const mq = window.matchMedia('(max-width: 749px)');
    const MARGIN = 10;
    const POS_KEY = 'ttg:miniPos';
    const mini = { active: false, wrap: null, drag: null, pinch: null, gesture: null, scale: 1, x: 0, y: 0, w: 0, h: 0, raf: 0, t: 0 };
    this._mini = mini;
    const MAX_ZOOM = 2.5;
    const pts = new Map();                            // aktive Pointer: 1 = Drag, 2 = Pinch
    // Abstand der ersten beiden Finger; || 1 gegen Division durch 0 (gleicher Punkt).
    const dist = () => { const p = Array.from(pts.values()); return Math.hypot(p[1].x - p[0].x, p[1].y - p[0].y) || 1; };

    const clamp = (v, lo, hi) => Math.min(Math.max(v, lo), Math.max(lo, hi));
    // iOS/Android: bei offener Bildschirmtastatur schiebt der Browser den VISUAL
    // viewport gegen den LAYOUT viewport. `position: fixed` hängt am Layout-Viewport
    // — beim Scrollen mit offener Tastatur wanderte die Kachel deshalb sichtbar nach
    // oben aus dem Bild. visualViewport liefert Größe UND Versatz des sichtbaren
    // Ausschnitts: danach wird geclampt (vpW/vpH) und der Versatz in die transform
    // gerechnet (vvX/vvY), damit die Kachel am SICHTBAREN Rand klebt. Ohne
    // visualViewport (alte Browser) fällt alles auf das bisherige Verhalten zurück.
    const vv = window.visualViewport || null;
    const vpW = () => (vv ? vv.width : window.innerWidth);
    const vpH = () => (vv ? vv.height : window.innerHeight);
    const vvX = () => (vv ? vv.offsetLeft : 0);
    const vvY = () => (vv ? vv.offsetTop : 0);
    // Obere Sperrzone (Sticky-Header) kommt als CSS-Variable vom Theme-Adapter.
    const insetTop = () => {
      const raw = parseFloat(getComputedStyle(mini.wrap).getPropertyValue('--ttg-mini-inset-top'));
      return Number.isFinite(raw) && raw > 0 ? raw : MARGIN;
    };
    // Unten nicht hinter den mobilen Sticky-CTA rutschen, wenn der sichtbar ist.
    const insetBottom = () => {
      const sk = this.refs.sticky;
      return (sk && sk.classList.contains('is-visible')) ? sk.offsetHeight + MARGIN : MARGIN;
    };
    const readPos = () => {
      try { return JSON.parse(sessionStorage.getItem(POS_KEY)); } catch (e) { return null; }
    };
    const savePos = (side, y) => {
      try { sessionStorage.setItem(POS_KEY, JSON.stringify({ side, y })); } catch (e) { /* egal */ }
    };
    // Position IMMER über translate3d, Zoom als angehängtes scale() — eine
    // einzige transform-Property, nie width/height (Compositor-only).
    // mini.x/mini.y sind Koordinaten im SICHTBAREN Ausschnitt; der visualViewport-
    // Versatz kommt erst hier drauf — so bleibt die Drag-/Snap-Mathematik unberührt.
    const apply = () => {
      mini.wrap.style.transform = `translate3d(${mini.x + vvX()}px, ${mini.y + vvY()}px, 0)`
        + (mini.scale !== 1 ? ` scale(${mini.scale})` : '');
    };

    /** Kachel an gemerkter (oder Default-)Position platzieren: Seite → x, y geclampt. */
    const place = () => {
      const r = mini.wrap.getBoundingClientRect();
      mini.w = r.width; mini.h = r.height;
      const pos = readPos() || { side: 'right', y: insetTop() };
      mini.x = pos.side === 'left' ? MARGIN : vpW() - mini.w - MARGIN;
      mini.y = clamp(pos.y, insetTop(), vpH() - mini.h - insetBottom());
      apply();
      try { ausweichen(false); } catch (e) { /* Ausweichen ist Kür: nie die Platzierung/Aktivierung kippen */ }
    };

    /** Namensliste freihalten (Listen-Ansicht, Schema v1.37; 23.10.2026): Die Default-Lage oben rechts liegt
     *  genau über der Liste, die direkt unter der Bühne steht. Schneidet die Kachel den sichtbaren Teil der
     *  Liste, wandert sie vertikal an die freie Stelle (oben oder unten, sonst die mit der kleinsten
     *  Überdeckung). Nur ohne vom Kunden gezogene Lage (readPos) und nie während Drag/Pinch.
     *  Ohne .ttg-mlist (alle Kachel-Produkte) sofort zurück — dort ändert sich nichts. */
    const ausweichen = (sanft) => {
      if (!mini.active || mini.drag || mini.pinch || mini.scale !== 1 || readPos()) return;
      const liste = this.root && typeof this.root.querySelector === 'function' ? this.root.querySelector('.ttg-mlist') : null;
      if (!liste || !liste.offsetParent) return;
      const lr = liste.getBoundingClientRect();
      const oben = Math.max(lr.top, 0), unten = Math.min(lr.bottom, vpH());
      if (unten <= oben) return;
      const ueber = (y) => Math.max(0, Math.min(unten, y + mini.h) - Math.max(oben, y));
      const lo = insetTop(), hi = Math.max(lo, vpH() - mini.h - insetBottom());
      const kand = [mini.y, lo, hi];
      let ziel = kand.find((y) => ueber(y) === 0);
      if (ziel === undefined) ziel = kand.reduce((a, b) => (ueber(b) < ueber(a) ? b : a));
      if (ziel === mini.y) return;
      mini.y = ziel;
      if (sanft) {
        mini.wrap.classList.add('is-settling');
        setTimeout(() => mini.wrap && mini.wrap.classList.remove('is-settling'), 250);
      }
      apply();
    };
    this._miniAusweichen = () => { try { ausweichen(true); } catch (e) { /* egal */ } };
    // Nach dem Scrollen (Liste wandert durchs Bild) erneut prüfen — entprellt, nur solange die Kachel schwebt.
    let ausweichT = 0;
    const onScrollEnde = () => { clearTimeout(ausweichT); ausweichT = setTimeout(() => this._miniAusweichen(), 150); };

    /** Loslassen: horizontal zum nächsten Rand einrasten, vertikal clampen. */
    const snap = () => {
      const side = (mini.x + mini.w / 2) < vpW() / 2 ? 'left' : 'right';
      mini.x = side === 'left' ? MARGIN : vpW() - mini.w - MARGIN;
      mini.y = clamp(mini.y, insetTop(), vpH() - mini.h - insetBottom());
      mini.wrap.classList.add('is-settling');
      apply();
      setTimeout(() => mini.wrap && mini.wrap.classList.remove('is-settling'), 250);
      savePos(side, mini.y);
    };

    // Zoom-Origin = geparkte Ecke, damit die Kachel IN den Screen hinein
    // aufklappt statt über den Rand hinaus (rechts geparkt → nach links).
    const setZoomOrigin = () => {
      mini.wrap.style.transformOrigin =
        ((mini.x + mini.w / 2) < vpW() / 2 ? 'left' : 'right') + ' '
        + ((mini.y + mini.h / 2) < vpH() / 2 ? 'top' : 'bottom');
    };
    /** Peek beenden: auf 1× zurückfedern — der Zoom ist nie dauerhaft. */
    const unzoom = () => {
      mini.scale = 1;
      mini.wrap.classList.remove('is-zooming');
      mini.wrap.classList.add('is-springing');
      apply();
      setTimeout(() => mini.wrap && mini.wrap.classList.remove('is-springing'), 350);
    };
    /** Harter Gesten-Reset: Geister-Pointer und hängende Pinch-/Zoom-Reste
     *  verwerfen. Nötig nach nativem Gesten-Handoff (iOS Safari cancelt Pointer
     *  beim Seiten-Zoom — und einzelne pointercancel können dabei verloren
     *  gehen; ohne Reset zählt jeder spätere Einzelfinger als „zweiter" und
     *  die Kachel reagiert scheinbar gar nicht mehr). */
    const resetPointers = () => {
      pts.clear();
      mini.drag = null;
      mini.wrap.classList.remove('is-dragging');
      if (mini.pinch || mini.gesture || mini.scale !== 1) {
        mini.pinch = null; mini.gesture = null;
        unzoom();
      }
    };

    const onDown = (e) => {
      if (!mini.active) return;                        // kein isPrimary-Gate: Finger 2 (Pinch) ist nie primary
      // Foto-Gesten gehen vor (07.10.2026, Kissen-Briefing 12): Liegt das Foto in der
      // Kachel und startet der Finger auf dem Fotorahmen, gehört die Geste dem
      // Foto-Modul (ttg-foto.js bindStage: Verschieben/Pinch). Vorher holte sich die
      // Kachel hier per setPointerCapture den Pointer — der Rahmen bekam kein
      // pointermove mehr, und statt des Fotos wanderte die Kachel. Gemessen auf allen
      // sechs Foto-Produkten (390 px, Touch): Bühne verschiebt, Kachel nie. Außerhalb
      // des Rahmens bleibt die Kachel wie bisher ziehbar.
      const fotoRahmen = this.state.photo && e.target && typeof e.target.closest === 'function'
        ? e.target.closest('.ttg__layer--photo') : null;
      if (fotoRahmen) return;
      e.preventDefault();                              // kein natives Image-Drag/Select
      // Ein PRIMARY-Pointer beginnt per Spec immer eine frische Touch-Sequenz
      // (alle Finger waren oben) → alte Reste sind Geister und fliegen raus.
      if (e.isPrimary) resetPointers();
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      try { mini.wrap.setPointerCapture(e.pointerId); } catch (err) { /* egal */ }
      if (pts.size === 1) {
        mini.drag = { px: e.clientX, py: e.clientY, sx: mini.x, sy: mini.y };
        mini.wrap.classList.add('is-dragging');        // will-change nur während des Drags
      } else if (pts.size === 2) {
        // Zweiter Finger = Pinch-Peek: Drag pausieren, damit die Kachel nicht
        // gleichzeitig wegwandert. Basis-Scale mitnehmen, falls ein neuer Pinch
        // in eine noch laufende Rückfeder-Animation startet.
        mini.drag = null;
        mini.wrap.classList.remove('is-dragging');
        mini.wrap.classList.remove('is-springing');
        setZoomOrigin();
        mini.pinch = { d0: dist(), base: mini.scale };
        mini.wrap.classList.add('is-zooming');
      }
      // >2 Finger: ignorieren, die ersten beiden bleiben maßgeblich.
    };
    const onMove = (e) => {
      if (pts.has(e.pointerId)) pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (mini.pinch) {
        if (pts.size >= 2) {
          mini.scale = clamp(mini.pinch.base * (dist() / mini.pinch.d0), 1, MAX_ZOOM);
          if (!mini.raf) mini.raf = requestAnimationFrame(() => { mini.raf = 0; if (mini.pinch) apply(); });
        }
        return;
      }
      if (!mini.drag) return;
      mini.x = mini.drag.sx + (e.clientX - mini.drag.px);
      mini.y = mini.drag.sy + (e.clientY - mini.drag.py);
      if (!mini.raf) mini.raf = requestAnimationFrame(() => { mini.raf = 0; if (mini.drag) apply(); });
    };
    const onUp = (e) => {
      pts.delete(e.pointerId);
      if (mini.pinch) {
        if (pts.size < 2) {
          mini.pinch = null;
          // Läuft parallel eine native Geste (iOS-Handoff: Safari cancelt die
          // Pointer, gesture* geht weiter), NICHT zurückfedern — onGestureChange
          // zoomt nahtlos weiter (e.scale misst dieselbe Geste), gestureend
          // federt am Ende zurück. Sonst (Finger wirklich oben): Peek beenden.
          // Ein evtl. verbliebener Finger startet KEINEN Drag (kein Springen).
          if (!mini.gesture) unzoom();
        }
        return;
      }
      if (!mini.drag) return;
      mini.drag = null;
      mini.wrap.classList.remove('is-dragging');
      snap();
    };

    /* iOS Safari meldet Pinch zusätzlich über proprietäre gesture*-Events
     * (e.scale relativ zum Gestenstart) und übergibt die Geste sonst an den
     * nativen Seiten-Zoom — touch-action: none allein unterbindet das dort
     * nicht zuverlässig. preventDefault auf diesen Events unterdrückt den
     * Seiten-Zoom NUR für Gesten, die auf der Kachel starten (Listener hängen
     * am Wrapper); der Rest der Seite zoomt nativ weiter. Getrieben wird der
     * Peek hieraus nur, wenn der Pointer-Pinch nicht ohnehin läuft — Chrome/
     * Android kennen diese Events nicht, dort bleibt der Pointer-Pfad allein.
     * Cancelt Safari die Pointer trotzdem (Gesten-Handoff), übernimmt
     * onGestureChange den Peek nahtlos per Lazy-Init auf aktueller Skalierung. */
    const onGestureStart = (e) => {
      if (!mini.active) return;
      e.preventDefault();
      mini.drag = null;                                // Pinch gewinnt, Kachel wandert nicht
      mini.wrap.classList.remove('is-dragging');
      // Basis IMMER merken — auch bei laufendem Pointer-Pinch: e.scale misst
      // dieselbe Geste ab demselben Startmoment. Cancelt Safari die Pointer
      // später (Handoff), setzt onGestureChange exakt an der aktuellen
      // Skalierung fort, ohne Rückfeder-Ruckler.
      if (!mini.gesture) {
        mini.wrap.classList.remove('is-springing');
        setZoomOrigin();
        mini.gesture = { base: mini.scale };
        mini.wrap.classList.add('is-zooming');
      }
    };
    const onGestureChange = (e) => {
      if (!mini.active) return;
      e.preventDefault();
      if (mini.pinch) return;                          // Pointer-Pinch hat Vorrang
      if (!mini.gesture) {                             // Lazy-Init nach Pointer-Cancel: nahtlos weiterzoomen
        setZoomOrigin();
        mini.gesture = { base: mini.scale / (e.scale || 1) };
        mini.wrap.classList.add('is-zooming');
      }
      mini.scale = clamp(mini.gesture.base * (e.scale || 1), 1, MAX_ZOOM);
      if (!mini.raf) mini.raf = requestAnimationFrame(() => { mini.raf = 0; if (mini.gesture) apply(); });
    };
    const onGestureEnd = (e) => {
      if (!mini.active) return;
      e.preventDefault();
      pts.clear();                                     // Handoff-Reste: verlorene pointercancel abräumen
      if (mini.gesture) {
        mini.gesture = null;
        unzoom();
      }
    };
    // Orientation-/Toolbar-Resize: Kachelgröße (dvh) ändert sich → neu platzieren.
    const onResize = () => { if (mini.active && !mini.drag && !mini.pinch) place(); };
    // Scrollen mit offener Tastatur: der visualViewport-Versatz ändert sich laufend —
    // nur die transform nachziehen (Compositor-only, kein Re-Layout, kein Clamp).
    const onVVScroll = () => { if (mini.active && !mini.drag && !mini.pinch) apply(); };
    // Tastatur klappt auf/zu (oder Toolbar): die sichtbare HÖHE springt → neu clampen,
    // sonst stünde die Kachel hinter der Tastatur.
    const onVVResize = () => { if (mini.active && !mini.drag && !mini.pinch) place(); };

    const activate = () => {
      if (mini.active || !mq.matches) return;
      if (!mini.wrap) {
        const w = document.createElement('div');
        w.className = 'ttg-mini';
        w.hidden = true;
        w.setAttribute('aria-hidden', 'true');         // reine Sichtkopie der großen Bühne
        w.addEventListener('pointerdown', onDown);
        w.addEventListener('pointermove', onMove);
        w.addEventListener('pointerup', onUp);
        w.addEventListener('pointercancel', onUp);
        // iOS Safari: Zwei-Finger-Kontakt auf der Kachel darf NICHT zum
        // nativen Seiten-Zoom eskalieren. touch*-Listener müssen dafür
        // ausdrücklich non-passive sein, sonst ist preventDefault wirkungslos.
        // Ein-Finger-Touches bleiben unangetastet (Pointer-Pfad macht den Drag).
        const noPass = { passive: false };
        const eatMultiTouch = (e) => { if (e.touches && e.touches.length > 1) e.preventDefault(); };
        w.addEventListener('touchstart', eatMultiTouch, noPass);
        w.addEventListener('touchmove', eatMultiTouch, noPass);
        w.addEventListener('gesturestart', onGestureStart, noPass);
        w.addEventListener('gesturechange', onGestureChange, noPass);
        w.addEventListener('gestureend', onGestureEnd, noPass);
        this.root.appendChild(w);                       // im Root: CSS-Variablen erben
        mini.wrap = w;
      }
      // Bühne behält ihre Fläche (kein Layout-Sprung, IO-Ziel bleibt stabil):
      // Seitenverhältnis der Vorschau festhalten, solange sie ausgehängt ist.
      const r = preview.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) home.style.aspectRatio = `${Math.round(r.width)} / ${Math.round(r.height)}`;
      mini.home = { parent: preview.parentElement, next: preview.nextSibling };
      mini.active = true;
      mini.wrap.appendChild(preview);
      mini.wrap.hidden = false;
      place();
      window.addEventListener('resize', onResize, { passive: true });
      window.addEventListener('scroll', onScrollEnde, { passive: true });
      if (vv) {
        vv.addEventListener('scroll', onVVScroll, { passive: true });
        vv.addEventListener('resize', onVVResize, { passive: true });
      }
    };

    const deactivate = () => {
      if (!mini.active) return;
      mini.active = false;
      mini.drag = null;
      mini.pinch = null; mini.gesture = null; mini.scale = 1; pts.clear();  // Pinch-/Gesten-Reste verwerfen (Zoom ist nur ein Peek)
      mini.home.parent.insertBefore(preview, mini.home.next);
      home.style.aspectRatio = '';
      mini.wrap.classList.remove('is-dragging', 'is-zooming', 'is-springing');
      mini.wrap.hidden = true;
      window.removeEventListener('resize', onResize);
      window.removeEventListener('scroll', onScrollEnde);
      clearTimeout(ausweichT);
      if (vv) {
        vv.removeEventListener('scroll', onVVScroll);
        vv.removeEventListener('resize', onVVResize);
      }
    };

    // Hysterese: aktivieren erst, wenn die Bühne KOMPLETT draußen ist (ratio 0);
    // deaktivieren erst ab 35 % Sichtbarkeit. Dazwischen passiert nichts — der
    // Debounce fängt zusätzlich das Wackeln direkt am Schwellwert ab.
    const io = new IntersectionObserver((entries) => {
      const e = entries[entries.length - 1];
      clearTimeout(mini.t);
      mini.t = setTimeout(() => {
        if (!mq.matches) return;
        try {
          if (!e.isIntersecting) activate();
          else if (e.intersectionRatio >= 0.35) deactivate();
        } catch (err) {
          // Async-Isolation (läuft außerhalb von mount()): Vorschau best-effort
          // nach Hause retten und das Feature stilllegen — die große Bühne und
          // damit der Kaufpfad bleiben intakt. deactivate() ist gefahrlos, weil
          // activate() `mini.active` VOR dem Umhängen setzt: ein halb gelaufenes
          // activate wird dadurch sauber zurückgerollt, ein nie gestartetes
          // ist ein No-Op.
          try { deactivate(); } catch (e2) { /* egal */ }
          try { io.disconnect(); } catch (e2) { /* egal */ }
          console.warn('[ttg] Mini-Vorschau stillgelegt:', err && err.message);
        }
      }, 120);
    }, { threshold: [0, 0.35] });
    io.observe(home);
    this._miniIO = io;

    // Breakpoint-Wechsel (Rotation, Resize): Desktop ⇒ sofort zurückhängen.
    const onMq = () => { if (!mq.matches) { clearTimeout(mini.t); deactivate(); } };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);
  }

  /**
   * Weckt den Upload-Dienst mit einem leisen no-cors-GET an dessen Origin —
   * fire-and-forget, blockiert nichts. Der Kunde konfiguriert danach einige
   * Sekunden; bis zum (nachgelagerten) Upload ist der Container warm. Ein
   * schlafender Railway-Container wird durch den Request geweckt.
   */
  _prewarmPreviewBackend() {
    try {
      const pu = this.config.previewUpload;
      if (!pu || !pu.enabled || !pu.url || typeof fetch === 'undefined') return;
      const origin = new URL(pu.url).origin;
      fetch(origin + '/', { method: 'GET', mode: 'no-cors', cache: 'no-store' }).catch(() => {});
    } catch (e) { /* egal — nur Aufwärm-Versuch */ }
  }

  /**
   * Lädt weitere Motiv-Seiten über die Section-Rendering-API nach: die Section
   * paginiert die Motiv-Referenzen (Liquid-Page-Size max. 250); Seiten 2..n werden
   * als ?sections=<id>&page=<n> gerendert und ihr data-ttg-config eingesammelt.
   * Rein additiv — bei Fehlern bleibt es bei den server-gerenderten Motiven.
   */
  async _loadMoreMotifs() {
    const p = this.config.motifsPagination;
    if (!p || !(p.pages > 1) || !p.sectionId) return;
    const seen = new Set((this.config.motifs || []).map((m) => m.id));
    for (let page = 2; page <= p.pages; page++) {
      try {
        const u = new URL(window.location.href);
        u.searchParams.set('sections', p.sectionId);
        // Listen-Arrays haben einen eigenen Pagination-Param (paginate.page_param) —
        // '?page' würde im Produktkontext ignoriert.
        u.searchParams.set(p.pageParam || 'page', String(page));
        const res = await fetch(u.toString(), { credentials: 'same-origin' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        const html = data[p.sectionId] || '';
        const m = html.match(/<script type="application\/json" data-ttg-config>\s*([\s\S]*?)\s*<\/script>/);
        if (!m) throw new Error('kein data-ttg-config in Seite ' + page);
        const cfg = JSON.parse(m[1]);
        (cfg.motifs || []).forEach((mo) => {
          if (mo && mo.id && !seen.has(mo.id) && !this._motifAusgeschlossen(mo)) { seen.add(mo.id); this.config.motifs.push(mo); }
        });
      } catch (e) {
        console.warn('[ttg] Motiv-Seite ' + page + ' nicht nachladbar:', e && e.message);
      }
    }
    this._rebuildMotifIndex();
    // Falls der Motiv-Schritt bereits sichtbar ist: neu rendern (mehr Buckets/Motive).
    if (this.refs && this.refs.steps) this.renderSteps();
  }

  /**
   * Globaler Motiv-Katalog (#14): assets/ttg-motifs.json einmal laden (memoized),
   * nach config.motifsCatalog.categories filtern (Union der categoryGroups —
   * Kategorie-Filter ersetzt die per-Produkt-Referenzliste 1:1, Deckung gegen die
   * echten Daten bewiesen) und in config.motifs mergen (Dedupe per id — das
   * inline injizierte Override-/Default-Motiv bleibt Position 1).
   * FEHLERTOLERANT: Fehlschlag setzt nur ein Flag (Picker zeigt Meldung + Retry);
   * der nächste Aufruf versucht es erneut. Kaufpfad bleibt unberührt.
   */
  _ensureCatalog() {
    const cat = this.config.motifsCatalog;
    if (!cat || !cat.url) return Promise.resolve(false);
    if (this._catalogLoaded) return Promise.resolve(true);
    if (this._catalogPromise) return this._catalogPromise;
    this._catalogFailed = false;
    this._catalogPromise = fetch(cat.url, { credentials: 'omit' })
      .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then((data) => {
        const all = Array.isArray(data) ? data : ((data && data.motifs) || []);
        const allow = (Array.isArray(cat.categories) && cat.categories.length)
          ? cat.categories : null;
        // extraMotifs (Schema v1.25): ein Motiv, das eine Gruppe zusätzlich führt, darf
        // aus einer Kategorie kommen, die motifsCatalog.categories NICHT nennt — die
        // Section baut die Liste nur aus den Gruppen-Kategorien. Zulassung per id/gid,
        // sonst verwürfe der Filter genau dieses Motiv still.
        const extra = this._extraMotifKeys();
        const isExtra = (m) => extra.size > 0 && (extra.has(String(m.id)) || (m.gid != null && extra.has(String(m.gid))));
        const seen = new Set((this.config.motifs || []).map((m) => m && m.id));
        // Motiv-Geometrie (Schema v1.35): inkUnten/hals stehen nur im Katalog, nicht in der
        // Inline-Emission der Section — inline vorhandene Motive (Default, featured) bekommen
        // sie hier nachgetragen. Katalog-Einträge ohne die Felder: kein Eingriff.
        const GEO_FELDER = ['inkUnten', 'inkOben', 'inkLinks', 'inkRechts', 'hals', 'bildVerhaeltnis', 'groesse'];
        const geo = all.some((m) => m && (m.inkUnten != null || m.hals != null));
        const ausschluss = this._hatExcludeMotifs();
        for (const m of all) {
          if (geo && m && m.id && seen.has(m.id)) {
            const vorh = this._resolveMotif(m.id);
            if (vorh) {
              for (const f of GEO_FELDER) if (m[f] != null && vorh[f] == null) vorh[f] = m[f];
              // Geometrie je Bild (Schema v1.38, 24.10.2026, Halspunkte Bild 2/3): bilder[i] des Katalogs →
              // gleiches Bild der Inline-Liste (Index, bei vorhandener ID nur bei gleicher ID).
              if (Array.isArray(m.bilder) && Array.isArray(vorh.bilder)) {
                m.bilder.forEach((b, i) => {
                  const z = vorh.bilder[i];
                  if (!b || !z || (b.id != null && z.id != null && String(b.id) !== String(z.id))) return;
                  for (const f of GEO_FELDER) if (b[f] != null && z[f] == null) z[f] = b[f];
                });
              }
            }
          }
          if (!m || !m.id || seen.has(m.id)) continue;
          if (allow && allow.indexOf(m.kategorie) === -1 && !isExtra(m)) continue;
          if (ausschluss && this._motifAusgeschlossen(m)) continue;
          this.config.motifs.push(m);
          seen.add(m.id);
        }
        this._rebuildMotifIndex();
        this._catalogLoaded = true;
        this._afterCatalogLoaded();
        return true;
      })
      .catch((e) => {
        console.warn('[ttg] Motiv-Katalog nicht ladbar:', e && e.message);
        this._catalogPromise = null;                 // nächster Picker-Open = Retry
        this._catalogFailed = true;
        if (this.refs && this.refs.steps) this.renderSteps();
        return false;
      });
    return this._catalogPromise;
  }

  /** Nach Katalog-Ankunft: verspätete Defaults nachziehen + neu rendern. */
  _afterCatalogLoaded() {
    // Bucket-Pinning korrigieren: der Konstruktor sah nur die Inline-Motive
    // (z. B. genau das injizierte Override → dessen Gruppe wirkte als einziger
    // Bucket und war vorgepinnt). Nach dem Merge gibt es wieder mehrere Gruppen
    // → Kategorie-Dialog, sofern der Kunde den Bucket nicht selbst gewählt hat.
    if (!this._motifTouched) this.state.bucket = this._soleBucket();
    // Motivbuch-Deep-Link nachholen: ?ttg-motif war inline nicht auflösbar; das
    // Default-Motiv wurde dafür im Konstruktor unterdrückt (kein Aufblitzen).
    // Gültig → Default-Motiv-Semantik (Bucket, One-Click-Erledigung, Vorschau) +
    // ggf. Bildvariante. Ungültig (unbekannt/fremde Kategorie — der Katalog-Merge
    // filtert fremde Kategorien ohnehin aus) → still zurück auf den Standardpfad:
    // die Late-Default-/Titel-Blöcke unten sehen ein unberührtes Motiv und greifen
    // exakt wie ohne Parameter.
    if (this._urlMotifPending) {
      const uh = this._urlMotifPending;
      this._urlMotifPending = null;
      const um = this._resolveMotif(uh);
      if (um && this._urlMotifAllowed(um)) {
        if (!this._motifTouched && !this.state.noMotif) {
          this._motifFromUrl = true;   // vor dem Apply: _openDefaultMotifBucket liest das Flag
          this._applyLateDefaultMotif(um, this._urlMotifBild);
          // Scroll NUR hier, nicht in _applyLateDefaultMotif: die Funktion bedient
          // auch das konfigurierte Default-Motiv (unten, und im Konstruktor-Nachlauf)
          // — dort würde JEDES Produkt mit Default-Motiv beim Laden springen.
          this._scrollToMotifCard();
          this._pendingDeepLinkMotif = null;   // ?ttg-motif gewinnt über ?motiv
          // Cross-Sell-Einstieg (?ttg-xsell=1): das nachgezogene Deep-Link-Motiv
          // gilt wie im Inline-Fall als BESTÄTIGT (gleiche Regel wie
          // _applyXsellPrefillDone — dort war das Motiv noch nicht auflösbar).
          if (this._xsellFlag && this.state.motif && !this.state.noMotif) {
            this.state.done.motif = true;
            this.renderSteps();
          }
        }
      } else {
        console.warn('[ttg] ?ttg-motif ungültig: ' + uh);
      }
    }
    // Deep-Link nachholen: ?motiv=<handle> war vor dem Katalog nicht auflösbar
    // (_applyDeepLink hat den Handle geparkt). Guard = KUNDENAKTION, nicht
    // done.motif: ein injiziertes Override erledigt den Schritt ohne Kundenzutun
    // — der Deep-Link muss es überstimmen (Parität zum Inline-Verhalten).
    if (this._pendingDeepLinkMotif) {
      const h = this._pendingDeepLinkMotif;
      this._pendingDeepLinkMotif = null;
      const m = this._resolveMotif(h);
      if (m && !this._motifTouched && !this.state.noMotif) this._applyMotifDeepLink(m);
    }
    // Konfiguriertes Default nachholen: defaults.motif gewinnt IMMER — auch wenn
    // es erst mit dem Katalog auflösbar wird (Schema-/Section-Default ohne
    // Inline-Injektion). Erst wenn KEIN Default konfiguriert ist, darf der
    // Titel ableiten (gleiche Präzedenz wie im Konstruktor).
    const dflt = (this.config.defaults || {}).motif;
    const pristine = () => !this._motifTouched && !this.state.motif
      && !this.state.noMotif && !this._reopened.has('motif');
    if (dflt && pristine()) {
      const dm = this._resolveMotif(dflt);
      if (dm) this._applyLateDefaultMotif(dm);
    }
    // Titel-Ableitung nachholen: im Konstruktor gab es (Katalog-Modus) noch keine
    // Motivliste. Ergebnis verhält sich exakt wie ein Schema-Default.
    if (!dflt && this.config.deriveMotifFromTitle === true && pristine()) {
      const dm = this._deriveDefaultMotifFromTitle();
      if (dm) this._applyLateDefaultMotif(dm);
    }
    // Default-Bucket nach dem Merge (neu) öffnen: das Re-Pinning oben hat ihn auf
    // _soleBucket() (=null bei mehreren Gruppen) zurückgesetzt. Für ein bereits im
    // KONSTRUKTOR aufgelöstes Override-Motiv greifen die Late-Blöcke oben nicht
    // (state.motif ist schon gesetzt) — ohne diesen Aufruf zeigte der Schritt den
    // Bucket-Dialog statt des Default-Grids (live gefangen). Idempotent + nur ohne
    // Kundeninteraktion; setzt state.bucket aus der Gruppe des Default-Motivs.
    if (!this._motifTouched) this._openDefaultMotifBucket();
    if (this.refs && this.refs.steps) this.renderSteps();
    // Aktive Suche über den Katalog-Load hinweg erhalten (Race-Fix): der Re-Render hat
    // das Suchfeld geleert. Lag eine Suche an, Text zurücksetzen und über den nun
    // VOLLEN Satz neu filtern — so bleibt der Suchtext stehen und die zuvor gezeigte
    // Lade-Meldung wird durch die echten Treffer ersetzt (statt falschem Leerstand).
    if (this._motifQuery) this._restoreMotifSearch();
  }

  /** Aktive Motiv-Suche nach dem Katalog-Load erneut anwenden (Text + Fokus erhalten). */
  _restoreMotifSearch() {
    if (!this.refs || !this.refs.steps) return;
    // Nur im Bucket wiederanwenden, in dem tatsächlich gesucht wurde: navigierte der
    // Kunde während des Ladens in einen ANDEREN Such-Bucket, dürfen wir dort weder den
    // Suchtext injizieren noch fälschlich „nicht gefunden" auslösen (Cross-Bucket-Leak).
    if (this.state.bucket !== this._motifQueryBucket) return;
    const input = this.refs.steps.querySelector('[data-field="motifSearch"]');
    if (!input) return;                              // Suchfeld nicht (mehr) sichtbar
    input.value = this._motifQuery;
    this._onMotifSearch(this._motifQuery);
    try { input.focus(); const n = input.value.length; input.setSelectionRange(n, n); } catch (e) { /* egal */ }
  }

  /** Verspätetes Default-Motiv anwenden (Katalog-Modus) — identische Semantik
   *  wie ein Konstruktor-Default: Intro-Zeile, One-Click-Erledigung, Vorschau.
   *  Optional variant (0-basiert, ?ttg-bild): nur übernommen, wenn der Index existiert. */
  _applyLateDefaultMotif(m, variant) {
    this.state.motif = m;
    // Anker neu bestimmen: hier installiert die ENGINE ein Lade-Motiv (verspäteter
    // Deep-Link, Default, Titel-Ableitung) — es löst einen ggf. schon festgenagelten
    // früheren Anker ab. Alle Aufrufer prüfen vorher !_motifTouched, ein Kundenklick
    // kommt also nie hier an. Siehe _pinnedMotifId.
    this._motifPinned = undefined;
    this.state.motifVariant = this._urlBildIndex(m, variant);
    this.state.motifIntro = this.config.motifStartExpanded !== true;
    this._openDefaultMotifBucket();          // Bucket der Default-Gruppe direkt öffnen (Gruppen-Modus)
    if (this._isPreSatisfied('motif')) this.state.done.motif = true;
    this.renderPreview();
    // Hier rendert nur die Vorschau — ist das spaete Default-Motiv vollfarbig,
    // muss die Schritt-Liste den Druckfarben-Schritt nachziehen.
    this._syncPrintStep();
    this._updateCta();
  }

  /**
   * Phase 2 — Mit gesetztem Default-Motiv + startExpanded (GRUPPEN-Modus) den Bucket
   * der Default-Gruppe direkt öffnen: der Motiv-Schritt zeigt beim Laden das Grid
   * (Featured + Suche) statt der 10-Bucket-Auswahl und bleibt ERLEDIGT + sichtbar
   * (keepExpanded-Semantik wie an der Größe — grüne Nummer, CTA frei). Gruppen-Wahl:
   *   config.defaultGroup (falls gültige Gruppe) > Gruppe der Kategorie des Default-Motivs.
   * NUR Gruppen-Modus (categoryGroups): Einzelkategorie-Produkte (Fußmatte) bleiben
   * unberührt — dort gibt es keinen Bucket-Dialog, und der Motiv-Schritt bleibt bewusst
   * offen/unerledigt (allowNoMotif:false = Pflichtwahl). Fallback (kein Default-Motiv
   * oder keine passende Gruppe): heutiges Verhalten. Setzt this._motifOpenDefault.
   */
  _openDefaultMotifBucket() {
    this._motifOpenDefault = false;
    if (this.config.motifStartExpanded !== true) return false;
    if (!this.state.motif || this.state.noMotif) return false;
    if (!this._motifGroups()) return false;               // nur Gruppen-Modus (nicht Fußmatte)
    let grp = null;
    // Ein Deep-Link (?ttg-motif / ?motiv) benennt ein KONKRETES Motiv — dann gewinnt
    // dessen eigene Gruppe über config.defaultGroup. Sonst öffnet der Schritt eine
    // Gruppe, in der das gewählte Motiv gar nicht vorkommt: das Grid zeigt drei fremde
    // Motive, die Vorschau etwas anderes (live gemessen 09.08.2026 — defaultGroup
    // „handgezeichnet" schluckte jeden Link nach Hundeliebe, PopArt, Katzen, Sprüche).
    // Für das KONFIGURIERTE Default-Motiv bleibt defaultGroup vorn (Vertrag unverändert).
    if (!this._motifFromUrl && this.config.defaultGroup && this._bucketDef(this.config.defaultGroup)) grp = this.config.defaultGroup;
    else grp = this._bucketForMotif(this.state.motif);
    if (!grp || !this._bucketDef(grp)) return false;      // keine passende Gruppe → Fallback
    this.state.bucket = grp;
    this.state.motifCollapsed = false;                    // Grid (Featured + Suche), kein Varianten-Kollaps
    this._motifOpenDefault = true;
    return true;
  }

  /**
   * Motivbuch-Deep-Link: ?ttg-motif/&ttg-bild aus der URL lesen →
   * { handle, bild (0-basiert) } oder null. Nie werfen (Node/Tests: kein window).
   */
  _readUrlMotifParams() {
    try {
      if (typeof window === 'undefined' || !window.location) return null;
      const qs = new URLSearchParams(window.location.search);
      const handle = (qs.get('ttg-motif') || '').trim();
      if (!handle) {
        // Kein ?ttg-motif: die UTM-Zuordnung (config.utmMap) darf das Motiv liefern —
        // Anzeigen ohne Deep-Link, deren utm_content/utm_term/utm_campaign bekannt ist.
        const utm = this._utmMapEntry();
        return (utm && utm.motif) ? { handle: utm.motif, bild: 0, utm } : null;
      }
      const n = parseInt(qs.get('ttg-bild') || '', 10);
      // 1-basiert → 0-basiert; alles Unbrauchbare (NaN, <2) bleibt Bild 1 (=0).
      return { handle, bild: (Number.isFinite(n) && n >= 2) ? n - 1 : 0 };
    } catch (e) { return null; }
  }

  /**
   * UTM-Zuordnung (Schema v1.26, 21.09.2026): config.utmMap =
   *   { "<utm-Wert>": { "motif": "<handle>", "farbe": "<Optionswert>", "handle": "<Produkt-Handle, optional>" } }
   * — als Objekt oder als JSON-String (Section-Setting utm_map, Textarea im Theme-Editor).
   *
   * Anlass: die DE-Mantel-Videoanzeige 120253075077320653 zeigt den Navy-Mantel mit „Dog Mom",
   * verlinkt aber ohne ?ttg-motif/?ttg-farbe — der Kunde landet auf Oliv mit „Hand & Pfote".
   * Die Anzeige selbst wird nicht angefasst (keine neue URL, keine url_tags); stattdessen liest
   * die Engine die UTM-Parameter, die ohnehin ankommen, und belegt Motiv und Farbe vor.
   *
   * Regeln: (1) Greift NUR ohne ?ttg-motif in der URL — ein expliziter Deep-Link gewinnt immer,
   * auch für die Farbe. (2) ?ttg-farbe in der URL schlägt die Farbe aus der Zuordnung.
   * (3) Gesucht wird utm_content, dann utm_term, dann utm_campaign (spezifisch vor allgemein).
   * (4) Trägt der Eintrag „handle", gilt er nur auf /products/<handle>. (5) Unbekannte Werte,
   * kaputtes JSON, kein window → null, nie werfen; das Motiv läuft danach durch dieselbe
   * Prüfung wie ein Deep-Link (_resolveMotif/_urlMotifAllowed). Ohne utmMap ist alles ein No-Op.
   */
  _utmMapEntry() {
    try {
      if (typeof window === 'undefined' || !window.location) return null;
      if (this._utmMapHit !== undefined) return this._utmMapHit;
      this._utmMapHit = null;
      let map = this.config.utmMap;
      if (typeof map === 'string') { try { map = JSON.parse(map); } catch (e) { console.warn('[ttg] utmMap ist kein gültiges JSON'); return null; } }
      if (!map || typeof map !== 'object') return null;
      const qs = new URLSearchParams(window.location.search);
      if ((qs.get('ttg-motif') || '').trim()) return null;
      const pfad = String(window.location.pathname || '');
      for (const param of ['utm_content', 'utm_term', 'utm_campaign']) {
        const val = (qs.get(param) || '').trim();
        if (!val || !Object.prototype.hasOwnProperty.call(map, val)) continue;
        const e = map[val];
        if (!e || typeof e !== 'object') continue;
        if (e.handle) {
          // Nur auf genau diesem Produkt (Locale-Präfix erlaubt, „…-2"-Handles nicht).
          const seg = '/products/' + String(e.handle).trim(); const i = pfad.indexOf(seg);
          if (i < 0 || !/^(\/|$)/.test(pfad.slice(i + seg.length))) continue;
        }
        const hit = { param, value: val, motif: e.motif ? String(e.motif).trim() : null, farbe: e.farbe ? String(e.farbe).trim() : null };
        if (!hit.motif && !hit.farbe) continue;
        this._utmMapHit = hit;
        console.info('[ttg] utm-map: ' + param + '=' + val + ' → Motiv ' + (hit.motif || '–') + ', Farbe ' + (hit.farbe || '–'));
        return hit;
      }
      return null;
    } catch (e) { return null; }
  }

  /**
   * Motivbuch-Deep-Link: ?ttg-farbe=<Optionswert> roh aus der URL lesen → getrimmter
   * String oder null. BEWUSST eigenständig statt in _readUrlMotifParams(): die steigt
   * ohne ?ttg-motif mit null aus, ein alleinstehendes ?ttg-farbe (z. B. aus einer
   * Anzeige) wäre dort tot. Nie werfen (Node/Tests: kein window).
   */
  _readUrlColorParam() {
    // ?ttg-farbe gewinnt; ohne Parameter darf die UTM-Zuordnung die Farbe liefern (nie bei ?ttg-motif).
    const url = this._readUrlParam('ttg-farbe');
    if (url) return url;
    const utm = this._utmMapEntry();
    return (utm && utm.farbe) ? utm.farbe : null;
  }

  /**
   * Einen getrimmten Query-Parameter lesen — leer/fehlend → null. Nie werfen
   * (Node/Tests: kein window). Gemeinsame Basis von _readUrlColorParam und
   * _resolveUrlOptionValue, damit beide Wege dieselbe Trim-/Leer-Regel tragen.
   */
  _readUrlParam(name) {
    try {
      if (typeof window === 'undefined' || !window.location) return null;
      const val = (new URLSearchParams(window.location.search).get(name) || '').trim();
      return val || null;
    } catch (e) { return null; }
  }

  /**
   * Optionswert-Deep-Link je Varianten-Achse: `?ttg-<paramId>=<Optionswert>`.
   *
   * `paramId` ist die id des `variant_option`-Schritts aus der Config, von der
   * Section an die Achse gehängt (base.paramId / size.paramId; extraOptions
   * tragen ihre id ohnehin). Das Halstuch heißt seinen Design-Schritt „design",
   * also greift `?ttg-design=Camouflage` — ohne dass für jede neue Kategorie ein
   * eigener Parametername erfunden werden muss. `?ttg-farbe` bleibt als
   * Erstbelegung der Farb-Achse daneben bestehen (Motivbuch, Anzeigen).
   *
   * Rückgabe wie _resolveUrlColor: der KANONISCHE Optionswert (nie die
   * Roheingabe) — sonst greifen die Exact-Match-Lookups in resolveVariant() und
   * baseImages[…] nicht. Unbekannter Wert oder Achse ohne paramId → null +
   * console.warn (stiller Fallback, kein Fehlerzustand).
   */
  _resolveUrlOptionValue(paramId, values) {
    if (!paramId) return null;
    const want = this._readUrlParam('ttg-' + paramId);
    if (!want) return null;
    const key = (s) => String(s).trim().toLowerCase();
    const hit = (values || []).find((v) => key(v) === key(want));
    if (hit == null) { console.warn('[ttg] ?ttg-' + paramId + ' ungültig: ' + want); return null; }
    return hit;
  }

  /**
   * Startzustand der Varianten-Achsen aus `?variant=<id>` (Shopify-Standard-
   * Parameter an JEDEM eingehenden Produktlink: Google Shopping, Merchant
   * Center, geteilte Links, Varianten-Wechsel im Theme).
   *
   * Bis 19.08.2026 las nur der Cross-Sell-Pfad diesen Parameter
   * (_applyXsellPrefillDone, hinter ?ttg-xsell=1). Ohne das Flag startete der
   * Konfigurator auf dem ersten Optionswert, während Shopifys natives Formular
   * bereits auf der verlinkten Variante stand — sichtbare Auswahl und
   * Formularzustand klafften auseinander (gemessen am Halstuch, ?variant=…349963
   * = „Sterne Rot"/M zeigte „Anker"/keine Größe).
   *
   * NAMENSBASIERT statt über Indizes der Achsen: die Zuordnung läuft über
   * config.options[i].name, damit sie unabhängig von der Optionsreihenfolge
   * trifft. Unbekannte oder ausverkaufte Variante → null (Standardstart wie
   * bisher); dieselbe Verfügbarkeitsregel wie im Cross-Sell-Pfad, damit ein
   * toter Link nicht auf einer nicht kaufbaren Auswahl landet.
   *
   * @returns {{color: (string|null), size: (string|null), options: object}|null}
   */
  _variantParamValues() {
    const vid = this._readUrlParam('variant');
    if (!vid) return null;
    const v = (this.config.variants || []).find((x) => String(x.id) === String(vid));
    if (!v || v.available === false) return null;
    const out = { color: null, size: null, options: {} };
    (this.config.options || []).forEach((o, i) => {
      const val = v.options[i];
      if (val == null) return;
      if (this.config.base && o.name === this.config.base.optionName) out.color = val;
      else if (this.config.size && o.name === this.config.size.optionName) out.size = val;
      else if (this.extraOptions.some((xo) => xo.optionName === o.name)) out.options[o.name] = val;
    });
    return out;
  }

  /**
   * Deep-Link-Druckfarbe: ?ttg-druckfarbe=<Handle eines druckfarbe-Metaobjekts> (09.10.2026).
   * Aufgelöst NUR gegen printColors[].value DIESES Produkts (resolvePrintValue) — kein Hex, keine
   * Namen. Schlägt defaultBy und defaults.druckfarbe; gilt als Vorbelegung, nicht als Kundenwahl
   * (_printTouched bleibt false). _urlPrintHex hält sie gegen spätere defaultBy-Läufe
   * (Textilfarbwechsel), bis der Kunde selbst wählt. Fehlt der Parameter, ist der Wert unbekannt,
   * auf diesem Produkt nicht wählbar oder gibt es nur eine Palettenfarbe: still No-Op, keine Meldung.
   * Unabhängig von ?ttg-motif (ein Link darf nur die Druckfarbe setzen).
   */
  _applyUrlPrint() {
    this._urlPrintHex = null;
    try {
      if (this._printSingleOption()) return;
      const want = this._readUrlParam('ttg-druckfarbe');
      const p = want ? this.resolvePrintValue(want) : null;
      if (!p || !p.hex) return;
      this._urlPrintHex = p.hex;
      if (this.state.druckfarbe !== p.hex) { this.state.druckfarbe = p.hex; this.emit('printChanged', p.hex); }
    } catch (e) { /* still: bisheriges Verhalten */ }
  }

  /**
   * Deep-Link-Farbe auf einen EXISTIERENDEN Wert der Basis-/Farboption abbilden
   * (trim-fest, case-insensitiv). Rückgabe: der kanonische Optionswert — nie die
   * Roheingabe, sonst greifen die Exact-Match-Lookups in resolveVariant() und
   * baseImages[…] nicht. Unbekannter Wert, Wert einer anderen Option oder Produkt
   * ohne Farboption → null + console.warn (stiller Fallback, kein Fehlerzustand).
   */
  _resolveUrlColor(values) {
    const want = this._readUrlColorParam();
    if (!want) return null;
    const key = (s) => String(s).trim().toLowerCase();
    const hit = (values || []).find((v) => key(v) === key(want));
    if (hit == null) { console.warn('[ttg] ?ttg-farbe ungültig: ' + want); return null; }
    return hit;
  }

  /**
   * Cross-Sell-Deep-Links (?ttg-name, &ttg-text-def, &ttg-font, &ttg-xsell) aus
   * der URL — { name, defId, font, xsell } oder null. Nie werfen (Node/Tests: kein window).
   */
  _readUrlXsellParams() {
    try {
      if (typeof window === 'undefined' || !window.location) return null;
      const qs = new URLSearchParams(window.location.search);
      const name = (qs.get('ttg-name') || '').trim();
      const defId = (qs.get('ttg-text-def') || '').trim();
      const font = (qs.get('ttg-font') || '').trim();
      const xsell = qs.get('ttg-xsell') === '1';
      // &ttg-xsrc (18.10.2026): Quell-Motiv des Motiv-Bonus-Umwegs (configuratorUrl in ttg-crosssell.js).
      // Nur Handle-/ID-Zeichen, höchstens 100 — alles andere wird verworfen. Gilt nur mit ttg-xsell=1.
      const srcRoh = (qs.get('ttg-xsrc') || '').trim();
      const src = /^[A-Za-z0-9_-]{1,100}$/.test(srcRoh) ? srcRoh : null;
      if (!name && !xsell && !font) return null;
      return { name, defId: defId || null, font: font || null, xsell, src: xsell ? src : null };
    } catch (e) { return null; }
  }

  /**
   * Cross-Sell-Deep-Link (?ttg-xsell=1): vorbefüllte Schritte als BESTÄTIGT
   * markieren — der Kunde kann ändern, muss aber nicht durch jeden Wizard-
   * Schritt klicken. Die VALIDIERUNG bleibt unangetastet: gesetzt wird nur das
   * done-Flag von Schritten, deren Wert tatsächlich valide vorliegt (Motiv
   * aufgelöst, Text gefüllt/„Kein Text", Varianten-Optionen aus einer
   * VERFÜGBAREN ?variant=<id>). Ohne ttg-xsell=1 läuft dieser Code nie —
   * der normale Wizard ist byte-gleich.
   */
  _applyXsellPrefillDone() {
    const s = this.state;
    // ?variant=<id> (Shopify-Standard-Param; das Cross-Sell-Element hängt die
    // Kartenwahl an): Optionswerte NAMENSBASIERT übernehmen — nur verfügbare
    // Varianten, sonst bleiben die Options-Schritte offen.
    //
    // Das LESEN teilt sich diese Stelle seit 19.08.2026 mit dem Konstruktor
    // (_variantParamValues) — dort gilt der Parameter inzwischen für jeden Aufruf.
    // Hier wird er BEWUSST erneut angewandt: am Cross-Sell-Pfad schlägt ?variant=
    // die Deep-Link-Parameter (die Karte hängt die Kartenwahl an), im Konstruktor
    // ist er die schwächste Quelle. Genau diese Reihenfolge galt auch vorher.
    const vp = this._variantParamValues();
    if (vp) {
      if (vp.color) s.color = vp.color;
      if (vp.size) s.size = vp.size;
      for (const n of Object.keys(vp.options)) s.options[n] = vp.options[n];
      this._applyPrintDefaultBy();
    }
    const variantOk = !!vp;

    for (const d of this._stepDefs()) {
      const k = d.key;
      if (k === 'motif') {
        if (s.motif && !s.noMotif) s.done[k] = true;
      } else if (k === 'text' || k.indexOf('text:') === 0) {
        const id = k === 'text' ? (this.texts[0] && this.texts[0].id) : k.slice(5);
        const def = this.texts.find((t) => t.id === id);
        if (def && ((s.texts[def.id] || '').trim() || s.noTexts[def.id])) s.done[k] = true;
      } else if (variantOk && (k === 'color' || k === 'size' || k.indexOf('vo:') === 0)) {
        s.done[k] = true;
      }
    }
  }

  /**
   * Deep-Link-Motiv zulässig? Seine Kategorie muss von der Produkt-Config referenziert
   * sein (categories ODER searchCategories irgendeiner categoryGroup). Bewusst gegen die
   * ROHEN config.categoryGroups geprüft — _motifGroups() filtert auf „hat Inline-Motive"
   * und würde im Katalog-Modus vor dem Merge fast alles fälschlich ablehnen. Ohne
   * Gruppen (Fußmatten-Modus) filtert bereits die Produkt-Motivliste selbst: alles,
   * was _resolveMotif dort findet, ist zulässig.
   */
  _urlMotifAllowed(m) {
    if (!m || !m.kategorie) return false;
    const gs = Array.isArray(this.config.categoryGroups) ? this.config.categoryGroups : null;
    if (!gs || !gs.length) return true;
    return gs.some((g) => g && (
      (Array.isArray(g.categories) && g.categories.indexOf(m.kategorie) !== -1) ||
      (Array.isArray(g.searchCategories) && g.searchCategories.indexOf(m.kategorie) !== -1) ||
      // extraMotifs (Schema v1.25): das Motiv ist zulässig, wenn eine Gruppe es
      // namentlich führt — auch ohne seine Kategorie in categories/searchCategories.
      this._isExtraMotifOf(g, m)));
  }

  /**
   * Deep-Links: ?motiv=<handle> wählt das Motiv vor (Dialog übersprungen, Bucket
   * der Gruppe geöffnet, Vorschau zeigt es — bestätigt wird wie beim Default-Motiv
   * erst per Klick); ?intent=<gruppen-id> öffnet nur den Bucket. Unbekannte Werte
   * fallen still auf den normalen Dialog zurück.
   */
  /** ?motiv-Deep-Link anwenden: Motiv vorwählen, Bucket öffnen, Vorschau zeigen. */
  _applyMotifDeepLink(m) {
    this.state.motif = m;
    this._motifFromUrl = true;   // sonst zöge _openDefaultMotifBucket den Bucket unten wieder auf defaultGroup
    this._motifPinned = undefined;   // Anker folgt dem Deep-Link, nicht einem früher gesetzten Default
    this.state.noMotif = false;
    this.state.motifVariant = 0;
    this.state.motifIntro = false;   // Deep-Link hat eigene Kollaps-Logik
    this.state.motifCollapsed = this._motifImages(m).length > 1;
    const b = this._bucketForMotif(m);
    if (b) this.state.bucket = b;
    this.renderSteps();
    this.renderPreview();
    // Deckt ?motiv auf BEIDEN Zeitpunkten ab: inline (_applyDeepLink) und
    // nachgezogen aus dem Katalog (_afterCatalogLoaded).
    this._scrollToMotifCard();
  }
  _applyDeepLink() {
    let qs;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { return; }
    const handle = qs.get('motiv');
    const intent = qs.get('intent');
    if (handle) {
      const m = this._resolveMotif(handle);
      if (m) {
        this._applyMotifDeepLink(m);
        return;
      }
      // Katalog-Modus: das Ziel kann im (noch nicht geladenen) globalen Katalog
      // liegen — Handle parken; _afterCatalogLoaded wendet ihn nachträglich an.
      if (this.config.motifsCatalog && !this._catalogLoaded) this._pendingDeepLinkMotif = handle;
    }
    if (intent) {
      const def = this._bucketDef(intent);
      if (def && (this.config.motifs || []).some((m) => this._motifInBucketDef(def, m))) {
        this.state.bucket = intent;
        this.renderSteps();
      }
    }
  }

  /** Text-Ebenen-Elemente einsammeln: refs.texts = { defId → Element }.
   *  refs.text bleibt als Alias auf die erste Ebene erhalten (Back-Compat). */
  _collectTextRefs(scope) {
    this.refs.texts = {};
    scope.querySelectorAll('[data-ttg-text]').forEach((el) => {
      this.refs.texts[el.dataset.ttgText] = el;
    });
    this.refs.text = (this.texts[0] && this.refs.texts[this.texts[0].id]) || null;
    // Deko-Ebenen (type:"deco") einsammeln — leeres Objekt bei Produkten ohne Deko.
    this.refs.deco = {};
    scope.querySelectorAll('[data-ttg-deco]').forEach((el) => {
      this.refs.deco[el.dataset.ttgDeco] = el;
    });
    // Motiv-Ebenen (Mehrfach-Motiv): refs.motifs = { layerKey → Element }.
    // refs.motif bleibt als Alias auf die erste Ebene erhalten (Back-Compat;
    // der Mount setzt ihn weiterhin über [data-ttg="motif"]).
    this.refs.motifs = {};
    scope.querySelectorAll('[data-ttg-motif]').forEach((el) => {
      this.refs.motifs[el.dataset.ttgMotif] = el;
    });
    // Leinen-Ebenen (Schema v1.35) — leeres Objekt ohne Leine.
    this.refs.leash = {};
    scope.querySelectorAll('[data-ttg-leash]').forEach((el) => {
      this.refs.leash[el.getAttribute('data-ttg-leash')] = el;
    });
    // Foto-Ebene (Schema v1.18) — null bei Produkten ohne config.photo.
    this.refs.photo = scope.querySelector('[data-ttg="photo"]');
    this.refs.photoImg = scope.querySelector('[data-ttg="photo-img"]');
  }

  _previewLayersHtml() {
    return `${this._baseImgHtml()}${this._overlayLayersHtml()}`;
  }
  /** Basis-<img> (LCP-Bild). Fallback-Markup, wenn die Section es NICHT server-seitig
   *  vorgerendert hat; sonst adoptiert der Mount das SSR-<img> (Teil 3: der Preload-
   *  Scanner sieht das LCP-Bild beim HTML-Parsing statt erst nach dem Engine-Mount). */
  _baseImgHtml() {
    return `
      <img class="ttg__base" data-ttg="base" alt="" width="1000" height="1000" decoding="async" fetchpriority="high">`;
  }
  /** Overlay-Ebenen (Motiv + Text) OHNE Basis-<img> — damit ein SSR-Basisbild beim
   *  Mount erhalten bleibt (kein Ersetzen → kein Doppel-Fetch/kein Flash). */
  _overlayLayersHtml() {
    const layout = this._layoutLayers();
    const motifLayers = this._motifLayers(layout);
    // Eine Text-Ebene PRO Text-Def, positioniert über dessen Layout-Ebene.
    // Der Legacy-Def behält zusätzlich data-ttg="text" (bisheriger Selektor).
    // Bildgetriebene Schritte (valueImages) bekommen KEINE Text-Ebene — ihre
    // Grafik liegt auf der deco-Ebene aus def.layer. Ohne diesen Ausschluss
    // stuende der Wert zusaetzlich als Schrift auf dem Druck.
    const textDivs = this.texts.filter((def) => !this._ohneTextEbene(def)).map((def) => `
      <div class="ttg__layer ttg__layer--text"${def._legacy ? ' data-ttg="text"' : ''} data-ttg-text="${escapeHtml(def.id)}" style="${this._layerBoxStyle(this._textLayer(def), true)}" aria-hidden="true"></div>`).join('');
    // Statische Deko-Ebenen (type:"deco", z. B. Pfötchen): eine Ebene pro deco-Layer,
    // positioniert wie Motiv (Box mit height). Maske/Farbe setzt renderPreview.
    //
    // `behindText:true` (Schema v1.19) zieht eine Ebene VOR die Textebenen —
    // gebraucht vom Namensbanner, auf dem der Name STEHEN soll. Das ist zugleich
    // die Reihenfolge, die der Drucker seit jeher zeichnet (Deko, dann Texte);
    // die Vorschau lag hier andersherum, was nur deshalb nie auffiel, weil sich
    // bei den Bestandsprodukten keine Deko mit Text überschneidet. Ohne das Flag
    // bleibt die DOM-Reihenfolge deshalb exakt wie bisher, statt sie pauschal
    // umzudrehen und dabei fremde Produkte zu verändern.
    const decoAlle = this._decoLayers();
    const decoHtml = (l) => `
      <div class="ttg__layer ttg__layer--deco" data-ttg-deco="${escapeHtml(l.id)}" style="${this._layerBoxStyle(l)}" aria-hidden="true"></div>`;
    const decoUnten = decoAlle.filter((l) => l.behindText === true).map(decoHtml).join('');
    const decoDivs = decoAlle.filter((l) => l.behindText !== true).map(decoHtml).join('');
    // Motiv-Ebenen: EINE pro type-"motif"-Layer (Mehrfach-Motiv, z. B. das
    // gespiegelte Doppelmotiv des Handtuchs). Die ERSTE behält data-ttg="motif"
    // — bisheriger Selektor, refs.motif und Layout-Editor-Fallback hängen daran.
    // Ohne Motiv-Ebene im Layout: der bisherige einzelne, versteckte Platzhalter
    // (renderPreview und motifOnSwatch erwarten ein existierendes Element).
    const motifDivs = motifLayers.length ? motifLayers.map((l, i) => `
      <div class="ttg__layer ttg__layer--motif"${i === 0 ? ' data-ttg="motif"' : ''} data-ttg-motif="${escapeHtml(l.id)}" style="${this._layerBoxStyle(l)}" aria-hidden="true"></div>`).join('') : `
      <div class="ttg__layer ttg__layer--motif" data-ttg="motif" style="display:none" aria-hidden="true"></div>`;
    // Foto-Ebene (Schema v1.18, nur mit config.photo UND type-"photo"-Layer im
    // Layout): Rahmen = die Ebenen-Box (overflow hidden im CSS beschneidet),
    // das <img> darin wird von _applyPhotoLayer nach state.photo.crop verschoben/
    // skaliert. Liegt UNTER Motiv/Text/Deko (zuerst im DOM), direkt über der Base.
    const photoLayer = this.config.photo ? this._photoLayer(layout) : null;
    const photoDiv = photoLayer ? `
      <div class="ttg__layer ttg__layer--photo" data-ttg="photo" style="${this._layerBoxStyle(photoLayer)}display:none;" aria-hidden="true"><img data-ttg="photo-img" alt="" decoding="async"><span class="ttg__photo-badge" data-ttg="photo-badge" hidden>${escapeHtml((this.config.photo && this.config.photo.sampleLabel) || 'Beispielfoto')}</span></div>` : '';
    // Leinen-Ebenen (Schema v1.35): ein SVG über die ganze Bühne je type-"leash"-Ebene;
    // den Pfad setzt renderPreview. Ohne Leinen-Ebene leer → Markup unverändert.
    const leashDivs = this._leinenLayers(layout).map((l) => `
      <svg class="ttg__layer--leash" data-ttg-leash="${escapeHtml(l.id)}" viewBox="0 0 1000 1000" preserveAspectRatio="none" style="position:absolute;left:0;top:0;width:100%;height:100%;overflow:visible;pointer-events:none;display:none" aria-hidden="true"><path fill="none" stroke-linecap="round" stroke-linejoin="round"></path></svg>`).join('');
    // `decoUnten` ist ohne das Flag leer — dann ist diese Zeile Zeichen für
    // Zeichen die bisherige Reihenfolge.
    return `${photoDiv}${motifDivs}${leashDivs}${decoUnten}${textDivs}${decoDivs}`;
  }
  /** Die type-"photo"-Ebene des Layouts — null ohne (fremde Produkte unberührt). */
  _photoLayer(layout) {
    return this._findLayer(layout || this._layoutLayers(), 'photo');
  }
  /**
   * Kundenfoto in die Vorschau-Ebene schreiben (Schema v1.18). Reines CSS-
   * Positionieren, kein Canvas: das <img> wird so skaliert/verschoben, dass der
   * gewählte Quell-Ausschnitt (state.photo.crop) den Rahmen deckend füllt —
   * Prozentrechnung setzt voraus, dass crop dasselbe Seitenverhältnis trägt wie
   * die Rahmen-Box (das Modul erzwingt das beim Setzen). Ohne Foto bleibt die
   * Ebene versteckt; ohne config.photo/Layer ist alles ein No-op.
   */
  _applyPhotoLayer(layout) {
    if (!this.config.photo) return;
    const el = this.refs.photo;
    const img = this.refs.photoImg;
    if (!el || !img) return;
    const badge = el.querySelector('[data-ttg="photo-badge"]');
    const p = this.state.photo;
    if (!p || !p.crop || !(p.localUrl || p.url)) {
      // Vorlagenfoto (Schema v1.18, config.photo.sampleUrl): zeigt dem Kunden,
      // wie der Rahmen wirkt, BEVOR er hochlädt. Reine VORSCHAU-Anzeige mit
      // sichtbarem „Beispielfoto"-Schild: state.photo bleibt null — Kauf-Gate
      // (_photoSatisfied), Snapshot und _ttg_foto_config kennen das Sample
      // nie, und die Auflösungs-Ampel des Moduls läuft nur über state.photo.
      // Positionierung per object-fit:cover (CSS-Klasse), nicht über die
      // Crop-Prozentrechnung — die bräuchte die Bildmaße vor dem Laden.
      const sample = this.config.photo.sampleUrl;
      if (sample) {
        el.style.display = '';
        img.classList.add('ttg__photo-img--sample');
        img.style.width = ''; img.style.height = ''; img.style.left = ''; img.style.top = '';
        if (img.getAttribute('src') !== sample) img.setAttribute('src', sample);
        if (badge) badge.hidden = false;
      } else {
        el.style.display = 'none';
      }
      return;
    }
    img.classList.remove('ttg__photo-img--sample');
    if (badge) badge.hidden = true;
    el.style.display = '';
    const src = p.localUrl || p.url;
    if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    const c = p.crop;
    img.style.width = (p.srcW / c.w * 100) + '%';
    img.style.height = (p.srcH / c.h * 100) + '%';
    img.style.left = (-c.x / c.w * 100) + '%';
    img.style.top = (-c.y / c.h * 100) + '%';
    // Auflösungs-Ampel des Moduls nachführen (Größenwechsel ändert die Schwelle).
    if (typeof window !== 'undefined' && window.TTG_FOTO && typeof window.TTG_FOTO.refresh === 'function') {
      window.TTG_FOTO.refresh(this);
    }
  }

  _buyHtml() {
    const s = this.config.strings || {};
    return `
      <div class="ttg__qty" role="group" aria-label="${escapeHtml(s.quantity || 'Menge')}">
        <button type="button" class="ttg__qty-btn" data-action="qty-dec" aria-label="${escapeHtml(s.qty_less || 'weniger')}">−</button>
        <input class="ttg__qty-input" data-ttg="qty" type="text" inputmode="numeric" value="1" aria-label="${escapeHtml(s.quantity || 'Menge')}">
        <button type="button" class="ttg__qty-btn" data-action="qty-inc" aria-label="${escapeHtml(s.qty_more || 'mehr')}">+</button>
      </div>
      <button type="button" class="ttg__add ttg-add--blocked" data-ttg="add" data-action="submit" aria-disabled="true">${escapeHtml(s.add_to_cart || 'In den Warenkorb legen')}</button>`;
  }

  _stickyHtml() {
    const s = this.config.strings || {};
    // Ausgangszustand ohne `disabled`: der Button muss von der ersten Sekunde an
    // klickbar sein, sonst schluckt er den Klick, bevor _updateCta() gelaufen ist.
    return `<button type="button" class="ttg__add ttg__sticky-btn ttg-add--blocked" data-ttg="add" data-action="submit" aria-disabled="true">${escapeHtml(s.add_to_cart || 'In den Warenkorb legen')}</button>`;
  }

  _findLayer(layers, type) {
    for (const key in layers) if (layers[key] && layers[key].type === type) return layers[key];
    return null;
  }
  /** Vertikaler Versatz einer Ebene in % der EIGENEN Höhe (negativ = nach oben).
   *  valign:"middle" macht yPercent zur MITTE der Ebene (−50%) statt zur Oberkante —
   *  generisch über das Flag, für Text UND Deko (keine Typ-Sonderlogik).
   *  offsetYPercent verschiebt zusätzlich (positiv = nach unten) und gleicht damit
   *  einen internen Offset der Grafik aus (Motiv nicht mittig im PNG). Nur für
   *  Bild-Ebenen (Deko/Motiv) — Text-Ebenen haben dafür keine sinnvolle Höhe, und
   *  der Snapshot-Textpfad setzt valign über textBaseline. 0 → kein transform-Anteil. */
  _layerShiftPct(layer, isText) {
    const mid = (layer && layer.valign === 'middle') ? -50 : 0;
    const off = isText ? 0 : (Number(layer && layer.offsetYPercent) || 0);
    if (!isText && layer && (layer.alignInk === 'bottom' || layer.alignInk === 'center')) return mid + off + this._inkVersatzPct(layer);
    return mid + off;
  }
  /**
   * alignInk:"bottom" (Schema v1.35, 23.10.2026 — Silhouetten-Shirts): die Motiv-Ebene sitzt mit
   * der SICHTBAREN Unterkante des Motivs (letzte deckende Zeile, im Katalog-Build als
   * motif.inkUnten = Anteil der Bildhöhe vorberechnet) auf der Unterkante der Ebenen-Box statt
   * mit der Bildkante. Rückgabe: Versatz in % der Box-Höhe, wirkt über _layerShiftPct in
   * Vorschau (transform), Snapshot und Druckvertrag gleich. Rechnung für „contain, zentriert":
   * r = Bildhöhe/Box-Höhe; Bild-Unterkante liegt bei 0.5 + r/2 (Box-Höhen), die Tinte endet
   * (1 − inkUnten)·r darüber → Versatz 0.5 − r/2 + (1 − inkUnten)·r. Ohne inkUnten (Motiv
   * nicht vermessen) oder ohne Motiv: 0 — die Ebene sitzt wie bisher.
   */
  _inkVersatzPct(layer) {
    if (!layer || (layer.alignInk !== 'bottom' && layer.alignInk !== 'center') || layer.type !== 'motif') return 0;
    const m = this._motivGeo();
    if (!m || this.state.noMotif) return 0;
    const ib = Number(m.inkUnten);
    if (!(ib > 0 && ib <= 1)) return 0;
    const r = this._motifBildAnteil(layer, m).h;
    if (layer.alignInk === 'center') {
      // alignInk:"center" (Nachtrag 23.10.2026, Herz mit Hund): Mitte der sichtbaren Tinte auf die
      // Box-Mitte. Braucht inkOben; ohne → kein Versatz.
      const it = Number(m.inkOben);
      if (!(it >= 0 && it < ib)) return 0;
      return r * (0.5 - (it + ib) / 2) * 100;
    }
    return (0.5 - r / 2 + (1 - ib) * r) * 100;
  }
  /** Waagerechter Versatz für alignInk:"center" in % der Box-Breite (inkLinks/inkRechts, mirrorX
   *  gespiegelt). Alle anderen Ebenen: 0 — _layerTransform hängt dann nichts an. */
  _inkVersatzXPct(layer) {
    if (!layer || layer.alignInk !== 'center' || layer.type !== 'motif') return 0;
    const m = this._motivGeo();
    if (!m || this.state.noMotif) return 0;
    const il = Number(m.inkLinks), ir = Number(m.inkRechts);
    if (!(il >= 0 && ir > il && ir <= 1)) return 0;
    let c = (il + ir) / 2;
    if (layer.mirrorX === true) c = 1 - c;
    return this._motifBildAnteil(layer, m).w * (0.5 - c) * 100;
  }
  /** Anteil des „contain"-Bildes an der Ebenen-Box {w, h} (0..1) — Bühne ist quadratisch,
   *  Box-Verhältnis = widthPercent / heightPercent. motif.bildVerhaeltnis (Breite/Höhe, nur
   *  im Katalog, fehlt bei quadratischen Bildern) — Default 1. */
  _motifBildAnteil(layer, m) {
    const a = Number(m && m.bildVerhaeltnis) > 0 ? Number(m.bildVerhaeltnis) : 1;
    const bw = Number(layer.widthPercent) || 0, bh = Number(layer.heightPercent) || 0;
    if (!(bw > 0) || !(bh > 0)) return { w: 1, h: 1 };
    const br = bw / bh;
    return br > a ? { w: a / br, h: 1 } : { w: 1, h: br / a };
  }
  /** Bildrechteck des aktuellen Motivs einer Motiv-Ebene in Bühnen-Anteilen {x, y, w, h}
   *  (0..1, ohne Drehung) — inkl. valign/offsetY/alignInk-Versatz. Gemeinsame Geometrie für
   *  Leine und Aussparung, damit Vorschau, Snapshot und Vertrag dieselbe Zahl sehen. */
  _motifBildRechteck(ml) {
    const m = this._motivGeo();
    const bw = (Number(ml.widthPercent) || 0) / 100, bh = (Number(ml.heightPercent) || 0) / 100;
    const top = (Number(ml.yPercent) || 0) / 100 + (this._layerShiftPct(ml) / 100) * bh;
    const an = this._motifBildAnteil(ml, m);
    const w = an.w * bw, h = an.h * bh;
    const cx = (Number(ml.xPercent) || 0) / 100 + (this._inkVersatzXPct(ml) / 100) * bw;
    return { x: cx - w / 2, y: top + (bh - h) / 2, w, h };
  }
  /**
   * Leinen-Ebene (type:"leash", Schema v1.35): Linie von einem festen Startpunkt (Hand,
   * fromX/fromY in % der Bühne) zum Halspunkt des gewählten Motivs (motif.hals = {x, y} in
   * Anteilen des Motivbilds, im Katalog-Build gesetzt). Ebene nennt ihre Motiv-Ebene über
   * `motif` (Layer-Key); mirrorX und Drehung dieser Ebene werden mitgerechnet. Durchhang
   * `sag` (% der Bühne) setzt den Kontrollpunkt der quadratischen Kurve unter die tiefere
   * Spitze. Strichstärke `width` in % der Bühnenbreite. Rückgabe in Bühnen-Anteilen oder
   * null (kein Motiv / kein Halspunkt / Motiv-Ebene fehlt) — dann zeichnet niemand etwas.
   */
  _leinenLayers(layout) {
    const src = layout || this._layoutLayers() || {};
    const out = [];
    for (const key in src) if (src[key] && src[key].type === 'leash') out.push(Object.assign({ id: key }, src[key]));
    return out;
  }
  _leinenGeometrie(l, layout) {
    const src = layout || this._layoutLayers() || {};
    const ml = src[l.motif];
    const m = this._motivGeo();
    if (!ml || ml.type !== 'motif' || !m || this.state.noMotif || !m.hals) return null;
    const hx = Number(m.hals.x), hy = Number(m.hals.y);
    if (!(hx >= 0 && hx <= 1 && hy >= 0 && hy <= 1)) return null;
    const mlg = Object.assign({ id: l.motif }, ml);
    const b = this._motifBildRechteck(mlg);
    let x2 = b.x + (ml.mirrorX === true ? 1 - hx : hx) * b.w;
    let y2 = b.y + hy * b.h;
    const deg = this._layerRotateDeg(ml);
    if (deg) {   // um die Box-Mitte, Uhrzeigersinn (CSS-Konvention)
      const bh = (Number(ml.heightPercent) || 0) / 100;
      const cx = (Number(ml.xPercent) || 0) / 100;
      const cy = (Number(ml.yPercent) || 0) / 100 + (this._layerShiftPct(mlg) / 100) * bh + bh / 2;
      const rad = (deg * Math.PI) / 180, dx = x2 - cx, dy = y2 - cy;
      x2 = cx + dx * Math.cos(rad) - dy * Math.sin(rad);
      y2 = cy + dx * Math.sin(rad) + dy * Math.cos(rad);
    }
    const x1 = (Number(l.fromX) || 0) / 100, y1 = (Number(l.fromY) || 0) / 100;
    const sag = (Number(l.sag) || 0) / 100;
    return { x1, y1, cx: (x1 + x2) / 2, cy: Math.max(y1, y2) + sag, x2, y2, w: (Number(l.width) || 0.6) / 100 };
  }
  /** Motiv-Ebene mit knockout:"<deco-id>" (Schema v1.35): das Motiv wird nicht gedruckt, sondern
   *  aus dieser Deko-Ebene ausgespart (Herz mit Hund). Map deco-id → Motiv-Ebene. */
  _aussparungen(layout) {
    const src = layout || this._layoutLayers() || {};
    let map = null;
    for (const key in src) {
      const l = src[key];
      if (l && l.type === 'motif' && typeof l.knockout === 'string' && l.knockout) (map || (map = {}))[l.knockout] = Object.assign({ id: key }, l);
    }
    return map;
  }
  /** Gespiegelte Kopie eines Motivbilds als data-URL (nur für Aussparungs-Masken mit mirrorX). Erster Aufruf
   *  lädt asynchron und zeichnet danach neu; bis dahin null (die Deko steht kurz ohne Loch). */
  _gespiegelteMaske(url) {
    this._spiegelCache = this._spiegelCache || new Map();
    if (this._spiegelCache.has(url)) return this._spiegelCache.get(url);
    this._spiegelCache.set(url, null);
    this._loadImg(url).then((img) => {
      if (!img || typeof document === 'undefined') return;
      const c = document.createElement('canvas'); c.width = img.width; c.height = img.height;
      const x = c.getContext('2d'); x.translate(img.width, 0); x.scale(-1, 1); x.drawImage(img, 0, 0);
      try { this._spiegelCache.set(url, c.toDataURL('image/png')); this.renderPreview(); } catch (_) { /* Canvas ohne CORS: ohne Loch */ }
    });
    return null;
  }
  /** Leinen-Ebene mit knockout:"<deco-id>" (Nachtrag 23.10.2026, Online/Offline-Felder): die Leine wird
   *  nicht gedruckt, sondern aus dieser Deko ausgespart. Map deco-id → [Leinen-Ebenen]; null ohne. */
  _leinenAussparungen(layout) {
    let map = null;
    for (const l of this._leinenLayers(layout)) {
      if (typeof l.knockout === 'string' && l.knockout) ((map || (map = {}))[l.knockout] = (map[l.knockout] || [])).push(l);
    }
    return map;
  }
  _layerShiftY(layer, isText) {
    const t = this._layerShiftPct(layer, isText);
    return t ? ` translateY(${t}%)` : '';
  }
  /** Drehung einer Ebene in Grad — rotate:20 = 20° IM UHRZEIGERSINN (CSS-Konvention,
   *  y-Achse zeigt nach unten; negativ = gegen den Uhrzeigersinn). Gilt für ALLE
   *  Ebenentypen (Motiv, Deko, Text). 0 → kein Anteil.
   *
   *  Text war bis 05.08.2026 hart auf 0 geklemmt, weil der Snapshot-Textpfad an einer
   *  Box OHNE Höhe zeichnet: dort läge der Drehpunkt auf der Oberkante, im DOM aber
   *  in der Mitte der Zeilenhöhe — der Versatz wäre mit dem Winkel gewachsen. Die
   *  Klemme ist gefallen, weil _drawSnapshotText jetzt eine Ersatzbox mit der
   *  DOM-Zeilenhöhe (TEXT_LINE_HEIGHT) aufspannt und um DEREN Mitte dreht. */
  _layerRotateDeg(layer) {
    return Number(layer && layer.rotate) || 0;
  }
  _layerRotate(layer) {
    const d = this._layerRotateDeg(layer);
    return d ? ` rotate(${d}deg)` : '';
  }
  /** Horizontale Spiegelung (mirrorX:true, Schema v1.17) — nur Bild-Ebenen
   *  (Motiv/Deko), Text ignoriert das Flag (gespiegelte Schrift wäre unlesbar
   *  und nie gewollt). scaleX(-1) steht als LETZTES Glied der Kette: CSS wendet
   *  rechts-zuerst an, gespiegelt wird also um die EIGENE Mitte, DANN
   *  rotiert/verschoben — Box-Position und Drehsinn bleiben exakt wie
   *  ungespiegelt, nur die Grafik klappt um. Ohne Flag: leer → byte-identische
   *  transform-Kette für alle Bestands-Layouts. */
  _layerMirror(layer, isText) {
    return (!isText && layer && layer.mirrorX === true) ? ' scaleX(-1)' : '';
  }
  /** Vollständige transform-Kette einer Ebene. Reihenfolge ist bindend:
   *  translateX/Y zuerst (setzt die Ebenen-MITTE auf x/yPercent), rotate ZULETZT.
   *  CSS wendet die Liste als Matrix T×R an → gedreht wird um transform-origin
   *  (Default 50% 50% = Ebenen-Mitte), und die Translation bleibt in den Eltern-Achsen.
   *  Die Mitte wandert dadurch beim Drehen nicht — Position/Zentrierung bleiben exakt.
   *  Umgekehrte Reihenfolge (rotate zuerst) würde den Versatz mitdrehen und die Ebene
   *  verschieben. */
  _layerTransform(layer, isText) {
    const dx = (!isText && layer && layer.alignInk === 'center') ? this._inkVersatzXPct(layer) : 0;
    return 'translateX(-50%)' + (dx ? ` translateX(${dx}%)` : '') + this._layerShiftY(layer, isText) + this._layerRotate(layer)
      + this._layerMirror(layer, isText);
  }
  _layerBoxStyle(layer, isText) {
    if (!layer) return 'display:none';
    let s = `left:${layer.xPercent}%;top:${layer.yPercent}%;width:${layer.widthPercent}%;transform:${this._layerTransform(layer, isText)};`;
    if (!isText && layer.heightPercent != null) s += `height:${layer.heightPercent}%;`;
    if (isText) s += `text-align:${layer.align || 'center'};`;
    return s;
  }
  /** Layer-Geometrie zur LAUFZEIT nachführen (Layout v2: Overrides je Options-
   *  wert ändern Position/Größe nach dem Mount — z. B. Damen-/Herren-Schnitt).
   *  Setzt nur die Box-Properties, nie display (das steuert renderPreview). */
  _applyLayerBox(el, layer, isText) {
    if (!el || !layer) return;
    el.style.left = layer.xPercent + '%';
    el.style.top = layer.yPercent + '%';
    el.style.width = layer.widthPercent + '%';
    if (!isText && layer.heightPercent != null) el.style.height = layer.heightPercent + '%';
    // valign/offsetY/rotate (s. _layerTransform) auch bei Layout-Overrides beibehalten —
    // für Text UND Deko. Ohne die Flags ergibt das exakt das bisherige translateX(-50%).
    el.style.transform = this._layerTransform(layer, isText);
    if (isText) el.style.textAlign = layer.align || 'center';
  }

  // ---- Auto-Druckfarbe (Kontrast aus Hintergrund) + Deko-Ebenen -------------
  /** Hex der aktuell gewählten Hintergrundfarbe (aus den Swatches) oder null. */
  _currentBgHex() {
    const sw = (this.config.base && this.config.base.swatches) || {};
    const h = sw[this.state.color];
    return (typeof h === 'string' && /^#?[0-9a-fA-F]{6}$/.test(h.trim())) ? h.trim() : null;
  }
  /** Kontrast-Tinte aus einem Hintergrund-Hex: helle Matte → dunkle Tinte, dunkle
   *  Matte → helle Tinte (YIQ-Helligkeit, Schwelle 128). Ohne Hex → dunkler Default. */
  _autoInk(bgHex) {
    const dark = '#1f1f1f', light = '#ffffff';
    if (!bgHex) return dark;
    const h = bgHex.replace('#', '');
    const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    return ((r * 299 + g * 587 + b * 114) / 1000) >= 128 ? dark : light;
  }
  /** Farbwert auflösen: NUR der Literal "auto" wird zur Kontrast-Tinte der aktuellen
   *  Hintergrundfarbe; jeder andere Wert (Hex/undefined) bleibt unverändert →
   *  bestehende Produkte byte-gleich (kein Produkt nutzt heute "auto"). */
  _resolveInk(value) {
    if (value !== 'auto') return value;
    // Per-Hintergrundfarbe fester Tinten-Override (customizer_layout.inkByColor,
    // Map: Farbname → Hex, z. B. {"Schwarz":"#2b2b2b"}). Gesetzt → gewinnt über die
    // Auto-Kontrast-Berechnung genau für diese Farbe; alle anderen bleiben auf Auto.
    // Fehlt inkByColor (oder die Farbe), unverändert = reines "auto".
    const ov = (this.config.layout && this.config.layout.inkByColor) || {};
    const forced = this.state.color != null ? ov[this.state.color] : null;
    if (typeof forced === 'string' && /^#?[0-9a-fA-F]{3,8}$/.test(forced.trim())) return forced.trim();
    return this._autoInk(this._currentBgHex());
  }
  /** Statische Deko-Ebenen (type:"deco") aus dem Layout — [] wenn keine.
   *  Rein additiv: Produkte ohne solche Ebenen erhalten eine leere Liste, damit
   *  Vorschau-/Snapshot-Loops schlicht nichts tun (byte-gleiches Verhalten). */
  /**
   * Bildgetriebener Auswahl-Schritt? (Schema v1.11) — def.values liefert die
   * Knopfreihe, def.valueImages die Grafik je Wert. Der Schritt verhält sich
   * ansonsten wie jeder Text-Schritt: derselbe State, dasselbe done-Gate,
   * dieselbe sichtbare Line-Item-Property. Nur GEZEICHNET wird statt Text ein
   * Bild — auf der deco-Ebene aus def.layer.
   */
  _isImageValueDef(def) {
    return !!(def && def.valueImages && Array.isArray(def.values) && def.values.length);
  }
  /** Aktuell gewählte Grafik eines bildgetriebenen Defs (oder null). */
  _valueImageFor(def) {
    if (!this._isImageValueDef(def)) return null;
    if (this._textAus(def)) return null;
    const v = this.state.texts[def.id];
    if (!v) return null;
    const url = def.valueImages[v];
    return (typeof url === 'string' && url.trim()) ? url.trim() : null;
  }
  /** Werte-Schritt, dessen Wahl das Basisbild bestimmt (Schema v1.34, def.baseImages)? */
  _isBaseValueDef(def) {
    return !!(def && def.baseImages && Array.isArray(def.values) && def.values.length);
  }
  /** Keine Text-Ebene, kein Druck-Text, keine Schrift: Grafik-Werte (v1.11) und Basisbild-Werte (v1.34).
   *  Ohne baseImages identisch zu _isImageValueDef — Bestandsprodukte unverändert. */
  _ohneTextEbene(def) {
    return this._isImageValueDef(def) || this._isBaseValueDef(def);
  }
  /** Basisbild eines Werts für den aktuellen Wert der Achse def.baseImagesBy (oder Einzel-URL). */
  _wertBild(def, v) {
    const e = def && def.baseImages ? def.baseImages[v] : null;
    if (typeof e === 'string') return e.trim() || null;
    if (!e || typeof e !== 'object') return null;
    const achse = def.baseImagesBy ? this._selectedOptionValue(def.baseImagesBy) : null;
    const u = achse != null ? e[achse] : null;
    return (typeof u === 'string' && u.trim()) ? u.trim() : null;
  }
  /** Basisbild aus dem gewählten Wert eines Basisbild-Schritts — null, wenn keiner greift. */
  _wertBasisbild() {
    for (const def of this.texts) {
      if (!this._isBaseValueDef(def) || this._textAus(def)) continue;
      const v = this.state.texts[def.id];
      const url = v ? this._wertBild(def, v) : null;
      if (url) return url;
    }
    return null;
  }
  /** Kachelbild eines Werts (tiles:"image"): tileImages, sonst Basisbild der aktuellen Achse, sonst valueImages. */
  _kachelBild(def, v) {
    const t = def.tileImages ? def.tileImages[v] : null;
    if (typeof t === 'string' && t.trim()) return t.trim();
    const b = this._wertBild(def, v);
    if (b) return b;
    const g = def.valueImages ? def.valueImages[v] : null;
    return (typeof g === 'string' && g.trim()) ? g.trim() : null;
  }

  _decoLayers() {
    const layers = this._layoutLayers() || {};
    // Bildgetriebene Schritte speisen ihre deco-Ebene aus der Kundenwahl. Die
    // Ebene selbst bleibt eine ganz normale deco-Ebene — Einfärbung, rotate,
    // valign, shadow und der Snapshot-Pfad gelten unverändert. Ohne Auswahl
    // bleibt url leer, und die bestehende `if (!l.url)`-Prüfung blendet sie aus.
    const ausWahl = {};
    for (const def of this.texts) {
      if (!this._isImageValueDef(def) || !def.layer) continue;
      ausWahl[def.layer] = this._valueImageFor(def);
    }
    const out = [];
    for (const key in layers) {
      const l = layers[key];
      if (!l || l.type !== 'deco') continue;
      const e = Object.assign({ id: key }, l);
      if (Object.prototype.hasOwnProperty.call(ausWahl, key)) e.url = ausWahl[key] || '';
      out.push(e);
    }
    return out;
  }

  /** Alle Motiv-Ebenen (type:"motif") als [{id, …Geometrie}] in Layout-
   *  Reihenfolge — Muster wie _decoLayers. Mehrere Ebenen dürfen denselben
   *  Motiv-Step speisen (source dokumentiert das; es gibt je Config genau
   *  EINEN Motiv-Step, also zeigen alle dasselbe state.motif — Doppelmotiv
   *  Handtuch: motiv_links gespiegelt + motiv_rechts). `layers` optional
   *  vorberechnet: renderPreview reicht sein _layoutLayers()-Ergebnis durch,
   *  damit pro Render kein zweiter Override-Merge läuft. */
  _motifLayers(layers) {
    const src = layers || this._layoutLayers() || {};
    const out = [];
    for (const key in src) {
      if (src[key] && src[key].type === 'motif') out.push(Object.assign({ id: key }, src[key]));
    }
    return out;
  }

  /**
   * Vollfarb-Motiv? Datengetrieben über config.fullColorCategories (Array von
   * Kategorie-Namen). Fehlt der Key → immer false → alles wird wie bisher
   * maskiert/eingefärbt (Warnweste unberührt).
   */
  _isFullColorMotif(m) {
    const cats = this.config.fullColorCategories;
    return !!(m && Array.isArray(cats) && m.kategorie && cats.indexOf(m.kategorie) !== -1);
  }

  /** Bildliste eines Motivs: motif.bilder [{url,id},…] oder Fallback auf das einzelne bild. */
  /** Geometrie des gewählten Motivbilds (Schema v1.38, 24.10.2026, Halspunkte Bild 2/3): Felder am Bildeintrag
   *  (bilder[i].inkUnten/inkOben/inkLinks/inkRechts/hals/bildVerhaeltnis, im Katalog-Build gesetzt) gewinnen über die
   *  Felder je Motiv; fehlt ein Feld am Bild, gilt der Motivwert (Bild 1 und alle Bestandsmotive: unverändert).
   *  Gilt nur für das Motiv im Zustand — die gewählte Bildvariante gehört zu ihm. */
  _motivGeo(m = this.state && this.state.motif) {
    if (!m || m !== (this.state && this.state.motif)) return m;
    const b = this._currentMotifImage(m);
    const F = ['inkUnten', 'inkOben', 'inkLinks', 'inkRechts', 'hals', 'bildVerhaeltnis'];
    if (!b || !F.some((f) => b[f] != null)) return m;
    const o = Object.create(m);
    for (const f of F) if (b[f] != null) o[f] = b[f];
    return o;
  }
  _motifImages(m) {
    if (m && Array.isArray(m.bilder) && m.bilder.length) {
      const imgs = m.bilder.filter((b) => b && b.url);
      if (!this.config || !this._hatExcludeMotifs()) return imgs;
      // excludeMotifs mit Bildvarianten (s. _bildAusgeschlossen) — nie alle Bilder entfernen.
      const frei = imgs.filter((b) => !this._bildAusgeschlossen(m, b));
      return frei.length ? frei : imgs;
    }
    if (m && m.bild) return [{ url: m.bild, id: m.gid || m.id || '' }];
    return [];
  }
  /** Aktuell gewähltes Motiv-Bild (Variante) — {url,id} oder null. */
  _currentMotifImage(m = this.state.motif, idx = this.state.motifVariant) {
    const imgs = this._motifImages(m);
    if (!imgs.length) return null;
    return imgs[Math.min(Math.max(idx || 0, 0), imgs.length - 1)];
  }
  /** Dateiname aus einer Bild-URL (Fallback-Kennung, wenn keine Bild-ID vorliegt). */
  _fileNameFromUrl(url) {
    if (!url) return '';
    const noQuery = String(url).split('?')[0];
    return noQuery.substring(noQuery.lastIndexOf('/') + 1) || '';
  }
  /**
   * Produktions-Basisname eines Motiv-Bildes: Dateiname ohne Endung und ohne den
   * von Shopify bei Namenskollisionen angehängten UUID-Suffix
   * ("_d9eaf0be-1234-…"). Beispiel: "15MT_Frau_d9eaf0be-….png" → "15MT_Frau".
   * Ohne UUID-Suffix bleibt nur die Endung ab ("15MT_Frau.png" → "15MT_Frau").
   */
  _motifBaseName(nameOrUrl) {
    let n = this._fileNameFromUrl(nameOrUrl) || String(nameOrUrl == null ? '' : nameOrUrl);
    n = n.replace(/\.[a-z0-9]+$/i, '');                                                // Endung ab
    n = n.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, ''); // Shopify-UUID-Suffix ab
    return n;
  }

  /** Base-Umschalter-Optionen (config.baseOptions = [{label, image}, …]) oder []. */
  _baseOptions() {
    const o = this.config.baseOptions;
    return Array.isArray(o) ? o.filter((x) => x && x.image) : [];
  }
  /** Rück-/Nicht-Default-Seitenbild (config.sides.images), aufgelöst über die
   *  konfigurierten Achsen (imageKey, z. B. Geschlecht × Farbe). Default-Seite
   *  (Vorderseite) → null (nutzt das Variantenbild). Fehlt die Kombination im Map
   *  → null (Fallback aufs Variantenbild statt kaputtem Bild). Ohne config.sides
   *  immer null → _currentBaseImage byte-identisch wie bisher. */
  _sideImage() {
    const cfg = this.config.sides;
    if (!cfg || !cfg.images) return null;
    const side = this.state.side;
    if (!side || side === (cfg.default || null)) return null;   // Vorderseite → Variantenbild
    const map = cfg.images[side];
    if (!map || typeof map !== 'object') return null;
    const axes = Array.isArray(cfg.imageKey) ? cfg.imageKey : [];
    // normalizeKey: die Section leitet den Map aus Dateinamen-Tokens ab (klein,
    // ß→ss). Dann müssen die Achsen-Werte (Optionswerte wie „Weiß") identisch
    // normalisiert werden, sonst matcht der Schlüssel nicht. Ohne das Flag: Rohwerte.
    const norm = cfg.normalizeKey
      ? (v) => String(v == null ? '' : v).toLowerCase().replace(/ß/g, 'ss').replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
      : (v) => v;
    const key = axes.map((n) => norm(this._selectedOptionValue(n))).join('|');
    return map[key] || null;
  }
  /** Aktuell anzuzeigendes Base-Foto (Motivseite > Vorlagen-Auswahl > per-Farbe-Bild > Einzelquelle). */
  _currentBaseImage() {
    // Rückseite gewählt (und ein Rück-Foto für Schnitt×Farbe vorhanden) → dieses.
    const sideImg = this._sideImage();
    if (sideImg) return sideImg;
    // Basisbild je Auswahlwert (Schema v1.34): ein Werte-Schritt mit baseImages (z. B. Design × Größe)
    // schlägt die Achsen-Bilder. Ohne solchen Schritt null → Reihenfolge wie bisher.
    const wertBild = this._wertBasisbild();
    if (wertBild) return wertBild;
    // Rasse-Motive: das Foto der gewählten Variante (Rasse × Ausführung); ohne gewählte
    // Ausführung das Kachelbild des Motivs (= dasselbe Variantenfoto wie im Grid).
    if (this._motifAchse()) {
      const cur = this.resolveVariant();
      if (cur && cur.image) return cur.image;
      if (this.state.motif && this.state.motif.bild) return this.state.motif.bild;
    }
    const opts = this._baseOptions();
    if (opts.length) return (opts[this.state.baseChoice] || opts[0]).image;
    // Mit extraOptions folgt das Foto der ersten Variante, die Farbe UND
    // Zusatz-Optionen matcht (Damen-/Herren-Mockups unterscheiden sich).
    // Initial identisch zur Farb-Map (erster Optionswert = erste Variante der
    // Farbe) → der SSR-Adopt (Teil 3) bleibt byte-exakt. Ohne extraOptions
    // unverändert die per-Farbe-Ableitung.
    if (this.extraOptions.length) {
      const ci = this._optionIndex(this.config.base.optionName);
      const match = this.config.variants.find((vv) => (
        (ci < 0 || vv.options[ci] === this.state.color) && this._extraMatch(vv) && vv.image
      ));
      if (match) return match.image;
    }
    const byColor = this.baseImages[this.state.color];
    if (byColor) return byColor;
    // Ab hier ist die je Optionswert gepflegte Quelle erschöpft. Beide folgenden
    // Ausgänge waren bis 30.08.2026 STILL: die Kachelreihe meldete ein fehlendes
    // Blanko längst (_colorRow → _warnEinmal), die Bühne — also die Hälfte, die der
    // Kunde ansieht — nicht. Kein stiller Fallback: beide melden jetzt.
    const basisOpt = (this.config.base && this.config.base.optionName) || '';
    const hatFarbachse = this._optionIndex(basisOpt) >= 0;
    const wert = (this.state.color == null || this.state.color === '') ? '(kein Wert gewählt)' : this.state.color;
    if (this.config.base && this.config.base.image) {
      // Einzelquelle = erstes Produktmedium mit dem Alt-Marker „Vorlage für
      // Personalisierung" (ttg-customizer.liquid, base_img). OHNE Farbachse ist sie die
      // VORGESEHENE Quelle, kein Ersatz — dort bleibt es still, sonst warnte jedes
      // korrekt gepflegte einfarbige Produkt bei jedem Aufruf und die Meldung wäre
      // Rauschen statt Signal. MIT Farbachse ist sie ein echter Ersatz: alle Farben
      // zeigen dasselbe Blanko, und das ist für mindestens eine davon das falsche.
      if (hatFarbachse) {
        this._warnEinmal('basisbild-ersatz-' + wert, `Kein eigenes Basisbild für den Optionswert "${wert}" — die Bühne zeigt ersatzweise die Einzelquelle (Produktmedium mit Alt-Marker "Vorlage für Personalisierung"). Erwartet wäre custom.customizer_base_images["${wert}"] oder ein Variantenbild dieses Optionswerts.`);
      }
      return this.config.base.image;
    }
    // Hat das Produkt die bildgebende Achse gar nicht (einfarbiges Produkt ohne
    // variant_option-Schritt), bleibt baseImages leer — dann trägt die VARIANTE das
    // Basisbild. Bewusst nur in diesem Fall: MIT Farbachse wäre das Bild einer
    // fremden Variante schlicht die falsche Farbe, da ist „kein Bild" ehrlicher.
    // Erst die aktuell gewählte Variante, sonst (noch keine Größe gewählt) die erste
    // mit Bild. Generisch über das FEHLEN der Achse — keine produktspezifische Logik.
    if (!hatFarbachse) {
      const cur = this.resolveVariant();
      if (cur && cur.image) return cur.image;
      const first = this.config.variants.find((v) => v.image);
      if (first) return first.image;
    }
    // Letzte Stufe: gar kein Bild. renderPreview() setzt dann KEIN src (`if (img && …)`),
    // das <img class="ttg__base"> bleibt ohne Quelle stehen — ohne Meldung ist das von
    // einem noch ladenden Bild nicht zu unterscheiden. Die drei möglichen Quellen
    // stehen in der Meldung, damit die Ursache in der Konsole steht statt gesucht wird.
    this._warnEinmal('basisbild-fehlt-' + wert, `Kein Basisbild für den Optionswert "${wert}" — die Bühne bleibt leer. Drei mögliche Quellen, in dieser Rangfolge: (1) Produkt-Metafeld custom.customizer_base_images["${wert}"], (2) Variantenbild der Variante mit diesem Optionswert, (3) Produktmedium mit dem Alt-Marker "Vorlage für Personalisierung" (Einzelquelle, nur ohne Farbachse vorgesehen).`);
    return null;
  }

  /** Shopify-CDN-Bild auf eine gewünschte Breite bringen (responsiv, weniger Bytes). */
  _sizedImg(u, w) {
    try {
      const base = (typeof location !== 'undefined' && location.href) ? location.href : 'https://x/';
      const url = new URL(u, base);
      url.searchParams.set('width', String(w));
      return url.href;
    } catch (e) { return u; }
  }

  /**
   * Basis-Vorschaubild responsiv setzen (LCP): srcset über mehrere Breiten statt
   * fix 1000px — der Browser lädt nur die zur Bühnengröße passende Stufe. Die
   * sizes-Angabe bildet das echte Layout ab (Desktop-Spalte = Container − 460px
   * Rechte-Spalte − 40px Gap, gedeckelt bei 1080px Container → max. 580px).
   * Nur für Shopify-CDN-Bilder (per width-Parameter skalierbar); sonst unverändert.
   * Der Bestellbild-Snapshot lädt weiterhin die volle Quelle (_currentBaseImage).
   */
  _applyResponsiveBase(base, img) {
    const scalable = /\/cdn\/shop\//.test(img) || /cdn\.shopify\.com/.test(img) || /[?&]width=\d+/.test(img);
    if (!scalable) { base.setAttribute('src', img); base.removeAttribute('srcset'); return; }
    const widths = [360, 480, 600, 760, 1000, 1200];
    base.setAttribute('src', this._sizedImg(img, 600));
    base.setAttribute('srcset', widths.map((w) => this._sizedImg(img, w) + ' ' + w + 'w').join(', '));
    if (!base.getAttribute('sizes')) {
      base.setAttribute('sizes', '(min-width: 1080px) 580px, (min-width: 750px) calc(100vw - 500px), 92vw');
    }
  }

  /* -------------------------------------------------------------- Rendering */
  renderPreview() {
    this._syncMotifVariant();
    const { base, motif } = this.refs;
    const layout = this._layoutLayers();

    // Layer-Geometrie (left/top/width/height) NUR nachschreiben, wenn ein
    // override-relevanter Optionswert sich seit dem letzten Render geändert hat.
    // INP-Disziplin: v1-Produkte (Warnweste, Fußmatte, alle Live-Exposure) haben
    // keine overrides → Signatur null → dieser Block bleibt komplett aus. Der
    // Render-Pfad ist dann byte-identisch zu VOR dem v2-Umbau — kein zusätzlicher
    // Style-Write vor der Text-Fit-Messung, also kein extra Forced Reflow pro
    // Tastenanschlag. Bei v2 kostet ein Render nur einen String-Vergleich; die
    // Box-Writes fallen ausschließlich beim echten Optionswechsel (z. B. Schnitt)
    // an — und dann auf ALLE Ebenen (auch versteckte), damit eine später
    // eingeblendete Ebene nie mit veralteter Geometrie erscheint.
    const laySig = this._layoutSignature();
    const motifLayers = this._motifLayers(layout);
    // Schema v1.35 (Silhouetten-Shirts): null bzw. [] ohne die Ebenen-Optionen → No-Op.
    const aussparung = this._aussparungen(layout);
    const leinen = this._leinenLayers(layout);
    const leinenAus = this._leinenAussparungen(layout);
    if (laySig !== null && laySig !== this._lastLayoutSig) {
      for (const ml0 of motifLayers) {
        const el0 = this.refs.motifs ? this.refs.motifs[ml0.id] : null;
        if (el0) this._applyLayerBox(el0, ml0, false);
      }
      for (const def of this.texts) {
        if (this._ohneTextEbene(def)) continue;   // keine Text-Ebene vorhanden
        const el0 = this.refs.texts ? this.refs.texts[def.id] : null;
        const tl0 = this._textLayer(def);
        if (el0 && tl0) this._applyLayerBox(el0, tl0, true);
      }
      // Foto- und Deko-Ebenen EBENFALLS nachführen (28.08.2026). Bis hierher
      // fasste der Block nur Motiv und Text an — beim Designwechsel der
      // Foto-Leckerlidose blieben Fotorahmen und Passepartout auf der
      // Geometrie des VORHERIGEN Designs stehen (live gemessen: Fotobox
      // 146,6x117,4 px statt 212,4x172,0 auf der 580er-Buehne, Faktor 1,449 —
      // das Kundenfoto lag als kleines Rechteck mitten im Herzkranz, und der
      // Zoom konnte es nicht retten, weil er nur IN der falschen Box zoomt).
      // Die Deko-URL wechselte dagegen laengst bei jedem Render (Deko-Loop
      // unten) — Herz-PNG in der Pfoten-Box. Bestand (gemessen 28.08.2026,
      // scripts/mess-overrides-ebenen-2026-08-28.mjs, 116 Layouts): 9 tragen
      // overrides, davon hat neben der Dose genau EINES eine deco-Ebene —
      // muetze-hundemama-papa. Dessen Overrides verschieben den 'schriftzug'
      // je Muetzenart um 1-2 % und liefen bis heute ins Leere (derselbe
      // Defekt, unauffaellig klein). Der Fix fuehrt ihn ab jetzt nach — eine
      // gewollte Reparatur, keine Regression. Die uebrigen 7 haben weder
      // photo- noch deco-Ebenen: dort ist das hier ein No-op.
      const pl0 = this._photoLayer(layout);
      if (pl0 && this.refs.photo) this._applyLayerBox(this.refs.photo, pl0, false);
      for (const dl0 of this._decoLayers()) {
        const el0 = this.refs.deco ? this.refs.deco[dl0.id] : null;
        if (el0) this._applyLayerBox(el0, dl0, false);
      }
    }
    this._lastLayoutSig = laySig;

    // Gruppen-Ebenen (Schema v1.19) nachführen, wenn der Kunde das Namensfeld
    // bewegt/skaliert hat. BEWUSST ein eigener Block neben dem Override-Block
    // darüber: der fasst nur Motiv- und Text-Ebenen an: käme hier Deko hinzu,
    // änderte sich das Verhalten von Bestands-Configs mit Overrides.
    // Die Schriftgröße folgt von allein — _fitText liest den Layer bei jedem
    // Render neu, und der trägt die skalierte fontSizePercent.
    const grpSig = this._groupSignature();
    if (grpSig !== null && grpSig !== this._lastGroupSig) {
      for (const l of this._decoLayers()) {
        if (!l.group) continue;
        const el0 = this.refs.deco ? this.refs.deco[l.id] : null;
        if (el0) this._applyLayerBox(el0, l, false);
      }
      for (const def of this.texts) {
        if (this._ohneTextEbene(def)) continue;
        const tl0 = this._textLayer(def);
        if (!tl0 || !tl0.group) continue;
        const el0 = this.refs.texts ? this.refs.texts[def.id] : null;
        if (el0) this._applyLayerBox(el0, tl0, true);
      }
      for (const ml0 of this._motifLayers(layout)) {
        if (!ml0.group) continue;
        const el0 = this.refs.motifs ? this.refs.motifs[ml0.id] : null;
        if (el0) this._applyLayerBox(el0, ml0, false);
      }
    }
    this._lastGroupSig = grpSig;

    // Base-Layer — nur src tauschen. Quelle: gewählte Base-Vorlage (config.baseOptions),
    // sonst per-Farbe-Bild, sonst konfigurierte Einzelquelle.
    const img = this._currentBaseImage();
    if (img && base.getAttribute('data-ttg-basesrc') !== img) {
      base.setAttribute('data-ttg-basesrc', img);
      this._applyResponsiveBase(base, img);
    }
    base.setAttribute('alt', this.config.strings?.baseAlt || 'Vorschau');

    // Foto-Ebene (Schema v1.18): no-op ohne config.photo bzw. ohne Foto-Layer.
    this._applyPhotoLayer(layout);

    // Motiv-Ebenen: Vollfarb-Illustration als Bild, sonst CSS-Maske + Druckfarbe.
    // ALLE type-"motif"-Ebenen zeigen dasselbe state.motif (ein Motiv-Step speist
    // sie alle, s. _motifLayers) — ein Motivwechsel aktualisiert sie damit im
    // SELBEN Render gleichzeitig. Spiegelung (mirrorX) sitzt in der transform-
    // Kette der Ebene (_layerMirror), nicht hier.
    if (motifLayers.length && this.state.motif && !this.state.noMotif) {
      const cur = this._currentMotifImage();
      const url = cur ? cur.url : this.state.motif.bild;
      const voll = this._isFullColorMotif(this.state.motif);
      // _resolveInk: "auto" → Kontrast-Tinte der Hintergrundfarbe; Hex unverändert.
      const ink = voll ? null : this._resolveInk(this.state.druckfarbe);
      for (const ml of motifLayers) {
        const mel = this.refs.motifs ? this.refs.motifs[ml.id] : null;
        if (!mel) continue;
        // Aussparungs-Ebene (knockout, Schema v1.35): zeichnet nicht selbst — die Deko-Ebene
        // trägt das Loch (Deko-Loop unten).
        if (ml.knockout) { mel.style.display = 'none'; continue; }
        // alignInk (Schema v1.35): Versatz hängt am Motiv → transform bei jedem Render neu.
        if (ml.alignInk === 'bottom' || ml.alignInk === 'center') mel.style.transform = this._layerTransform(ml, false);
        mel.style.display = '';
        if (voll) {
          // Vollfarbe: normales Bild — keine Maske, keine Einfärbung.
          mel.style.webkitMaskImage = 'none';
          mel.style.maskImage = 'none';
          mel.style.backgroundColor = 'transparent';
          mel.style.backgroundImage = `url("${url}")`;
          mel.style.backgroundRepeat = 'no-repeat';
          mel.style.backgroundPosition = 'center';
          mel.style.backgroundSize = 'contain';
        } else {
          // Einfarbig: Alphakanal-Maske, eingefärbt über Druckfarbe (bisheriges Verhalten).
          mel.style.backgroundImage = 'none';
          mel.style.webkitMaskImage = `url("${url}")`;
          mel.style.maskImage = `url("${url}")`;
          // Akzentfarbe (Schema v1.35): inkSource:"accent" färbt diese Ebene mit der Akzentfarbe.
          mel.style.backgroundColor = ml.inkSource === 'accent' ? this._ebenenTinte(ml) : ink;
        }
      }
    } else {
      // Kein Motiv gewählt / „Kein Motiv" / keine Motiv-Ebene: alles verstecken.
      const mels = this.refs.motifs && Object.keys(this.refs.motifs).length
        ? Object.values(this.refs.motifs) : (motif ? [motif] : []);
      for (const mel of mels) mel.style.display = 'none';
    }

    // Text-Layer: pro Text-Def eine eigene Ebene; ohne Eingabe optional der
    // Vorschau-Platzhalter (def.placeholder) — nur Darstellung, nicht im Cart.
    for (const def of this.texts) {
      if (def.blockChars) this._setzeSperre(def);  // Schema v1.36, ohne blockChars kein Aufruf
      if (this._ohneTextEbene(def)) continue;     // zeichnet die deco-Ebene
      const el = this.refs.texts ? this.refs.texts[def.id] : null;
      if (!el) continue;
      const tl = this._textLayer(def);
      if (!tl) { el.style.display = 'none'; continue; }
      const raw = this.state.texts[def.id] || '';
      const typed = raw.trim();
      // Sekundäre Slots zeigen NIE den Platzhalter in der Vorschau (leer = nichts
      // drucken); der Platzhalter gehört dort nur ins Eingabefeld.
      const content = typed ? raw : (def.secondary ? '' : (def.placeholder || ''));
      const show = !this._textAus(def) && content !== '';
      el.style.display = show ? '' : 'none';
      if (show) {
        // Schrift/Farbe pro Ebene: fixe Def-Werte gewinnen, sonst globale Auswahl.
        // _fontDef löst ID oder Familiennamen (Schema v1.17) auf.
        const font = this._textFont(def);
        el.style.fontFamily = font ? font.stack : 'inherit';
        // Versalsatz pro Ebene (layout.layers.<id>.transform:"uppercase"): VOR _fitText,
        // damit die (breiteren) Großbuchstaben korrekt eingepasst werden. Fehlt das Flag,
        // bleibt textTransform leer → bestehende Ebenen unverändert.
        el.style.textTransform = (tl && tl.transform === 'uppercase') ? 'uppercase' : '';
        el.style.color = this._resolveInk(this._textColorOf(def) || this.state.druckfarbe);
        // Lesbarkeits-Kontur: dezenter dunkler Schatten, damit helle Schrift auch
        // auf hellen Hintergründen (Beige/Holz/Kork) lesbar bleibt. Der Snapshot
        // rendert denselben Effekt (Vorschau = Druckbild).
        el.style.textShadow = def.shadow ? '0 1px 2px rgba(0,0,0,.55), 0 0 1px rgba(0,0,0,.5)' : '';
        // Platzhalter standardmäßig gedämpft (Hinweis-Charakter). Produkte, die die Vorschau
        // druckecht wollen (placeholderDimmed === false), zeigen ihn voll deckend.
        el.style.opacity = (typed || !def.placeholderDimmed) ? '' : '0.5';
        this._renderTextContent(el, content, def);
        this._fitText(el, tl, content, def);
      }
    }

    // Deko-Ebenen (statische Bilder, z. B. Pfötchen): Maske + Tinte wie das Motiv
    // (Farbe folgt der Druckfarbe, "auto" kontrastiert zum Hintergrund), oder
    // Vollbild bei fullColor. Ohne deco-Layer läuft der Loop 0× → kein Effekt.
    for (const l of this._decoLayers()) {
      const de = this.refs.deco ? this.refs.deco[l.id] : null;
      if (!de) continue;
      if (!l.url) { de.style.display = 'none'; continue; }
      de.style.display = '';
      de.style.filter = l.shadow ? 'drop-shadow(0 1px 2px rgba(0,0,0,.55))' : '';
      if (l.fullColor) {
        de.style.webkitMaskImage = 'none';
        de.style.maskImage = 'none';
        de.style.backgroundColor = 'transparent';
        de.style.backgroundImage = `url("${l.url}")`;
        de.style.backgroundRepeat = 'no-repeat';
        de.style.backgroundPosition = 'center';
        de.style.backgroundSize = 'contain';
      } else {
        const ink = this._resolveInk((l.color == null || l.color === 'inherit') ? this.state.druckfarbe : l.color);
        de.style.backgroundImage = 'none';
        de.style.webkitMaskImage = de.style.maskImage = `url("${l.url}")`;
        de.style.webkitMaskRepeat = de.style.maskRepeat = 'no-repeat';
        de.style.webkitMaskPosition = de.style.maskPosition = 'center';
        de.style.webkitMaskSize = de.style.maskSize = 'contain';
        de.style.backgroundColor = ink;
        // Aussparung (Schema v1.35): zweite Maskenschicht = Motiv, abgezogen von der Deko.
        // Nur wenn eine Motiv-Ebene knockout auf diese Deko setzt — sonst unberührt.
        const ko = aussparung && aussparung[l.id];
        let kurl = ko && this.state.motif && !this.state.noMotif ? (this._currentMotifImage() || {}).url || this.state.motif.bild : null;
        // Gespiegelte Aussparung (Nachtrag 23.10.2026, D: Hunde nach rechts): CSS-Masken lassen sich nicht
        // einzeln spiegeln — die Maske nimmt eine einmal per Canvas gespiegelte Kopie (Cache je URL).
        if (kurl && ko.mirrorX === true) kurl = this._gespiegelteMaske(kurl);
        // Leinen-Aussparung (Nachtrag 23.10.2026): SVG der Linie in Deko-Koordinaten als weitere Maskenschicht.
        const lkoListe = leinenAus && leinenAus[l.id];
        let lurl = null;
        if (lkoListe) {
          const dw0 = (Number(l.widthPercent) || 0) / 100, dh0 = (Number(l.heightPercent) || 0) / 100;
          const dx0 = (Number(l.xPercent) || 0) / 100 - dw0 / 2;
          const dy0 = (Number(l.yPercent) || 0) / 100 + (this._layerShiftPct(l) / 100) * dh0;
          const k = (v) => Math.round(v * 100000) / 100;
          const pfade = lkoListe.map((lk) => this._leinenGeometrie(lk, layout)).filter(Boolean).map((g) =>
            `<path d='M${k(g.x1 - dx0)} ${k(g.y1 - dy0)} Q${k(g.cx - dx0)} ${k(g.cy - dy0)} ${k(g.x2 - dx0)} ${k(g.y2 - dy0)}' stroke='black' stroke-width='${k(g.w)}' fill='none' stroke-linecap='round'/>`).join('');
          if (pfade) lurl = 'data:image/svg+xml;utf8,' + encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${k(dw0)} ${k(dh0)}' preserveAspectRatio='none'>${pfade}</svg>`);
        }
        if (kurl) {
          const dw = (Number(l.widthPercent) || 0) / 100, dh = (Number(l.heightPercent) || 0) / 100;
          const dx = (Number(l.xPercent) || 0) / 100 - dw / 2;
          const dy = (Number(l.yPercent) || 0) / 100 + (this._layerShiftPct(l) / 100) * dh;
          const r = this._motifBildRechteck(ko);
          const sw = (r.w / dw) * 100, sh = (r.h / dh) * 100;
          const lx = ((r.x - dx) / dw) * 100, ly = ((r.y - dy) / dh) * 100;
          const px = Math.abs(100 - sw) < 1e-6 ? 0 : (lx * 100) / (100 - sw);
          const py = Math.abs(100 - sh) < 1e-6 ? 0 : (ly * 100) / (100 - sh);
          de.style.webkitMaskImage = de.style.maskImage = `url("${l.url}"), url("${kurl}")` + (lurl ? `, url("${lurl}")` : '');
          de.style.webkitMaskRepeat = de.style.maskRepeat = 'no-repeat, no-repeat' + (lurl ? ', no-repeat' : '');
          de.style.webkitMaskPosition = de.style.maskPosition = `center, ${px}% ${py}%` + (lurl ? ', 0 0' : '');
          de.style.webkitMaskSize = de.style.maskSize = `contain, ${sw}% ${sh}%` + (lurl ? ', 100% 100%' : '');
          de.style.webkitMaskComposite = lurl ? 'source-out, source-over, source-over' : 'source-out';
          de.style.maskComposite = lurl ? 'subtract, add, add' : 'subtract';
        } else if (ko) {
          de.style.webkitMaskComposite = de.style.maskComposite = '';
        }
      }
    }
    // Leinen-Ebenen (Schema v1.35): SVG-Pfad von der Hand zum Halspunkt, Farbe = Druckfarbe.
    if (leinen.length && this.refs.leash) {
      const ink = this._resolveInk(this.state.druckfarbe);
      for (const l of leinen) {
        const el = this.refs.leash[l.id];
        if (!el) continue;
        const g = l.knockout ? null : this._leinenGeometrie(l, layout);   // Aussparungs-Leine: zeichnet die Deko-Maske
        el.style.display = g ? '' : 'none';
        if (!g) continue;
        const k = (v) => Math.round(v * 10000) / 10;
        const p = el.firstElementChild;
        p.setAttribute('d', `M${k(g.x1)} ${k(g.y1)} Q${k(g.cx)} ${k(g.cy)} ${k(g.x2)} ${k(g.y2)}`);
        p.setAttribute('stroke-width', String(k(g.w)));
        p.setAttribute('stroke', ink);
      }
    }

    // Tassen (Schema v1.27): zwei Seiten mit Rundung über die DOM-Vorschau legen. Ohne
    // config.print.vorschau nicht aufgerufen.
    if (this._tasseAktiv()) this._tasseNaht('planen');
    this._renderPrice();
    this._updateCta();
    this.emit('previewUpdated', this.getState());
  }

  /**
   * Gemeinsame Text-Einpassung für Live-Vorschau UND Snapshot — bestimmt die
   * größte Schriftgröße (px), bei der der Text in die Layer-Breite passt, rein
   * per Canvas-Messung, OHNE DOM-Reflow. `ref` ist die Bezugsbreite: die
   * Vorschau übergibt die Container-Breite (clientWidth), der Snapshot die
   * Canvas-Breite W. Feldbreite, Start- und Mindestgröße hängen alle an `ref`,
   * deshalb ist das Ergebnis px/ref in beiden Pfaden identisch → die Vorschau
   * zeigt genau die Größe, die gedruckt wird (eine Messung statt zweier, die
   * auseinanderlaufen konnten). Rückgabe: { px, total } (total = gemessene
   * Breite bei px, für die Snapshot-Ausrichtung). Lässt ctx.font zuletzt auf
   * der Endgröße stehen.
   */
  /**
   * Segmentliste an harten Umbrüchen (\n) in Zeilen zerlegen. Glyphen-Segmente
   * (Emoji-Pfade) tragen nie einen Umbruch und bleiben in der laufenden Zeile.
   *
   * Ohne \n kommt GENAU EIN Eintrag mit den unveränderten Segmenten zurück —
   * darauf beruht die Rückwärtskompatibilität aller Aufrufer: eine Zeile misst
   * und zeichnet dann exakt wie vor der Mehrzeiligkeit.
   *
   * Leere Zeilen bleiben als leeres Segment-Array erhalten (Kunde hat bewusst
   * eine Leerzeile gesetzt) — sie messen 0 und verbrauchen trotzdem ihre
   * Zeilenhöhe, sonst rutschte die Folgezeile hoch.
   */
  _segLines(segs) {
    const lines = [[]];
    for (const s of segs || []) {
      if (s.glyph) { lines[lines.length - 1].push(s); continue; }
      const teile = String(s.text == null ? '' : s.text).split('\n');
      teile.forEach((t, i) => {
        if (i > 0) lines.push([]);
        if (t !== '') lines[lines.length - 1].push({ text: t });
      });
    }
    return lines;
  }

  /** Präfix einer Text-Ebene (Schema v1.36, Wörterbuch-Kissen „4.“): layout.layers.<id>.prefix
   *  steht links vor dem Text, prefixGapEm (Schriftgrößen) ist der Abstand Präfix-Anfang →
   *  Text-Anfang. Nur bei align:"left" wirksam; sonst 0 bzw. '' — jede Bestands-Ebene unverändert. */
  _prefixOf(layer) {
    return (layer && layer.align === 'left' && typeof layer.prefix === 'string' && layer.prefix) ? layer.prefix : '';
  }
  _prefixGapEm(layer) {
    if (!this._prefixOf(layer)) return 0;
    const g = Number(layer.prefixGapEm);
    return (Number.isFinite(g) && g > 0) ? g : 1;
  }
  _fitFontPx(ctx, segs, stack, layer, ref) {
    // Tassen-Textfenster (Schema v1.27, 14.10.2026): fitFactor > 1 passt auf Fensterbreite ÷ fitFactor
    // ein — der Renderer (raqm) misst bis +3,3 % breiter als Canvas, sein Tinten-Gate erlaubt nur +1 %.
    // maxW im Vertrag bleibt die volle Fensterbreite (_blattDruckConfig liest die Box, nicht availW).
    // Ohne fitFactor: Division durch 1, Ergebnis bitgleich zu vorher.
    const ff = (typeof layer.fitFactor === 'number' && layer.fitFactor > 1) ? layer.fitFactor : 1;
    const availW = ((layer.widthPercent || 0) / 100) * ref / ff;
    const minPx = ((layer.minFontSizePercent || (layer.fontSizePercent || 5) * 0.4) / 100) * ref;
    // Mehrzeilig: die LÄNGSTE Zeile bestimmt die Einpassung, nicht die Zeichenkette
    // samt Umbrüchen — sonst schrumpfte die Schrift an einer Breite, die nie
    // gezeichnet wird. Einzeilig ist das Maximum über eine Zeile die alte Summe.
    const lines = this._segLines(segs);
    const breite = (ls, p) => ls.reduce((w, s) => w + (s.glyph ? p * 0.95 : ctx.measureText(s.text).width), 0);
    // Präfix (Schema v1.36): „4.“ + Abstand belegt prefixGapEm × Schriftgröße VOR der ersten Zeile —
    // die Einpassung rechnet ihn mit, damit Präfix + Text zusammen in widthPercent passen.
    const vorlauf = (p, li) => (li === 0 ? this._prefixGapEm(layer) * p : 0);
    const measure = (p) => {
      ctx.font = `700 ${p}px ${stack}`;
      return lines.reduce((mx, ls, li) => Math.max(mx, breite(ls, p) + vorlauf(p, li)), 0);
    };
    // Tassen-Textfenster (fitFactor): bei der Bühnengröße liegen kleine Namen bei 5–7 px Schrift, wo die
    // Canvas-Messung ungenau wird (gemessen 14.10.2026: „Hannes & Yuxuan“ als passend gemeldet, 20,56 mm
    // in 20,07 mm). Deshalb einmal bei 100 px messen und linear skalieren. Nur mit fitFactor.
    let messe = measure;
    if (ff !== 1) {
      const ref100 = (() => { ctx.font = `700 100px ${stack}`; return lines.map((ls) => ls.map((s) => (s.glyph ? null : ctx.measureText(s.text).width))); })();
      const breite100 = (li, p) => lines[li].reduce((w, s, si) => w + (s.glyph ? p * 0.95 : ref100[li][si] * p / 100), 0);
      messe = (p) => { ctx.font = `700 ${p}px ${stack}`; return lines.reduce((mx, ls, li) => Math.max(mx, breite100(li, p) + vorlauf(p, li)), 0); };
    }
    let px = ((layer.fontSizePercent || 5) / 100) * ref;
    // fitSteps (Schema v1.27): mehr als 24 Verkleinerungsstufen, damit eine Mindestgröße unter
    // Start × 0,94^24 erreichbar ist (Tassen, z. B. Hundemama 3). Ohne das Feld unverändert 24.
    let guard = (typeof layer.fitSteps === 'number' && layer.fitSteps > 24) ? Math.floor(layer.fitSteps) : 24;
    while (messe(px) > availW && px > minPx && guard-- > 0) {
      px = Math.max(minPx, px * 0.94);
    }
    const total = messe(px);   // setzt ctx.font auf die Endgröße
    // lineWidths: Breite JE Zeile bei der Endgröße — der Snapshot richtet jede
    // Zeile eigenständig aus. ctx.font steht dabei schon auf der Endgröße.
    const lineWidths = lines.map((ls) => breite(ls, px));
    // ueberlauf: auch bei der Endgröße breiter als die Einpassbreite (Breitenprüfung, blockOverflow).
    return { px, total, lines, lineWidths, ueberlauf: total > availW };
  }

  /**
   * B (Schriftmetrik): Canvas misst nur mit der TATSÄCHLICH geladenen Schrift
   * richtig. Ist die Familie noch kalt, wird jetzt mit dem Fallback eingepasst
   * (wie bisher der DOM) und GENAU EINMAL neu eingepasst, sobald die Schrift
   * eintrifft. Lieber einmal zu oft neu einpassen als einmal mit falschen
   * Metriken — sonst liefen Vorschau und Druckvorlage in der Zeilengröße
   * auseinander. Ohne Font-Loading-API (altes Safari, Node) passiert nichts.
   */
  _refitWhenFontReady(stack) {
    if (typeof document === 'undefined' || !document.fonts || !document.fonts.load) return;
    const first = String(stack || '').split(',')[0].trim().replace(/^['"]|['"]$/g, '');
    if (!first || /^(serif|sans-serif|cursive|monospace|fantasy|system-ui|inherit)$/i.test(first)) return;
    const spec = `700 100px "${first}"`;
    let ready = false;
    try { ready = document.fonts.check(spec); } catch (e) { ready = true; }
    if (ready) return;
    if (!this._fitPendingFonts) this._fitPendingFonts = new Set();
    if (this._fitPendingFonts.has(spec)) return;
    this._fitPendingFonts.add(spec);
    document.fonts.load(spec)
      .then(() => { this._fitPendingFonts.delete(spec); this.renderPreview(); })
      .catch(() => { this._fitPendingFonts.delete(spec); });
  }

  /**
   * Text-Layer-Fit der Live-Vorschau. Misst per Canvas (kein Reflow) und nutzt
   * dieselbe Einpassung wie der Snapshot (_fitFontPx) → Vorschau = Druckbild.
   * Läuft bei jeder Eingabe (renderPreview) und bei Resize (ResizeObserver).
   * Die Bezugsbreite (Container) ist schriftunabhängig und wird gecacht; der
   * ResizeObserver leert den Cache (this._previewW = 0). Dadurch kostet das
   * Einpassen beim Tippen und Wählen KEIN erzwungenes Layout mehr.
   */
  _fitText(el, layer, content, def) {
    const preview = this.refs.base?.parentElement;
    if (!preview) return;
    // Harte Umbrüche muss die Vorschau auch ANZEIGEN, sonst zeichnet der Canvas
    // zwei Zeilen und die Vorschau eine — genau die Kluft, die zu schließen ist.
    // 'normal'/'nowrap' falten \n zu einem Leerzeichen; 'pre-line'/'pre' halten es.
    // Ohne maxLines > 1 bleiben exakt die bisherigen zwei Werte stehen.
    // Seit 09.10.2026 bricht die Vorschau NIE mehr selbst nach Breite um (früher
    // 'normal'/'pre-line' bei Ebenen ohne nowrap): das Warenkorbbild kennt nur
    // Zeilen, die die Engine festlegt. Einzeilige Ebenen bleiben einzeilig wie im
    // Warenkorbbild; mehrzeilige Ebenen ohne nowrap bekommen den Breitenumbruch
    // von _breitenZeilen — dieselben Zeilen zeichnet _drawSnapshotText.
    const mehrzeilig = !!(def && def.maxLines > 1);
    el.style.whiteSpace = mehrzeilig ? 'pre' : 'nowrap';
    // Bezugsbreite EINMAL lesen (Mount / nach Resize), dann aus dem Cache.
    if (!this._previewW) this._previewW = preview.clientWidth || 320;
    const ref = this._previewW;
    // Schrift-Stack wie im Snapshot auflösen (gleiche Messung → gleiche Größe).
    const font = this._textFont(def);
    const stack = font ? font.stack : 'sans-serif';
    // Zeilenhöhe NACH der Schrift-Auflösung: sie hängt seit 19.08.2026 an der
    // Schrift (_lineHeightFor). Ohne lineHeightFactor ist der Wert unverändert
    // TEXT_LINE_HEIGHT — jedes Bestandsprodukt rendert damit zeichengleich.
    // Dieselbe Zahl bekommt der Snapshot für seine Dreh-Ersatzbox.
    el.style.lineHeight = String(this._lineHeightFor(font));
    // Versalsatz zählt für die Breite (wie im Snapshot, VOR dem Messen).
    let text = content != null ? content : (el.textContent || '');
    if (layer && layer.transform === 'uppercase') text = String(text).toUpperCase();
    const segs = this._glyphSegments(text, def) || [{ text }];
    this._refitWhenFontReady(stack);
    const ctx = this._measureCtx
      || (this._measureCtx = (typeof document !== 'undefined' && document.createElement)
        ? (document.createElement('canvas').getContext('2d') || null) : null);
    if (!ctx) {                    // Umgebung ohne Canvas (Node-Testharness): Startgröße
      el.style.fontSize = (((layer.fontSizePercent || 5) / 100) * ref) + 'px';
      return;
    }
    const { px, lines, ueberlauf } = this._fitFontPx(ctx, segs, stack, layer, ref);
    el.style.fontSize = px + 'px';
    // Breitenprüfung (Schema v1.27, Tassen): passt der Text auch bei Mindestgröße nicht ins
    // Fenster, wird der Kauf gesperrt und ein Hinweis gezeigt — nie kappen. Nur mit
    // layer.blockOverflow === true; ohne das Flag bleibt _zuLang undefiniert.
    if (layer && layer.blockOverflow === true && def) this._setzeZuLang(def, !!ueberlauf && !!String(text).trim());
    if (this._umbruchNachBreite(layer, def)) {
      const z = this._breitenZeilen(ctx, lines, px, ((layer.widthPercent || 0) / 100) * ref);
      if (z.lines.length !== lines.length) {
        this._renderTextContent(el, z.lines.map((ls) => ls.map((s) => (s.glyph ? s.emoji : s.text)).join('')).join('\n'), def);
      }
    }
  }

  /** Mehrzeilige Ebene (maxLines > 1) OHNE nowrap: Zeilen, die bei der Endgröße breiter
   *  als die Ebene sind, werden an Wortgrenzen umbrochen — in Vorschau UND Warenkorbbild
   *  (09.10.2026). Mit nowrap:true oder maxLines ≤ 1 nie. Renderer-Verträge (Foto, Dose,
   *  Kissen) rufen das bewusst nicht auf. */
  _umbruchNachBreite(layer, def) {
    return !!(layer && layer.nowrap !== true && def && def.maxLines > 1);
  }

  /** Gieriger Umbruch an Leerzeichen bei Breite availW (Canvas-Messung, ctx.font steht auf
   *  der Endgröße). Glyphen (❤/🐾, 0,95 em) hängen am Wort. Ein Wort, das allein breiter ist,
   *  bleibt ungebrochen (wie im Browser). Rückgabe { lines, widths }. */
  _breitenZeilen(ctx, lines, px, availW) {
    const breite = (ls) => ls.reduce((w, s) => w + (s.glyph ? px * 0.95 : ctx.measureText(s.text).width), 0);
    const fuege = (ls, s) => {                     // benachbarte Textstücke zusammenlegen (Kerning wie am Stück)
      const l = ls[ls.length - 1];
      if (!s.glyph && l && !l.glyph) ls[ls.length - 1] = { text: l.text + s.text }; else ls.push(s);
      return ls;
    };
    const out = [];
    for (const ls of lines) {
      const woerter = [[]];
      for (const s of ls) {
        if (s.glyph) { woerter[woerter.length - 1].push(s); continue; }
        String(s.text).split(' ').forEach((t, i) => {
          if (i > 0) woerter.push([]);
          if (t !== '') fuege(woerter[woerter.length - 1], { text: t });
        });
      }
      let cur = [];
      for (const w of woerter) {
        if (!w.length) continue;
        const kand = cur.length ? w.reduce(fuege, fuege(cur.map((x) => ({ ...x })), { text: ' ' })) : w.map((x) => ({ ...x }));
        if (cur.length && breite(kand) > availW) { out.push(cur); cur = w.map((x) => ({ ...x })); } else cur = kand;
      }
      out.push(cur);
    }
    return { lines: out, widths: out.map(breite) };
  }

  /* ----------------------------------------------------------------- Steps */
  _stepDefs() {
    // Reihenfolge des geführten Flows (datengetrieben, kein Produkt-Name im Kern).
    // Steuerbar über config.steps (Array von Keys, in Wunschreihenfolge). Fehlt der
    // Key, gilt der bisherige 6er-Default. Unbekannte Keys werden ignoriert.
    const S = this.config.strings || {};
    const TITLES = {
      base: S.step_base || 'Anzahl',
      color: S.step_color || 'Westenfarbe',
      motif: S.step_motif || 'Motiv',
      text: S.step_text || 'Wunschtext',
      font: S.step_font || 'Schrift',
      print: S.step_print || 'Druckfarbe',
      size: S.step_size || 'Größe',
      photo: S.step_photo || 'Dein Foto'
    };
    const order = (Array.isArray(this.config.steps) && this.config.steps.length)
      ? this.config.steps
      : ['color', 'motif', 'text', 'font', 'print', 'size'];
    // Text-Schritte: 'text:<id>' bindet an den Def mit dieser id; nacktes 'text'
    // konsumiert die Defs sequenziell (Ein-Text-Produkte: genau der Legacy-Def).
    const defs = [];
    let ti = 0;
    for (const k of order) {
      if (typeof k === 'string' && (k === 'text' || k.indexOf('text:') === 0)) {
        let def = null;
        if (k.indexOf('text:') === 0) def = this.texts.find((t) => t.id === k.slice(5)) || null;
        else def = this.texts[ti] || null;
        if (!def) continue;
        ti = this.texts.indexOf(def) + 1;
        // Sekundäre Slots haben keinen eigenen Wizard-Schritt (rendern in der
        // Sektion ihres primären Defs) — auch wenn sie in steps gelistet sind.
        if (def.secondary) continue;
        if (this._ohneName(def)) continue;        // Motiv ohne Namen: kein Namensschritt, keine Pflicht
        defs.push({ key: this._stepKeyForDef(def), title: def.cardTitle || def.label || TITLES.text, textDef: def });
      } else if (typeof k === 'string' && k.indexOf('vo:') === 0) {
        // Zusätzliche Varianten-Option (z. B. Geschlecht): 'vo:<id>' bindet an
        // den extraOptions-Eintrag mit dieser id. Unbekannte ids werden ignoriert.
        const xo = this._extraDef(k);
        if (!xo) continue;
        defs.push({ key: k, title: xo.label || xo.optionName, vo: xo });
      } else if (typeof k === 'string' && k.indexOf('addon:') === 0) {
        // Zusatzartikel (Schema v1.31): 'addon:<id>' bindet an config.addons. Ohne angebotene
        // Variante (alles ausverkauft) entfällt der Schritt; unbekannte ids werden ignoriert.
        const ad = this._addonDef(k);
        if (!ad || !this._addonItems(ad).length) continue;
        defs.push({ key: k, title: ad.label || 'Zusatzartikel', addon: ad });
      } else if (k === 'akzent') {
        // Akzentfarbe (Schema v1.35): nur mit config.accent; sonst fällt der Key still durch.
        if (this._akzentFarben().length > 1) defs.push({ key: 'akzent', title: this.config.accent.label || 'Akzentfarbe' });
      } else if (k === 'side') {
        // Motivseite (config.sides): eigener schlanker Choice-Schritt — KEIN vo/
        // extraOption (dieselbe SKU, sichtbare Cart-Property statt Varianten-Dublette).
        // Ohne config.sides fällt der Key durch (v1-tolerant).
        if (this.config.sides) defs.push({ key: 'side', title: this.config.sides.label || (S.step_side || 'Motivseite') });
      } else if (TITLES[k] != null) {
        // Foto-Schritt (Schema v1.18) nur, wenn das Produkt ihn konfiguriert —
        // ohne config.photo fällt der Key still durch (fremde Configs unberührt).
        if (k === 'photo' && !this.config.photo) continue;
        // Schrift nur anbieten, wenn Text da ist, auf den sie wirken kann —
        // taucht reaktiv wieder auf, sobald ein Textfeld gefüllt wird.
        // Opt-in fontAlwaysVisible (alwaysVisible:true am choice-Schrift-Schritt):
        // der Schritt steht dann von Anfang an, auch bei leerem Text. Wirkt NUR für
        // Configs, die überhaupt einen Schrift-Schritt haben — Produkte mit fest
        // verdrahteter Schrift (kein 'font' in steps) erreichen diese Zeile nie.
        if (k === 'font' && !this._fontRelevant() && this.config.fontAlwaysVisible !== true) continue;
        // Druckfarbe nur anbieten, wenn sie auf das gewählte Motiv überhaupt
        // wirkt — Vollfarb-Motive werden als Bild gezeichnet, nicht eingefärbt.
        // Taucht reaktiv wieder auf, sobald ein einfarbiges Motiv gewählt wird.
        if (k === 'print' && !this._printRelevant()) continue;
        // Eine einzige Druckfarbe ist keine Wahl: Schritt weglassen (die Farbe gilt
        // trotzdem). Hier — und nur hier — fällt er aus der Schrittliste; damit ist er
        // zugleich aus Nummerierung, Fortschritt und Pflichtprüfung raus, weil alle
        // drei aus _stepDefs() ableiten.
        if (k === 'print' && this._printSingleOption()) continue;
        // Eine einzige (verfügbare) Größe ist ebenso wenig eine Wahl: Schritt
        // weglassen, Wert gilt trotzdem (s. _sizeSingleOption). Damit fällt er
        // zugleich aus Nummerierung, Fortschritt und Pflichtprüfung, weil alle drei
        // aus _stepDefs() ableiten — und der Kauf bleibt möglich, weil state.size
        // im Konstruktor vorbelegt wurde.
        if (k === 'size' && this._sizeSingleOption()) continue;
        // Dasselbe für die Farb-Achse (14.10.2026, Herzhenkel-Tassen: eine Kachel „Weiß“ als
        // eigener Schritt 1): genau EIN verfügbarer Farbwert ist keine Wahl. state.color ist im
        // Konstruktor mit dem ersten (= einzigen) Wert vorbelegt; Property, Variante und
        // Druckvertrag hängen an state.color, nicht am Schritt — sie bleiben unverändert.
        if (k === 'color' && this._colorSingleOption()) continue;
        // Rasse-Motive (Schema v1.28): die Achse wählt der Motiv-Schritt, keine eigene Kachelreihe.
        if (k === 'color' && this._motifAchse()) continue;
        // … und die Ausführung erst, wenn eine Rasse gewählt ist (vorher hat sie keinen Bezug).
        if (k === 'size' && this._motifAchse() && !this.state.motif) continue;
        defs.push({ key: k, title: TITLES[k] });
      }
    }
    return defs;
  }
  _activeStep() {
    const defs = this._stepDefs();
    // Ein aktiv wieder geöffneter (reopen), noch nicht erledigter Schritt ist DER
    // aktive — sonst verdrängt ihn ein noch offener Vorgänger (z. B. der Wunschtext),
    // sein Body bliebe zu und „Druckfarbe ändern" täte nichts: die vorbelegte
    // Druckfarbe gilt als erledigt (Kompaktzeile), aber der Text ist noch offen →
    // ohne diese Zeile bleibt der Text der aktive Schritt und die Swatches erscheinen
    // nie (reproduziert auf der Leckerlidose, unabhängig von der Farbanzahl). Sind alle
    // Vorgänger erledigt, ist der reopen-Schritt ohnehin der erste offene → kein Effekt.
    for (const d of defs) if (this._reopened.has(d.key) && !this.state.done[d.key]) return d.key;
    for (const d of defs) if (!this.state.done[d.key]) return d.key;
    return null;
  }

  /**
   * Vorbelegte Schritte als erledigt markieren — die EINE Stelle dafür. Läuft in
   * renderSteps(), bei jeder Texteingabe (_onTextInput) und im Submit (_submit).
   *
   * Anlass (Jens 21.09.2026, Mantel-Videoanzeige): Der Schrift-Schritt wird erst durch
   * einen Wunschtext relevant (_fontRelevant → _stepDefs). Markiert wurde seine
   * Vorbelegung bisher NUR hier in renderSteps() — und das lief beim Tippen bewusst
   * nicht (_onTextInput: „Kein Abschluss/Sprung während des Tippens"), sondern erst
   * nach dem Blur-Timeout (_onTextBlur, setTimeout 0). Ein Tipp auf „In den Warenkorb
   * legen" direkt aus dem Feld kam VOR diesem Render an: _ready() sah done.font ===
   * false, _flagBlocked() meldete „Schriftart: das fehlt noch", obwohl die Schrift
   * längst vorgewählt war; erst der zweite Tipp legte in den Warenkorb. Ebenso war
   * der CTA ab dem ersten Buchstaben grau (renderPreview → _updateCta).
   *
   * Bedingung WORTGLEICH mit der bisherigen Schleife in renderSteps(): keine neue
   * Semantik, nur ein zweiter und dritter Ort, an dem sie zählt. Ein vom Kunden
   * wieder geöffneter Schritt (_reopened) bleibt unangetastet; ein Produkt mit
   * fontPreSelected:false behält sein Gate (_isPreSatisfied('font') ist dort false).
   * Text-Schritte hängen nur an Config-Defaults (td.default/defaultNoText), nicht am
   * getippten Wert — für sie ändert der Aufruf während des Tippens nichts.
   */
  _markPreSatisfiedSteps() {
    for (const d of this._stepDefs()) {
      if (!this.state.done[d.key] && !this._reopened.has(d.key) && this._isPreSatisfied(d.key)) this.state.done[d.key] = true;
    }
  }
  /** Hat dieser Schritt beim Start eine vollständige Vorauswahl, die sofort als Wahl gilt? */
  _isPreSatisfied(key) {
    // „Anzahl"-Umschalter: der Default-Index (z. B. „1 Hund") ist eine vollständige Wahl.
    // Produkte ohne Base-Umschalter (Warnweste) haben keine baseOptions → unverändert.
    if (key === 'base') return this._baseOptions().length > 0;
    // Farb-Schritt: eine vorbelegte variant_option gilt ALLGEMEIN als vollständige
    // Wahl — kein Bestätigungs-Klick nötig, die Swatch-Reihe bleibt als inline-
    // Kompaktzeile direkt bedienbar, Wechsel jederzeit möglich. Opt-out pro Produkt
    // über preSelected:false am Farb-Schritt (config.colorPreSelected === false).
    if (key === 'color') return this.config.colorPreSelected !== false && !!this.state.color;
    // Zusätzliche Varianten-Option: der vorbelegte erste Wert gilt wie die Farbe
    // als vollständige Wahl (inline umschaltbar). Opt-out je Schritt über
    // preSelected:false am variant_option-Schritt (Schema v1.7).
    if (typeof key === 'string' && key.indexOf('vo:') === 0) {
      const xo = this._extraDef(key);
      return !!(xo && xo.preSelected !== false && this.state.options[xo.optionName]);
    }
    // Motivseite: die vorbelegte Default-Seite (Vorderseite) ist eine vollständige
    // Wahl → Schritt startet erledigt, bleibt inline umschaltbar.
    if (key === 'side') return !!(this.config.sides && this.state.side);
    // Zusatzartikel: „Keine“ ist die vollständige Vorauswahl — der Schritt blockiert nie.
    if (this._addonDef(key)) return true;
    // Schrift-Schritt: eine per default vorbelegte Schrift ist bereits eine vollständige
    // Wahl — kein Bestätigungs-Klick nötig, genau wie bei der vorgewählten Farbe. Die
    // Schrift-Buttons bleiben direkt bedienbar (STEP_MODE.font = 'inline'), ein Klick
    // wechselt nur die Auswahl und ist kein Gate. Opt-out pro Produkt über
    // fontPreSelected:false. Ohne Text ist der Schritt ohnehin nicht in _stepDefs().
    if (key === 'font') return this.config.fontPreSelected !== false && !!this.state.font;
    // Motiv-Schritt: ein per default gesetztes Start-Motiv (config.defaults.motif)
    // gilt als vollständige Wahl — wie Farbe/Schrift. Opt-out über
    // motifStartExpanded:true (Fußmatten behalten so ihren offenen Picker).
    // „Kein Motiv" zählt hier NICHT als Vorauswahl.
    if (key === 'motif') return (this.config.motifStartExpanded !== true || this._motifOpenDefault === true) && !!this.state.motif && !this.state.noMotif;
    // Druckfarbe-Schritt: eine per default vorbelegte Druckfarbe gilt als vollständige
    // Wahl — kein Bestätigungs-Klick. Opt-out pro Produkt über printPreSelected:false.
    if (key === 'print') return this.config.printPreSelected !== false && !!this.state.druckfarbe;
    // Akzentfarbe (Schema v1.35): vorbelegt wie die Druckfarbe → vollständige Wahl.
    if (key === 'akzent') return !!this.state.akzentfarbe;
    // Text-Schritt mit vorbelegtem default: der Wert steht schon in Feld + Vorschau —
    // vollständige Wahl, der Kunde muss nur ändern, wenn er will. (Legacy-Def hat nie
    // einen default → Warnweste & Co. unverändert.)
    const td = this._textDef(key);
    // Text-Schritt erledigt, wenn ein Default-Wert im Feld steht ODER der optionale
    // Schritt per defaultNoText auf „Kein Text gewünscht" vorbelegt ist.
    if (td) return !!((td.default && String(td.default).trim()) || (td.optional && td.defaultNoText));
    return false;
  }
  /** Darf der Kunde diesen Schritt verlassen? Erledigt ODER es liegt eine gültige (Vor-)Wahl vor. */
  _canLeave(key) {
    // Sperrzeichen (Schema v1.36): kein Verlassen, solange ein Platzhalter im Text steht — auch nicht über „erledigt“.
    const sd = this._textDef(key);
    if (sd && this._sperrzeichenIn(sd)) return false;
    if (this.state.done[key]) return true;
    // Motiv gilt als verlassbar, sobald ein Motiv (oder „kein Motiv") gewählt ist — auch bei
    // Mehrbild-Motiven, deren Schritt bewusst offen bleibt (Varianten-Vergleich).
    if (key === 'motif') return this.state.noMotif || !!this.state.motif;
    // Text-Schritt: verlassbar, sobald er gefüllt ODER optional ist — WORTGLEICH mit der
    // Kauf-Prüfung (_textStepSatisfied). Ein OPTIONALER Text-Schritt ist immer verlassbar
    // (leer = übersprungen), PFLICHT-Text (optional:false, leer) bleibt Gate.
    //
    // Früher lag diese Regel nur im _multiText-Zweig — Ein-Text-Produkte fielen auf
    // `return false`. Damit war der (immer optionale) Textschritt einer Fußmatte oder
    // Thermosflasche unverlassbar, obwohl der Kauf ihn korrekt als erfüllt wertete: alle
    // Folge-Schritte galten als unerreichbar (_reachable=false), der Kauf-Blocker
    // markierte den Pflichtschritt danach (Größe/Füllmenge) rot, konnte ihn aber weder
    // aufklappen noch antippbar machen. Der Kunde kam erst weiter, nachdem er das
    // Namensfeld berührt hatte. Jetzt gilt für Ein- UND Mehrfach-Text dieselbe Regel.
    if (this._textDef(key)) return this._textStepSatisfied(key);
    // Foto-Schritt: verlassbar, sobald das Foto hochgeladen ist — WORTGLEICH mit
    // der Kauf-Prüfung (_photoSatisfied). Ein gewähltes, aber noch nicht fertig
    // hochgeladenes Foto hält den Flow an (sonst käme eine Bestellung ohne URL).
    if (key === 'photo') return this._photoSatisfied();
    return false;
  }
  /**
   * Ist der Foto-Schritt erfüllt? Erst mit SERVER-URL: die lokale Vorschau
   * (localUrl) genügt der Bühne, aber nicht der Bestellung — ohne url hätte
   * _ttg_foto_config keinen ladbaren Foto-Verweis und die Druckstrecke liefe leer.
   */
  _photoSatisfied() {
    return !!(this.state.photo && this.state.photo.url);
  }
  /** Ist dieser (noch offene) Schritt vorwärts antippbar? Nur wenn alle davor verlassbar sind. */
  _reachable(key) {
    const defs = this._stepDefs();
    const idx = defs.findIndex((d) => d.key === key);
    if (idx < 0) return false;
    for (let i = 0; i < idx; i++) if (!this._canLeave(defs[i].key)) return false;
    return true;
  }
  /** Öffnet dieser Schritt sein Panel schon im 'todo'-Zustand (kein Antippen nötig),
   *  sobald alle Vorgänger verlassbar sind? Nur im Mehrfach-Text-Modus: der Motiv-
   *  Schritt und Pflicht-Text-Schritte (optional:false, ohne default) — z. B. Rasse
   *  und Hundename sind so sofort bedienbar. Ein-Text-Produkte: strikter Flow wie bisher. */
  _autoOpen(d) {
    if (!this._multiText) return false;
    if (d.key === 'motif') return true;
    return !!(d.textDef && !d.textDef.optional && !d.textDef.default);
  }

  renderSteps() {
    this._syncMotifVariant();
    // Ausstehende Such-Debounce verwerfen: jede Aktion baut das Grid neu — ein
    // überlebender Timer würde das frische Grid nachträglich mit dem alten
    // Suchbegriff filtern (ohne sichtbares Suchfeld; adversarial reproduziert).
    if (this._searchTimer) { clearTimeout(this._searchTimer); this._searchTimer = null; }
    // Blockier-Markierung verfällt, sobald der Kunde die Ursache behoben hat —
    // sie soll nicht kleben bleiben, während er weiterarbeitet.
    if (this._invalid) {
      const fixed = this._invalid.variant
        ? !!this.resolveVariant()
        : this.state.done[this._invalid.key] === true;
      if (fixed) this._invalid = null;
    }
    // Merker für die reaktive Schrift-Ein-/Ausblendung (_syncFontStep).
    this._fontShown = this._fontRelevant();
    this._printShown = this._printRelevant();
    const defs = this._stepDefs();
    // Vorbelegte Schritte gelten als erledigt. Der Konstruktor markiert nur, was zu
    // dem Zeitpunkt in _stepDefs() steht — der Schrift-Schritt taucht aber erst auf,
    // sobald Text eingegeben wurde. Ohne diese Nachmarkierung würde er beim
    // Erscheinen zum Gate (done === undefined) und den Flow blockieren.
    // Seit 21.09.2026 die EINE Stelle dafür (_markPreSatisfiedSteps): dieselbe
    // Markierung läuft auch bei der Texteingabe und im Submit — sonst hing sie am
    // nächsten Render, und der lag hinter dem Klick (Blur-Timeout in _onTextBlur).
    this._markPreSatisfiedSteps();
    const active = this._activeStep();
    const S = this.config.strings || {};
    // Sichtbare Nummerierung ohne die stillen Wert-Zeilen (die tragen nie eine Nummer).
    const numbered = defs.filter((d) => !(d.textDef && this._isQuietDef(d.textDef)));
    let html = '';
    for (const d of defs) {
      const done = this.state.done[d.key];
      // Eingeklappter Motiv-Start (defaultMotif): Accordion-Zeile im FORMAT der
      // übrigen Sektionsköpfe — Schritt-Nummer + Frage als Titel (gleiche Typo),
      // kein Thumbnail, kein Body. Das Start-Motiv bleibt intern gewählt
      // (Vorschau + Druck). Klick öffnet den vollen Kategorie-Dialog
      // (motif-browse hebt motifIntro auf).
      if (d.key === 'motif' && !done && this.state.motifIntro && this.state.motif && !this.state.noMotif) {
        const prompt = S.q_motif || 'Möchtest Du ein anderes Motiv?';
        html += `<div class="ttg-card ttg-card--motif-intro">
          <div class="ttg-card__h" data-action="motif-browse" role="button" tabindex="0" aria-label="${escapeHtml(prompt)}">
            <span class="ttg-card__num" data-num="${numbered.indexOf(d) + 1}" aria-hidden="true"></span>
            <span class="ttg-card__t">${escapeHtml(prompt)}</span>
          </div>
        </div>`;
        continue;
      }
      // Stille vorbelegte Text-Zeile: kompakt »Wert« + „Ändern"; Editor nur bei Bedarf.
      // Kein Nummern-/Titel-Kopf, keine Aufforderung — der Schritt ist dauerhaft erfüllt.
      if (d.textDef && this._isQuietDef(d.textDef)) {
        const def = d.textDef;
        if (this._quietOpen[def.id]) {
          html += `<div class="ttg-card ttg-card--active ttg-card--quiet ttg-card--quiet-open">
            <div class="ttg-card__body">${this._bodyText(def)}</div>
          </div>`;
        } else {
          const val = (this.state.texts[def.id] || '').trim();
          const shown = (this.state.noTexts[def.id] || !val)
            ? (def.noTextValue || S.no_text || 'Kein Text')
            : '»' + val + '«';
          html += `<div class="ttg-card ttg-card--done ttg-card--quiet">
            <div class="ttg-card__h ttg-quiet__h" data-action="quiet-edit" data-def-id="${escapeHtml(def.id)}" role="button" tabindex="0" aria-label="${escapeHtml((d.title || 'Text') + ' ändern')}">
              <span class="ttg-quiet__val">${escapeHtml(shown)}</span>
              <span class="ttg-quiet__edit">${escapeHtml(S.change || 'Ändern')}</span>
            </div>
          </div>`;
        }
        continue;
      }
      const status = done ? 'done' : (d.key === active ? 'active' : 'todo');
      // Modus über den Basis-Typ ('text:<id>' → 'text'); config.stepModes kann ihn
      // pro Schritt übersteuern (z. B. print → 'inline': Sektion bleibt nach der
      // Auswahl offen und direkt bedienbar, statt zur Kompaktzeile zu kollabieren).
      const baseKey = String(d.key).split(':')[0];
      const mode = (this.config.stepModes && this.config.stepModes[baseKey]) || STEP_MODE[baseKey] || 'inline';
      // keepExpanded (config-Map je Basis-Schritt, z. B. {"size": true}): der Body
      // bleibt in ALLEN Zuständen (todo/active/done) voll gerendert — der Schritt
      // kollabiert nie zur Chip-/Kompakt-Zeile. Nur Darstellung: done-Zählung,
      // Add-to-Cart-Gate und grüne Nummer laufen unverändert. Gedacht für die
      // Pflichtwahl Größe (die einzige echte Pflicht-Interaktion — nie verstecken).
      const keep = !!(this.config.keepExpanded && this.config.keepExpanded[baseKey] === true)
        || (d.key === 'motif' && this._motifOpenDefault === true);   // Default-Bucket offen halten (grün, CTA frei)
      // Immer die Schritt-Nummer (kein Haken mehr) — erledigte Schritte färbt die
      // CSS über .ttg-card--done .ttg-card__num grün ein.
      const num = numbered.indexOf(d) + 1;
      // Mehrbild-Motiv gewählt (done) im Kollaps-/Vergleichs-Zustand: die Variantenreihe
      // bleibt sichtbar (Body statt Chip), damit der Kunde die Variante frei wählen kann —
      // der Schritt ist trotzdem erledigt (grüne Nummer, CTA frei). Ein Klick aufs Motiv
      // (motif-browse) öffnet das Grid wieder. Einbild-/Nicht-Motiv → normaler Kollaps.
      const motifCompare = d.key === 'motif' && !!this.state.motifCollapsed
        && !!this.state.motif && !this.state.noMotif;
      // Panel-Schritte werden erledigt zur klickbaren Kompaktzeile (Klick = wieder öffnen).
      const reopenable = done && mode === 'panel' && !keep && !motifCompare;
      // Gewählte Druckfarbe im Kopf, AUCH wenn der Schritt offen bleibt (Jens 03.08.2026).
      // Grund: alle 44 customizer_configs tragen autoAdvance:false → stepModes.print
      // = 'inline' → der Druckfarben-Schritt kollabiert nie, und der vorhandene
      // Summary-Chip (der genau diesen Wert zeigt) wurde deshalb auf KEINEM Produkt
      // je gerendert. Kein neues Config-Feld nötig — die Menge ist eindeutig.
      // BEWUSST nur 'print': Farbe, Größe, Schrift und die Zusatz-Optionen sind
      // ebenfalls inline und würden den Chip sonst ungefragt dazubekommen.
      const wertImKopf = done && !reopenable && baseKey === 'print';
      // Noch offener Folge-Schritt, dessen Vorgänger alle verlassbar sind → vorwärts antippbar
      // (der Kunde geht selbst weiter, ohne dass ein Schritt automatisch schließt/aufspringt).
      const gotoable = status === 'todo' && this._reachable(d.key);
      // Auto-offene Schritte rendern ihr Panel schon jetzt (statt antippbarer Kopfzeile).
      const autoOpen = gotoable && this._autoOpen(d);
      const headAction = reopenable ? 'reopen' : (gotoable && !autoOpen ? 'goto' : '');
      // Blockier-Markierung (CTA-Klick bei unvollständiger Konfiguration): genau EIN
      // Schritt trägt sie — der erste offene bzw. die Achse der unmöglichen Kombination.
      const invalid = !!(this._invalid && this._invalid.key === d.key);
      html += `<div class="ttg-card ttg-card--${autoOpen ? 'active' : status} ttg-card--${mode} ttg-card--k-${baseKey}${gotoable && !autoOpen ? ' ttg-card--next' : ''}${autoOpen ? ' ttg-card--autoopen' : ''}${invalid ? ' ttg-card--invalid' : ''}">`;
      html += `<div class="ttg-card__h"${headAction ? ` data-action="${headAction}" data-step="${d.key}" role="button" tabindex="0"` : ''}>
          <!-- Ziffer als data-Attribut, NICHT als Textknoten: siehe .ttg-card__num im CSS.
               Zepto (globales App-Embed) markiert dokumentweit jedes Blattelement, dessen
               Text exakt der Warenkorbmenge entspricht, und überschreibt es danach bei
               jeder Warenkorbänderung. Ein leerer Knoten liefert text() === "" und ist
               damit für diese Suche unsichtbar. -->
          <span class="ttg-card__num" data-num="${num}" aria-hidden="true"></span>
          <span class="ttg-card__t">${escapeHtml(d.title)}</span>
          ${reopenable || wertImKopf ? this._summaryChip(d.key) : ''}
          ${reopenable ? `<span class="ttg-quiet__edit">${escapeHtml(S.change || 'Ändern')}</span>` : ''}
        </div>`;
      // Meldung direkt unter der Kopfzeile — sichtbar auch dann, wenn der Body
      // (erledigter Panel-Schritt) gar nicht gerendert wird.
      if (invalid) html += `<p class="ttg-card__err">${escapeHtml(this._invalid.msg)}</p>`;
      if (keep || status === 'active' || autoOpen || motifCompare) {
        html += `<div class="ttg-card__body">${this._stepBody(d.key)}</div>`;
      } else if (done && mode === 'inline') {
        // Erledigt + inline: Controls bleiben sichtbar & direkt bedienbar (kein „Ändern").
        html += `<div class="ttg-card__body ttg-card__body--compact">${this._stepControls(d.key)}</div>`;
      }
      html += `</div>`;
    }
    morphSteps(this.refs.steps, html);   // Handy-INP 13.10.2026: abgleichen statt ersetzen (s. morphSteps)
    this._listeZurAuswahl();             // Listen-Ansicht (Schema v1.37); ohne Liste sofort zurück
    if (this._miniAusweichen) this._miniAusweichen();   // Handy: schwebende Vorschau gibt die Liste frei (23.10.2026)
    // Foto-Modul (Schema v1.18) in den frisch gebauten Schritt hängen — no-op
    // ohne config.photo bzw. ohne gerenderten Foto-Schritt.
    this._mountPhotoStep();
    this._mountGroupHandles();
    // Autofokus NUR im tatsächlich aktiven Schritt — auto-offene Panels und stille
    // Editoren ziehen keinen Fokus (sonst würde jede Interaktion hineinspringen).
    const focusEl = this.refs.steps.querySelector('.ttg-card--active:not(.ttg-card--autoopen):not(.ttg-card--quiet) [data-autofocus]');
    // Per Klick/Tap zieht nur das Motiv-Suchfeld den Fokus — dort IST Tippen der
    // nächste Schritt —, und dann ohne Scroll. Jedes andere Feld (v. a. der
    // Wunschtext) bekommt ihn nur per Tastatur-Navigation: sonst schöbe der native
    // Fokus-Scroll den Viewport in den nächsten Schritt und auf Mobile klappte
    // ungefragt die Bildschirmtastatur auf.
    if (focusEl && (this._kbNav || focusEl.dataset.field === 'motifSearch')) {
      focusEl.focus({ preventScroll: !this._kbNav });
    }
    this._announce();
    this._emitStepChanged(defs, active);
  }

  /** Fortschritts-Ereignis für Zuhörer (Messung). Hier zentral, weil an dieser
   *  Stelle Schrittliste, done-Nachmarkierung und aktiver Schritt fertig sind —
   *  ein Emit deckt alle Schritte ab, statt in jedem Klick-Fall einzeln zu feuern.
   *  renderSteps() läuft bei jeder Aktion; gefeuert wird nur bei echter Änderung,
   *  sonst bekäme ein Zuhörer Dutzende identische Ereignisse pro Sitzung. */
  _emitStepChanged(defs, active) {
    const reached = defs.filter((d) => this.state.done[d.key]).map((d) => d.key);
    const sig = active + '|' + reached.join(',');
    if (sig === this._stepSig) return;
    this._stepSig = sig;
    this.emit('stepChanged', { active, reached, steps: defs.map((d) => d.key) });
  }

  /** Kompakt-Zusammenfassung im Kopf eines erledigten Schritts (mit Mini-Vorschau). */
  _summaryChip(key) {
    const s = this.state;
    let inner = '';
    if (key === 'motif') {
      if (s.noMotif) inner = escapeHtml(this.config.strings.no_motif || 'Kein Motiv');
      else if (s.motif) {
        const cur = this._currentMotifImage();
        const url = cur ? cur.url : s.motif.bild;
        const thumb = this._isFullColorMotif(s.motif)
          ? `<span class="ttg-card__thumb ttg-card__thumb--full" style="background-image:url('${url}')"></span>`
          // Ohne Druckfarbe: die Miniatur sagt, WELCHES Motiv gewählt ist, nicht wie es
          // gedruckt wird. Die Tinte kommt aus dem CSS (fest #262a33) — sonst war der
          // Chip bei weißer Druckfarbe unsichtbar (weiß auf weißer Karte).
          : `<span class="ttg-card__thumb" style="-webkit-mask-image:url('${url}');mask-image:url('${url}')"></span>`;
        // Bei mehreren Varianten die gewählte Variante im Chip ausweisen.
        const imgs = this._motifImages(s.motif);
        const vsuffix = imgs.length > 1 ? ` · Var. ${(s.motifVariant || 0) + 1}` : '';
        inner = `${thumb}${escapeHtml(s.motif.label + vsuffix)}`;
      }
    } else if (key === 'print') {
      const p = this.config.printColors.find((x) => x.hex === s.druckfarbe);
      // Kein auflösbarer Name → GAR KEIN Chip. Vorher stand hier ersatzweise der
      // rohe Hex ("#e6007d"); im Kopf neben "Druckfarbe auswählen" wäre das für
      // den Kunden unlesbar. Lieber nur die Aufforderung ohne Zusatz. Der Fall
      // tritt nur auf, wenn state.druckfarbe nicht in printColors steht.
      if (!p) return '';
      const _pt = this._surchargeText(p.surcharge);
      const psc = _pt ? ' ' + _pt : '';
      inner = `<span class="ttg-card__dot" style="background:${escapeHtml(s.druckfarbe)}"></span>${escapeHtml(p.name + psc)}`;
    } else if (key === 'akzent') {
      const p = this._akzentFarben().find((x) => x.hex === s.akzentfarbe);
      if (!p) return '';
      const _pt = this._surchargeText(p.surcharge);
      inner = `<span class="ttg-card__dot" style="background:${escapeHtml(s.akzentfarbe)}"></span>${escapeHtml(p.name + (_pt ? ' ' + _pt : ''))}`;
    } else {
      inner = escapeHtml(this._summary(key));
    }
    return `<span class="ttg-card__sum">${inner}</span>`;
  }

  /** Nur die Controls eines inline-Schritts (für den erledigten Kompaktzustand). */
  _stepControls(key) {
    const xo = this._extraDef(key);
    if (xo) return this._extraRow(xo);
    const ad = this._addonDef(key);
    if (ad) return this._addonRow(ad);
    switch (key) {
      case 'base': return this._baseRow();
      case 'color': return this._colorRow();
      case 'side': return this._sideRow();
      case 'font': return this._fontRow();
      case 'print': return this._bodyPrint();   // via stepModes.print='inline' (autoAdvance:false)
      case 'akzent': return this._bodyAkzent();
      // Größenratgeber bleibt auch nach der Auswahl erreichbar (nicht nur im aktiven Zustand).
      case 'size': return this._sizeRow() + this._sizeGuideHtml();
    }
    return '';
  }

  _summary(key) {
    const s = this.state;
    const xo = this._extraDef(key);
    if (xo) return s.options[xo.optionName] || '';
    const ad = this._addonDef(key);
    if (ad) {
      const it = this._addonItems(ad).find((x) => String(x.variantId) === String(s.addons[ad.id]));
      return it ? (it.label || '') : (ad.noneLabel || 'Keine');
    }
    const td = this._textDef(key);
    if (td) {
      let out = s.noTexts[td.id]
        ? (td.noTextValue || this.config.strings.no_text || 'Kein Text')
        : ('»' + (s.texts[td.id] || '…') + '«');
      // Gefüllte Sekundär-Slots im Chip mit ausweisen.
      for (const sd of this._secondariesFor(td)) {
        const v = (s.texts[sd.id] || '').trim();
        if (v && !s.noTexts[sd.id]) out += ' · »' + v + '«';
      }
      return out;
    }
    switch (key) {
      case 'base': { const o = this._baseOptions(); return (o[s.baseChoice] || o[0] || {}).label || ''; }
      case 'color': return s.color || '';
      case 'side': return s.side || '';
      case 'motif': return s.noMotif ? (this.config.strings.no_motif || 'Kein Motiv') : (s.motif ? s.motif.label : '');
      case 'font': { const f = this.config.fonts.find((x) => x.id === s.font); return f ? f.label : ''; }
      case 'print': { const p = this.config.printColors.find((x) => x.hex === s.druckfarbe); return p ? p.name : ''; }
      case 'akzent': { const p = this._akzentFarben().find((x) => x.hex === s.akzentfarbe); return p ? p.name : ''; }
      case 'size': return s.size || '';
      case 'photo': return s.photo ? ((this.config.strings || {}).photo_done || 'Foto hochgeladen') : '';
    }
    return '';
  }

  _stepBody(key) {
    const xo = this._extraDef(key);
    if (xo) return this._bodyExtra(xo);
    const ad = this._addonDef(key);
    if (ad) return this._bodyAddon(ad);
    const td = this._textDef(key);
    if (td) return this._bodyText(td);
    switch (key) {
      case 'base': return this._bodyBase();
      case 'color': return this._bodyColor();
      case 'side': return this._bodySide();
      case 'motif': return this._bodyMotif();
      case 'font': return this._bodyFont();
      case 'print': return this._bodyPrint();
      case 'akzent': return this._bodyAkzent();
      case 'size': return this._bodySize();
      case 'photo': return this._bodyPhoto();
    }
    return '';
  }
  /** Foto-Schritt (Schema v1.18): die Sektion liefert nur den Mount-Punkt — die
   *  komplette Bedienung (Dateiwahl, Verschieben/Zoomen, Auflösungs-Ampel,
   *  Upload) rendert das eigenständige Modul assets/ttg-foto.js hinein
   *  (window.TTG_FOTO, Naht wie TTG_SIZE_OVERLAY_RENDERERS — kein Feature-Code
   *  in der Engine, CLAUDE.md §3). Ohne Modul bleibt der Hinweis stehen und der
   *  Kauf sauber blockiert (_photoSatisfied bleibt false — fail-closed). */
  _bodyPhoto() {
    const cfg = this.config.photo || {};
    const S = this.config.strings || {};
    const q = cfg.question ? `<div class="ttg-q">${escapeHtml(cfg.question)}</div>` : '';
    return `${q}<div class="ttg-photo" data-ttg="photo-step">
      <p class="ttg-photo__loading">${escapeHtml(S.photo_loading || 'Foto-Werkzeug wird geladen …')}</p>
    </div>`;
  }
  /** Foto-Modul in den frisch gerenderten Schritt hängen (jedes renderSteps baut
   *  den DOM neu, deshalb hier statt einmalig beim Mount). Doppelt abgesichert:
   *  lädt das Modul NACH der Engine, ruft es seinerseits mountAll() auf. */
  _mountPhotoStep() {
    if (!this.config.photo || !this.refs.steps) return;
    const el = this.refs.steps.querySelector('[data-ttg="photo-step"]');
    if (!el || el.dataset.ttgFotoMounted) return;
    if (typeof window !== 'undefined' && window.TTG_FOTO && typeof window.TTG_FOTO.mountStep === 'function') {
      window.TTG_FOTO.mountStep(this, el);
    }
  }
  /** Bedienung des verschiebbaren Namensfelds anmelden (Schema v1.19) — gleiches
   *  Muster wie _mountPhotoStep: die ENGINE ruft das Modul, sobald sie steht.
   *  Das Modul kann sich nicht selbst zuverlässig anmelden, weil es per `defer`
   *  lädt, die Engine aber asynchron als Modul mountet — wer zuerst da ist,
   *  ist nicht bestimmt. Ohne `layout.groups` passiert nichts. */
  _mountGroupHandles() {
    if (typeof window === 'undefined') return;
    if (!this.refs || !this.refs.base) return;
    const defs = this._groupDefs();
    let leer = true;
    for (const k in defs) { leer = false; break; }
    if (leer) return;
    if (window.TTG_NAMENSFELD && typeof window.TTG_NAMENSFELD.mount === 'function') {
      window.TTG_NAMENSFELD.mount(this);
    }
  }
  /** Motivseite-Umschalter: Text-Buttons im Größen-Stil (wie der Schnitt-Schritt) —
   *  Tippen wählt & bleibt inline umschaltbar. Auswahl schaltet Basisbild + Layout. */
  _sideRow() {
    const cfg = this.config.sides || {};
    const values = Array.isArray(cfg.values) ? cfg.values : [];
    const cur = this.state.side;
    return `<div class="ttg-sizes ttg-vorow ttg-siderow">${values.map((v) => `
        <button type="button" class="ttg-sz" data-action="side" data-v="${escapeHtml(v)}" aria-pressed="${cur === v}"><span class="ttg-sz__v">${escapeHtml(v)}</span></button>`).join('')}</div>`;
  }
  _bodySide() {
    const cfg = this.config.sides || {};
    const q = cfg.question ? `<div class="ttg-q">${escapeHtml(cfg.question)}</div>` : '';
    return q + this._sideRow();
  }

  /** Base-Umschalter: klickbare Buttons (Label je Vorlage). Auswahl = sofort, wechselt nur das Base-Foto. */
  _baseRow() {
    const opts = this._baseOptions();
    return `<div class="ttg-baserow">${opts.map((o, i) => `
        <button type="button" class="ttg-basebtn" data-action="base" data-i="${i}" aria-pressed="${this.state.baseChoice === i}">${escapeHtml(o.label || ('Option ' + (i + 1)))}</button>`).join('')}</div>`;
  }
  _bodyBase() {
    return `<div class="ttg-q">${escapeHtml(this.config.strings.q_base || 'Wie viele Hunde?')}</div>${this._baseRow()}`;
  }

  /** Zusätzliche Varianten-Option (z. B. Damen-/Herrenschnitt): Text-Buttons im
   *  Größen-Stil — Tippen wählt & schließt ab, bleibt inline umschaltbar. */
  _extraRow(xo) {
    const values = this._optionValues(xo.optionName);
    const cur = this.state.options[xo.optionName];
    return `<div class="ttg-sizes ttg-vorow">${values.map((v) => `
        <button type="button" class="ttg-sz" data-action="vo" data-opt="${escapeHtml(xo.optionName)}" data-v="${escapeHtml(v)}" aria-pressed="${cur === v}"><span class="ttg-sz__v">${escapeHtml(v)}</span></button>`).join('')}</div>`;
  }
  _bodyExtra(xo) {
    const q = xo.question ? `<div class="ttg-q">${escapeHtml(xo.question)}</div>` : '';
    return q + this._extraRow(xo);
  }

  /**
   * Basis-/Farbschritt. Standard ist der Farbpunkt (swatchHex).
   *
   * config.base.display === "image" (Schema v1.9, aus dem variant_option-Schritt)
   * zeigt stattdessen das VARIANTENBILD als Miniatur. Nötig, wo die Optionswerte
   * keine Farben benennen: "Beanie schwarz" und "Bommelmütze schwarz" liefern
   * beide denselben schwarzen Punkt und sind so nicht unterscheidbar.
   *
   * Rein additiv, zwei Stufen:
   *  - kein display / kein "image"  → exakt das bisherige Markup (Punkt).
   *  - "image", aber für DIESEN Wert kein Bild → ebenfalls der Punkt. Ein
   *    Produkt mit nur teilweise gemappten Variantenbildern verliert damit
   *    keine Auswahl, sondern zeigt gemischt — besser als eine leere Kachel.
   *
   * Die Bilder kommen aus this.baseImages (_deriveBaseImages, Variantenbild je
   * Optionswert) — dieselbe Quelle wie die Vorschau-Bühne, also keine zweite
   * Pflegestelle und kein zusätzliches Config-Feld.
   */
  /** Einmalige Warnung je Grund — `renderSteps()` läuft bei jeder Aktion, eine
   *  Warnung pro Render wäre nicht laut, sondern Rauschen (und würde die echte
   *  Meldung zuscrollen). */
  _warnEinmal(schluessel, text) {
    if (!this._warnGesehen) this._warnGesehen = new Set();
    if (this._warnGesehen.has(schluessel)) return;
    this._warnGesehen.add(schluessel);
    console.warn('[ttg] ' + text);
  }

  /* ENTFERNT 20.08.2026 — Motiv auf den Farb-Kacheln (motifOnSwatch, Schema v1.15).
   *
   * Hier standen `_swatchMotifTeile()` und `_swatchAspect()`: sie legten das
   * gewählte Motiv in der Druckfarbe auf die Kachel, sobald
   * `config.base.motifOnSwatch === true` war.
   *
   * Entscheidung Jens (Briefing 20.08.2026): In der Varianten-Farbauswahl steht
   * IMMER das blanke Produkt — katalogweit, ohne Ausnahme. Die Kachel beantwortet
   * „welche Farbe hat die Ware", nicht „wie sieht mein Motiv darauf aus"; dafür
   * ist die Bühne da.
   *
   * Warum im Code entfernt statt per Config abgeschaltet: Das Flag stand in 25
   * Configs (20.08. selbst gezählt), in einem Step-Block, der von Kategorie zu
   * Kategorie kopiert wird. Eine reine Datenkorrektur haelt deshalb nicht — die
   * naechste abgeleitete Kategorie braechte es zurueck. Ohne Auswerter ist der
   * Parameter wirkungslos, egal was in den Configs steht.
   *
   * `motifOnSwatch` ist ab jetzt ein toter Schluessel: die Engine liest ihn nicht
   * mehr, die Section emittiert ihn nicht mehr. Die Configs duerfen ihn behalten.
   * Die Fassung mit dem Kompositum steht in der Historie (bis a528ab1).
   */

  /**
   * Basis-/Farbschritt. Standard ist der Farbpunkt (swatchHex).
   *
   * config.base.display === "image" (Schema v1.9, aus dem variant_option-Schritt)
   * zeigt stattdessen das VARIANTENBILD als Miniatur. Nötig, wo die Optionswerte
   * keine Farben benennen: "Beanie schwarz" und "Bommelmütze schwarz" liefern
   * beide denselben schwarzen Punkt und sind so nicht unterscheidbar.
   *
   * Die Kachel zeigt IMMER das blanke Produkt — nie das gewählte Motiv
   * (Entscheidung Jens, 20.08.2026; s. den Vermerk über dieser Funktion).
   * `config.base.motifOnSwatch` wird nicht mehr gelesen.
   *
   * Drei Stufen:
   *  - kein display / kein "image"      → Farbpunkt.
   *  - "image", für DIESEN Wert kein Bild → ebenfalls der Punkt, laut gemeldet.
   *    Ein Produkt mit nur teilweise gemappten Bildern verliert keine Auswahl.
   *  - "image" mit Bild                 → das blanke Variantenbild.
   *
   * Die Bilder kommen aus this.baseImages (_deriveBaseImages, Blanko je
   * Optionswert) — dieselbe Quelle wie die Vorschau-Bühne, also keine zweite
   * Pflegestelle und kein zusätzliches Config-Feld.
   */
  _colorRow() {
    // Ohne config.base.hideSoldOut identisch zu _optionValues (Schema v1.32).
    const values = this._baseWerteSichtbar();
    if (this._baseAllesAusverkauft()) return '<p class="ttg-q ttg-soldout" role="status">Leider ausverkauft</p>';
    const sw = this.config.base.swatches || {};
    const alsBild = this.config.base.display === 'image';
    return `<div class="ttg-swrow${alsBild ? ' ttg-swrow--img' : ''}">${values.map((v) => {
      // swatchImages (Schema v1.21): eigene Kachelbilder je Optionswert, wenn
      // Buehne (baseImages = Blanko) und Kachel (Designfoto) auseinanderfallen
      // sollen — Foto-Leckerlidose. Ohne das Feld unveraendert this.baseImages,
      // jede Bestandskachel rendert byte-gleich.
      const bild = alsBild ? (((this.config.swatchImages || {})[v]) || this.baseImages[v]) : null;
      if (alsBild && !bild) {
        this._warnEinmal('swatch-bild-' + v, `Kein Blanko-Bild für den Optionswert "${v}" — diese Kachel zeigt den Farbpunkt.`);
      }
      let marke;
      if (bild) {
        marke = `<img class="ttg-vc__img" src="${escapeHtml(bild)}" alt="" loading="lazy" decoding="async">`;
      } else {
        marke = `<span class="ttg-vc__dot" style="background:${swatchHex(v, sw[v])}"></span>`;
      }
      return `
        <button type="button" class="ttg-vc" data-action="color" data-v="${escapeHtml(v)}" aria-pressed="${this.state.color === v}">
          ${marke}
          <small>${escapeHtml(v)}</small>
        </button>`;
    }).join('')}</div>`;
  }
  _bodyColor() {
    return `<div class="ttg-q">${escapeHtml(this.config.strings.q_color || 'Welche Westenfarbe?')}</div>${this._colorRow()}`;
  }

  /** Im Produkt vorhandene Motiv-Kategorien (datengetrieben; nur befüllte).
   *  Reihenfolge: config.categoryOrder (Schema v1.2), nicht gelistete dahinter
   *  in Ist-Reihenfolge; ohne categoryOrder die Ist-Reihenfolge der Motive. */
  _motifCategories() {
    const present = [];
    for (const m of (this.config.motifs || [])) if (m.kategorie && present.indexOf(m.kategorie) === -1) present.push(m.kategorie);
    const order = Array.isArray(this.config.categoryOrder) ? this.config.categoryOrder : null;
    if (order && order.length) {
      present.sort((a, b) => {
        const ia = order.indexOf(a), ib = order.indexOf(b);
        return (ia === -1 ? order.length : ia) - (ib === -1 ? order.length : ib);
      });
    }
    return present;
  }
  /** Vorschaubild einer Kategorie: Override aus config.categoryThumbs
   *  (URL-String oder {url}) — sonst das Bild des ersten Motivs der Kategorie. */
  _categoryThumb(cat) {
    const thumbs = this.config.categoryThumbs || {};
    let src = thumbs[cat];
    if (src && typeof src === 'object') src = src.url;
    if (typeof src === 'string' && src.indexOf('/') !== -1) return src;
    const first = (this.config.motifs || []).find((m) => m.kategorie === cat);
    return first ? first.bild : '';
  }

  /** Absichtsgruppen (Schema v1.3, categoryGroups): nur befüllte Gruppen —
   *  mindestens ein Motiv in einer der Gruppen-Kategorien ODER ein auflösbares
   *  extraMotifs-Handle (Schema v1.25). null = kein Gruppenmodus.
   *  Ohne den zweiten Zweig verschwände eine Gruppe, die ihren Inhalt nur über
   *  extraMotifs bekommt, still aus dem Dialog. */
  _motifGroups() {
    const gs = Array.isArray(this.config.categoryGroups) ? this.config.categoryGroups : null;
    if (!gs || !gs.length) return null;
    return gs.filter((g) => g && g.id && Array.isArray(g.categories) &&
      ((this.config.motifs || []).some((m) => g.categories.indexOf(m.kategorie) !== -1)
        || this._hasExtraMotif(g)));
  }
  /**
   * extraMotifs (Schema v1.25, 19.09.2026): eine categoryGroup führt einzelne Motive
   * FREMDER Kategorien zusätzlich — das Motiv-Metaobjekt behält seine Kategorie
   * (Anlass: „Never Walk Alone – Pferd & Hund", Gassi & Dogwalker, soll auf dem
   * Stallmantel in „Pferdeleben" stehen). Einträge sind Handles (oder gids), aufgelöst
   * über _resolveMotif — dieselbe Auflösung wie bei featured; Unbekanntes/Inaktives
   * bricht nichts. Drei Leser, eine Regel: _motifsInBucket hängt sie an, _bucketForMotif
   * ordnet ein Motiv OHNE Kategorie-Gruppe der ersten Gruppe zu, die es führt, und die
   * Zugehörigkeits-Prüfung (Kachel-Kollaps, Deep-Link) fragt _motifInBucketDef.
   */
  /** Führt die Gruppe/Bucket-Def `g` das Motiv `m` über extraMotifs? */
  _isExtraMotifOf(g, m) {
    const extra = g && Array.isArray(g.extraMotifs) ? g.extraMotifs : null;
    if (!extra || !extra.length || !m) return false;
    return extra.some((h) => this._resolveMotif(h) === m);
  }
  /** Löst mindestens ein extraMotifs-Handle der Gruppe auf ein Motiv auf? */
  _hasExtraMotif(g) {
    const extra = g && Array.isArray(g.extraMotifs) ? g.extraMotifs : null;
    if (!extra || !extra.length) return false;
    return extra.some((h) => !!this._resolveMotif(h));
  }
  /** Gehört das Motiv in diesen Bucket? Kategorie ODER extraMotifs der Gruppe.
   *  Synthetische Defs ({categories:[…]} ohne extraMotifs) verhalten sich wie bisher. */
  _motifInBucketDef(def, m) {
    if (!def || !m) return false;
    if (Array.isArray(def.categories) && def.categories.indexOf(m.kategorie) !== -1) return true;
    return this._isExtraMotifOf(def, m);
  }
  /** Alle extraMotifs-Einträge aller ROHEN categoryGroups als String-Set (Handle oder
   *  gid). Roh statt über _motifGroups(): der Katalog-Filter fragt VOR dem Merge, wenn
   *  die Gruppen noch leer sind. */
  _extraMotifKeys() {
    const set = new Set();
    const gs = Array.isArray(this.config.categoryGroups) ? this.config.categoryGroups : null;
    if (!gs) return set;
    for (const g of gs) {
      if (!g || !Array.isArray(g.extraMotifs)) continue;
      for (const h of g.extraMotifs) if (h != null && h !== '') set.add(String(h));
    }
    return set;
  }
  /**
   * excludeMotifs (Schema v1.35, 23.10.2026 — Silhouetten-Shirts): Gegenstück zu extraMotifs.
   * Eine categoryGroup nennt Motiv-Handles (oder gids) ihrer Kategorien, die sie NICHT führt
   * (z. B. Kopf-Motive auf einem Ganzkörper-Design). Ein Motiv fällt ganz aus der Motivliste,
   * wenn JEDE Gruppe, die es führen würde (categories, searchCategories, extraMotifs), es
   * ausschließt — damit wirkt der Ausschluss in Grid, Suche und Deep-Link zugleich
   * (?ttg-motif auf ein ausgeschlossenes Motiv löst nicht auf → Startmotiv). Führt eine andere
   * Gruppe es weiter, bleibt es dort; _motifsInBucket filtert die ausschließende Gruppe.
   * Ohne den Schlüssel in irgendeiner Gruppe: alle Prüfungen sind No-Op (byte-gleich).
   */
  _hatExcludeMotifs() {
    const gs = Array.isArray(this.config.categoryGroups) ? this.config.categoryGroups : null;
    return !!gs && gs.some((g) => g && Array.isArray(g.excludeMotifs) && g.excludeMotifs.length > 0);
  }
  _motifInExclude(g, m) {
    const ex = g && Array.isArray(g.excludeMotifs) ? g.excludeMotifs : null;
    if (!ex || !ex.length || !m) return false;
    return ex.some((h) => h != null && (String(h) === String(m.id) || (m.gid != null && String(h) === String(m.gid))));
  }
  _motifTraeger(m) {
    return this.config.categoryGroups.filter((g) => g && (
      (Array.isArray(g.categories) && g.categories.indexOf(m.kategorie) !== -1) ||
      (Array.isArray(g.searchCategories) && g.searchCategories.indexOf(m.kategorie) !== -1) ||
      (Array.isArray(g.extraMotifs) && g.extraMotifs.some((h) => String(h) === String(m.id) || (m.gid != null && String(h) === String(m.gid))))));
  }
  _motifAusgeschlossen(m) {
    if (!m || !this._hatExcludeMotifs()) return false;
    const traeger = this._motifTraeger(m);
    return traeger.length > 0 && traeger.every((g) => this._motifInExclude(g, m));
  }
  /**
   * Bildvarianten in excludeMotifs (Schema v1.38, 24.10.2026 — Leine/Schnur): Eintrag "<handle>--b<N>"
   * (N = 1-basierte Katalog-Nummer in motif.bilder) oder die Bild-ID. Die Variante fällt aus
   * _motifImages (Bildwahl, Deep-Link &ttg-bild, Vertrag), wenn jede Trägergruppe sie nennt —
   * gleiche Regel wie beim ganzen Motiv. Das Motiv selbst bleibt mit seinen übrigen Bildern.
   */
  _bildAusgeschlossen(m, b) {
    if (!m || !b || !Array.isArray(m.bilder)) return false;
    const keys = [String(m.id) + '--b' + (m.bilder.indexOf(b) + 1)];
    if (b.id != null) keys.push(String(b.id));
    const nennt = (g) => g && Array.isArray(g.excludeMotifs) && g.excludeMotifs.some((h) => h != null && keys.indexOf(String(h)) !== -1);
    if (!this.config.categoryGroups.some(nennt)) return false;
    const traeger = this._motifTraeger(m);
    return traeger.length > 0 && traeger.every(nennt);
  }
  /** &ttg-bild (0-basiert, Katalog-Nummer) → Index in _motifImages(m); 0 = Bild 1 (fehlt oder ausgeschlossen). */
  _urlBildIndex(m, n) {
    if (!m || !(n > 0)) return 0;
    const imgs = this._motifImages(m);
    if (!this._hatExcludeMotifs() || !Array.isArray(m.bilder) || !m.bilder.length) return n < imgs.length ? n : 0;
    const i = imgs.indexOf(m.bilder[n]);
    return i > 0 ? i : 0;
  }
  /** Definition eines Buckets — Gruppe (Gruppenmodus) oder einzelne Kategorie.
   *  Vereinheitlicht: { id, label, subline, categories[], search }. */
  _bucketDef(id) {
    const groups = this._motifGroups();
    if (groups) {
      const g = groups.find((x) => x.id === id);
      if (!g) return null;
      return {
        id: g.id, label: g.label || g.id, subline: g.subline || '',
        categories: g.categories,
        search: Array.isArray(g.searchCategories) && g.searchCategories.length > 0,
        // Für [STIL] in der Wunsch-Vorbefüllung: die Kategorien, die diese Gruppe
        // durchsucht, plus optionaler Klartext searchLabel. Heute trägt keine Gruppe
        // mehr als eine Kategorie (02.08. über alle 40 Configs ausgezählt) — die
        // Verkettung unten ist Vorsorge, kein aktiver Pfad.
        searchCategories: Array.isArray(g.searchCategories) ? g.searchCategories : [],
        searchLabel: g.searchLabel || null,
        // Gruppen-Ebene des Leere-Suche-Zustands (02.08.2026) — Schwestern von
        // showAllLabel/searchLabel: Wortlaut und Schalter pro Gruppe statt pro Schritt.
        // Aufgelöst in _emptySearchFor(); hier nur durchgereicht.
        emptySearch: (g.emptySearch && typeof g.emptySearch === 'object') ? g.emptySearch : null,
        searchPlaceholder: g.searchPlaceholder || null,
        // Listen-Ansicht (Schema v1.37): nur der Wert "liste" zählt, alles andere = Kacheln.
        ansicht: g.ansicht === 'liste' ? 'liste' : null,
        // Kuratierte Bucket-Köpfe (Reihenfolge-Vertrag) — muss die Normalisierung
        // überleben, sonst hebt _motifsInBucket nichts an (im DOM-Nachweis gefangen:
        // der direkte _motifsInBucket-Test übersprang genau diese Naht).
        featured: Array.isArray(g.featured) ? g.featured : null,
        // Optionaler per-Gruppe Text für den „Alle N … anzeigen"-Button ({n} =
        // Anzahl). Ohne ihn greift der bisherige Default: Such-Gruppe →
        // strings.show_all_motifs („… Rassen …"), sonst „Alle {n} Motive anzeigen".
        // Damit ist der Rassen-Wortlaut pro Gruppe steuerbar — z. B. eine such-
        // aktive Sprüche-Gruppe kann „Alle {n} Motive anzeigen" setzen.
        showAllLabel: g.showAllLabel || null,
        // Einzelne Motive fremder Kategorien, die diese Gruppe zusätzlich führt
        // (Schema v1.25, Handles/gids). _motifsInBucket hängt sie hinten an.
        extraMotifs: Array.isArray(g.extraMotifs) ? g.extraMotifs : null,
        // Ausgeschlossene Handles/gids (Schema v1.35) — _motifsInBucket filtert sie.
        excludeMotifs: Array.isArray(g.excludeMotifs) ? g.excludeMotifs : null,
      };
    }
    return {
      id, label: (this.config.categories || {})[id] || id, subline: '',
      categories: [id],
      search: (this.config.searchCategories || []).indexOf(id) !== -1,
      // Ohne Gruppen IST der Bucket die Kategorie — [STIL] ist damit ihr Name
      // (Fußmatten). Kein Ort für die Gruppen-Felder: die sitzen an der Gruppe,
      // die es hier nicht gibt. Die Kaskade fällt dort auf Schritt und Engine durch.
      searchCategories: (this.config.searchCategories || []).indexOf(id) !== -1 ? [id] : [],
      searchLabel: null,
      emptySearch: null,
      searchPlaceholder: null,
      // Kategorie-Katalog ohne categoryGroups (Fußmatte „Hier wohnt"): kuratierte
      // Einstiegs-Reihenfolge kommt aus motifsCatalog.featured (Handles). _motifsInBucket
      // hebt genau die IN DIESEM Bucket vorhandenen Featured an den Anfang — fremde
      // bleiben wirkungslos. Ohne motifsCatalog.featured (jedes bestehende Produkt) null.
      featured: (this.config.motifsCatalog && Array.isArray(this.config.motifsCatalog.featured))
        ? this.config.motifsCatalog.featured : null,
      // Ohne Gruppen gibt es keinen Ort für extraMotifs — der Bucket IST die Kategorie.
      extraMotifs: null,
    };
  }
  /** Template für den „Alle N … anzeigen"-Button eines Buckets ({n} = Anzahl).
   *  NEUTRAL by default: „Alle {n} Motive anzeigen" für JEDE Gruppe. Der „Rassen"-
   *  Wortlaut ist pro Gruppe ein Opt-in über showAllLabel (z. B. die Rasse-Gruppe
   *  setzt „Alle {n} Rassen anzeigen"). Der frühere globale strings.show_all_motifs
   *  wird NICHT mehr automatisch angewandt — er griff sonst auch für such-aktive
   *  Nicht-Rassen-Gruppen (Sprüche) und erzeugte „23 Rassen" für Motive. */
  _showAllTpl(def) {
    return def.showAllLabel || 'Alle {n} Motive anzeigen';
  }
  /** Genau ein befüllter Bucket (Gruppe oder Kategorie) → Dialog entfällt. */
  _soleBucket() {
    const groups = this._motifGroups();
    if (groups) return groups.length === 1 ? groups[0].id : null;
    return this._soleCategory();
  }
  /**
   * Ebenenwechsel in der Motivauswahl (Sektion betreten / zurück): an den KOPF der
   * Motiv-Karte scrollen.
   *
   * Warum überhaupt: Die Sektionsliste ist hoch — „Pferdeleben" steht ganz unten.
   * Ein Klick dort tauscht per renderSteps() den Karteninhalt aus, die Seite bleibt
   * aber an der Klickposition stehen. Die neue (kürzere) Ansicht beginnt dann WEIT
   * OBERHALB des Bildschirms; der Kunde sieht nichts und hält den Klick für wirkungslos.
   *
   * Anker ist die Motiv-Karte selbst, NIE der Seitenanfang — der Kunde soll das
   * Motivfenster sehen, nicht den Produktkopf. Den Sticky-Header des Themes hält
   * scroll-margin-top im CSS frei (dieselbe --ttg-mini-inset-top, die auch die
   * Mini-Vorschau und der Fehler-Anker benutzen) — kein Offset-Rechnen in JS.
   *
   * Ein rAF Abstand, damit das frisch geschriebene Grid gelayoutet ist: renderSteps()
   * ersetzt innerHTML, direkt danach ist die Kartenhöhe noch die alte und das Ziel
   * verrutscht.
   *
   * Kein Konflikt mit der Mini-Vorschau (PiP): deren IntersectionObserver beobachtet
   * das stationäre .ttg__stage und scrollt selbst nie; activate() friert zusätzlich
   * dessen aspectRatio ein, das Layout springt beim Umhängen also nicht. Ein Scroll
   * kann dort höchstens den normalen Ein-/Ausblendpfad auslösen (Hysterese 0/35 %,
   * 120 ms Debounce) — er kommt aber nie auf den Scroller zurück, es gibt keine Schleife.
   */
  _scrollToMotifCard() {
    if (typeof window === 'undefined') return;
    let done = false;
    const run = () => {
      if (done) return;                       // rAF und Timeout laufen beide — nur der erste zählt
      done = true;
      const card = this.refs && this.refs.steps && this.refs.steps.querySelector('.ttg-card--k-motif');
      if (!card) return;
      // Barrierefreiheit: wer Bewegung reduziert, bekommt den Sprung ohne Animation.
      let behavior = 'smooth';
      try {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) behavior = 'auto';
      } catch (e) { /* matchMedia fehlt → smooth */ }
      try { card.scrollIntoView({ behavior, block: 'start' }); }
      catch (e) { try { card.scrollIntoView(); } catch (e2) { /* egal, nie den Klick verschlucken */ } }
    };
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(run);
      // rAF ist in einem VERSTECKTEN Tab pausiert (im Test nachgewiesen: document.hidden
      // → der Callback kam nie). Dort ist der Sprung zwar folgenlos, aber der Zustand
      // bliebe ungescrollt zurück, wenn der Kunde zurückkehrt. Der Timeout holt ihn
      // nach; der done-Riegel verhindert, dass beide Wege doppelt scrollen.
      setTimeout(run, 150);
    } else run();
  }
  /** Bucket-ID, in der ein Motiv lebt (Gruppenmodus: Gruppe der Kategorie).
   *  Reihenfolge bewusst: ERST die Gruppe über die Kategorie wie bisher; nur wenn keine
   *  passt, die erste Gruppe, deren extraMotifs das Motiv führt (Schema v1.25). So bleibt
   *  das Verhalten für jedes Bestandsprodukt gleich — ein Motiv, dessen Kategorie eine
   *  eigene Gruppe hat, wandert nicht in die Gruppe, die es nur zusätzlich führt. */
  _bucketForMotif(m) {
    if (!m) return null;
    const groups = this._motifGroups();
    if (groups) {
      const g = groups.find((x) => x.categories.indexOf(m.kategorie) !== -1);
      if (g) return g.id;
      const ge = groups.find((x) => this._isExtraMotifOf(x, m));
      return ge ? ge.id : null;
    }
    return m.kategorie;
  }
  /** Genau eine Kategorie → diese (dann entfällt die Kategorie-Ebene); sonst null. */
  _soleCategory() {
    const c = this._motifCategories();
    return c.length === 1 ? c[0] : null;
  }
  /** Darf „Kein Motiv gewünscht" angeboten werden? (Setting, Default an — Warnweste unverändert.) */
  _allowNoMotif() {
    return this.config.allowNoMotif !== false;
  }
  /**
   * „Kein Motiv gewünscht" als Kästchen (15.08.2026). Vorher war es an drei Stellen
   * ein Link-Button — der konnte den Zustand nur EINSCHALTEN: `no-motif` warf
   * `state.motif` weg, und es gab keinen Weg zurück ausser einer neuen Motivwahl.
   * Das Kästchen zeigt den Zustand an UND nimmt ihn zurück; die vorherige Wahl
   * kommt dabei wieder (siehe `_motifBeforeNone` im Handler).
   * Bewusst dieselbe Form wie „Kein Text gewünscht" am Text-Schritt: gleiche Klasse
   * `.ttg-check`, gleiches `data-action`-Muster, gleicher Klick-Pfad. Deshalb
   * braucht dieser Umbau KEINE CSS-Änderung.
   */
  /**
   * Sieht der Kunde an DIESEM Text-Schritt eine „Kein Text gewünscht"-Wahl?
   * EINE Quelle für zwei Verbraucher: das Kästchen im Render (Hauptfeld + Slot)
   * UND die Line-Item-Property in getProperties. Beides muss dieselbe Antwort
   * geben — sonst steht in der Bestellung eine Aussage, die der Kunde nie
   * treffen konnte (oder es fehlt eine, die er getroffen hat).
   *
   * Sekundäre Slots (secondary:true) ohne noTextCta haben KEIN Kästchen: sie
   * klappen leer zum „+ …"-Link zusammen. Für sie bleibt Leere weiterhin Leere —
   * sonst trüge jede Warnwesten-Bestellung eine „Zusatztext: Kein Text"-Zeile,
   * die niemand gewählt hat.
   */
  _noTextChoiceVisible(def) {
    if (!def || !def.optional) return false;
    return def.secondary ? !!def.noTextCta : true;
  }
  _noMotifHtml() {
    if (!this._allowNoMotif()) return '';
    const label = this.config.strings.no_motif_cta || 'Kein Motiv gewünscht';
    return `<label class="ttg-check"><input type="checkbox" data-action="no-motif"${this.state.noMotif ? ' checked' : ''}> ${escapeHtml(label)}</label>`;
  }

  /** Überschrift (ttg-q) der Motiv-Übersicht — oder '' als Dubletten-Schutz
   *  (Jens 17.07.): ist die Frage textgleich mit dem Sektionstitel des
   *  Motiv-Schritts (z. B. beide „Motivauswahl"), zeigt der Kartenkopf sie
   *  bereits — die zweite Zeile entfällt. Eine ABWEICHENDE Frage bleibt stehen
   *  (sie trägt dann echte Zusatzinformation). Gilt für alle Konfiguratoren. */
  _motifOverviewQ() {
    const S = this.config.strings || {};
    const q = S.q_motif || 'Was soll auf Deine Weste?';
    if (String(q).trim() === String(S.step_motif || 'Motiv').trim()) return '';
    return `<div class="ttg-q">${escapeHtml(q)}</div>`;
  }

  _bodyMotif() {
    // Katalog-Modus: der VOLLE Katalog (229 KB) lädt LAZY — Idle nach dem First Paint
    // (mount) und bei Interaktion (Suche/„alle anzeigen"/Bucket-Wechsel). Er darf NICHT
    // in den kritischen Pfad. Sind für den aktuellen Bucket bereits Motive inline
    // (Default + Featured, von der Section mitgegeben, wenige hundert Byte), malt das
    // Grid SOFORT daraus — kein Warten, kein Fetch beim Render. Nur wenn NICHTS inline
    // für den Bucket vorliegt (kein Default / fremder Bucket vor dem Katalog), ein
    // leichter Lade-Zustand, der den Katalog anstößt.
    if (this.config.motifsCatalog && this.config.motifsCatalog.url && !this._catalogLoaded) {
      const bucketHasInline = !!this.state.bucket && this._motifsInBucket().length > 0;
      if (!bucketHasInline) {
        const q = this._motifOverviewQ();
        if (this._catalogFailed) {
          // Härtung: auch im Fehlzustand bleibt der Flow abschließbar — „Kein Motiv
          // gewünscht" (sofern erlaubt) entsperrt Produkte ohne Default-Motiv.
          return `${q}<p class="ttg-motif-cataloghint">${escapeHtml(this.config.strings.catalog_error || 'Die Motive konnten gerade nicht geladen werden — bitte kurz erneut versuchen.')}</p>
            <button type="button" class="ttg-link ttg-link--block" data-action="catalog-retry">${escapeHtml(this.config.strings.catalog_retry || 'Motive erneut laden')}</button>
            ${this._noMotifHtml()}`;
        }
        this._ensureCatalog();
        return `${q}<p class="ttg-motif-cataloghint">${escapeHtml(this.config.strings.catalog_loading || 'Motive werden geladen …')}</p>`;
      }
      // Inline-Motive vorhanden → Grid sofort malen; den Rest zieht der Idle-Prefetch
      // bzw. die erste Interaktion (kein Fetch hier im Render-Pfad).
    }
    const cats = this.config.categories || {};
    const sole = this._soleBucket();
    if (!this.state.bucket) {
      // Bucket-Dialog — nur bei MEHREREN Buckets (bei genau einem ist bucket
      // vorgesetzt). Gruppenmodus (categoryGroups): 1 Kachel pro Absichtsgruppe
      // (Label + Subline + Vorschaubild); sonst 1 Kachel pro Kategorie.
      const groups = this._motifGroups();
      let body;
      if (groups) {
        // Gruppenmodus: vertikale Liste voll-breiter Zeilen (Wireframe-Muster) —
        // Label fett, Subline grau, Chevron rechts. Bewusst OHNE Vorschaubild.
        body = groups.map((g) => `
          <button type="button" class="ttg-bucket" data-action="bucket" data-id="${escapeHtml(g.id)}">
            <span class="ttg-bucket__chev">›</span>
            <b>${escapeHtml(g.label || g.id)}</b>
            ${g.subline ? `<small class="ttg-bucket__sub">${escapeHtml(g.subline)}</small>` : ''}
          </button>`).join('');
      } else {
        const tiles = this._motifCategories().map((cat) => {
          const src = this._categoryThumb(cat);
          const thumb = this._isFullColorMotif({ kategorie: cat, bild: src })
            ? `<span class="ttg-tile__img ttg-tile__img--full" style="background-image:url('${src}')"></span>`
            : `<span class="ttg-tile__img" style="-webkit-mask-image:url('${src}');mask-image:url('${src}')"></span>`;
          return `<button type="button" class="ttg-tile ttg-tile--cat" data-action="bucket" data-id="${escapeHtml(cat)}">${thumb}<small>${escapeHtml(cats[cat] || cat)}</small></button>`;
        });
        body = `<div class="ttg-grid ttg-grid--cats">${tiles.join('')}</div>`;
      }
      return `${this._motifOverviewQ()}
        ${body}
        ${this._noMotifHtml()}`;
    }
    const def = this._bucketDef(this.state.bucket) || { id: this.state.bucket, label: this.state.bucket, categories: [this.state.bucket], search: false };
    const inBucket = this._motifsInBucket(def);
    const isSearch = def.search;
    const sel = this.state.motif;
    // Zugehörigkeit über _motifInBucketDef: Kategorie ODER extraMotifs (Schema v1.25) —
    // sonst zeigte ein gewähltes Extra-Motiv in seiner Gruppe weder Varianten noch Kollaps.
    const selHere = !!(sel && !this.state.noMotif && this._motifInBucketDef(def, sel));
    const selImgs = selHere ? this._motifImages(sel) : [];
    // Feature 2: Direkt nach Wahl eines Mehrbild-Motivs nur dieses zeigen (Grid aus). Der Flag ist
    // transient — jedes Wieder-Betreten des Schritts (reopen/bucket) setzt ihn zurück → das Grid
    // kommt zurück (kein „Kleben"). Das SUCHFELD bleibt seit 16.08.2026 durchgehend stehen, in
    // beiden Zuständen (Jens: „Suchfeld bleibt nach der Motivwahl sichtbar").
    const collapsedToSelection = this._collapsedToSelection();

    // Rücksprung zum Kategorie-Menü nur, wenn es mehr als eine Kategorie gibt.
    // Label „Mehr Motive entdecken" (Jens 17.07.): lädt zum Stöbern ein statt
    // nach Abbruch zu klingen — die Aktion (bucket-back) bleibt unverändert.
    // Steuerbar per Config-Key backLabel am Motiv-Schritt (Jens 18.07.); ohne ihn
    // greift der ältere globale strings.back, dann der Default — so bleibt der Text
    // künftig ohne Engine-Anfassen konfigurierbar.
    const backLabel = this.config.backLabel || (this.config.strings && this.config.strings.back) || 'Mehr Motive entdecken';
    // Kategorie-Überschrift über dem Grid nur zeigen, wenn per Setting aktiviert (generisch abschaltbar).
    const showCatHeading = this.config.showMotifCategoryHeading !== false;
    // Kaskade Gruppe → Schritt → Engine für Suchfeld-Platzhalter, Meldung, CTA und
    // Schalter dieses Buckets. Einmal je Render aufgelöst, unten dreimal gelesen.
    const es = this._emptySearchFor(def);
    let inner = `${sole ? '' : `<button type="button" class="ttg-link" data-action="bucket-back">‹ ${escapeHtml(backLabel)}</button>`}${showCatHeading ? `
      <div class="ttg-q">${escapeHtml(def.label || this.state.bucket)}</div>` : ''}`;

    if (collapsedToSelection) {
      // Suchfeld bleibt auch nach getroffener Wahl stehen (Jens 16.08.2026). Vorher führte
      // der einzige Weg zu einer zweiten Suche über „Andere Rasse wählen" ganz unten — die
      // Kunden suchen ihre Rasse aber regelmäßig im zweiten Anlauf. Ohne `autofocus`, sonst
      // klappte direkt nach dem Antippen einer Kachel die Bildschirmtastatur auf.
      if (isSearch) inner += this._motifSearchHtml(es, false);
      // Nur das gewählte Motiv als aktive Kachel — Klick darauf öffnet das volle Grid wieder.
      inner += `<div class="ttg-grid ttg-grid--single" data-ttg="motif-grid">${this._motifTileHtml(sel, false, 'motif-browse')}</div>`;
      // Der Leere-Suche-Zustand gehört mit dem Suchfeld zusammen — eine treffelose Suche
      // liefe hier sonst in eine tote Fläche. Das Loch entstünde erst durch das neue Feld.
      inner += this._motifEmptyHtml(isSearch, es);
    } else {
      if (isSearch) inner += this._motifSearchHtml(es, true);
      // Feature 1: Ausgangszustand (Suche leer, nicht „alle anzeigen") zeigt nur die ersten N Motive.
      // INP: NUR die sichtbaren Tiles rendern — versteckte display:none-Tiles wären
      // toter DOM-Ballast (146+ Knoten je Bucket bei JEDEM renderSteps, der
      // Haupt-Render-Kostenpunkt: 34,8 ms → gemessen). Die Suche arbeitet daten-
      // getrieben auf inBucket (_onMotifSearch) und rendert Treffer selbst.
      const initial = this._motifGridInitialWert();
      const expanded = this.state.motifExpandedFor === this.state.bucket;
      const collapsed = initial > 0 && inBucket.length > initial && !expanded;
      // _withSelectedVisible: beim Laden vorgewähltes Motiv (?ttg-motif / default_motif)
      // an Position 0 holen, falls es sonst hinter der Falz läge. Kachelzahl bleibt `initial`.
      const visibleMotifs = collapsed ? this._withSelectedVisible(inBucket, initial).slice(0, initial) : inBucket;
      inner += `<div class="ttg-grid${this._listenAnsicht() ? ' ttg-mlist' : ''}" data-ttg="motif-grid">${visibleMotifs.map((m) =>
        this._motifTileHtml(m, false)
      ).join('')}</div>`;
      // Leere-Suche-Zustand (versteckt; _onMotifSearch blendet ihn bei 0 Treffern ein):
      // freundliche Meldung + „Motiv wünschen"-Button zum Kontaktformular (fehlertolerant —
      // öffnet das Formular immer, ggf. mit vorbefülltem Text). Gilt in JEDEM Konfigurator
      // mit Suchfeld — es gibt kein Theme-Setting und kein Produkt-Metafeld mehr, das ihn
      // zuschaltet. Abschalten NUR per emptySearch.enabled:false im customizer_config; die
      // Section emittiert dann raceRequest:null und der Container entfällt.
      // Markup und Kaskade stehen seit 16.08. in _motifEmptyHtml — der Kollaps-Zweig
      // oben braucht denselben Container, seit dort ein Suchfeld steht.
      inner += this._motifEmptyHtml(isSearch, es);
      if (collapsed) {
        const label = this._showAllTpl(def).replace('{n}', inBucket.length);
        inner += `<button type="button" class="ttg-link ttg-link--block ttg-showall" data-action="motif-expand">${escapeHtml(label)}</button>`;
      }
      // Das Kästchen steht am ENDE des Motiv-Schritts: unter dem Grid, unter dem
      // „Alle {n} anzeigen"-Button, vor der Varianten-Reihe. Frueher hing es an
      // `sole` — bei mehreren Kategorien lebte die Option nur im Chooser eine Ebene
      // hoeher, im Bucket kam man nicht mehr an sie heran, ohne zurueckzugehen.
      // Jetzt ueberall dort, wo der Schritt sichtbar ist. Doppelt gerendert wird
      // nichts: Chooser und Bucket sind zwei getrennte Rueckgabezweige.
      inner += this._noMotifHtml();
    }

    // Varianten-Reihe NUR im kollabierten Auswahl-Zustand (Grid aus). Ist das Grid offen
    // (Ausgangszustand mit Default-Motiv oder „andere Rasse wählen"), keine Varianten zeigen —
    // sonst wären volles Grid + Varianten gleichzeitig sichtbar (inkonsistent). So sind „Grid offen"
    // und „Varianten" gegenseitig ausschließend; beim Wählen einer neuen Mehrbild-Rasse
    // (motifCollapsed → true) wird sauber auf deren Varianten umgeschaltet.
    // `data-ttg="motif-selection-only"` trägt genau diese Ausschließlichkeit in die Suche:
    // Tippt der Kunde jetzt (das Feld bleibt ja stehen), füllt _onMotifSearch dasselbe Grid
    // mit Treffern — die Varianten des noch gewählten Motivs stünden dann unter fremden
    // Kacheln. Ein Marker statt dreier Selektoren, damit die Liste nicht auseinanderläuft.
    if (collapsedToSelection) {
      const full = this._isFullColorMotif(sel);
      inner += `<div class="ttg-q ttg-q--variants" data-ttg="motif-selection-only">${escapeHtml(this.config.strings.q_variant || 'Variante wählen')}</div>
        <div class="ttg-variants" data-ttg="motif-selection-only">${selImgs.map((img, i) => {
          const t = full
            ? `<span class="ttg-varbtn__img ttg-varbtn__img--full" style="background-image:url('${img.url}')"></span>`
            // Ohne Druckfarbe (Jens 21.07.): Der Varianten-Umschalter ist ein
            // AUSWAHL-Element — er zeigt, welches Bild man wählt, nicht wie es
            // gedruckt wird. Das übernimmt die große Vorschau. Die Tinte kommt aus
            // dem CSS (fest #262a33), genau wie bei den normalen Motiv-Kacheln, die
            // schon immer entkoppelt sind. Bei weißer Druckfarbe (alle sieben
            // Hundesportwesten) rendert er sonst weiß auf weißem Grund.
            : `<span class="ttg-varbtn__img" style="-webkit-mask-image:url('${img.url}');mask-image:url('${img.url}')"></span>`;
          return `<button type="button" class="ttg-varbtn" data-action="motif-variant" data-i="${i}" aria-pressed="${this.state.motifVariant === i}" aria-label="Variante ${i + 1}">${t}</button>`;
        }).join('')}</div>`;
    }

    // Zurück zur vollen Rassenauswahl, wenn wegen Mehrbild-Motiv auf die Auswahl kollabiert wurde.
    if (collapsedToSelection) {
      inner += `<button type="button" class="ttg-link ttg-link--block ttg-link--solid" data-action="motif-browse" data-ttg="motif-selection-only">${escapeHtml(this.config.strings.other_motif || 'Andere Rasse wählen')}</button>`;
    }
    // Härtung (Defekt 2): Malt das Grid aus Inline-Motiven, WÄHREND der Katalog-Fetch
    // fehlgeschlagen ist, wäre der Fehler sonst unsichtbar — der Fehler-/Retry-Zustand
    // weiter oben greift nur, wenn KEINE Inline-Motive für den Bucket vorliegen. Ohne
    // Suchfeld (Nicht-Such-Gruppe mit genau einer Inline-Kachel) säße der Kunde bei 1
    // Motiv fest. Der Retry-Link hält den Zugang zum restlichen Katalog in jedem Zustand
    // offen; er erscheint nur nach einem echten Fehlversuch — aber NICHT unter einer
    // bereits getroffenen (kollabierten) Auswahl (dort wäre die Fehlermeldung verwirrend;
    // sie kehrt zurück, sobald der Kunde per „Andere Rasse wählen" das Grid öffnet).
    if (!collapsedToSelection && this._catalogFailed && this.config.motifsCatalog && !this._catalogLoaded) {
      inner += `<p class="ttg-motif-cataloghint">${escapeHtml(this.config.strings.catalog_error || 'Die Motive konnten gerade nicht geladen werden — bitte kurz erneut versuchen.')}</p>
        <button type="button" class="ttg-link ttg-link--block" data-action="catalog-retry">${escapeHtml(this.config.strings.catalog_retry || 'Motive erneut laden')}</button>`;
    }
    return inner;
  }

  /**
   * „Auf die Auswahl kollabiert": ein Mehrbild-Motiv AUS DIESEM BUCKET ist gewählt und
   * der transiente Flag steht. Der Motiv-Body zeigt dann statt des Grids nur diese eine
   * Kachel plus Variantenreihe.
   *
   * Steht seit 16.08.2026 als Helfer da, weil `_onMotifSearch` denselben Zustand kennen
   * muss: Seit das Suchfeld auch nach getroffener Wahl stehen bleibt, entscheidet dort
   * dieselbe Bedingung, ob eine geleerte Suche zur Einzelkachel zurückkehrt. Zwei Kopien
   * der Bedingung würden auseinanderlaufen, ohne dass es jemand merkt — und zwar in die
   * gefährliche Richtung: Der Body zeigt den Kollaps, die Suche glaubt an das offene Grid.
   * Der Bucket-Fallback ist derselbe wie in `_bodyMotif` (`def` kann dort synthetisch sein).
   */
  /** Listen-Ansicht (Schema v1.37, 23.10.2026): categoryGroups[].ansicht === "liste" am aktuellen Bucket.
   *  Ohne das Feld (alle Bestands-Configs) false → Kacheln wie bisher. */
  _listenAnsicht() {
    const d = this.state && this.state.bucket ? this._bucketDef(this.state.bucket) : null;
    if (!(d && d.ansicht === 'liste')) return false;
    this._listenStil();
    return true;
  }
  /** Anschnitt des Grids: in der Liste immer ALLE Einträge (0 = kein Anschnitt), sonst motifGridInitial. */
  _motifGridInitialWert() {
    return this._listenAnsicht() ? 0 : Math.max(0, parseInt(this.config.motifGridInitial, 10) || 4);
  }
  /** Stil der Liste einmal je Seite in den <head> — kein Theme-Asset nötig. Feste Höhe, scrollt in sich
   *  (mobil niedriger), damit die Vorschau beim Blättern stehen bleibt; Auswahl markiert. */
  _listenStil() {
    if (typeof document === 'undefined' || !document.head || document.getElementById('ttg-mlist-css')) return;
    const st = document.createElement('style');
    st.id = 'ttg-mlist-css';
    st.textContent = '.ttg-grid.ttg-mlist{display:block;max-height:360px;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;'
      + 'border:1px solid rgba(38,42,51,.14);border-radius:10px;background:#fff}'
      + '.ttg-mlist__item{display:flex;align-items:center;justify-content:space-between;width:100%;margin:0;padding:11px 14px;border:0;'
      + 'border-bottom:1px solid rgba(38,42,51,.08);background:transparent;color:#262a33;font:inherit;font-size:15px;line-height:1.3;text-align:left;cursor:pointer}'
      + '.ttg-mlist__item:last-child{border-bottom:0}'
      + '.ttg-mlist__item:hover{background:rgba(38,42,51,.04)}'
      + '.ttg-mlist__item[aria-pressed="true"]{font-weight:700;background:rgba(58,107,53,.10);box-shadow:inset 3px 0 0 var(--ttg-accent,#3a6b35)}'
      + '.ttg-mlist__item[aria-pressed="true"]::after{content:"\\2713";color:var(--ttg-accent,#3a6b35);font-weight:700;margin-left:12px}'
      + '@media (max-width:749px){.ttg-grid.ttg-mlist{max-height:240px}}';
    document.head.appendChild(st);
  }
  /** Nach jedem Render: die gewählte Zeile in den sichtbaren Bereich der Liste holen (nur die Liste scrollt,
   *  nie die Seite). Steht sie schon sichtbar, bleibt die Liste, wo der Kunde sie hingeblättert hat. */
  _listeZurAuswahl() {
    const liste = this.refs && this.refs.steps && this.refs.steps.querySelector('.ttg-mlist');
    if (!liste) return;
    const sel = liste.querySelector('.ttg-mlist__item[aria-pressed="true"]');
    if (!sel) return;
    const oben = sel.offsetTop - liste.offsetTop, unten = oben + sel.offsetHeight;
    if (oben < liste.scrollTop || unten > liste.scrollTop + liste.clientHeight) {
      liste.scrollTop = Math.max(0, oben - (liste.clientHeight - sel.offsetHeight) / 2);
    }
  }
  _collapsedToSelection() {
    if (!this.state.motifCollapsed || this.state.noMotif) return false;
    const sel = this.state.motif;
    if (!sel) return false;
    const def = this._bucketDef(this.state.bucket) || { categories: [this.state.bucket] };
    if (!this._motifInBucketDef(def, sel)) return false;   // Kategorie ODER extraMotifs — wie selHere in _bodyMotif
    return this._motifImages(sel).length > 1;
  }

  /** Motiv-Suchfeld. `autofocus` NUR im offenen Grid: `renderSteps` fokussiert `motifSearch`
   *  auch ohne Tastatur-Navigation (:3130) — im Kollaps-Zustand risse das Feld direkt nach
   *  dem Antippen einer Kachel auf Mobile die Bildschirmtastatur auf. */
  _motifSearchHtml(es, autofocus) {
    return `<input type="text" class="ttg-search" data-field="motifSearch"${autofocus ? ' data-autofocus' : ''} placeholder="${escapeHtml(es.placeholder)}" autocomplete="off">`;
  }

  /** Leere-Suche-Zustand: versteckter Container, den `_onMotifSearch` bei 0 Treffern
   *  einblendet (Meldung + „Motiv wünschen" zum Kontaktformular).
   *
   *  Er gehört in JEDEN Zweig, der ein Suchfeld zeigt — seit 02.08. ist der Zustand in
   *  jedem Konfigurator mit Suche an (CLAUDE.md §7). Als Helfer statt als Kopie, weil
   *  eine treffelose Suche ohne diesen Container in ein leeres Grid ohne jede Erklärung
   *  liefe: kein Fehler, keine Meldung, nur eine tote Fläche.
   *
   *  Wortlaut und Schalter kommen aus der Kaskade (`_emptySearchFor`): Gruppe schlägt
   *  Schritt schlägt Engine-Default. `es.enabled === false` schaltet NUR diesen Bucket ab —
   *  dann entsteht gar kein Container, nicht einmal ein leerer. Ohne `raceRequest` (die
   *  Section emittiert `null`, wenn die Config den Zustand abschaltet) ebenfalls nicht. */
  _motifEmptyHtml(isSearch, es) {
    const rr = this.config.raceRequest;
    if (!isSearch || !rr || !es.enabled) return '';
    return `<div class="ttg-motif-empty" data-ttg="motif-empty" hidden>
          <p class="ttg-motif-empty__msg">${escapeHtml(es.message)}</p>
          <a class="ttg-link ttg-link--block ttg-motif-empty__cta" data-ttg="motif-empty-cta" href="${sanitizeUrl(rr.url)}" target="_blank" rel="noopener">${escapeHtml(es.ctaLabel)}</a>
        </div>`;
  }

  /** Eine Motiv-Kachel (Vollfarb-Bild oder Masken-Motiv). hidden = im Ausgangszustand ausgeblendet.
   *  action = Klick-Aktion (Default 'motif'; im Kollaps-Zustand 'motif-browse' → Grid wieder öffnen). */
  _motifTileHtml(m, hidden = false, action = 'motif') {
    // Listen-Ansicht (Schema v1.37): nur der Name, ohne Bild — für Gruppen, deren Kacheln einander
    // gleichen (Wörterbuch-Kissen: jede Kachel zeigt den ganzen Eintrag). Gleiche data-action/-id und
    // aria-pressed wie die Kachel → Klick-, Such- und Auswahlwege bleiben unverändert.
    if (action === 'motif' && this._listenAnsicht()) {
      return `<button type="button" class="ttg-mlist__item" data-action="motif" data-id="${escapeHtml(m.id)}" aria-pressed="${this.state.motif && this.state.motif.id === m.id}"${hidden ? ' style="display:none"' : ''}>${escapeHtml(m.label)}</button>`;
    }
    const thumb = this._isFullColorMotif(m)
      ? `<span class="ttg-tile__img ttg-tile__img--full" style="background-image:url('${m.bild}')"></span>`
      : `<span class="ttg-tile__img" style="-webkit-mask-image:url('${m.bild}');mask-image:url('${m.bild}')"></span>`;
    return `<button type="button" class="ttg-tile" data-action="${action}" data-id="${escapeHtml(m.id)}" aria-pressed="${this.state.motif && this.state.motif.id === m.id}"${hidden ? ' style="display:none"' : ''}>${thumb}<small>${escapeHtml(m.label)}</small></button>`;
  }

  /**
   * Feste Auswahlwerte statt Freitext (Schema v1.10, def.values): der Schritt
   * rendert eine Knopfreihe im Muster von _extraRow, der gewählte Wert landet
   * unverändert in state.texts[def.id]. Damit erbt er die komplette Text-
   * Maschinerie — Ebene (def.layer), Schrift (def.font), Druckfarbe, _fitText,
   * Canvas-Snapshot und die sichtbare Line-Item-Property (def.property).
   *
   * Bewusst KEIN eigener Step-Typ: ein neuer Typ hätte State, done-Logik,
   * Gate und Property-Emission neu gebraucht — und die Property ist die
   * produktionskritische Stelle (falscher Druck fällt erst bei der Reklamation
   * auf). Ein Text-Def mit fester Werteliste ist derselbe Pfad wie getippter
   * Text, nur ohne Tastatur.
   *
   * Ohne def.values ändert sich nichts — Bestandsprodukte rendern byte-gleich.
   */
  _valueRow(def) {
    const cur = this.state.texts[def.id] || '';
    // Bildkacheln (Schema v1.34, def.tiles === 'image'): Muster der Farb-Kacheln (_colorRow), gleiche
    // Aktion text-value — Zustand, Gate und Property bleiben die des Werte-Schritts.
    if (def.tiles === 'image') {
      return `<div class="ttg-swrow ttg-swrow--img">${(def.values || []).map((v) => {
        const bild = this._kachelBild(def, v);
        const marke = bild
          ? `<img class="ttg-vc__img" src="${escapeHtml(bild)}" alt="" loading="lazy" decoding="async">`
          : `<span class="ttg-vc__dot"></span>`;
        return `
        <button type="button" class="ttg-vc" data-action="text-value" data-def-id="${escapeHtml(def.id)}" data-v="${escapeHtml(v)}" aria-pressed="${cur === v}">
          ${marke}
          <small>${escapeHtml(v)}</small>
        </button>`;
      }).join('')}</div>`;
    }
    return `<div class="ttg-sizes ttg-vorow">${(def.values || []).map((v) => `
        <button type="button" class="ttg-sz" data-action="text-value" data-def-id="${escapeHtml(def.id)}" data-v="${escapeHtml(v)}" aria-pressed="${cur === v}"><span class="ttg-sz__v">${escapeHtml(v)}</span></button>`).join('')}</div>`;
  }

  _bodyText(def) {
    // Feste Auswahl: Frage + Knopfreihe, kein Eingabefeld, kein Zeichenzähler,
    // kein „Kein Text"-Schalter (der Wert IST die Wahl). Hilfe-Link bleibt.
    if (Array.isArray(def.values) && def.values.length) {
      const hl0 = def.helpLink;
      const help0 = (hl0 && hl0.url)
        ? `<a class="ttg-help" href="${sanitizeUrl(hl0.url)}" target="_blank" rel="noopener">${ICON_SPARK}<span>${escapeHtml(hl0.label || 'Mehr erfahren')}</span></a>`
        : '';
      const q0 = def.question || def.label || '';
      return `${q0 ? `<div class="ttg-q">${escapeHtml(q0)}</div>` : ''}${this._valueRow(def)}${help0}`;
    }
    const max = def.maxLength || 30;
    const val = this.state.texts[def.id] || '';
    const off = !!this.state.noTexts[def.id];
    const s = this.config.strings;
    // Überschrift: Mehrfach-Text nutzt def.question. Legacy (Ein-Text) dynamisch nach
    // Anzahl (Base-Umschalter): Singular/Plural. Nur wenn ein Base-Umschalter existiert
    // UND die Strings gesetzt sind — sonst normale q_text (generisch, Warnweste ohne
    // Base-Umschalter → unverändert). Reagiert live, weil die Base-Auswahl renderSteps
    // auslöst und den aktiven Namens-Schritt neu rendert.
    let q = def._legacy ? s.q_text : def.question;
    if (def._legacy && this._baseOptions().length > 1 && (s.q_text_singular || s.q_text_plural)) {
      q = this.state.baseChoice > 0 ? (s.q_text_plural || s.q_text_singular) : (s.q_text_singular || s.q_text_plural);
    }
    const fieldId = 'ttg-t-' + def.id;
    // Sekundäre Slots (secondary:true) rendern in DERSELBEN Sektion unter dem
    // Hauptfeld: leerer Slot = dezenter „+ …"-Link (mit Aufschlags-Label), Klick
    // klappt das Eingabefeld auf; gefüllter Slot bleibt offen. Optional — leer
    // druckt nichts und löst keinen Aufschlag aus.
    const slotHtml = (sd) => {
      const sval = this.state.texts[sd.id] || '';
      const offSlot = !!this.state.noTexts[sd.id];
      const price = this._surchargeText(sd.surcharge);
      const priceHtml = price ? ` <span class="ttg-slot__price">${escapeHtml(price)}</span>` : '';
      // Kollaps zum „+ …"-Link: nie im „Kein Text"-Zustand (die angehakte
      // Checkbox muss sichtbar bleiben, sonst wäre die Abwahl unauffindbar).
      if (!sval.trim() && !this._slotOpen[sd.id] && !offSlot) {
        return `<button type="button" class="ttg-link ttg-slot__add" data-action="text2-toggle" data-def-id="${escapeHtml(sd.id)}">+ ${escapeHtml(sd.label || 'Zusätzlicher Text')}${price ? ` <span class="ttg-slot__price">(${escapeHtml(price)})</span>` : ''}</button>`;
      }
      // noTextCta (Phase 9): Checkbox wie am Hauptfeld — gleicher Handler
      // (no-text, data-def-id), gleiche Semantik: angehakt = Feld gesperrt,
      // Property entfällt (Blanko-Regel), Abhaken holt den Text zurück.
      const cta = this._noTextChoiceVisible(sd)
        ? `<label class="ttg-check"><input type="checkbox" data-action="no-text" data-def-id="${escapeHtml(sd.id)}" ${offSlot ? 'checked' : ''}> ${escapeHtml(sd.noTextLabel || s.no_text_cta || 'Kein Text gewünscht')}</label>` : '';
      return `<div class="ttg-slot">
          <div class="ttg-fieldrow">
            <label for="ttg-t-${escapeHtml(sd.id)}">${escapeHtml(sd.label || 'Zusätzlicher Text')}${priceHtml}</label>
            <span class="ttg-cnt" data-ttg-cnt="${escapeHtml(sd.id)}">${this._restZeichen(sval, sd)} ${escapeHtml(s.chars_free || 'Zeichen frei')}</span>
          </div>
          ${this._textFieldHtml(sd, sval, { locked: offSlot })}${this._suggestHtml(sd)}${cta}
        </div>`;
    };
    // Slots in Anzeige-Reihenfolge: position:'before' VOR dem Hauptfeld (Phase 7),
    // alle übrigen wie bisher dahinter — Bestands-Configs byte-identisch.
    const slotsVor = this._secondariesVor(def).map(slotHtml).join('');
    const slots = this._secondariesNach(def).map(slotHtml).join('');
    // Optionaler Hilfe-Link unter dem Feld (config: helpLink {label,url} am Text-Schritt).
    // Öffnet in neuem Tab — ein Wechsel im selben Tab würde die halbfertige
    // Konfiguration verwerfen. Fehlt helpLink, ändert sich am Markup nichts.
    const hl = def.helpLink;
    const helpHtml = (hl && hl.url)
      ? `<a class="ttg-help" href="${sanitizeUrl(hl.url)}" target="_blank" rel="noopener">${ICON_SPARK}<span>${escapeHtml(hl.label || 'Mehr erfahren')}</span></a>`
      : '';
    // Das Feld-Label nur zeigen, wenn es KEINE Überschrift gibt (sonst Dopplung). Zeichen-Zähler bleibt.
    // „Kein Text gewünscht" nur bei optionalen Schritten (Pflichtfelder haben keinen Clear-CTA).
    return `${q ? `<div class="ttg-q">${escapeHtml(q)}</div>` : ''}${slotsVor}<div class="ttg-fieldrow">
        ${q ? '' : `<label for="${fieldId}">${escapeHtml(def.label || s.step_text || 'Wunschtext')}</label>`}
        <span class="ttg-cnt"${this._multiText ? ` data-ttg-cnt="${escapeHtml(def.id)}"` : ''}>${this._restZeichen(val, def)} ${escapeHtml(s.chars_free || 'Zeichen frei')}</span>
      </div>
      ${this._textFieldHtml(def, val, { locked: off, autofocus: !off })}${this._zuLang && this._zuLang[def.id] ? this._zuLangHtml(def) : ''}${this._sperrzeichenIn(def) ? this._sperrHtml(def) : ''}${this._suggestHtml(def)}${this._deepLinkTextHint && this._deepLinkTextHint.defId === def.id ? `
      <p class="ttg-motif-cataloghint" data-ttg="deeplink-text-hint">${escapeHtml(this.config.strings.deeplink_text_too_long || 'Dein Wunschtext war für dieses Produkt zu lang — bitte trage hier eine kürzere Version ein (max. ' + max + ' Zeichen).')}</p>` : ''}
      ${helpHtml}${this._noTextChoiceVisible(def) ? `<label class="ttg-check"><input type="checkbox" data-action="no-text" data-def-id="${escapeHtml(def.id)}" ${off ? 'checked' : ''}> ${escapeHtml(def.noTextLabel || s.no_text_cta || 'Kein Text gewünscht')}</label>` : ''}${slots}${this._textNextBtn(def)}`;
  }

  /** Vorschlags-Overlay (Phase 8): Button „Inspiration" unterm Feld, Panel mit
   *  übernehmbaren Textvorschlägen. Desktop öffnet per Hover (CSS, hover:hover),
   *  Tipp/Klick toggelt (auch Touch), Escape und Klick außerhalb schließen
   *  (steps-Handler). Klick auf einen Eintrag übernimmt den Wert WIE GETIPPT —
   *  derselbe Weg wie _onTextInput samt charFilter/Zeichenrahmen. Ohne
   *  def.suggestions rendert NICHTS (Bestands-Configs byte-identisch). */
  /**
   * Vorschlagslisten auf EINE Form bringen: [{label, items[]}].
   *  - flaches String-Array  → genau eine Gruppe ohne Überschrift (Bestand)
   *  - [{label, items[]}]    → übernommen, leere Gruppen fallen raus
   * Alles andere (keine Liste, leer, nur Müll) → null, dann rendert nichts.
   * Kürzt NICHT: zu lange Listen werden gemeldet, nicht stillschweigend
   * beschnitten (s. SUGGEST_WARN_AB).
   */
  _normSuggestions(roh, defId) {
    if (!Array.isArray(roh) || !roh.length) return null;
    const sauber = (arr) => (Array.isArray(arr) ? arr : [])
      .filter((x) => typeof x === 'string' && x.trim());
    // Formerkennung über das VORHANDENSEIN von Gruppen-Objekten, nicht über
    // „alles Strings". Sonst kippt ein flaches Array mit einem einzigen
    // Fremdkörper (`['a', 'b', '', 42]` — genau so steht es im Bestandstest)
    // in den Gruppen-Zweig und wird dort komplett verworfen, obwohl der alte
    // Code den Müll einfach herausgefiltert hat.
    const hatGruppen = roh.some((x) => x && typeof x === 'object' && !Array.isArray(x)
      && Array.isArray(x.items));
    let gruppen;
    if (!hatGruppen) {
      const items = sauber(roh);
      gruppen = items.length ? [{ label: null, items }] : [];
    } else {
      gruppen = roh
        .filter((g) => g && typeof g === 'object' && !Array.isArray(g))
        .map((g) => ({
          label: (typeof g.label === 'string' && g.label.trim()) ? g.label.trim() : null,
          items: sauber(g.items),
        }))
        .filter((g) => g.items.length);
    }
    if (!gruppen.length) return null;
    const anzahl = gruppen.reduce((n, g) => n + g.items.length, 0);
    if (anzahl > SUGGEST_WARN_AB) {
      // Laut, aber nicht tödlich: die Seite rendert vollständig weiter.
      try {
        console.warn(`[ttg] Text-Schritt "${defId}": ${anzahl} Vorschläge — das ist mehr, `
          + `als eine Liste tragen sollte (Grenze ${SUGGEST_WARN_AB}). Es wird NICHTS gekürzt; `
          + `bitte die Config prüfen.`);
      } catch (e) { /* egal */ }
    }
    return gruppen;
  }

  /**
   * Generisches Popover (Schema v1.21) — EIN Bauteil, zwei Verwender:
   * Textvorschläge (klickbare Einträge) und Fototipps (statischer Fließtext).
   * Vorher gab es nur die Text-Variante; ein zweites Popover daneben hätte
   * beide Mängel des ersten geerbt (keine Höhenbegrenzung, klappt immer nach
   * oben auf). Toggle, Escape- und Außenklick-Schließer sind bereits generisch
   * (`data-ttg-suggest` / `data-ttg-suggest-panel`) und werden mitbenutzt.
   * `key` ist frei wählbar und muss KEINE Text-Def sein.
   */
  _popoverHtml(key, label, inhaltHtml) {
    if (!key || !inhaltHtml) return '';
    // Einrückung und Umbrüche exakt wie in der Fassung vor dem 29.08.2026 —
    // sonst wäre das Markup der Bestandsmatten um 16 Zeichen anders. Funktional
    // wäre das folgenlos, aber es hätte den Byte-Vergleich gegen den Altstand
    // zerschossen, mit dem der Bestandsschutz belegt wird.
    return `<div class="ttg-suggest" data-ttg-suggest="${escapeHtml(key)}">
      <button type="button" class="ttg-suggest__btn" data-action="suggest-toggle" data-def-id="${escapeHtml(key)}" aria-expanded="false" aria-haspopup="true">${ICON_SPARK}<span>${escapeHtml(label)}</span></button>
      <div class="ttg-suggest__panel" data-ttg-suggest-panel hidden>
        ${inhaltHtml}
      </div>
    </div>`;
  }

  _suggestHtml(def) {
    if (!def || !def.suggestions || this.state.noTexts[def.id]) return '';
    const S = this.config.strings || {};
    const label = def.suggestionsLabel || S.suggest_label || 'Inspiration';
    // Fortlaufender Index über alle Gruppen — der Pick-Handler greift weiter
    // per data-i in EINE flache Liste (_suggestFlat), damit sich an seinem
    // Weg nichts ändert.
    let i = -1;
    const inhalt = def.suggestions.map((g) => {
      const kopf = g.label
        ? `<div class="ttg-suggest__group">${escapeHtml(g.label)}</div>` : '';
      return kopf + g.items.map((v) => {
        i += 1;
        return `<button type="button" class="ttg-suggest__item" data-action="suggest-pick" data-def-id="${escapeHtml(def.id)}" data-i="${i}">${escapeHtml(v)}</button>`;
      }).join('');
    }).join('');
    return this._popoverHtml(def.id, label, inhalt);
  }

  /** Vorschläge eines Defs als flache Liste — der Pick-Index zählt über alle
   *  Gruppen hinweg durch (s. _suggestHtml). */
  _suggestFlat(def) {
    if (!def || !def.suggestions) return [];
    return def.suggestions.reduce((acc, g) => acc.concat(g.items), []);
  }
  /** Alle offenen Vorschlags-Panels schließen (Escape / Klick außerhalb). */
  /**
   * Vorschlags-Panel beim ÖFFNEN einpassen: Richtung und Höhe nach dem Platz,
   * der tatsächlich da ist (30.08.2026).
   *
   * DER FEHLER, den das behebt: Das Panel klappt nach oben auf und ist bis zu
   * 632 px hoch (auf einem 812-px-Gerät gemessen). Damit sein oberer Rand im
   * Bild liegt, müsste der Knopf mindestens 638 px unter der Fensterkante
   * stehen — also im untersten Fünftel. Steht er höher, ragt das Panel oben aus
   * dem Fenster. `overflow-y:auto` hilft dann NICHT: es scrollt den Inhalt
   * INNERHALB des Kastens, und der Kastenanfang liegt außerhalb. Die ersten
   * Vorschläge sind gerendert und trotzdem unerreichbar — genau der Befund.
   *
   * Das ist kein Höhenwert, den man kleiner drehen kann: `max-height` steht in
   * CSS fest, der Abstand des Knopfes zur Fensterkante ändert sich beim
   * Scrollen. Nur eine Messung IM MOMENT DES ÖFFNENS kennt beide Zahlen.
   *
   * Was hier passiert:
   *   1. Platz oberhalb und unterhalb des Knopfes messen.
   *   2. Die Seite mit mehr Platz gewinnt (`--unten` wird gesetzt oder entfernt).
   *   3. Die Höhe auf diesen Platz deckeln — über die CSS-Variable
   *      `--ttg-suggest-max`, damit die `max-height` aus dem Stylesheet der
   *      Deckel BLEIBT und hier nur zusätzlich begrenzt wird.
   *
   * Bestandsschutz: Panels, die ohnehin passen, bekommen einen Deckel, der
   * größer ist als ihre Höhe — für sie ändert sich nichts. Ein Produkt mit vier
   * kurzen Vorschlägen verhält sich exakt wie bisher.
   *
   * NACHTRAG 31.08.2026 — der Deckel oben war nie das, was der Kunde sah.
   * An der Live-Seite gemessen: Das Panel war im Layout 404–664 px hoch,
   * SICHTBAR davon 62 px (nach unten) bzw. 120 px (nach oben) — konstant, und
   * zwar unabhängig von `max-height`, von der Richtung und von der
   * Fenstergröße (am Rechner mit 1440 × 900 dieselben 120 px). Ursache ist
   * `.ttg-card { overflow: hidden }`: die Regel hält Kinder in den abgerundeten
   * Ecken und beschneidet dabei auch dieses absolut positionierte Panel — auf
   * den Kasten der Step-Karte, 212 px hoch. Die sichtbare Höhe hing damit
   * allein an der Kartengeometrie (Kartenoberkante → Knopf − 6 px), nie am
   * Deckel. Deshalb hat die Verdopplung 340 → 680 px nichts bewirkt.
   *
   * Die Kartenregel bleibt unangetastet — sie ist nicht der Fehler. Stattdessen
   * wechselt das Panel beim Öffnen auf `position: fixed` (Klasse
   * `ttg-suggest__panel--fenster`) und wird mit denselben Zahlen platziert, die
   * hier ohnehin schon berechnet werden. Ein fixiertes Element wird von
   * `overflow` eines Vorfahren nicht beschnitten, solange keiner sein
   * enthaltender Block ist; dafür bräuchte es `transform`, `filter`,
   * `perspective` oder `contain` in der Kette — davon steht dort nichts
   * (31.08.2026 zur Laufzeit geprüft, leere Trefferliste). Gemessene Wirkung:
   * sichtbar 120 px → 416 px.
   *
   * Beim SCHLIESSEN muss `_suggestLoesen()` laufen, sonst schleppt das Panel
   * seine Position mit — der CSS-Hover-Weg am Rechner öffnet ohne JS.
   */
  _suggestPlatzieren(wrap, panel) {
    if (!wrap || !panel) return;
    const sicht = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    const r = wrap.getBoundingClientRect();
    const LUFT = 12;                       // Fensterrand nicht bündig berühren
    const ABSTAND = 6;                     // entspricht calc(100% + 6px) im CSS
    const oben = Math.max(0, r.top - ABSTAND - LUFT);
    const unten = Math.max(0, sicht - r.bottom - ABSTAND - LUFT);
    // Gleichstand geht nach oben — das ist die bisherige Voreinstellung, und
    // ohne diese Regel flackerte die Richtung bei fast gleichem Platz.
    const nachUnten = unten > oben;
    wrap.classList.toggle('ttg-suggest--unten', nachUnten);
    panel.style.setProperty('--ttg-suggest-max', Math.round(nachUnten ? unten : oben) + 'px');
    // Aus dem Beschnitt der Karte heraus (s. NACHTRAG oben): fensterbezogen
    // stellen und mit DENSELBEN Zahlen platzieren. `getBoundingClientRect()`
    // und `position: fixed` teilen sich das Koordinatensystem — die Rechnung
    // geht deshalb ohne Umrechnung auf.
    panel.classList.add('ttg-suggest__panel--fenster');
    // Aus der Deckkraft-Gruppe der Karte heraus. MUSS vor dem Messen der
    // Hoehe stehen: `_suggestFreierPlatz` macht einen Treffertest per
    // `elementFromPoint`, und der beantwortet die Frage nur richtig, wenn das
    // Panel dort schon in seiner endgueltigen Lage haengt.
    this._suggestPortal(wrap, panel);
    // Links am Knopf, aber nie so weit rechts, dass das Panel aus dem Fenster
    // ragt. Im beschnittenen Zustand konnte das nie auffallen. Der Deckel ist
    // die `max-width` aus dem Stylesheet — hier GELESEN statt abgeschrieben,
    // sonst driften zwei Zahlen auseinander.
    const maxB = parseFloat(getComputedStyle(panel).maxWidth) || 300;
    panel.style.left = Math.round(
      Math.max(LUFT, Math.min(r.left, window.innerWidth - maxB - LUFT))) + 'px';
    this._suggestHoehe(panel, r, nachUnten, nachUnten ? unten : oben, ABSTAND);
    // GEGENPROBE, und zwar per Treffertest statt per Annahme. Fensterbezogen
    // heißt auch: unter fremden fixierten Elementen. Auf der Produktseite legt
    // sich die eingeblendete Kopfzeile über die obersten Vorschläge — sichtbar,
    // aber nicht antippbar; der Klick landete gemessen auf dem Shop-Logo und
    // führte auf die Startseite. Das wäre derselbe Defekt in neuer Form.
    // Unten dieselbe Lage mit der Kauf-Leiste. Ein einziger Nachschlag, keine
    // Schleife: Was danach noch verdeckt ist, bleibt es.
    const frei = this._suggestFreierPlatz(panel, r, nachUnten, ABSTAND, LUFT);
    if (frei != null && frei > 0 && frei < (nachUnten ? unten : oben)) {
      this._suggestHoehe(panel, r, nachUnten, frei, ABSTAND);
    }
    // Zugleich das „ein Panel ist offen"-Signal für die Wächter in _bind().
    // null heißt zu. `wrap`/`panel` liegen mit drin, damit eine
    // Größenänderung neu platzieren kann, statt schließen zu müssen.
    this._suggestOffen = { wrap, panel, scrollY: window.scrollY, seit: performance.now() };
  }

  /** Deckel setzen und daraus `top` rechnen. Die Höhe steht erst fest, wenn
   *  Deckel, Bezug und Breite gesetzt sind — deshalb hier ein erzwungener
   *  Layout-Lesevorgang. Er läuft einmal je Öffnen, nicht je Scroll. */
  _suggestHoehe(panel, r, nachUnten, platz, ABSTAND) {
    panel.style.setProperty('--ttg-suggest-max', Math.round(Math.max(0, platz)) + 'px');
    const h = panel.getBoundingClientRect().height;
    panel.style.top = Math.round(nachUnten ? r.bottom + ABSTAND : r.top - ABSTAND - h) + 'px';
  }

  /** Liegt an der äußeren Kante des Panels etwas Fremdes darüber, und wie viel
   *  Platz bleibt dann wirklich? Gemessen per `elementFromPoint` an genau der
   *  Stelle, an der das Panel gerade steht — ohne jedes Wissen über das Theme.
   *  Damit trägt die Prüfung auch, wenn die Kopfzeile umgebaut wird oder eine
   *  App eine neue Leiste einblendet. `null` heißt: nichts liegt darüber. */
  _suggestFreierPlatz(panel, r, nachUnten, ABSTAND, LUFT) {
    const pr = panel.getBoundingClientRect();
    const x = Math.round(pr.left + pr.width / 2);
    const y = nachUnten ? Math.round(pr.bottom) - 2 : Math.round(pr.top) + 2;
    const el = document.elementFromPoint(x, y);
    if (!el || el === panel || panel.contains(el)) return null;
    const hr = el.getBoundingClientRect();
    return nachUnten ? (hr.top - LUFT) - (r.bottom + ABSTAND)
                     : (r.top - ABSTAND) - (hr.bottom + LUFT);
  }

  /** Fensterbezug wieder abnehmen. Geschlossen gehört das Panel in seinen
   *  Bestandszustand zurück — sonst trüge der CSS-Hover-Weg am Rechner
   *  (`@media (hover: hover)`, öffnet OHNE JS) die Koordinaten der letzten
   *  Öffnung mit sich und stünde an einer Stelle, die längst nicht mehr gilt. */
  _suggestLoesen(panel) {
    if (!panel) return;
    panel.classList.remove('ttg-suggest__panel--fenster');
    panel.style.removeProperty('left');
    panel.style.removeProperty('top');
    panel.style.removeProperty('--ttg-suggest-max');
    this._suggestHeim(panel);
  }

  /**
   * Panel aus der Karte heraus- und wieder zurückhängen (31.08.2026).
   *
   * WARUM ÜBERHAUPT: `.ttg-card--todo` trägt `opacity: .5`, `--next` `.8`.
   * `opacity` bildet eine GRUPPE — kein Kindselektor holt das zurück, und
   * `position: fixed` hilft nicht, weil die Gruppe auch fixierte Nachfahren
   * einschließt. Am Live-Produkt gemessen: das Panel stand bei effektiv **0,5**,
   * aus genau einem Vorfahren. Auf einem noch nicht erledigten Schritt — und
   * das ist der Normalfall, Zeile 2 ist der dritte Schritt — war der Text
   * unlesbar.
   *
   * WARUM DIESER WEG UND NICHT DIE DÄMPFUNG VERSCHIEBEN: Die Dämpfung von der
   * Karte auf einen inneren Träger zu verlagern hieße, dass der RAHMEN der
   * Karte nicht mehr mitgedimmt wird — eine sichtbare Änderung an der Optik
   * aller 120 Konfigurator-Produkte. Dieser Weg lässt die Karten völlig
   * unberührt.
   *
   * WARUM ER JETZT BILLIG IST: Das Panel ist seit dem Umbau vom 31.08. ohnehin
   * `position: fixed` und wird über Fensterkoordinaten platziert. Sein
   * DOM-Elternteil spielt für die Geometrie deshalb KEINE Rolle mehr — das
   * Verschieben ändert an der Lage nichts.
   *
   * WARUM `refs.steps` UND NICHT `document.body`: Der Übernehmen-Weg läuft über
   * den delegierten Handler auf `refs.steps`. Im Body läge das Panel außerhalb,
   * und ein Klick auf einen Vorschlag feuerte nicht mehr — genau die Warnung,
   * die diesen Weg teuer aussehen ließ. `refs.steps` liegt außerhalb JEDER
   * Karte (gemessen: `opacity` 1) und innerhalb des Handlers. Damit entfällt
   * der Grund.
   */
  _suggestPortal(wrap, panel) {
    if (!wrap || !panel || !this.refs.steps) return;
    if (panel.parentElement === this.refs.steps) return;      // schon draußen
    // Rückweg merken, damit `_suggestHeim` nicht raten muss. Ein Marker am
    // Knoten selbst, nicht eine Landkarte an der Engine: renderSteps() baut die
    // Karten neu, und eine Landkarte zeigte dann auf entfernte Knoten.
    panel._ttgHeimat = panel.parentElement;
    panel._ttgHeimatNachbar = panel.nextSibling;
    this.refs.steps.appendChild(panel);
  }

  _suggestHeim(panel) {
    if (!panel || !panel._ttgHeimat) return;
    const heim = panel._ttgHeimat, nachbar = panel._ttgHeimatNachbar;
    panel._ttgHeimat = null;
    panel._ttgHeimatNachbar = null;
    // Die Karte kann zwischenzeitlich neu gebaut worden sein. Dann hängt die
    // alte Heimat nicht mehr im Dokument, und ein Zurückhängen erzeugte eine
    // Leiche außerhalb des Baums. In dem Fall das Panel schlicht entfernen —
    // renderSteps() hat bereits ein frisches gebaut.
    if (!heim.isConnected) { panel.remove(); return; }
    if (nachbar && nachbar.parentElement === heim) heim.insertBefore(panel, nachbar);
    else heim.appendChild(panel);
  }

  /**
   * Das Panel eines Wraps — auch wenn es gerade im Portal haengt (31.08.2026).
   *
   * `wrap.querySelector()` allein findet es dort NICHT mehr, und ein
   * fehlgeschlagener Lookup faellt nicht auf: das Panel bliebe offen stehen,
   * waehrend der Knopf `aria-expanded="false"` meldet. Deshalb eine Stelle,
   * die beide Faelle kennt, statt zwei Aufrufer, die es je zur Haelfte tun.
   */
  _suggestPanelVon(wrap) {
    if (!wrap) return null;
    const drin = wrap.querySelector('[data-ttg-suggest-panel]');
    if (drin) return drin;
    const offen = this._suggestOffen;
    return (offen && offen.wrap === wrap) ? offen.panel : null;
  }

  _closeSuggestPanels(ausser) {
    if (!this.refs.steps) return;
    // `_suggestOffen` wird ERST AM ENDE geleert. Vorher ist es die einzige Spur
    // zu einem ins Portal ausgelagerten Panel — wer es zuerst loescht, findet
    // das Panel nicht mehr und laesst es offen stehen, waehrend der Knopf schon
    // `aria-expanded="false"` meldet (31.08.2026).
    this.refs.steps.querySelectorAll('[data-ttg-suggest]').forEach((wrap) => {
      if (ausser && wrap === ausser) return;
      const panel = this._suggestPanelVon(wrap);
      const btn = wrap.querySelector('[data-action="suggest-toggle"]');
      if (panel) { panel.hidden = true; this._suggestLoesen(panel); }
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
    // Nur leeren, wenn das offene Panel wirklich geschlossen wurde. Beim
    // Umschalten auf ein anderes Panel (`ausser`) bleibt dessen Eintrag stehen
    // und wird gleich darauf von `_suggestPlatzieren` ueberschrieben.
    if (!ausser || (this._suggestOffen && this._suggestOffen.wrap !== ausser)) {
      this._suggestOffen = null;
    }
  }

  /** Sichtbare „Weiter"-Affordance im AKTIVEN Text-Schritt (Mehrfach-Text): bestätigt den
   *  Schritt und öffnet den nächsten — ohne dass der Kunde Blur/Enter erraten muss (genau
   *  der Fall, in dem Familienname/Größe sonst unerreichbar blieben). Nur der aktive, noch
   *  nicht erledigte PRIMÄRE Text-Schritt bekommt den Button; stille Default-Zeilen und
   *  Ein-Text-Produkte (kein _multiText) bleiben byte-identisch. */
  _textNextBtn(def) {
    if (!this._multiText || def.secondary) return '';
    // hideNext (Schema v1.19): Schritte, die keine „Weiter"-Affordance brauchen,
    // weil die Karte ohnehin offen bleibt (keepExpanded) und alle uebrigen
    // Schritte bereits erfuellt sind — dann ist der Knopf nur eine Sackgasse
    // mehr. NUR wo ausdruecklich gesetzt: der Knopf loest sonst genau den Fall,
    // in dem Familienname/Groesse unerreichbar blieben (s. Kommentar oben), und
    // Bestandsprodukte behalten ihn deshalb unveraendert.
    if (def.hideNext === true) return '';
    if (this.state.done[this._stepKeyForDef(def)]) return '';
    const s = this.config.strings || {};
    return `<button type="button" class="ttg-weiter" data-action="text-next" data-def-id="${escapeHtml(def.id)}">${escapeHtml(s.next || 'Weiter')}</button>`;
  }

  _fontRow() {
    return `<div class="ttg-fonts">${this.config.fonts.map((f) => `
      <button type="button" class="ttg-fb" data-action="font" data-id="${escapeHtml(f.id)}" aria-pressed="${this.state.font === f.id}" style="font-family:${f.stack}">Aa<small>${escapeHtml(f.label)}</small></button>`).join('')}</div>`;
  }
  _bodyFont() {
    // Tippen wählt & schließt ab (kein „Weiter"); Default ist vorausgewählt.
    return this._fontRow();
  }

  /** Aufpreis-Anzeigetext: echter Variantenpreis (surcharge.priceCents — kommt seit dem
   *  Palette-Umbau aus der Section, Schema docs/briefings/druckfarben-schema.md) VOR dem
   *  statischen priceLabel (Alt-Configs + Übergangsfenster, §6-Regel; D-2-Abbau).
   *  Leerer String, wenn beides fehlt — dann erscheint kein Schild. */
  _surchargeText(sc) {
    if (!sc) return '';
    if (sc.priceCents != null) return '+ ' + formatMoneyEUR(sc.priceCents);
    return sc.priceLabel || '';
  }

  /**
   * Akzentfarbe (Schema v1.35, 23.10.2026 — Silhouetten-Shirt Muster): zweite Farbwahl neben der
   * Druckfarbe. config.accent = {label, property, default, colors:[{name, hex, value?, surcharge?}]}
   * (Section: choice-Schritt mit role:"accent"). Färbt nur Motiv-Ebenen mit inkSource:"accent"
   * (Vorschau, Snapshot, Druckvertrag), eigene Property, eigener Aufpreis. Ohne config.accent: [].
   */
  _akzentFarben() {
    const a = this.config && this.config.accent;
    return (a && Array.isArray(a.colors)) ? a.colors.filter((c) => c && c.hex) : [];
  }
  /** Tinte einer Motiv-Ebene: Akzentfarbe bei inkSource:"accent" (und vorhandenem Zustand), sonst Druckfarbe. */
  _ebenenTinte(ml) {
    if (ml && ml.inkSource === 'accent' && this.state.akzentfarbe) return this._resolveInk(this.state.akzentfarbe);
    return this._resolveInk(this.state.druckfarbe);
  }
  _bodyAkzent() {
    return `<div class="ttg-swatches">${this._akzentFarben().map((p) => {
      const scText = this._surchargeText(p.surcharge);
      const name = p.name + (scText ? ' (' + scText + ')' : '');
      const btn = `
      <button type="button" class="ttg-sw" data-action="akzent" data-c="${escapeHtml(p.hex)}" title="${escapeHtml(name)}" aria-label="${escapeHtml(name)}" aria-pressed="${this.state.akzentfarbe === p.hex}" style="background:${escapeHtml(p.hex)}"></button>`;
      if (!scText) return btn;
      return `<span class="ttg-sw-w" data-action="akzent" data-c="${escapeHtml(p.hex)}">${btn}<span class="ttg-sw__price">${escapeHtml(scText)}</span></span>`;
    }).join('')}</div>`;
  }
  _bodyPrint() {
    // Tippen wählt & schließt ab (kein „Weiter"). Optionen mit Aufpreis zeigen
    // den Aufpreis (_surchargeText: priceCents vor priceLabel) als kleines Schild
    // unter dem Farbpunkt; das Wrap trägt die gleiche data-action, damit auch ein
    // Klick aufs Schild wählt.
    return `<div class="ttg-swatches">${this.config.printColors.map((p) => {
      const scText = this._surchargeText(p.surcharge);
      const name = p.name + (scText ? ' (' + scText + ')' : '');
      const btn = `
      <button type="button" class="ttg-sw" data-action="print" data-c="${escapeHtml(p.hex)}" title="${escapeHtml(name)}" aria-label="${escapeHtml(name)}" aria-pressed="${this.state.druckfarbe === p.hex}" style="background:${escapeHtml(p.hex)}"></button>`;
      if (!scText) return btn;
      return `<span class="ttg-sw-w" data-action="print" data-c="${escapeHtml(p.hex)}">${btn}<span class="ttg-sw__price">${escapeHtml(scText)}</span></span>`;
    }).join('')}</div>`;
  }

  _sizeRow() {
    let values = this._optionValues(this.config.size.optionName);
    // Rasse-Motive: nur Ausführungen zeigen, die es für diese Rasse als Variante gibt.
    if (this._motifAchse() && this.state.motif) {
      const ci = this._optionIndex(this.config.base.optionName);
      const si = this._optionIndex(this.config.size.optionName);
      values = values.filter((w) => this.config.variants.some((v) => v.options[ci] === this.state.color && v.options[si] === w));
    }
    // Preise nur zeigen, wenn sie sich je Größe unterscheiden (einheitlich → wie bisher).
    // size.showPrices (Schema v1.29): Preis auf jedem Knopf, auch bei gleichen Preisen (Ringclip, Jens 18.10.2026).
    const showPrice = !this._pricesUniform() || !!(this.config.size && this.config.size.showPrices === true);
    return `<div class="ttg-sizes">${values.map((v) => {
        const avail = this.sizeAvailable(v);
        let priceHtml = '';
        if (showPrice) {
          const variant = this.resolveVariant(this.state.color, v);
          if (variant) {
            const cmp = (variant.compareAtPrice && variant.compareAtPrice > variant.price)
              ? `<s>${formatMoneyEUR(variant.compareAtPrice)}</s>` : '';
            priceHtml = `<span class="ttg-sz__price">${formatMoneyEUR(variant.price)}${cmp}</span>`;
          }
        }
        return `<button type="button" class="ttg-sz${showPrice ? ' ttg-sz--priced' : ''}" data-action="size" data-v="${escapeHtml(v)}" aria-pressed="${this.state.size === v}" ${avail ? '' : 'disabled aria-disabled="true"'}><span class="ttg-sz__v">${escapeHtml(v)}</span>${priceHtml}</button>`;
      }).join('')}</div>`;
  }
  /** Größenratgeber-Trigger (Overlay/Kiwi/Link/Inline-Liste) — generisch aus
   *  config.sizeGuide. Als eigener Helfer, damit er AUCH im erledigten
   *  Kompaktzustand des Größen-Schritts rendert (Tabelle bleibt jederzeit
   *  erreichbar, verschwindet nicht mit der Auswahl). */
  _sizeGuideHtml() {
    const sg = this.config.sizeGuide || {};
    const label = escapeHtml(this.config.strings.size_guide || 'Größentabelle');
    // Größenhilfe (Schema v1.26, 21.09.2026): kurzer Satz VOR dem Größentabelle-Trigger, nur wenn die
    // Section strings.size_hint mitgibt (Mantel: „Fällt bewusst weit aus"). Ohne den String byte-identisch.
    const hint = this.config.strings.size_hint
      ? `<span class="ttg-sizeguide__hint">${escapeHtml(String(this.config.strings.size_hint))}</span>` : '';
    if (sg.type && TTG_SIZE_OVERLAY_RENDERERS[sg.type]) {
      // Theme-natives Overlay (Lazy: bis zum Klick existiert nur dieser Button).
      return `${hint}<button type="button" class="ttg-sizeguide__link" data-action="sizeguide-overlay">${escapeHtml(sg.label || '') || label}</button>`;
    } else if (sg.kiwiSelector) {
      // Kiwi Sizing: Trigger, der Kiwis injizierten Chart auslöst (keine eigene Tabelle).
      return `${hint}<button type="button" class="ttg-sizeguide__link" data-action="sizeguide-kiwi" data-target="${escapeHtml(sg.kiwiSelector)}">${label}</button>`;
    } else if (sg.url) {
      return `${hint}<a class="ttg-sizeguide__link" href="${sanitizeUrl(sg.url)}" target="_blank" rel="noopener">${label}</a>`;
    } else if (sg.text) {
      return `${hint}<details class="ttg-sizeguide"><summary class="ttg-sizeguide__link">${label}</summary><div class="ttg-sizeguide__body">${escapeHtml(sg.text)}</div></details>`;
    }
    return hint;
  }

  _bodySize() {
    if (this._motifAusverkauft()) {
      return `<p class="ttg-q ttg-soldout" role="status">${escapeHtml(this._ausverkauftText())}</p>`;
    }
    return `<div class="ttg-q">${escapeHtml(this.config.strings.q_size || 'Deine Größe?')}</div>${this._sizeRow()}${this._sizeGuideHtml()}`;
  }

  /* --------------------------------------------------------------- Binding */
  _bind() {
    // Fokus-Modalität. renderSteps() fokussiert den neu aktivierten Schritt nur
    // nach Tastatur-Navigation: `focus()` scrollt das Ziel nativ in den Viewport
    // (und öffnet auf Mobile die Bildschirmtastatur). Bei Klick/Tap ist der
    // Schritt bereits im Blick — der Fokus-Scroll läse sich dort als Sprung.
    // Capture-Phase am Root: greift auch, wenn ein Handler das Event stoppt.
    this.root.addEventListener('pointerdown', () => { this._kbNav = false; }, true);
    this.root.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ') this._kbNav = true;
    }, true);
    this.refs.steps.addEventListener('click', (e) => {
      // Klick außerhalb eines Vorschlags-Overlays schließt es (Phase 8) —
      // vor dem Action-Dispatch, damit ein Klick auf ein ANDERES Element beides
      // tut: Panel zu + Aktion. Billig: no-op ohne offenes Panel.
      if (!e.target.closest('[data-ttg-suggest]')) this._closeSuggestPanels();
      const el = e.target.closest('[data-action]');
      if (!el) return;
      this._onAction(el.dataset.action, el, { ausKlick: true });
    });
    // Klick GANZ außerhalb der Schritte (Bühne, Seite) schließt offene
    // Vorschlags-Panels ebenfalls. Ein Listener pro Engine-Instanz.
    document.addEventListener('click', (e) => {
      if (this.refs.steps && !this.refs.steps.contains(e.target)) this._closeSuggestPanels();
    });
    // Ein fensterbezogenes Panel wandert beim Scrollen NICHT mit: es klebt am
    // Fenster, der Knopf am Dokument. Entschieden wurde SCHLIESSEN statt
    // Nachfuehren. Nachfuehren hiesse ein `getBoundingClientRect()` je
    // Scroll-Bild — ein erzwungenes Layout auf dem Scrollpfad, dieselbe Klasse
    // Defekt wie `_fitText` je Anschlag — und auf Mobile hinkte das Panel dem
    // Finger sichtbar nach. Schliessen fuegt sich ausserdem ins bestehende
    // Verhalten: Klick daneben, Escape und Uebernehmen schliessen ebenfalls.
    window.addEventListener('scroll', () => {
      const o = this._suggestOffen;
      if (!o) return;                                              // nichts offen: no-op
      if (performance.now() - o.seit < SUGGEST_RUHE_MS) return;     // s. SUGGEST_RUHE_MS
      if (Math.abs(window.scrollY - o.scrollY) < SUGGEST_SCROLL_SCHWELLE) return;
      this._closeSuggestPanels();
    }, { passive: true });
    // Groessenaenderung (Drehen, Fenster ziehen, ein- und ausfahrende
    // Bildschirmtastatur) verschiebt alle Bezugsgroessen auf einmal. Hier wird
    // NEU PLATZIERT statt geschlossen — anders als beim Scrollen: Der Fall ist
    // selten, eine Neuplatzierung kostet genau einen Aufruf, und Schliessen
    // waere hier sogar falsch. Auf Android loest der Knopf beim Antippen den
    // Fokuswechsel aus, die Tastatur faehrt ein, und das dabei gefeuerte Resize
    // wuerde das eben geoeffnete Panel wieder zuklappen.
    // Ein rAF fasst die Salve zusammen, die eine Tastatur-Animation abfeuert.
    window.addEventListener('resize', () => {
      if (!this._suggestOffen || this._suggestRaf) return;
      this._suggestRaf = requestAnimationFrame(() => {
        this._suggestRaf = null;
        const o = this._suggestOffen;
        if (o) this._suggestPlatzieren(o.wrap, o.panel);
      });
    }, { passive: true });
    // A11y: erledigte Panel-Kopfzeile (role=button) per Tastatur wieder öffnen.
    this.refs.steps.addEventListener('keydown', (e) => {
      // Enter im Wunschtext-Feld = Schritt bestätigen (wie Blur), aber kein Form-Submit.
      // Ausnahme mehrzeiliges Feld (maxLines > 1): solange noch eine Zeile frei ist,
      // setzt Enter den Umbruch (nativ, kein preventDefault). Ist das Limit erreicht,
      // bestätigt Enter wieder den Schritt — sonst täte die Taste dort gar nichts.
      if (e.key === 'Enter' && e.target && e.target.dataset && e.target.dataset.field === 'text') {
        const tdef = this._textDefById(e.target.dataset.defId);
        if (tdef && this._maxLines(tdef) > 1
            && String(e.target.value || '').split('\n').length < this._maxLines(tdef)) return;
        e.preventDefault();
        this._confirmText(e.target.dataset.defId, { ausKlick: true });   // Handy-INP 13.10.2026: Neuaufbau nach dem Paint
        return;
      }
      // Escape schließt ein offenes Vorschlags-Panel (Phase 8).
      if (e.key === 'Escape') { this._closeSuggestPanels(); return; }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      // Kopfzeilen mit role=button (reopen/goto/quiet-edit/motif-intro) per Tastatur
      // bedienbar machen — echte <button> lösen ihren Klick nativ aus (kein Doppel-Fire).
      const el = e.target.closest('[data-action="reopen"], [data-action="goto"], [data-action="quiet-edit"], [data-action="motif-browse"]');
      if (!el || el.tagName === 'BUTTON') return;
      e.preventDefault();
      this._onAction(el.dataset.action, el);
    });
    this.refs.steps.addEventListener('input', (e) => {
      const f = e.target.dataset.field;
      if (f === 'text') {
        const def = this._textDefById(e.target.dataset.defId);
        if (!def) return;
        // print-safe-Filter (charFilter): verbotene Zeichen direkt bei der
        // Eingabe verwerfen — Caret um die entfernte Länge zurückziehen. Wurde
        // dabei wirklich etwas entfernt, sagt es der Hinweis am Feld; reine
        // Normalisierung (bares ❤ → ❤️, CRLF) löst ihn nicht aus.
        const raw = e.target.value;
        // Mehrzeiliges Feld: automatischer Umbruch statt Deckeln. Läuft Zeile 1
        // über, wandert der Überhang am Wort in Zeile 2 und die Schreibmarke
        // wandert mit. Passt nichts mehr, wird die Eingabe VERWORFEN (vorheriger
        // Stand bleibt) und der Hinweis erscheint — nicht still gekürzt.
        if (this._maxLines(def) > 1) {
          const vorCaret = e.target.selectionStart;
          const info = {};
          const w = this._autoWrap(this._filterText(raw, def, info), def, vorCaret);
          if (!w) {
            const zurueck = this.state.texts[def.id] || '';
            e.target.value = zurueck;
            const p = Math.max(0, Math.min(zurueck.length, vorCaret == null ? zurueck.length : vorCaret));
            try { e.target.setSelectionRange(p, p); } catch (err) { /* egal */ }
            this._zeigeTextGrenze(e.target, def);
            // KEIN Zeichen-Hinweis: die Eingabe wurde als Ganzes verworfen, es ist
            // also nichts entfernt worden — der vorherige Stand steht unverändert.
            return;
          }
          this._raeumeTextGrenze(e.target);
          if (info.removed) this._zeigeZeichenHinweis(e.target, def);
          if (w.text !== raw) {
            e.target.value = w.text;
            if (w.caret != null) { try { e.target.setSelectionRange(w.caret, w.caret); } catch (err) { /* egal */ } }
          }
          this._onTextInput(w.text, def);
          return;
        }
        // charFilter zuerst (verbotene Zeichen), dann der Zeilenrahmen (maxLines).
        // Bei maxLines === 1 faltet _clampLines einen eingefügten Umbruch zum
        // Leerzeichen — ein <input> kann keinen tragen, eingefügt werden kann er.
        const info = {};
        const filtered = this._clampInput(this._filterText(raw, def, info), def);
        if (filtered !== raw) {
          const pos = e.target.selectionStart;
          e.target.value = filtered;
          if (pos != null) {
            const p = Math.max(0, Math.min(filtered.length, pos - (raw.length - filtered.length)));
            try { e.target.setSelectionRange(p, p); } catch (err) { /* egal */ }
          }
        }
        if (info.removed) this._zeigeZeichenHinweis(e.target, def);
        this._onTextInput(filtered, def);
      }
      else if (f === 'motifSearch') {
        const v = e.target.value;
        // Suchtext + Ursprungs-Bucket SOFORT merken (nicht erst im 120-ms-Debounce):
        // Löst der Idle-Prefetch INNERHALB des Debounce-Fensters auf, bevor
        // _onMotifSearch je lief, verwirft renderSteps den Timer (der Debounce feuert
        // nie) — stünde _motifQuery nur im Debounce, ginge der getippte Text beim
        // Re-Render verloren. Der Bucket macht die spätere Wiederanwendung
        // (_restoreMotifSearch) leck-sicher: nur im Bucket, in dem gesucht wurde.
        this._motifQuery = v;
        this._motifQueryBucket = this.state.bucket;
        // Suche = Interaktion → den (lazy) Katalog sicher anstoßen, falls der Idle-
        // Prefetch noch nicht lief (sonst fände der Kunde nur die paar Inline-Motive).
        if (this.config.motifsCatalog && !this._catalogLoaded) this._ensureCatalog();
        // INP: Debounce — beim schnellen Tippen nur den letzten Stand filtern
        // (Levenshtein-Matching über den Bucket ist der teuerste Tastenanschlag-Pfad).
        if (this._searchTimer) clearTimeout(this._searchTimer);
        this._searchTimer = setTimeout(() => { this._searchTimer = null; this._userSearched(v); }, 120);
      }
    });
    // Text-Schritt schließt beim Verlassen des Feldes ab (nicht pro Tastenanschlag).
    this.refs.steps.addEventListener('focusout', (e) => {
      if (e.target && e.target.dataset && e.target.dataset.field === 'text') this._onTextBlur(e.target.dataset.defId);
    });
    // „Kein Text gewünscht": das gedimmte Feld ist NICHT disabled (ein echtes disabled-
    // Input feuert in mehreren Browsern kein focus/click). Fokus/Klick ins Feld hebt den
    // Zustand sofort auf → direkt tippbar (Caret im Feld, kein zweiter Klick), Haken flippt
    // auf aus. Das gedimmte Feld trägt bewusst KEIN data-autofocus (sonst würde der Auto-
    // fokus beim Wieder-Öffnen des Panels „Kein Text" ungewollt aufheben). Leeren des
    // Feldes schnappt NICHT zurück (nur der Haken selbst setzt „Kein Text" wieder).
    this.refs.steps.addEventListener('focusin', (e) => {
      const t = e.target;
      if (!t || !t.dataset || t.dataset.field !== 'text') return;
      const def = this._textDefById(t.dataset.defId);
      if (!def || !this.state.noTexts[def.id]) return;
      this.state.noTexts[def.id] = false;
      t.classList.remove('ttg-field--locked');
      const cb = this.refs.steps.querySelector(`[data-action="no-text"][data-def-id="${def.id}"]`);
      if (cb) cb.checked = false;
      const len = t.value.length;
      try { t.setSelectionRange(len, len); } catch (err) { /* egal */ }
      this.renderPreview();          // Textebene erscheint, sobald getippt wird (leer = nichts)
      this._syncFontStep();          // Schrift-Schritt ggf. wieder relevant
      // Gegenstück zum „Kein Text"-Haken: das Wieder-Einschalten muss ebenso
      // nach außen, sonst bliebe das Cross-Sell-Element umgekehrt auf dem
      // leeren Wert stehen.
      this._emitEffectiveText(def);
    });
    // Race-Schutz: focusout feuert bei POINTERDOWN, der zugehörige Klick erst bei
    // pointerup — der 0ms-Confirm-Timeout läuft dazwischen und würde die Sektion
    // neu rendern, bevor der Klick auf Slot-Link/„Kein Text" landet (Klick ginge
    // ins Leere, Wizard spränge weiter). Das Flag unterdrückt genau diesen Confirm;
    // der Klick-Handler übernimmt danach selbst. Jeder pointerdown setzt es frisch.
    this.refs.steps.addEventListener('pointerdown', (e) => {
      const el = e.target.closest('[data-action="text2-toggle"], [data-action="no-text"]');
      this._textActionPending = !!el;
    });
    // Kaufbereich (Menge + Add-to-Cart) und optionaler Sticky-CTA
    const onBuyClick = (e) => {
      const el = e.target.closest('[data-action]');
      if (!el) return;
      const a = el.dataset.action;
      if (a === 'submit') this._submit();
      else if (a === 'qty-dec') this._setQty(this.state.quantity - 1);
      else if (a === 'qty-inc') this._setQty(this.state.quantity + 1);
    };
    if (this.refs.buy) {
      this.refs.buy.addEventListener('click', onBuyClick);
      this.refs.buy.addEventListener('input', (e) => {
        if (e.target.dataset.ttg === 'qty') this._setQty(parseInt(e.target.value, 10));
      });
    }
    if (this.refs.sticky) this.refs.sticky.addEventListener('click', onBuyClick);
    // Preview an Resize anpassen (Textgröße)
    if ('ResizeObserver' in window) {
      // Container-Breite hat sich evtl. geändert → gecachte Bezugsbreite (_fitText)
      // verwerfen, damit sie beim nächsten Render EINMAL frisch gelesen wird.
      this._ro = new ResizeObserver(() => { this._previewW = 0; this.renderPreview(); });
      this._ro.observe(this.refs.base.parentElement);
    }
  }

  /** Handy-INP 13.10.2026: Bei einem echten Klick auf Farbe, Motiv, Druckfarbe oder Größe zeigt der nächste
   *  Frame nur die Auswahl am angetippten Knopf (aria-pressed — darüber laufen die Auswahl-Stile); Schrittliste,
   *  Vorschau, Preis und Ereignisse folgen direkt nach diesem Paint. Der Zustand (state) ist sofort gesetzt.
   *  Gemessen vorher: Verarbeitung + Darstellung der vollen Neuberechnung lag im selben Frame wie der Tipp.
   *  Ohne Klick (Tests, Deep-Links, Programmaufrufe) bleibt alles synchron wie bisher. */
  _sofortAuswahl(el) {
    if (!el || !el.getAttribute || !el.parentElement) return;
    const act = el.getAttribute('data-action');
    for (const b of el.parentElement.querySelectorAll(`[data-action="${act}"]`)) {
      if (b !== el && b.getAttribute('aria-pressed') === 'true') b.setAttribute('aria-pressed', 'false');
    }
    el.setAttribute('aria-pressed', 'true');
  }
  _nachPaint(fn, opts) {
    const rAF = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : null;
    if (!(opts && opts.ausKlick) || !rAF) { fn(); return; }
    const q = this._nachPaintQ || (this._nachPaintQ = []);
    q.push(fn);
    if (q.length > 1) return;   // ein Paint-Termin für alle Klicks dieses Frames, Reihenfolge bleibt
    rAF(() => setTimeout(() => { const l = q.splice(0); for (const f of l) f(); }, 0));
  }

  _onAction(action, el, opts) {
    const s = this.state;
    // Kundeninteraktion am Motiv-Schritt merken: nachgelagerte Katalog-Defaults
    // (Deep-Link-Retry, Bucket-Re-Pinning, Late-Derivation) fassen NIE einen
    // Zustand an, den der Kunde bereits aktiv verändert hat. done.motif taugt
    // dafür NICHT als Guard — ein injiziertes Override setzt es ohne Kundenzutun.
    if (action === 'motif' || action === 'motif-variant' || action === 'no-motif'
        || action === 'bucket' || action === 'bucket-back' || action === 'motif-browse'
        || action === 'motif-expand') this._motifTouched = true;
    switch (action) {
      case 'base':
        // Nur das Base-Foto umschalten — kein zweites Motiv/Name, gleiche Koordinaten.
        s.baseChoice = parseInt(el.dataset.i, 10) || 0; s.done.base = true;
        this.renderSteps(); this.renderPreview(); this.emit('baseChanged', s.baseChoice);
        break;
      case 'color':
        s.color = el.dataset.v; s.done.color = true;
        // Größe gegen neue Farbe prüfen (Verfügbarkeit)
        if (s.size && !this.sizeAvailable(s.size)) { s.size = null; s.done.size = false; }
        // defaultBy: dunkle Farben → helle Druckfarbe (solange unberührt)
        this._applyPrintDefaultBy(this.config.base.optionName);
        if (opts && opts.ausKlick) this._sofortAuswahl(el);
        this._nachPaint(() => { this.renderSteps(); this.renderPreview(); this.emit('colorChanged', s.color); this.emit('variantChanged', this.getVariantId()); }, opts);
        break;
      case 'side':
        // Motivseite wählen: Seite setzen, Schritt erledigen. renderPreview aktualisiert
        // das Basisbild (Rück-Foto via _currentBaseImage) IMMER und schreibt die Layer-
        // Boxen nach, sobald ein Motivseite-Override die Layout-Signatur ändert. Keine
        // Varianten-/Preisauflösung (dieselbe SKU).
        s.side = el.dataset.v; s.done.side = true;
        this.renderSteps(); this.renderPreview(); this.emit('sideChanged', s.side);
        break;
      case 'addon': {
        // Zusatzartikel wählen (Schema v1.31): leeres data-v = „Keine“. Keine Varianten-,
        // Preis- oder Vorschau-Wirkung am Hauptartikel — nur die Auswahl merken.
        const aid = el.dataset.addon;
        if (!this._addonDef('addon:' + aid)) break;
        s.addons[aid] = el.dataset.v ? el.dataset.v : null;
        s.done['addon:' + aid] = true;
        this.renderSteps(); this.emit('addonChanged', { id: aid, variantId: s.addons[aid] });
        break;
      }
      case 'vo': {
        // Zusätzliche Varianten-Option (z. B. Geschlecht) wählen: Wert setzen,
        // Schritt erledigen, Variante/Preis/Layout-Overrides neu auflösen.
        const optName = el.dataset.opt;
        s.options[optName] = el.dataset.v;
        const xod = this.extraOptions.find((o) => o.optionName === optName);
        if (xod) s.done['vo:' + xod.id] = true;
        if (s.size && !this.sizeAvailable(s.size)) { s.size = null; s.done.size = false; }
        this._applyPrintDefaultBy(optName);
        this.renderSteps(); this.renderPreview();
        this.emit('optionChanged', { option: optName, value: s.options[optName] });
        this.emit('variantChanged', this.getVariantId());
        break;
      }
      case 'bucket':
        // Frischer Finder-Blick beim Betreten einer Kategorie → Darstellungs-Flags zurücksetzen.
        s.bucket = el.dataset.id; s.motifExpandedFor = null; s.motifCollapsed = false; s.motifIntro = false;
        this.emit('bucketChanged', { bucket: s.bucket });
        this.renderSteps();
        this._scrollToMotifCard();   // sonst liegt die neue Ansicht über dem Bildschirm
        break;
      // Zurück zum Kategorie-Menü — bei nur einer Kategorie bleibt der Bucket gesetzt (kein Menü).
      // Der Rückweg braucht den Sprung genauso: aus einem langen Motiv-Grid heraus säße
      // das wieder eingeblendete Sektionsmenü sonst ebenfalls oberhalb des Bildes.
      case 'bucket-back':
        s.bucket = this._soleBucket(); s.motifCollapsed = false;
        this.renderSteps();
        this._scrollToMotifCard();
        break;
      // Reine Darstellungs-Aktionen (keine Auswahl): volles Grid einblenden bzw. zur Auswahl zurück.
      case 'motif-expand':
        if (this.config.motifsCatalog && !this._catalogLoaded) this._ensureCatalog();   // „alle anzeigen" braucht den Katalog
        s.motifExpandedFor = s.bucket; this.renderSteps(); break;
      case 'motif-browse':
        // „Anderes Motiv?" aus der Varianten-/Kollaps-Ansicht: der (erledigte) Schritt
        // wird wieder zur aktiven Auswahl — done zurücknehmen + als reopened merken
        // (sonst schließt die Nachmarkierung ihn sofort), dann erscheint das volle Grid.
        s.motifCollapsed = false; s.motifIntro = false;
        s.done.motif = false; this._reopened.add('motif');
        this.renderSteps(); break;
      // Katalog-Fehlzustand: erneut versuchen (Promise wurde beim Fehler zurückgesetzt).
      case 'catalog-retry': this._ensureCatalog(); this.renderSteps(); break;
      case 'motif': {
        const m = this._resolveMotif(el.dataset.id);
        s.motif = m; s.noMotif = false; s.motifVariant = 0;   // neues Motiv → Bild 1 vorgewählt
        // Eine echte Motiv-Auswahl ERLEDIGT den Schritt — auch bei Mehrbild-Motiven
        // (Bild 1 ist eine gültige, bestellbare Vorauswahl). Früher blieb Mehrbild
        // done=false „offen für die Variantenwahl"; im One-Click-Flow gibt es danach
        // aber KEINEN Todo-Schritt zum Abschließen → CTA blieb gesperrt (Umsatz-Blocker,
        // latent seit One-Click). Die Variantenreihe bleibt trotzdem sichtbar & wählbar
        // (renderSteps: motifCompare), der Schritt ist aber erledigt (grün, CTA frei).
        s.done.motif = true;
        // Mehrbild: Grid der anderen Rassen ausblenden → nur das gewählte Motiv + Varianten.
        s.motifCollapsed = this._motifImages(m).length > 1;
        if (opts && opts.ausKlick) this._sofortAuswahl(el);
        this._nachPaint(() => { this.renderSteps(); this.renderPreview(); this._syncPrintStep(); this.emit('motifChanged', m); }, opts);
        break;
      }
      case 'motif-variant': {
        // Variante gewählt (Bild i) → nur die Vorschau wechselt. Der Schritt bleibt OFFEN und es
        // gibt kein Auto-Advance: der Kunde kann frei zwischen den Varianten vergleichen. Die
        // zuletzt getippte Variante (Default: Bild 1) gilt als gewählt; weiter geht es, indem der
        // Kunde den nächsten Schritt antippt / ins Textfeld klickt.
        s.motifVariant = parseInt(el.dataset.i, 10) || 0;
        this.renderSteps(); this.renderPreview(); this.emit('motifChanged', s.motif);
        break;
      }
      case 'no-motif': {
        // Kästchen statt Button (15.08.2026): schaltet in BEIDE Richtungen.
        // `el.checked` ist beim Klick schon der neue Zustand — derselbe Pfad wie
        // bei „Kein Text gewünscht" darunter. Der `!== false`-Vergleich haelt den
        // Handler auch fuer ein Element ohne `checked` (alter Button) gutmuetig.
        const an = el.checked !== false;
        if (an) {
          // Vorherige Wahl merken, sonst ist sie nach dem Abhaken verloren: der
          // frühere Handler setzte `s.motif = null` und warf sie ersatzlos weg.
          if (s.motif) {
            this._motifBeforeNone = {
              motif: s.motif, variant: s.motifVariant || 0,
              bucket: s.bucket, collapsed: s.motifCollapsed,
            };
          }
          s.motif = null; s.noMotif = true; s.done.motif = true;
        } else {
          const vor = this._motifBeforeNone;
          s.noMotif = false;
          if (vor && vor.motif) {
            s.motif = vor.motif;
            s.motifVariant = vor.variant;
            s.motifCollapsed = vor.collapsed;
            if (vor.bucket) s.bucket = vor.bucket;
            s.done.motif = true;               // die Wahl war schon erledigt
          } else {
            // Nichts zu erinnern (Kästchen kam per Deep-Link oder Default vorbelegt):
            // Schritt wieder OEFFNEN statt still „erledigt" zu lassen — sonst koennte
            // ohne jede Motivwahl gekauft werden, obwohl der Kunde sie zurueckgenommen hat.
            s.motif = null; s.done.motif = false;
          }
          this._motifBeforeNone = null;
        }
        this.renderSteps(); this.renderPreview(); this._syncPrintStep();
        this.emit('motifChanged', s.motif);
        break;
      }
      case 'no-text': {
        this._textActionPending = false;   // Klick ist gelandet — Blur-Schutz aufheben
        const def = this._textDefById(el.dataset.defId);
        if (!def) break;
        s.noTexts[def.id] = el.checked;
        if (el.checked) {
          // „Kein Text" = wählen & abschließen; bei stillen Zeilen zusätzlich den
          // Editor zuklappen (zurück zur Wert-Zeile „Kein Text · Ändern").
          if (this._isQuietDef(def)) this._quietOpen[def.id] = false;
          s.done[this._stepKeyForDef(def)] = true; this.renderSteps(); this.renderPreview();
        } else {
          // Abgewählt: Dimm-Zustand entfernen, Feld fokussieren (Caret ans Ende), Schritt
          // bleibt offen bis Blur.
          const inp = this.refs.steps.querySelector(`[data-field="text"][data-def-id="${def.id}"]`);
          if (inp) {
            inp.classList.remove('ttg-field--locked');
            inp.focus();
            const len = inp.value.length;
            try { inp.setSelectionRange(len, len); } catch (err) { /* egal */ }
          }
          this.renderPreview();
        }
        // „Kein Text" ändert die Schrift-Relevanz ggf. sofort (Ebene zählt nicht mehr).
        this._syncFontStep();
        // Den WIRKSAMEN Text nach außen melden — in derselben Form wie
        // _onTextInput. Ohne das erfährt das Cross-Sell-Element nie, dass der
        // Kunde den Text abgewählt hat: sein ui.source wird ausschließlich aus
        // den Engine-Events (motif/text/font/print) neu gebaut, und „Kein Text"
        // war das einzige Textereignis ohne Emission. Der zuletzt getippte Wert
        // blieb dort stehen und ging über die Bonuszeile auf die Druckvorlage.
        this._emitEffectiveText(def);
        break;
      }
      case 'quiet-edit': {
        // Stille Wert-Zeile aufklappen: reiner UI-Zustand, done bleibt unangetastet.
        const def = this._textDefById(el.dataset.defId);
        if (!def) break;
        this._quietOpen[def.id] = true;
        this.renderSteps();
        const inp = this.refs.steps.querySelector(`[data-field="text"][data-def-id="${def.id}"]`);
        if (inp && !inp.disabled) inp.focus();
        break;
      }
      case 'text2-toggle': {
        // Sekundären Text-Slot aufklappen: reiner UI-Zustand (kein eigener Schritt).
        this._textActionPending = false;   // Klick ist gelandet — Blur-Schutz aufheben
        const def = this._textDefById(el.dataset.defId);
        if (!def) break;
        this._slotOpen[def.id] = true;
        this.renderSteps();
        const inp = this.refs.steps.querySelector(`[data-field="text"][data-def-id="${def.id}"]`);
        if (inp) inp.focus();
        break;
      }
      case 'suggest-toggle': {
        // Vorschlags-Panel auf/zu (Phase 8) — reines DOM-Toggle, kein Re-Render
        // (renderSteps würde den Fokus und ein offenes Panel wegräumen).
        this._textActionPending = false;
        const wrap = el.closest('[data-ttg-suggest]');
        const panel = this._suggestPanelVon(wrap);
        if (!panel) break;
        const auf = panel.hidden;
        this._closeSuggestPanels(wrap);
        panel.hidden = !auf;
        el.setAttribute('aria-expanded', auf ? 'true' : 'false');
        // Zuklappen laeuft hier vorbei an _closeSuggestPanels (das ueberspringt
        // per `ausser` genau dieses Panel) — der Fensterbezug muss trotzdem weg.
        if (auf) this._suggestPlatzieren(wrap, panel);
        else this._suggestLoesen(panel);
        break;
      }
      case 'suggest-pick': {
        // Vorschlag übernehmen — WIE GETIPPT: value setzen und das native
        // input-Event feuern, damit exakt der bestehende Eingabe-Weg läuft
        // (charFilter, Zeilenrahmen, Zähler, _onTextInput → Vorschau).
        this._textActionPending = false;
        const def = this._textDefById(el.dataset.defId);
        if (!def || !def.suggestions) break;
        // data-i zählt fortlaufend über ALLE Gruppen (s. _suggestHtml) — die
        // flache Sicht löst ihn auf, damit der Pick-Weg unverändert bleibt.
        const wert = this._suggestFlat(def)[parseInt(el.dataset.i, 10)] || '';
        const inp = this.refs.steps.querySelector(`[data-field="text"][data-def-id="${def.id}"]`);
        if (inp) {
          inp.value = wert;
          inp.dispatchEvent(new Event('input', { bubbles: true }));
        } else {
          // Feld gerade nicht im DOM (defensiv): denselben Filterweg nehmen.
          this.state.texts[def.id] = this._clampLines(this._filterText(wert, def), def);
          this.renderPreview();
        }
        this._closeSuggestPanels();
        break;
      }
      // Tippen = wählen & abschließen → nächster Schritt öffnet automatisch (renderSteps).
      // _warmSnapshotFonts: die neu gewählte Schrift schon jetzt anfordern, damit
      // der Schrift-Gate im Snapshot später nicht warten muss.
      case 'font': s.font = el.dataset.id; s.done.font = true; this.renderSteps(); this.renderPreview(); this._warmSnapshotFonts(); this.emit('fontChanged', s.font); break;
      case 'print':
        s.druckfarbe = el.dataset.c; s.done.print = true;
        // Kunde hat die Druckfarbe aktiv gewählt → defaultBy fasst sie nie mehr an.
        this._printTouched = true;
        if (opts && opts.ausKlick) this._sofortAuswahl(el);
        this._nachPaint(() => { this.renderSteps(); this.renderPreview(); this.emit('printChanged', s.druckfarbe); }, opts); break;
      case 'akzent':   // Schema v1.35
        if (!this._akzentFarben().some((c) => c.hex === el.dataset.c)) return;
        s.akzentfarbe = el.dataset.c; s.done.akzent = true;
        if (opts && opts.ausKlick) this._sofortAuswahl(el);
        this._nachPaint(() => { this.renderSteps(); this.renderPreview(); this.emit('accentChanged', s.akzentfarbe); }, opts); break;
      case 'size': if (el.disabled) return; s.size = el.dataset.v; s.done.size = true;
        if (opts && opts.ausKlick) this._sofortAuswahl(el);
        this._nachPaint(() => { this.renderSteps(); this.renderPreview(); this.emit('variantChanged', this.getVariantId()); }, opts); break;
      case 'sizeguide-kiwi': this._openKiwi(el.dataset.target); break;
      case 'sizeguide-overlay': this._openSizeOverlay(); break;
      case 'next': s.done[el.dataset.step] = true; this.renderSteps(); this.renderPreview(); break;
      case 'text-value': {
        // Fester Auswahlwert (def.values) — wie ein zu Ende getippter Text:
        // Wert in state.texts, Schritt erledigt, Vorschau neu. Der Snapshot und
        // die Line-Item-Property lesen dieselbe Quelle, deshalb ist hier nichts
        // Zusätzliches nötig. Unbekannter Wert (fremdes Markup) wird ignoriert.
        const dv = this._textDefById(el.dataset.defId);
        if (!dv || !Array.isArray(dv.values) || dv.values.indexOf(el.dataset.v) === -1) break;
        s.texts[dv.id] = el.dataset.v;
        s.noTexts[dv.id] = false;
        s.done[this._stepKeyForDef(dv)] = true;
        this.renderSteps(); this.renderPreview();
        this._syncFontStep();
        this.emit('textChanged', { defId: dv.id, value: s.texts[dv.id] });
        break;
      }
      case 'text-next': {
        // „Weiter" im aktiven Text-Schritt: bestätigt den Schritt (Wert liegt via input
        // schon in state.texts) und springt zum nächsten. Optionale Schritte dürfen auch
        // leer weiter (= übersprungen). Ein PFLICHT-Feld ohne Inhalt bleibt offen (Fokus
        // zurück ins Feld), damit die einzige echte Pflicht-Eingabe nicht übersprungen wird.
        const def = this._textDefById(el.dataset.defId);
        if (!def) break;
        const hasContent = (s.texts[def.id] || '').trim() !== '';
        if (!def.optional && !hasContent && !s.noTexts[def.id]) {
          const inp = this.refs.steps.querySelector(`[data-field="text"][data-def-id="${el.dataset.defId}"]`);
          if (inp) inp.focus();
          break;
        }
        s.done[this._stepKeyForDef(def)] = true;
        this.renderSteps(); this.renderPreview();
        break;
      }
      case 'goto': {
        // Vorwärts zu einem erreichbaren Schritt springen: alle davorliegenden, verlassbaren
        // Schritte gelten damit als erledigt (deren Vorauswahl/Motiv wird übernommen). So kann
        // der Kunde einen offen gehaltenen Schritt (z. B. Varianten-Vergleich) aktiv abschließen.
        const target = el.dataset.step;
        for (const d of this._stepDefs()) {
          if (d.key === target) break;
          if (this._canLeave(d.key)) s.done[d.key] = true;
        }
        this.renderSteps(); this.renderPreview();
        break;
      }
      case 'reopen':
        // Merken, dass der Kunde diesen (vorbelegten) Schritt aktiv geöffnet hat —
        // die Nachmarkierung in renderSteps klappt ihn dann nicht sofort wieder zu.
        this._reopened.add(el.dataset.step);
        s.done[el.dataset.step] = false;
        // Motiv-Schritt wieder geöffnet → voller Ausgangszustand: Grid + Suche zurück (kein „Kleben"),
        // Grid wieder auf den Schwellwert begrenzt. Das gewählte Motiv bleibt gewählt.
        if (el.dataset.step === 'motif') { s.motifCollapsed = false; s.motifExpandedFor = null; s.motifIntro = false; }
        this.renderSteps(); break;
    }
  }

  /* ------------------------------------------ Größenratgeber-Overlay (Lazy) */

  /**
   * Öffnet das Slide-in-Overlay. LAZY-PFLICHT: Der gesamte Aufbau (DOM, Bilder,
   * Inhalts-Rendering) passiert erst beim ERSTEN Klick — vorher existiert nur
   * der Button im Größen-Schritt. Danach wird das Panel wiederverwendet.
   */
  _openSizeOverlay() {
    if (!this._sizeOverlay) this._sizeOverlay = this._buildSizeOverlay();
    if (!this._sizeOverlay) return;
    this._refreshSizeOverlayContent();
    this._sizeOverlay.classList.add('is-open');
    document.documentElement.classList.add('ttg-ovl-lock');
    const closeBtn = this._sizeOverlay.querySelector('[data-ttg-ovl-close]');
    if (closeBtn) closeBtn.focus();
  }

  _closeSizeOverlay() {
    if (!this._sizeOverlay) return;
    this._sizeOverlay.classList.remove('is-open');
    document.documentElement.classList.remove('ttg-ovl-lock');
  }

  /** Rendert den Overlay-Inhalt beim Öffnen neu, damit eine schnitt-abhängige
   *  Tabelle (size_table v2) den aktuell gewählten Optionswert zeigt. Nur für
   *  String-Renderer (Tabelle): interaktive Inhalte (Visualizer, liefern { html,
   *  init, … }) behalten ihren Zustand und werden nicht angefasst. v1/flache
   *  Tabellen rendern dabei identisch — der Aufruf ist dann ein No-Op-Ersatz. */
  _refreshSizeOverlayContent() {
    const sg = this.config.sizeGuide || {};
    const renderer = TTG_SIZE_OVERLAY_RENDERERS[sg.type];
    if (!renderer) return;
    const out = renderer(this, sg);
    if (typeof out !== 'string') return;   // interaktive Inhalte nicht neu bauen
    const contentEl = this._sizeOverlay.querySelector('.ttg-ovl__content');
    if (contentEl) contentEl.innerHTML = out;
  }

  /** Baut den typoffenen Overlay-Rahmen + Inhalt (Renderer je sizeGuide.type). */
  _buildSizeOverlay() {
    const sg = this.config.sizeGuide || {};
    const renderer = TTG_SIZE_OVERLAY_RENDERERS[sg.type];
    if (!renderer) return null;
    const label = sg.label || this.config.strings.size_guide || 'Größentabelle';
    // Renderer liefert String ODER { html, init, hideHead } (interaktive Inhalte).
    const out = renderer(this, sg);
    const contentHtml = typeof out === 'string' ? out : (out && out.html) || '';
    const hideHead = !!(out && out.hideHead);
    // Kopfbereich. Trägt die size_table ein Top-Level-image (schnitt-unabhängiges
    // Mess-Schema, v2/flat), bleibt der Kopf LEER: das Schema rendert seit dem
    // 22.07. der Inhalts-Renderer, damit es unter dem beschreibenden Text steht
    // (Reihenfolge note → image → Tabelle). Der Kopf zeigt in dem Fall weiterhin
    // NICHT das gender-spezifische Produkt-Mockup (_currentBaseImage) — es
    // suggeriert genau die Damen-/Herren-Unterscheidung, die es beim Messen nicht
    // gibt. Ohne size_table-image bleibt der Kopf unverändert (optionale
    // Mess-Skizze sg.image + Produktbild) — Warnweste/Fußmatte hängen daran.
    const schemaImg = (sg.type === 'overlay' && sg.data && !Array.isArray(sg.data) && sg.data.image) || null;
    const productImg = this._currentBaseImage();
    const headImgs = (hideHead || schemaImg) ? '' : [
      sg.image ? `<img class="ttg-ovl__headimg" src="${escapeHtml(sg.image)}" alt="Mess-Skizze" loading="lazy" decoding="async">` : '',
      productImg ? `<img class="ttg-ovl__headimg" src="${escapeHtml(productImg)}" alt="" loading="lazy" decoding="async">` : '',
    ].filter(Boolean).join('');
    const wrap = document.createElement('div');
    wrap.className = 'ttg-ovl';
    wrap.innerHTML = `
      <div class="ttg-ovl__backdrop" data-ttg-ovl-close-area></div>
      <aside class="ttg-ovl__panel" role="dialog" aria-modal="true" aria-label="${escapeHtml(label)}">
        <div class="ttg-ovl__grip" aria-hidden="true"></div>
        <header class="ttg-ovl__head">
          <h3 class="ttg-ovl__title">${escapeHtml(label)}</h3>
          <button type="button" class="ttg-ovl__close" data-ttg-ovl-close aria-label="Schließen">×</button>
        </header>
        ${headImgs ? `<div class="ttg-ovl__imgs">${headImgs}</div>` : ''}
        <div class="ttg-ovl__content">${contentHtml}</div>
      </aside>`;
    wrap.addEventListener('click', (e) => {
      if (e.target.closest('[data-ttg-ovl-close]') || e.target.hasAttribute('data-ttg-ovl-close-area')) this._closeSizeOverlay();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && wrap.classList.contains('is-open')) this._closeSizeOverlay();
    });
    document.body.appendChild(wrap);
    this._attachOverlayDismiss(wrap);
    if (out && typeof out.init === 'function') out.init(wrap.querySelector('.ttg-ovl__content'), this, sg);
    return wrap;
  }

  /** Mobile: Swipe schließt das Overlay — zwei Achsen, beide konfliktfrei mit den
   *  nativen Scroll-Achsen des Inhalts.
   *
   *  • Swipe-runter (Bottom-Sheet): greift nur am oberen Panel-Anschlag (scrollTop 0),
   *    sonst gehört die Geste dem vertikalen Panel-Scroll.
   *  • Swipe-rechts (konsistent zur Rein-Animation von rechts): schließt IMMER —
   *    AUSSER die Tabelle unter dem Finger scrollt real horizontal und steht nicht
   *    am Anfang. Konkret: startet die Geste über einem Vorfahren mit
   *    scrollWidth>clientWidth UND scrollLeft>0, gehört ein Swipe-rechts dem Zurück-
   *    Scrollen der Spalten (nicht dismiss). Bei Tabellen OHNE Überlauf (T-Shirt,
   *    3 Spalten) schließt Swipe-rechts also überall im Panel; bei einer breiteren
   *    Tabelle (falls irgendwo) greift der Schutz automatisch — kein Edge-Swipe,
   *    keine Randabmessung.
   *
   *  Ein Swipe-links (Spalten vorwärts scrollen) und ein Swipe-hoch lösen nie aus.
   *  Desktop/Maus unberührt (nur Touch). Gilt für ALLE Größentabellen (Tabelle wie
   *  Visualizer). */
  _attachOverlayDismiss(wrap) {
    const panel = wrap.querySelector('.ttg-ovl__panel');
    const backdrop = wrap.querySelector('.ttg-ovl__backdrop');
    if (!panel) return;
    const DISMISS_PX = 90;            // Schwelle: darüber schließen, sonst zurückschnappen
    let startX = 0, startY = 0, startTarget = null, delta = 0, tracking = false, axis = null; // axis: 'down' | 'right'
    // Beansprucht ein real horizontal scrollender Vorfahre (bis zum Panel) unter dem
    // Touch die Swipe-rechts-Geste? (Überlauf vorhanden UND nicht am linken Anschlag)
    const hScrollOwnsRight = (node) => {
      for (let el = node; el && el !== panel.parentNode; el = el.parentElement) {
        if (el.scrollWidth > el.clientWidth + 1 && el.scrollLeft > 0) return true;
        if (el === panel) break;
      }
      return false;
    };
    const settle = (toDismiss, ax) => {
      panel.style.transition = '';   // CSS-Transition wieder aktiv → animiertes Setzen
      let done = false;
      const finish = () => {
        if (done) return; done = true;
        panel.removeEventListener('transitionend', finish);
        panel.style.transform = '';  // Inline lösen → CSS regiert wieder (offen: translateX(0); zu: translateX(102%))
        if (backdrop) backdrop.style.opacity = '';
        if (toDismiss) this._closeSizeOverlay();
      };
      panel.addEventListener('transitionend', finish);
      setTimeout(finish, 340);       // Fallback, falls transitionend ausbleibt
      // Ziel setzen (nächster Frame, damit die Transition greift). Rausslieden entlang
      // der gewählten Achse; Zurückschnappen immer auf die offene Position translateX(0).
      requestAnimationFrame(() => {
        panel.style.transform = toDismiss
          ? (ax === 'right' ? 'translateX(102%)' : 'translateY(100%)')
          : 'translateX(0)';
      });
    };
    panel.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) { tracking = false; return; }
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      startTarget = e.target; delta = 0; tracking = true; axis = null;
    }, { passive: true });
    panel.addEventListener('touchmove', (e) => {
      if (!tracking || e.touches.length !== 1) return;
      const ddx = e.touches[0].clientX - startX, ddy = e.touches[0].clientY - startY;
      if (!axis) {
        if (Math.abs(ddx) < 8 && Math.abs(ddy) < 8) return;          // noch unter der Erkennungsschwelle
        if (Math.abs(ddy) >= Math.abs(ddx)) {
          // vertikal-dominant: nur nach unten am oberen Anschlag (sonst V-Panel-Scroll)
          if (ddy > 0 && panel.scrollTop <= 0) axis = 'down';
          else { tracking = false; return; }
        } else {
          // horizontal-dominant: nur nach rechts, und nur wenn kein H-Scroll es beansprucht
          if (ddx > 0 && !hScrollOwnsRight(startTarget)) axis = 'right';
          else { tracking = false; return; }                         // H-Tabellen-Scroll / Swipe-links → nativ lassen
        }
        panel.style.transition = 'none';
      }
      delta = axis === 'right'
        ? Math.max(0, e.touches[0].clientX - startX)
        : Math.max(0, e.touches[0].clientY - startY);
      e.preventDefault();                                            // eigenes Dragging, kein nativer Scroll
      panel.style.transform = axis === 'right' ? `translateX(${delta}px)` : `translateY(${delta}px)`;
      if (backdrop) backdrop.style.opacity = String(Math.max(0, 1 - delta / 420));
    }, { passive: false });
    const end = () => {
      if (!tracking) return;
      tracking = false;
      if (!axis) return;
      settle(delta > DISMISS_PX, axis);
      axis = null; delta = 0;
    };
    panel.addEventListener('touchend', end);
    panel.addEventListener('touchcancel', end);
  }

  /** Triggert den vorhandenen Kiwi-Sizing-Chart über sein injiziertes Element (Proxy-Klick). */
  _openKiwi(selector) {
    const anchor = selector ? document.querySelector(selector) : null;
    if (!anchor) { console.warn('[ttg] Kiwi-Anchor nicht gefunden:', selector); return; }
    const trigger = anchor.querySelector('a, button, [role="button"], [class*="kiwi"], [class*="Kiwi"]') || anchor;
    trigger.click();
  }

  // aria-pressed innerhalb der aktiven Karte umschalten, ohne Re-Render (INP)
  _setPressed(action, el) {
    this.refs.steps.querySelectorAll(`[data-action="${action}"]`).forEach((b) => b.setAttribute('aria-pressed', 'false'));
    el.setAttribute('aria-pressed', 'true');
  }

  /**
   * Aktiver charFilter eines Text-Defs — oder null (= kein Filter).
   *
   * Seit 24.08.2026 ist der Filter die VOREINSTELLUNG (Begründung an
   * TTG_CHARFILTER_STANDARD). Die drei Fälle:
   *   nichts gesetzt        → Standard
   *   eigener charFilter    → der des Defs gewinnt; fehlt ihm die Emoji-Liste,
   *                           erbt er die des Standards. Eine ausdrücklich LEERE
   *                           Liste bleibt leer — das ist eine Aussage, kein Loch.
   *   false / mode:"off"    → aus. Der einzige Weg dorthin.
   *
   * Jeder ANDERE Wert filtert, auch ein unbekannter mode. Der sichere Ausgang aus
   * einem Tippfehler ist „gefiltert": ein versehentlich abgeschalteter Filter
   * druckt Emojis auf die Ware, ein versehentlich aktiver kostet den Kunden einen
   * Hinweis. Deshalb ist der Ausstieg eng und wörtlich.
   */
  _charFilter(def) {
    const cf = def && def.charFilter;
    if (cf === false || (cf && cf.mode === 'off')) return null;
    if (!cf || typeof cf !== 'object') return TTG_CHARFILTER_STANDARD;
    return Array.isArray(cf.allowedEmojis)
      ? cf
      : Object.assign({}, cf, { allowedEmojis: TTG_CHARFILTER_STANDARD.allowedEmojis });
  }

  /** Erlaubte Zeilenzahl eines Text-Defs (Schema v1.16). Immer ≥ 1. */
  _maxLines(def) {
    return Math.max(1, parseInt(def && def.maxLines, 10) || 1);
  }

  /**
   * Verbleibende Zeichen für den Zähler — über das GANZE Feld, nicht je Zeile.
   *
   * Budget = maxLength × maxLines, verbraucht = Summe aller Zeilenlängen ohne die
   * Umbruchzeichen. Der Zähler läuft damit durchgehend von 40 auf 0 herunter,
   * statt beim Umbruch auf den Rest der neuen Zeile zurückzuspringen.
   *
   * Bei maxLines === 1 ist das Budget maxLength und die Summe die ganze
   * Zeichenkette — also exakt die Rechnung von vorher.
   *
   * Ein Nebeneffekt, der kein Fehler ist: beim WORT-Umbruch fällt das
   * Leerzeichen an der Bruchstelle weg. Der Zähler steht deshalb für genau
   * einen Anschlag still (z. B. 20 → 20) statt rückwärts zu springen — das
   * Zeichen ist wirklich frei geworden.
   */
  _restZeichen(val, def) {
    const zeilen = String(val == null ? '' : val).split('\n');
    const budget = ((def && def.maxLength) || 30) * this._maxLines(def);
    return budget - zeilen.reduce((n, z) => n + z.length, 0);
  }

  /**
   * Eingabefeld eines Text-Defs. Bei maxLines <= 1 exakt das bisherige
   * <input type="text"> — Attribut für Attribut in derselben Reihenfolge, damit
   * jedes Bestandsprodukt zeichengleich rendert. Erst maxLines > 1 gibt ein
   * <textarea rows="maxLines"> frei.
   *
   * Das textarea trägt BEWUSST KEIN maxlength: das Attribut kann „je Zeile" nicht
   * ausdrücken, und es kürzt einen eingefügten Text schon im Browser — still, bevor
   * der Handler ihn je sieht. Genau das soll nicht passieren. Die Grenze zieht
   * _autoWrap: passt es nicht, wird die Eingabe verworfen und der Kunde bekommt
   * einen Hinweis. Das <input> behält sein maxlength (eine Zeile, gleiche Zahl).
   */
  _textFieldHtml(def, val, opt) {
    const o = opt || {};
    const max = def.maxLength || 30;
    const cls = 'ttg-field' + (o.locked ? ' ttg-field--locked' : '');
    const kopf = `class="${cls}" id="ttg-t-${escapeHtml(def.id)}" data-field="text" data-def-id="${escapeHtml(def.id)}"${o.autofocus ? ' data-autofocus' : ''}`;
    const ph = `placeholder="${escapeHtml(def.inputPlaceholder || '')}"`;
    const zeilen = this._maxLines(def);
    if (zeilen <= 1) {
      return `<input type="text" ${kopf} maxlength="${max}" value="${escapeHtml(val)}" ${ph}>`;
    }
    return `<textarea ${kopf} rows="${zeilen}" ${ph}>${escapeHtml(val)}</textarea>`;
  }

  /**
   * Zeilen-Begrenzung des Wunschtexts. Normalisiert CRLF/CR auf \n und hält den
   * Wert im vereinbarten Rahmen: höchstens `maxLines` Zeilen, je höchstens
   * `maxLength` Zeichen.
   *
   * maxLines === 1 (jedes heutige Produkt): Umbrüche werden zu Leerzeichen
   * gefaltet. Das ist KEINE Verhaltensänderung am Druckbild — genau so zeigen
   * Vorschau (white-space: normal/nowrap faltet \n) und Canvas (die
   * Textvorbereitung von fillText ersetzt Whitespace durch U+0020) den Wert
   * schon heute. Neu ist nur, dass die Cart-Property dasselbe sagt wie das Bild,
   * statt einen Umbruch zu behaupten, den niemand druckt.
   *
   * ZEICHEN kürzt diese Funktion bewusst NICHT — nur Zeilen. Die Längengrenze
   * bleibt Sache der bestehenden Prüfungen, und die verwerfen einen zu langen
   * Text, statt ihn still zu beschneiden (Vertrag seit dem Cross-Sell-Deep-Link:
   * der Kunde entscheidet selbst über die Kurzform). Wer beim Tippen begrenzen
   * will, nimmt _clampInput.
   */
  _clampLines(val, def) {
    const s = String(val == null ? '' : val).replace(/\r\n?/g, '\n');
    const max = this._maxLines(def);
    if (max === 1) return s.split('\n').join(' ');
    return s.split('\n').slice(0, max).join('\n');
  }

  /**
   * Wie _clampLines, zusätzlich je Zeile auf maxLength gedeckelt — NUR für das
   * Eingabefeld. Dort ist das Deckeln kein stiller Verlust, sondern dasselbe,
   * was das maxlength-Attribut beim <input> ohnehin tut: der Kunde sieht sofort,
   * dass nichts mehr hineingeht. Beim <textarea> kann das Attribut „je Zeile"
   * nicht ausdrücken, deshalb hier.
   */
  _clampInput(val, def) {
    const maxLen = (def && def.maxLength) || 30;
    return this._clampLines(val, def).split('\n').map((z) => z.slice(0, maxLen)).join('\n');
  }

  /**
   * Automatischer Zeilenumbruch im mehrzeiligen Wunschtext (maxLines > 1).
   *
   * Läuft eine Zeile über `maxLength`, wandert der Überhang in die NÄCHSTE Zeile —
   * am Wort, nicht am Zeichen: gebrochen wird am letzten Leerzeichen innerhalb der
   * ersten `maxLength` Zeichen. Nur wenn ein einzelnes Wort für sich schon länger
   * ist als eine Zeile, wird hart geschnitten; sonst bliebe die Eingabe stecken.
   *
   * Rückgabe `{ text, caret }` oder **null**, wenn es nicht hineinpasst (letzte
   * Zeile voll oder mehr Zeilen als erlaubt). null heißt: NICHTS annehmen — der
   * vorherige Stand bleibt stehen. Weder still kürzen noch still schlucken; der
   * Aufrufer zeigt stattdessen einen Hinweis.
   *
   * Nur ABWÄRTS: hier wird nie Text aus einer späteren Zeile zurückgeholt. Löscht
   * der Kunde in Zeile 1 Zeichen, bleibt Zeile 2 stehen. Ein einmal gesetzter
   * Umbruch gehört dem Kunden — zöge der Text automatisch zurück, spränge das
   * Feld beim Tippen.
   */
  _autoWrap(val, def, caret) {
    const maxLen = (def && def.maxLength) || 30;
    const maxZ = this._maxLines(def);
    const zeilen = String(val == null ? '' : val).replace(/\r\n?/g, '\n').split('\n');
    if (zeilen.length > maxZ) return null;          // mehr Zeilen als erlaubt
    let neuerCaret = null;
    for (let i = 0; i < zeilen.length; i++) {
      if (zeilen[i].length <= maxLen) continue;
      if (i + 1 >= maxZ) return null;               // letzte erlaubte Zeile läuft über
      const z = zeilen[i];
      const br = z.lastIndexOf(' ', maxLen);
      let kopf, rest, amWort;
      if (br > 0) { kopf = z.slice(0, br); rest = z.slice(br + 1); amWort = true; }
      else { kopf = z.slice(0, maxLen); rest = z.slice(maxLen); amWort = false; }
      zeilen[i] = kopf;
      const alt = zeilen[i + 1];
      if (alt === undefined || alt === '') zeilen[i + 1] = rest;
      // Am Wort getrennt → mit Leerzeichen anfügen; hart geschnitten gehört das
      // Wortstück direkt an den Rest, sonst entstünde ein Leerzeichen im Wort.
      else zeilen[i + 1] = amWort ? rest + ' ' + alt : rest + alt;
      // Schreibmarke ans ENDE des verschobenen Teils in der Folgezeile — dort
      // tippt der Kunde weiter. Anfang oder Mitte wäre ein Schreiben ins Leere.
      let vor = 0;
      for (let k = 0; k <= i; k++) vor += zeilen[k].length + 1;   // +1 je Zeilenumbruch
      neuerCaret = vor + rest.length;
    }
    for (const z of zeilen) if (z.length > maxLen) return null;   // Sicherheitsnetz
    const text = zeilen.join('\n');
    return { text, caret: neuerCaret == null ? caret : neuerCaret };
  }

  /** Hinweis „mehr passt nicht" direkt am Feld — ohne Re-Render (INP). Erscheint
   *  nur, wenn eine Eingabe VERWORFEN wurde, und verschwindet beim nächsten
   *  angenommenen Zeichen. Ohne ihn wäre das Verwerfen für den Kunden ein
   *  stummes Nichts — genau das soll es nicht sein. */
  _zeigeTextGrenze(feld, def) {
    if (typeof document === 'undefined' || !feld || !feld.parentNode) return;
    let p = feld.parentNode.querySelector('[data-ttg="text-limit-hint"]');
    if (!p) {
      p = document.createElement('p');
      p.className = 'ttg-motif-cataloghint';
      p.setAttribute('data-ttg', 'text-limit-hint');
      p.setAttribute('role', 'status');
      feld.insertAdjacentElement('afterend', p);
    }
    const s = this.config.strings || {};
    p.textContent = s.text_limit_hint
      || `Mehr passt nicht drauf — ${this._maxLines(def)} Zeilen à ${(def && def.maxLength) || 30} Zeichen.`;
  }

  _raeumeTextGrenze(feld) {
    if (!feld || !feld.parentNode) return;
    const p = feld.parentNode.querySelector('[data-ttg="text-limit-hint"]');
    if (p) p.remove();
  }

  /** Hinweisknoten des Zeichenfilters für GENAU dieses Feld. In einer Sektion mit
   *  Zusatz-Slots liegen mehrere Eingabefelder unter demselben Elternknoten —
   *  deshalb trägt der Knoten die def-ID, und gesucht wird über das Attribut statt
   *  über einen zusammengebauten Selektor (eine def-ID ist Config-Inhalt und hat in
   *  keinem Selektor etwas verloren). */
  _zeichenHinweisKnoten(feld, def) {
    if (!feld || !feld.parentNode || !def) return null;
    const alle = feld.parentNode.querySelectorAll('[data-ttg="char-filter-hint"]');
    for (const k of alle) if (k.getAttribute('data-def-id') === String(def.id)) return k;
    return null;
  }

  /** Hinweis „nicht druckbare Zeichen entfernt" direkt am Feld — Zwilling von
   *  _zeigeTextGrenze: gleiches Markup, gleiche gedämpfte Hinweisfarbe, kein Rot.
   *  Das ist ein Hinweis, kein Vorwurf.
   *
   *  Erscheint NUR, wenn der charFilter wirklich etwas entfernt hat, und verschwindet
   *  bei der nächsten sauberen Eingabe. Ohne ihn verschwänden die Zeichen stumm —
   *  genau das soll es nicht sein (gleiche Begründung wie beim Zwilling).
   *
   *  Der Standardtext nennt die beiden heute überall zugelassenen Emojis und sagt
   *  ZUERST, was geht — die Frage des Kunden in diesem Moment ist „ist meine
   *  Bestellung jetzt kaputt", nicht „was habt ihr weggenommen" (Wortlaut Jens
   *  24.08.2026; der erste Satz begann mit der Absage und klang nach Wegnehmen).
   *  Wortgleich hinterlegt in docs/feldkanon.json — check-feldkanon vergleicht
   *  beide, ein einseitiges Ändern fällt dort auf.
   *
   *  Eine Config mit anderer allowedEmojis-Liste setzt strings.char_filter_hint.
   *  Dieser Ausleseweg bleibt als Ausnahme bestehen, wird aber bewusst nirgends
   *  befüllt: kein Metaobjekt trägt einen strings-Eintrag dafür. */
  _zeigeZeichenHinweis(feld, def) {
    if (typeof document === 'undefined' || !feld || !feld.parentNode || !def) return;
    let p = this._zeichenHinweisKnoten(feld, def);
    if (!p) {
      p = document.createElement('p');
      p.className = 'ttg-motif-cataloghint';
      p.setAttribute('data-ttg', 'char-filter-hint');
      p.setAttribute('data-def-id', String(def.id));
      p.setAttribute('role', 'status');
      feld.insertAdjacentElement('afterend', p);
    }
    // Grosses S: genau die Schreibweise, an der der Feldkanon-Waechter das
    // Engine-Literal erkennt und gegen docs/feldkanon.json haelt
    // (scripts/check-feldkanon.mjs — Muster `(?:S|strings).<key> || '…'`).
    const S = this.config.strings || {};
    p.textContent = S.char_filter_hint
      || 'Herz ❤️ und Pfote 🐾 kommen mit aufs Produkt. Andere Emojis lassen sich leider nicht drucken – dein Text bleibt sonst genau so.';
  }

  _raeumeZeichenHinweis(feld, def) {
    const p = this._zeichenHinweisKnoten(feld, def);
    if (p) p.remove();
  }

  /**
   * print-safe-Eingabefilter: lässt Buchstaben/Zahlen/übliche Satzzeichen durch
   * plus die in charFilter.allowedEmojis gelisteten Emojis (VS16-tolerant,
   * normalisiert auf die konfigurierte Form). Alles andere wird verworfen.
   * Welcher Filter gilt, entscheidet _charFilter — seit 24.08.2026 ist print-safe
   * die Voreinstellung, ein Text-Step OHNE eigenen charFilter wird also gefiltert.
   * Unverändert bleibt der Wert nur beim ausdrücklichen Ausstieg
   * (`charFilter: false` / `{mode:"off"}`).
   *
   * Der ZEILENUMBRUCH überlebt den Filter (23.08.2026). Er steht bewusst nicht in
   * TTG_PRINT_SAFE — das ist die Liste der druckbaren Zeichen, und \n ist keines.
   * Über die Zeilenstruktur entscheiden ausschließlich die Stellen DANACH:
   * _autoWrap (mehrzeilig) und _clampInput/_clampLines (einzeilig → Leerzeichen).
   * Vorher fraß der Filter den Umbruch, bevor die beiden ihn je sahen: aus
   * „Luna⏎Max" wurde „LunaMax" — der von Hand gesetzte Umbruch verschwand, und
   * einzeilig verklebten zusätzlich die Wörter (ohne charFilter faltet _clampLines
   * dort zum Leerzeichen). CR/CRLF wird hier schon auf \n normalisiert, damit ein
   * Windows-Einfügen nicht als „Zeichen entfernt" gemeldet wird.
   *
   * `info` (optional; wird beschrieben statt zurückgegeben, damit alle bestehenden
   * Aufrufer unverändert bleiben): `info.removed` zählt die WIRKLICH verworfenen
   * Zeichen. Reine Normalisierung zählt NICHT mit — weder bares ❤ → ❤️ (da kommt
   * etwas dazu, es geht nichts weg) noch CRLF → \n noch ein alleinstehender
   * Variantenselektor U+FE0F. Sonst meldete die Oberfläche einen Verlust bei einer
   * völlig korrekten Eingabe.
   */
  _filterText(val, def, info) {
    const cf = this._charFilter(def);
    if (!cf) return val;
    const allowed = (Array.isArray(cf.allowedEmojis) ? cf.allowedEmojis : []).filter(Boolean);
    // Zielform der Herz-Abbildung: die in DIESER Config zugelassene Schreibweise
    // des Herzens (mit oder ohne Variantenselektor). Führt eine Config das Herz
    // gar nicht, wird auch nichts darauf abgebildet — sonst entstünde ein
    // Zeichen, das derselbe Filter im nächsten Zug wieder verwerfen müsste.
    const herz = allowed.find((e) => e.replace(TTG_VS16, '') === '\u2764') || null;
    const s = String(val == null ? '' : val).replace(/\r\n?/g, '\n');
    let out = '';
    let i = 0;
    outer: while (i < s.length) {
      for (const e of allowed) {
        if (s.startsWith(e, i)) { out += e; i += e.length; continue outer; }
        const bare = e.replace(TTG_VS16, '');
        if (bare && bare !== e && s.startsWith(bare, i)) {
          out += e;
          i += bare.length;
          if (s.charCodeAt(i) === 0xfe0f) i += 1;
          continue outer;
        }
      }
      const ch = String.fromCodePoint(s.codePointAt(i));
      if (ch === '\n' || TTG_PRINT_SAFE.test(ch)) out += ch;
      // Sperrzeichen (Schema v1.36) bleiben stehen, damit die Kauf-Sperre sie sieht.
      else if (def && def.blockChars && def.blockChars.indexOf(ch) !== -1) out += ch;
      // Herz-Variante → konfiguriertes Herz. Das ist Normalisierung, kein
      // Verlust: es geht nichts weg, es wird nur vereinheitlicht. Deshalb steht
      // dieser Zweig VOR der Verlustzählung und löst keinen Hinweis aus.
      else if (herz && TTG_HERZ_VARIANTEN.has(ch)) out += herz;
      else if (ch !== '\uFE0F' && info) info.removed = (info.removed || 0) + 1;
      i += ch.length;
    }
    return this._schriftZeichen(out, def, info);
  }
  /**
   * Zeichenfilter je Schrift (Schema v1.27, Tassen 14.10.2026): Eine Schrift mit `glyphen`
   * (Liste der vorhandenen Zeichen) nimmt nur diese an — Balingkang-TTG hat z. B. kein „&“,
   * keine Ziffern und kein „. , ! ?“; der Druck setzte dort sonst eine falsche Glyphe.
   * `ersetze` bildet Zeichen vorher ab (Balingkang: ß → ss, wie der Renderer). Verworfene
   * Zeichen zählen in info.removed (bestehender Hinweis). Ohne die Felder: unverändert.
   */
  _schriftZeichen(out, def, info) {
    const fid = this._textFontId(def);   // Konstruktor (Deep-Link) läuft vor state — _textFontId fängt das ab
    const fd = fid ? this._fontDef(fid) : null;
    if (!fd || (!fd.glyphen && !fd.ersetze)) return out;
    if (fd.ersetze) for (const [von, zu] of Object.entries(fd.ersetze)) out = out.split(von).join(zu);
    if (!fd.glyphen) return out;
    const erlaubt = String(fd.glyphen);
    let r = '', weg = 0;
    for (const ch of out) {
      if (ch === ' ' || ch === '\n' || erlaubt.includes(ch) || TTG_HERZ_VARIANTEN.has(ch) || ch === '\uFE0F' || /\p{Extended_Pictographic}/u.test(ch)) r += ch;
      else { weg++; if (info) info.removed = (info.removed || 0) + 1; }
    }
    // „Hannes & Yuxuan“ ohne „&“: kein doppeltes Leerzeichen stehen lassen (nur wenn etwas entfernt wurde).
    return weg ? r.replace(/ {2,}/g, ' ') : r;
  }

  /**
   * Zerlegt den Text in Segmente aus normalem Text und Glyphen-Emojis — nur
   * wenn charFilter aktiv ist UND ein erlaubtes Emoji mit hinterlegter Glyphe
   * vorkommt. Sonst null (= Aufrufer rendert wie bisher).
   */
  _glyphSegments(content, def) {
    const cf = this._charFilter(def);
    if (!cf || !content) return null;
    const emojis = (Array.isArray(cf.allowedEmojis) ? cf.allowedEmojis : []).filter((e) => TTG_EMOJI_GLYPHS[e]);
    if (!emojis.length) return null;
    const segs = [];
    let buf = '';
    let i = 0;
    outer: while (i < content.length) {
      for (const e of emojis) {
        if (content.startsWith(e, i)) {
          if (buf) { segs.push({ text: buf }); buf = ''; }
          // emoji = das Originalzeichen — der Foto-Druckvertrag (_fotoDruckConfig)
          // gibt es unverändert weiter; alle anderen Verbraucher lesen nur .glyph.
          segs.push({ glyph: TTG_EMOJI_GLYPHS[e], emoji: e });
          i += e.length;
          continue outer;
        }
      }
      const ch = String.fromCodePoint(content.codePointAt(i));
      buf += ch;
      i += ch.length;
    }
    if (buf) segs.push({ text: buf });
    return segs.some((s) => s.glyph) ? segs : null;
  }

  /**
   * Text-Layer-Inhalt setzen: mit aktiven Glyphen als HTML (SVG in currentColor
   * → erbt die Druck-/Textfarbe), sonst wie bisher als reiner Text.
   */
  _renderTextContent(el, content, def) {
    const segs = this._glyphSegments(content, def);
    // Präfix (Schema v1.36): eigener Kasten mit prefixGapEm Breite — skaliert mit der Schrift,
    // wie im Warenkorbbild und im Druckvertrag. Ohne prefix an der Ebene: unverändert.
    const pl = def ? this._textLayer(def) : null;
    const pre = this._prefixOf(pl);
    const preHtml = pre ? `<span class="ttg-text-prefix" style="display:inline-block;width:${this._prefixGapEm(pl)}em">${escapeHtml(pre)}</span>` : '';
    if (!segs) {
      if (pre) el.innerHTML = preHtml + escapeHtml(content); else el.textContent = content;
      return;
    }
    // emojiColor:'print' (Schema v1.18): Glyphe in der Druckfarbe statt currentColor
    // — renderPreview schreibt den Inhalt bei jedem Render neu, ein Druckfarben-
    // Wechsel färbt die Glyphen also sofort um. Ohne das Feld unverändert.
    const glyphFill = (def && def.emojiColor === 'print')
      ? this._resolveInk(this.state.druckfarbe) : 'currentColor';
    el.innerHTML = preHtml + segs.map((s) => s.glyph
      ? `<svg viewBox="0 0 24 24" aria-hidden="true" style="height:.95em;width:.95em;vertical-align:-.08em;fill:${glyphFill};display:inline-block"><path d="${s.glyph}"/></svg>`
      : escapeHtml(s.text)).join('');
  }

  /**
   * Meldet den WIRKSAMEN Text einer Ebene nach außen — „Kein Text" zählt als
   * leerer Wert. Gleiche Nutzlast-Form wie in _onTextInput, damit außenstehende
   * Verbraucher (Cross-Sell-Element, Theme-Adapter) nur EIN Ereignis kennen
   * müssen. Nötig, weil der „Kein Text"-Haken und das Wieder-Einschalten den
   * Zustand ändern, ohne dass je getippt wird.
   */
  _emitEffectiveText(def) {
    if (!def) return;
    const eff = this.state.noTexts[def.id] ? '' : (this.state.texts[def.id] || '');
    this.emit('textChanged', def._legacy ? eff : { id: def.id, value: eff });
  }

  _onTextInput(val, def) {
    this.state.texts[def.id] = val;
    // Mit dem ersten Zeichen wird der Schrift-Schritt relevant (_stepDefs). Seine
    // Vorbelegung gilt SOFORT als Wahl — nicht erst beim nächsten renderSteps() nach
    // dem Blur-Timeout. Sonst: CTA grau ab dem ersten Buchstaben (renderPreview →
    // _updateCta) und der erste Klick endet mit „Schriftart: das fehlt noch"
    // (Jens 21.09.2026). Kein Re-Render — der Fokus bleibt im Feld.
    this._markPreSatisfiedSteps();
    // Deep-Link-Hinweis („Text zu lang") erlischt, sobald der Kunde selbst tippt —
    // nur den DOM-Knoten entfernen, kein Re-Render (der Fokus bliebe sonst nicht).
    if (this._deepLinkTextHint && this._deepLinkTextHint.defId === def.id) {
      this._deepLinkTextHint = null;
      const hint = this.refs.steps && this.refs.steps.querySelector('[data-ttg="deeplink-text-hint"]');
      if (hint) hint.remove();
    }
    // Zähler des EIGENEN Feldes (bei mehreren Inputs in einer Sektion — Slots);
    // Fallback: erster Zähler (Ein-Text-Produkte, unverändert).
    const cnt = this.refs.steps.querySelector(`[data-ttg-cnt="${def.id}"]`)
      || this.refs.steps.querySelector('.ttg-cnt');
    if (cnt) cnt.firstChild ? (cnt.textContent = this._restZeichen(val, def) + ' ' + (this.config.strings.chars_free || 'Zeichen frei')) : null;
    // Kein Abschluss/Sprung während des Tippens — nur Vorschau aktualisieren.
    this.renderPreview();
    this.emit('textChanged', def._legacy ? val : { id: def.id, value: val });
  }

  /**
   * Text-Schritt beim Blur abschließen — aber verzögert, damit ein direkt
   * folgender Klick (z. B. auf „Kein Text") noch am aktuellen DOM landet,
   * bevor renderSteps() neu aufbaut. Nie während des Tippens.
   */
  _onTextBlur(defId) {
    setTimeout(() => {
      // Ein Klick auf Slot-Link/„Kein Text" ist gerade unterwegs (pointerdown
      // gesehen, click noch nicht) → nicht abschließen; der Klick-Handler übernimmt.
      if (this._textActionPending) return;
      const inp = this.refs.steps.querySelector(`[data-field="text"][data-def-id="${defId}"]`);
      if (inp && document.activeElement === inp) return;         // Fokus zurück im Feld
      // Fokus in einem ANDEREN Text-Feld derselben Sektion (Haupt-Feld ↔ Slot):
      // nicht abschließen — sonst würde renderSteps das gerade fokussierte Feld
      // wegrendern, bevor der Kunde tippen kann.
      const ae = document.activeElement;
      if (ae && ae.dataset && ae.dataset.field === 'text') {
        const a = this._primaryFor(this._textDefById(ae.dataset.defId));
        const b = this._primaryFor(this._textDefById(defId));
        if (a && b && a.id === b.id) return;
      }
      this._confirmText(defId);
    }, 0);
  }

  /**
   * Rand-Leerzeichen im Text-State entfernen — die EINE Stelle dafür.
   * Vorschau, Wizard-Anzeige, Canvas-Snapshot (= Druckvorlage) und die
   * Line-Item-Properties lesen ausnahmslos `state.texts`. Wer hier bereinigt,
   * bereinigt alle vier zugleich; sie können danach nicht mehr auseinander-
   * laufen (zwei Wahrheiten auf einer Bestellung waren genau das Problem).
   * Ohne Argument: alle Text-Ebenen — Sicherheitsnetz vor dem Absenden, falls
   * der Kunde den Kaufknopf klickt, ohne das Feld je zu verlassen.
   * @param {string} [defId] Nur diese Ebene bereinigen.
   * @returns {boolean} true, wenn sich etwas geändert hat.
   */
  _trimTextState(defId) {
    const texts = this.state.texts || {};
    const ids = defId != null ? [defId] : Object.keys(texts);
    let changed = false;
    for (const id of ids) {
      const cur = texts[id];
      if (typeof cur !== 'string') continue;
      const next = ttgTrimEdges(cur);
      if (next !== cur) { texts[id] = next; changed = true; }
    }
    return changed;
  }

  /** Schließt einen Text-Schritt ab (Blur ODER Enter), sofern Text vorhanden oder
   *  (bei optionalen Schritten) „Kein Text" gewählt. Pflichtfelder bleiben ohne Wert offen.
   *  Stille Zeilen (optional + default): Editor einfach zuklappen — auch leer erlaubt
   *  (leer = Ebene aus, Property entfällt), der Schritt war und bleibt erfüllt. */
  _confirmText(defId, opts) {
    const def = this._textDefById(defId);
    if (!def) return;
    // Der Zeichen-Hinweis gehört dem OFFENEN Feld. Er bleibt beim Weitertippen
    // stehen — sonst blitzte er beim Tippen nur auf und wäre beim nächsten
    // Buchstaben weg, und genau lesen soll der Kunde ihn ja. Weg geht er HIER:
    // beim Abschließen des Schritts, egal ob per Blur, Enter oder „Weiter".
    // Die Abbruchpfade von _onTextBlur (Fokus zurück im Feld, Fokus im
    // Nachbar-Slot, Klick unterwegs) kommen hier nicht an — dort ist der Kunde
    // noch am Feld, und der Hinweis bleibt richtigerweise stehen.
    if (this.refs && this.refs.steps && this.refs.steps.querySelectorAll) {
      for (const f of this.refs.steps.querySelectorAll('[data-field="text"]')) {
        if (f.dataset && f.dataset.defId === String(defId)) { this._raeumeZeichenHinweis(f, def); break; }
      }
    }
    // Rand-Leerzeichen entfernen, SOBALD der Schritt abgeschlossen wird (Blur
    // ODER Enter) — nie während des Tippens (_onTextInput schreibt roh weiter,
    // sonst verschwände ein gerade getipptes Trennzeichen unter dem Cursor).
    // Der State ist die einzige Quelle für Vorschau, Anzeige, Snapshot und
    // Properties — hier bereinigt, stimmen ab jetzt alle vier überein.
    this._trimTextState(def.id);
    if (def.secondary) {
      // Kein eigener Schritt: leerer Slot klappt wieder zum „+ …"-Link zu,
      // gefüllter bleibt sichtbar. Abschluss-Logik nur am primären Schritt.
      if (!(this.state.texts[def.id] || '').trim() && this._slotOpen[def.id]) {
        this._slotOpen[def.id] = false;
        this.renderSteps();
      }
      this._syncFontStep();
      return;
    }
    if (this._isQuietDef(def)) {
      if (!this._quietOpen[def.id]) return;
      this._quietOpen[def.id] = false;
      this.renderSteps(); this.renderPreview();
      this._syncFontStep();
      return;
    }
    const key = this._stepKeyForDef(def);
    const s = this.state;
    if (s.done[key]) { this._syncFontStep(); return; }           // schon abgeschlossen (z. B. „Kein Text")
    // Handy-INP 13.10.2026: Enter im Feld (opts.ausKlick) — Zustand sofort, Neuaufbau nach dem nächsten Paint
    // (gemessen: Schrittliste + Vorschau lagen im Frame der Taste). Blur/Weiter/Programm: synchron wie bisher.
    const abschluss = !!((s.texts[def.id] || '').trim() || (def.optional && s.noTexts[def.id]));
    if (abschluss) s.done[key] = true;
    this._nachPaint(() => {
      if (abschluss) { this.renderSteps(); this.renderPreview(); }
      // Auch OHNE Abschluss (z. B. Feld geleert): Schrift-Schritt reaktiv nachziehen.
      this._syncFontStep();
    }, opts);
  }

  /** Motive des aktuellen Buckets (Kategorie-Filter) — gemeinsame Quelle für
   *  Grid-Render und Suche. REIHENFOLGE ist Teil des Vertrags: optionales
   *  featured-Array der categoryGroup (Handles) hebt kuratierte Köpfe in genau
   *  dieser Reihenfolge an den Bucket-Anfang (die ersten gridInitial Kacheln
   *  sind Markenregel — z. B. Malinois/Labrador/Golden bei Oberbekleidung);
   *  der Rest folgt in Katalog-/Listen-Reihenfolge. Unbekannte oder inaktive
   *  Handles werden still übersprungen (deaktiviertes Motiv bricht nichts).
   *  extraMotifs (Schema v1.25) kommen NACH dem Kategorie-Filter hinten dazu (Dedupe
   *  gegen die Kategorie-Treffer) und VOR der featured-Logik — die findet sie dann in
   *  `list` und darf sie wie jedes andere Motiv nach vorn ziehen. */
  _motifsInBucket(def) {
    const d = def || this._bucketDef(this.state.bucket)
      || { id: this.state.bucket, label: this.state.bucket, categories: [this.state.bucket], search: false };
    let list = (this.config.motifs || []).filter((m) => d.categories.indexOf(m.kategorie) !== -1);
    if (this._motifAchse() && this.config.motifVariantHideSoldOut === true) list = list.filter((m) => !m._ausverkauft);
    const extra = Array.isArray(d.extraMotifs) ? d.extraMotifs : null;
    if (extra && extra.length) {
      for (const h of extra) {
        const m = this._resolveMotif(h);
        if (m && list.indexOf(m) === -1) list = list.concat([m]);
      }
    }
    if (Array.isArray(d.excludeMotifs) && d.excludeMotifs.length) list = list.filter((m) => !this._motifInExclude(d, m));
    const feat = Array.isArray(d.featured) ? d.featured : null;
    if (!feat || !feat.length) return list;
    const head = [];
    for (const h of feat) {
      const m = this._resolveMotif(h);
      if (m && list.indexOf(m) !== -1) head.push(m);
    }
    if (!head.length) return list;
    return head.concat(list.filter((m) => head.indexOf(m) === -1));
  }

  /** Das beim LADEN gesetzte Motiv — der Anker fürs Grid, EINMAL festgelegt und
   *  danach unveränderlich. Tri-State: `undefined` = noch nicht entschieden,
   *  `null` = es gibt keinen Anker, sonst die Motiv-id.
   *
   *  Warum einmalig und nicht einfach `state.motif`: der Anker belegt einen der
   *  `motifGridInitial` Plätze. Zöge er mit jeder Auswahl mit, würde das Grid bei
   *  JEDEM Kachelklick neu umbrechen — die eben angeklickte Kachel rutscht unter
   *  dem Finger eine Position nach links, sobald der alte Anker aus dem Anschnitt
   *  fällt. Ein fester Platz heißt: die Reihe steht, geklickt wird nur markiert.
   *
   *  Festgenagelt wird erst, wenn die Auswahl wirklich da ist — im Katalog-Modus
   *  kommt sie verspätet (?ttg-motif wird geparkt, das Default-Motiv solange
   *  unterdrückt). Bis dahin bleibt die Entscheidung offen. War der Kunde schneller
   *  als jedes Lade-Motiv, gibt es dauerhaft keinen Anker (heutiges Verhalten). */
  _pinnedMotifId() {
    if (this._motifPinned !== undefined) return this._motifPinned;
    if (this._motifTouched) return (this._motifPinned = null);
    if (!this.state.motif || this.state.noMotif) return null;   // noch offen — nicht festnageln
    return (this._motifPinned = this.state.motif.id);
  }

  /** Kollabiertes Grid: das beim Laden gewählte Motiv muss unter den sichtbaren
   *  Kacheln sein. Liegt es dahinter, sieht der Kunde drei fremde Motive und hält
   *  seine Auswahl für verloren — obwohl die Vorschau sie längst zeigt. Genau das
   *  passiert bei jedem ?ttg-motif= auf ein nicht-featured Motiv (seit der
   *  Katalog-Konsolidierung der Normalfall: 308 Redirect-Ziele) und ebenso bei
   *  einem custom.default_motif außerhalb der featured-Liste.
   *
   *  Es rutscht deshalb auf Position 0, und die LETZTE Featured-Kachel fällt aus
   *  dem Anschnitt: die Kachelzahl bleibt exakt `initial` (Markenregel „initial
   *  genau 3 Motive" — keine vierte Kachel, kein Zeilenumbruch). Markiert wird die
   *  Auswahl von _motifTileHtml per aria-pressed; hier geht es um die Position.
   *
   *  Der Anker steht IMMER auf Platz 1 — auch wenn er ohnehin featured und damit
   *  schon sichtbar wäre (Jens 09.08.2026). „Immer erste Kachel, immer markiert"
   *  ist eine Regel, die der Kunde auf einen Blick versteht; Platz 3 je nach
   *  featured-Zufall ist keine. Die verschobene featured-Reihenfolge kostet nichts:
   *  wer über einen Deep-Link kommt, hat die ursprüngliche nie gesehen.
   *
   *  Ausgenommen bleibt nur, was gar nichts zu heben gibt: ein Anker aus einer
   *  anderen Gruppe (Index -1) und einer, der schon vorn steht (Index 0).
   *
   *  Greift NUR im kollabierten Anschnitt. Passen ohnehin alle Motive des Buckets
   *  ins Grid (≤ initial), rendert _bodyMotif die Liste direkt — dann ist der Anker
   *  sichtbar und markiert, steht aber an seiner natürlichen Stelle. Live ohne
   *  Belang (kleinste Gruppe: 14 Motive), aber bewusst so und nicht vergessen.
   *
   *  `_motifsInBucket` bleibt unberührt: die featured-Reihenfolge ist Vertrag für
   *  Bucket-Liste UND Suche, gedreht wird ausschließlich der Anschnitt. */
  _withSelectedVisible(list, initial) {
    const pin = this._pinnedMotifId();
    if (!pin || !(initial > 0) || list.length <= initial) return list;
    const i = list.findIndex((m) => m && m.id === pin);
    if (i <= 0) return list;              // -1 = nicht in diesem Bucket, 0 = steht schon vorn
    return [list[i]].concat(list.filter((m, k) => k !== i));
  }

  /** Der Kunde hat getippt (entprellt). Bewusst NICHT in _onMotifSearch selbst:
   *  das ruft auch _restoreMotifSearch nach dem Katalog-Laden auf — dieselbe
   *  Suche zählte sonst zweimal. Gemeldet wird NUR die Tatsache, nie der
   *  Suchbegriff: der ist freier Kundentext (Hunde- und Personennamen), genau
   *  wie der Wunschtext. */
  _userSearched(q) {
    if (ttgNorm(q) !== '') this.emit('motifSearched', { bucket: this.state.bucket || null });
    this._onMotifSearch(q);
  }
  _onMotifSearch(q) {
    const nq = ttgNorm(q);
    const grid = this.refs.steps.querySelector('[data-ttg="motif-grid"]');
    if (!grid) return;
    // Weg A (Jens 16.08.2026): Das Suchfeld bleibt auch dann stehen, wenn auf ein
    // Mehrbild-Motiv kollabiert wurde. Damit sind hier zwei Zustände erreichbar, die es
    // vorher nicht gab — in diesem Zweig hatte das Grid bis heute nie eine Einzelkachel.
    if (this._collapsedToSelection()) {
      // (1) Während gesucht wird, sind die auswahlgebundenen Blöcke aus. Variantenreihe
      //     und „Andere Rasse wählen" gehören zum GEWÄHLTEN Motiv; unter den Treffern
      //     einer laufenden Suche zeigten sie auf etwas anderes als das, was darüber
      //     steht — eine Variante ließe sich dann für eine Rasse antippen, die gar nicht
      //     gewählt ist. Genau die Ausschließlichkeit, die _bodyMotif schon kennt.
      this.refs.steps.querySelectorAll('[data-ttg="motif-selection-only"]')
        .forEach((el) => { el.style.display = nq === '' ? '' : 'none'; });
      // (2) Wird die Suche wieder GELEERT, gehört die Einzelkachel zurück. Ohne diesen
      //     Zweig zeichnete der Code unten die ersten `motifGridInitial` Kacheln: offenes
      //     Grid unter einer kollabierten Auswahl, und der „Alle N anzeigen"-Button, der
      //     in diesem Zustand gar nicht gerendert wird, fehlte darunter.
      //     Die Suchtext-Buchhaltung muss mit — sonst spielte _restoreMotifSearch nach dem
      //     Katalog-Load einen längst gelöschten Begriff zurück ins Feld.
      if (nq === '') {
        this._motifQuery = '';
        this._motifQueryBucket = this.state.bucket;
        grid.innerHTML = this._motifTileHtml(this.state.motif, false, 'motif-browse');
        const leer = this.refs.steps.querySelector('[data-ttg="motif-empty"]');
        if (leer) leer.hidden = true;
        return;
      }
    }
    // Such-vor-Katalog-Race (Fix): Solange der VOLLE Katalog fehlt (lädt noch ODER
    // Fetch fehlgeschlagen), darf eine Suche NICHT über die paar Inline-Motive
    // (Default + Featured) filtern — sonst meldet sie fälschlich „diese Rasse haben
    // wir nicht" für eine Rasse, die im Katalog sehr wohl existiert (falsches
    // Wunschformular auf genau dem Produkt, das für die Rassensuche gebaut ist).
    // Stattdessen: Katalog erzwingen (_ensureCatalog re-armt auch nach einem
    // Fehlversuch → „lädt" ist immer der korrekte Zustand), Suchtext merken, Lade-
    // hinweis zeigen. Nach Ankunft wendet _afterCatalogLoaded → _restoreMotifSearch
    // die Suche über den vollen Satz an (Text + Fokus bleiben). Schlägt der Retry
    // erneut fehl, rendert _bodyMotif (bucketHasInline + _catalogFailed) den Retry-
    // Link. Guard inkl. .url — analog mount-Prefetch und _bodyMotif-Ladezustand.
    if (nq !== '' && this.config.motifsCatalog && this.config.motifsCatalog.url && !this._catalogLoaded) {
      this._motifQuery = q;
      this._motifQueryBucket = this.state.bucket;
      this._ensureCatalog();
      const empty = this.refs.steps.querySelector('[data-ttg="motif-empty"]');
      if (empty) empty.hidden = true;                // keine falsche „nicht gefunden"-Meldung
      const xbtn = this.refs.steps.querySelector('[data-action="motif-expand"]');
      if (xbtn) xbtn.style.display = 'none';
      grid.innerHTML = `<p class="ttg-motif-cataloghint" style="grid-column:1/-1">${escapeHtml(this.config.strings.catalog_loading || 'Motive werden geladen …')}</p>`;
      return;
    }
    // Suchtext + Ursprungs-Bucket für die Wiederanwendung merken (leer = gelöscht).
    this._motifQuery = nq === '' ? '' : q;
    this._motifQueryBucket = this.state.bucket;
    // INP: daten-getrieben — inBucket filtern und NUR die Treffer rendern (ein
    // innerHTML-Swap), statt über alle DOM-Tiles zu iterieren und pro Tile ein
    // Array.find über die volle Motivliste zu bezahlen (O(Tiles × Motive) mit
    // Levenshtein pro Tastenanschlag; das Grid enthält seit dem Cap ohnehin nur
    // noch die sichtbaren Tiles).
    const inBucket = this._motifsInBucket();
    // Nur im leeren Ausgangszustand (keine Suche, nicht „alle anzeigen") auf die ersten N kollabieren;
    // beim Tippen die vollen gefilterten Treffer zeigen (Auswahl-/Match-Logik unverändert).
    const initial = this._motifGridInitialWert();
    const expanded = this.state.motifExpandedFor === this.state.bucket;
    const collapse = nq === '' && !expanded && initial > 0 && inBucket.length > initial;
    const matches = nq === '' ? inBucket : inBucket.filter((m) => this._motifMatches(m, nq));
    // Gleicher Anschnitt wie _bodyMotif — sonst verschwände das vorgewählte Motiv genau
    // dann, wenn der Kunde die Suche wieder leert (collapse greift nur bei nq === '').
    const visible = collapse ? this._withSelectedVisible(matches, initial).slice(0, initial) : matches;
    grid.innerHTML = visible.map((m) => this._motifTileHtml(m, false)).join('');
    // „Alle N anzeigen"-Button nur im kollabierten Leerzustand einblenden.
    const btn = this.refs.steps.querySelector('[data-action="motif-expand"]');
    if (btn) btn.style.display = collapse ? '' : 'none';
    // Leere-Suche-Zustand: bei aktiver Suche ohne Treffer die Meldung + Wunsch-Button zeigen und
    // dessen Ziel-URL mit dem tatsächlich gesuchten Begriff (URL-encodiert) vorbereiten.
    const empty = this.refs.steps.querySelector('[data-ttg="motif-empty"]');
    if (empty) {
      const noHits = nq !== '' && matches.length === 0;
      empty.hidden = !noHits;
      if (noHits) {
        const cta = empty.querySelector('[data-ttg="motif-empty-cta"]');
        if (cta) cta.setAttribute('href', this._raceRequestUrl(q));
      }
    }
  }
  /**
   * Leere-Suche-Zustand für GENAU DIESEN Bucket auflösen. Kaskade von stark nach
   * schwach: Gruppe → Motiv-Schritt → Engine-Default. Sie gilt für den Schalter
   * genauso wie für die Texte.
   *
   * Maßgeblich ist die Gruppe, in der TATSÄCHLICH gesucht wird — nicht die erste
   * und nicht die beim Öffnen voreingestellte. Deshalb nimmt die Funktion die
   * Bucket-Definition entgegen statt sich selbst eine zu suchen: `def` kommt aus
   * `_bucketDef(this.state.bucket)`, und `state.bucket` ist der offene Bucket.
   * Ein Bucket trägt immer höchstens eine Gruppe (belegt 02.08. über alle 40
   * Configs), also gibt es hier nichts zu mischen.
   *
   * Die Schritt-Ebene steckt bereits im Config-JSON: die beiden race-Keys unter
   * strings werden nur bei echtem Override emittiert (Muster b — Sternchen-Schreibweise
   * hier bewusst vermieden, check-feldkanon.mjs liest sie sonst als eigenes Feld und
   * meldet einen Geistereintrag), und ein `emptySearch.enabled:false` am
   * Schritt lässt die Section `raceRequest: null` schreiben — dann kommt diese
   * Funktion gar nicht erst zum Zug. Ein `enabled:false` an der GRUPPE schaltet
   * dagegen nur diesen einen Bucket ab, der Rest des Schritts bleibt.
   */
  _emptySearchFor(def) {
    const g = (def && def.emptySearch) || {};
    const S = this.config.strings || {};
    const rr = this.config.raceRequest || {};
    return {
      enabled: g.enabled !== false,
      message: g.message || S.race_empty_msg || 'Diese Rasse haben wir leider noch nicht gezeichnet – aber wir zeichnen ständig neue Motive dazu. 🐾',
      ctaLabel: g.ctaLabel || S.race_request_cta || 'Sag uns Bescheid – wir zeichnen deine Rasse',
      textTemplate: g.textTemplate || rr.textTemplate || '',
      placeholder: (def && def.searchPlaceholder) || S.search_ph || 'Suchen …',
    };
  }
  /** Kontextzeile der Vorbefüllung („(Gesucht bei: [PRODUKT] – [STIL])") fällt KOMPLETT
   *  weg, sobald einer der beiden Werte fehlt — sonst bliebe eine halbe Zeile mit
   *  Gedankenstrich und Nichts dahinter stehen. Es fliegt jede Zeile, die einen der
   *  beiden Platzhalter trägt, nicht nur die Vorlage aus der Section; Händler dürfen
   *  ihre eigene Formulierung schreiben. Danach doppelte Leerzeilen einsammeln, damit
   *  keine Lücke bleibt, wo die Zeile stand. */
  _stripContextLine(tmpl) {
    return tmpl.split('\n')
      .filter((l) => l.indexOf('[PRODUKT]') === -1 && l.indexOf('[STIL]') === -1)
      .join('\n')
      .replace(/\n{3,}/g, '\n\n')
      .replace(/\s+$/, '');
  }
  /** Ziel-URL des „Motiv wünschen"-Buttons: Kontaktformular + vorbefüllter Text (Fallback: nur URL). */
  _raceRequestUrl(q) {
    const rr = this.config.raceRequest || {};
    const base = rr.url || '';
    if (!base) return '#';
    const term = (q || '').trim();
    // Vorlage aus derselben Kaskade wie Meldung und CTA — die Gruppe, in der gesucht
    // wurde, darf auch die Vorbefüllung eigenständig formulieren.
    const def = this._bucketDef(this.state.bucket);
    let tmpl = this._emptySearchFor(def).textTemplate;
    if (!tmpl || !term) return base;                 // ohne Vorlage/Begriff: nur das Formular öffnen
    // [PRODUKT] = Produkttitel, [STIL] = wonach in DIESER Gruppe gesucht wird. Der Klartext
    // kommt aus searchLabel der Gruppe, sonst aus den rohen Kategorienamen. Ohne offenen
    // Bucket (theoretisch) bleibt beides leer und die Kontextzeile entfällt.
    const produkt = this.config.productTitle || '';
    const stil = (def && (def.searchLabel || (def.searchCategories || []).join(', '))) || '';
    if (!produkt || !stil) tmpl = this._stripContextLine(tmpl);
    // Vier Platzhalter, nacheinander auf demselben String: [RASSE] ist kanonisch (so stehen
    // die bestehenden Vorlagen da), {SUCHBEGRIFF} ist der neutrale Alias für Konfiguratoren,
    // in denen nicht nach Rassen gesucht wird — beide → gesuchter Begriff.
    const body = tmpl
      .split('[RASSE]').join(term)
      .split('{SUCHBEGRIFF}').join(term)
      .split('[PRODUKT]').join(produkt)
      .split('[STIL]').join(stil);
    const sep = base.indexOf('?') === -1 ? '?' : '&';
    return base + sep + 'ttg_msg=' + encodeURIComponent(body);
  }
  /**
   * Fehlertolerantes Motiv-Matching: normalisiertes Label + Synonyme (suchbegriffe),
   * Teilstring beiderseits, sonst Levenshtein-Toleranz (≤1 kurz, ≤2 länger).
   */
  _motifMatches(m, nq) {
    if (!nq) return true;
    if (!m) return false;
    const cands = [m.label];
    if (m.suchbegriffe) String(m.suchbegriffe).split(',').forEach((x) => cands.push(x));
    const maxDist = nq.length <= 4 ? 1 : 2;
    for (const c of cands) {
      const nc = ttgNorm(c);
      if (!nc) continue;
      if (nc.indexOf(nq) !== -1 || nq.indexOf(nc) !== -1) return true;
      if (ttgLev(nq, nc, maxDist) <= maxDist) return true;
    }
    return false;
  }

  /* -------------------------------------------------------- CTA / Handover */
  /**
   * Ist ein Text-Schritt INHALTLICH erfüllt — unabhängig davon, ob der Kunde ihn je
   * bestätigt hat? Tippen füllt `state.texts`, setzt aber bewusst kein `done`
   * (_onTextInput: „Kein Abschluss/Sprung während des Tippens"). Das Bestätigen kam
   * bisher nur über Blur, Enter oder „Weiter" — und ZWEI Wege daran vorbei ließen den
   * Schritt offen, obwohl das Feld gefüllt war (Jens 21.07., blockierte Bestellungen):
   *   1. `_onTextBlur` bricht ab, wenn `_textActionPending` gesetzt ist — genau das
   *      passiert beim Tippen auf „+ Zusätzlicher Text" (pointerdown-Handler).
   *   2. `_confirmText` kehrt für sekundäre Slots früh zurück, ohne den PRIMÄREN
   *      Schritt abzuschließen („Abschluss-Logik nur am primären Schritt").
   * Wer also Wunschtext tippt, den Zusatztext aufklappt, ihn füllt und dann kauft,
   * hatte alles ausgefüllt — und wurde abgewiesen.
   * Bedingung absichtlich WORTGLEICH mit der aus `_confirmText`: keine neue Semantik,
   * nur ein zweiter Ort, an dem sie zählt. Und sie liest `state.texts`, das bei jedem
   * Tastenanschlag geschrieben wird — damit ist der Blur-Zeitpunkt gleichgültig.
   */
  _textFilled(key) {
    const td = this._textDef(key);
    if (!td) return false;
    // Sperrzeichen (Schema v1.36): ein Text mit Platzhalter („[Name]“) gilt NICHT als gefüllt — sonst
    // markierte ihn _commitFilledTexts beim Kaufklick als erledigt, der Schritt klappte zu und die Sperre
    // bliebe für den Kunden unsichtbar (gemessen 23.10.2026, Vorschau Wörterbuch-Kissen).
    if (this._sperrzeichenIn(td)) return false;
    return !!((this.state.texts[td.id] || '').trim() || (td.optional && this.state.noTexts[td.id]));
  }
  /**
   * Steht dieser Text-Schritt dem Kauf im Weg? Nein, wenn er gefüllt ist ODER gar nicht
   * gefordert wird. Ein Schritt, der wörtlich „(optional)" heißt, darf den Kauf nicht
   * blockieren, nur weil der Kunde ihn nicht angetippt hat (Jens 21.07.).
   * Belegt: In ALLEN 16 customizer_config-Metaobjekten ist jeder Text-Schritt optional,
   * keiner trägt default oder defaultNoText — es gibt shopweit keinen einzigen Pflicht-
   * Text, und trotzdem hielt jeder Konfigurator den Kauf an dieser Stelle auf.
   * Der Schritt bleibt im Wizard sichtbar und wird weiter angeboten; er ist nur kein Gate
   * mehr. `required: true` (bzw. `optional: false`) verlangt unverändert eine Eingabe.
   */
  _textStepSatisfied(key) {
    const td = this._textDef(key);
    if (!td) return false;
    // decide (Schema v1.36): optional heißt hier „Kein Text ist erlaubt“, nicht „leer genügt“ —
    // erfüllt erst mit Text oder angehaktem Kästchen (_textFilled zählt beides).
    return (td.optional === true && !td.decide) || this._textFilled(key);
  }
  /** Schritt erledigt ODER (bei Text) gefüllt bzw. nicht gefordert. */
  _stepSatisfied(key) {
    // Foto ist IMMER ein hartes Gate: erfüllt erst mit hochgeladener URL —
    // state.done zählt hier bewusst nicht (ein Klick bestätigt kein fehlendes Foto).
    if (key === 'photo') return this._photoSatisfied();
    // Sperrzeichen (Schema v1.36) schlagen auch ein früheres „erledigt“.
    const sd = this._textDef(key);
    if (sd && this._sperrzeichenIn(sd)) return false;
    return this.state.done[key] === true || this._textStepSatisfied(key);
  }
  /**
   * Gefüllte, aber unbestätigte Text-Schritte übernehmen. Läuft VOR der
   * Vollständigkeitsprüfung im Submit, damit der Wizard-Zustand danach zum
   * tatsächlichen Inhalt passt (sonst zeigte der Schritt weiter „offen", obwohl
   * gekauft wurde). Bewusst ohne Re-Render — mitten im Submit soll nichts umspringen.
   */
  _commitFilledTexts() {
    for (const d of this._stepDefs()) {
      if (!this.state.done[d.key] && this._textFilled(d.key)) this.state.done[d.key] = true;
    }
  }
  /** Motiv ohne Namen (Schema v1.29, Emaille 2b, 14.10.2026): Die Text-Ebene trägt für das gewählte Motiv
   *  `ohneName: true` (layout.overrides._motif.<handle>.<ebene>). Dann entfallen für dieses Motiv Feld,
   *  Pflicht, Vorschau, Vertrag, Warenkorbbild und Property — der Kundenzustand bleibt unangetastet, ein
   *  Wechsel zurück auf ein Motiv mit Namen stellt alles wieder her. Ohne _motif-Overrides sofort false
   *  (alle anderen Configs unverändert). */
  _ohneName(def) {
    const ov = def && this.config.layout && this.config.layout.overrides;
    if (!ov || !ov._motif) return false;
    const l = this._layoutLayers()[def.layer];
    return !!(l && l.ohneName === true);
  }
  /** Text dieses Defs gilt als nicht vorhanden: „Kein Text“ gewählt ODER Motiv ohne Namen. */
  _textAus(def) { return !!this.state.noTexts[def.id] || this._ohneName(def); }
  _ready() {
    // Breitenprüfung (Schema v1.27): ein Text, der auch bei Mindestgröße nicht ins Fenster passt,
    // sperrt den Kauf. _zuLang existiert nur bei Ebenen mit blockOverflow — sonst unverändert.
    if (this._zuLangDef()) return false;
    // Sperrzeichen (Schema v1.36): ein Platzhalter wie „[Name]“ steht noch im Text.
    if (this._sperrDef()) return false;
    // Generisch: alle definierten Schritte müssen erledigt sein.
    // Komplett ausverkaufte Hunderasse sperrt auch ohne Größen-Schritt (Teelichthalter, 19.10.2026).
    if (this._motifAusverkauft()) return false;
    return this._stepDefs().every((d) => this._stepSatisfied(d.key)) && !!this.resolveVariant();
  }
  /** Erster Text-Def, dessen Text bei Mindestgröße nicht ins Fenster passt (oder null). */
  _zuLangDef() {
    if (!this._zuLang) return null;
    return this.texts.find((d) => this._zuLang[d.id] && !this._textAus(d)) || null;
  }
  /** Breitenprüfung je Text-Ebene setzen und den Hinweis unter dem Feld ein-/ausblenden (ohne Re-Render). */
  _setzeZuLang(def, an) {
    if (!this._zuLang) this._zuLang = {};
    if (!!this._zuLang[def.id] === an) return;
    this._zuLang[def.id] = an;
    const steps = this.refs && this.refs.steps;
    if (steps) {
      const alt = steps.querySelector(`[data-ttg="zu-lang"][data-def-id="${def.id}"]`);
      if (alt) alt.remove();
      const inp = steps.querySelector(`[data-field="text"][data-def-id="${def.id}"]`);
      if (an && inp) inp.insertAdjacentHTML('afterend', this._zuLangHtml(def));
    }
    if (this.refs && this.refs.live && an) this.refs.live.textContent = this._zuLangText();
  }
  _zuLangText() {
    return (this.config.strings && this.config.strings.err_text_zu_lang) || 'Dein Text ist für dieses Motiv zu lang – bitte kürzen.';
  }
  _zuLangHtml(def) {
    return `<p class="ttg-motif-cataloghint ttg-zu-lang" role="alert" data-ttg="zu-lang" data-def-id="${escapeHtml(def.id)}">${escapeHtml(this._zuLangText())}</p>`;
  }
  /** Sperrzeichen (Schema v1.36): steht ein Zeichen aus def.blockChars im (wirksamen) Text? */
  _sperrzeichenIn(def) {
    if (!def || !def.blockChars || this._textAus(def)) return false;
    const v = this.state.texts[def.id] || '';
    for (const ch of def.blockChars) if (v.indexOf(ch) !== -1) return true;
    return false;
  }
  /** Erster Text-Def mit Sperrzeichen im Text (oder null). Ohne blockChars an keinem Def: immer null. */
  _sperrDef() {
    return this.texts.find((d) => this._sperrzeichenIn(d)) || null;
  }
  _sperrText(def) {
    return (def && def.blockMessage) || 'Bitte ersetze den Platzhalter';
  }
  _sperrHtml(def) {
    return `<p class="ttg-motif-cataloghint ttg-zu-lang" role="alert" data-ttg="sperre" data-def-id="${escapeHtml(def.id)}">${escapeHtml(this._sperrText(def))}</p>`;
  }
  /** Hinweis unter dem Feld nachführen, ohne den Schritt neu zu rendern (läuft in renderPreview). */
  _setzeSperre(def) {
    const steps = this.refs && this.refs.steps;
    if (!steps || !def || !def.blockChars) return;
    const an = this._sperrzeichenIn(def);
    const alt = steps.querySelector(`[data-ttg="sperre"][data-def-id="${def.id}"]`);
    if (!!alt === an) return;
    if (alt) alt.remove();
    const inp = steps.querySelector(`[data-field="text"][data-def-id="${def.id}"]`);
    if (an && inp) inp.insertAdjacentHTML('afterend', this._sperrHtml(def));
    if (this.refs.live && an) this.refs.live.textContent = this._sperrText(def);
  }
  /** Erster noch nicht erledigter Schritt in Wizard-Reihenfolge (oder null). */
  _firstIncomplete() {
    return this._stepDefs().find((d) => !this._stepSatisfied(d.key)) || null;
  }
  /**
   * WARUM der Kauf gerade nicht geht — zwei fachlich verschiedene Fälle, die
   * NICHT vermischt werden dürfen:
   *   { key, msg }              → ein Schritt ist offen (Feld fehlt)
   *   { key, msg, variant:true} → alle Schritte erledigt, aber die gewählte
   *                               Kombination existiert nicht (z. B. Miltec:
   *                               XS gibt es nur in Schwarz). Hier fehlt KEIN
   *                               Feld — der Kunde hat alles ausgefüllt.
   * Null = alles in Ordnung.
   */
  _blockReason() {
    // Alle Werte der Farb-/Basis-Achse ausverkauft (Schema v1.32, nur mit hideSoldOut).
    if (this._baseAllesAusverkauft()) return { key: 'color', msg: 'Leider ausverkauft' };
    const zl = this._zuLangDef();
    if (zl) return { key: this._stepKeyForDef(zl), msg: this._zuLangText() };
    const sp = this._sperrDef();
    if (sp) return { key: this._stepKeyForDef(sp), msg: this._sperrText(sp) };
    // Komplett ausverkaufte Hunderasse (Deep-Link): ehrlicher Grund statt „Ausführung: das fehlt noch“.
    if (this._motifAusverkauft()) return { key: 'motif', msg: this._ausverkauftText() };
    const miss = this._firstIncomplete();
    const S = this.config.strings || {};
    if (miss) {
      // Titel kommen aus der Config und haben JEDE Form: Substantiv („Größe"),
      // Imperativ („Druckfarbe ändern"), Satz („Dein persönlicher Wunschtext
      // (optional)"). Deshalb der Titel als Präfix vor einem eigenständigen Satz —
      // eine Vorlage wie „{field} fehlt noch" bricht bei Imperativen grammatisch
      // („Druckfarbe ändern fehlt noch"). Wortlaut von Jens: warm und knapp.
      const tpl = S.err_missing || '{field}: das fehlt noch';
      return { key: miss.key, msg: tpl.replace('{field}', miss.title || '') };
    }
    if (!this.resolveVariant()) {
      // Markiert wird die letzte bildgebende/variantenrelevante Achse — dort trifft
      // der Kunde die Wahl, die die Kombination unmöglich macht (meist die Größe).
      const defs = this._stepDefs();
      const axis = defs.find((d) => d.key === 'size')
        || defs.slice().reverse().find((d) => d.key === 'color' || String(d.key).indexOf('vo:') === 0)
        || defs[defs.length - 1];
      return {
        key: axis ? axis.key : null,
        msg: S.err_variant || 'Diese Kombination ist leider nicht verfügbar.',
        variant: true,
      };
    }
    return null;
  }
  /**
   * Klick auf den (bewusst klickbaren) CTA bei unvollständiger Konfiguration:
   * Schritt rot markieren, Meldung dort anzeigen, hinscrollen, vorlesen.
   * Ersetzt das frühere stille `disabled` — der Kunde erfährt jetzt, WAS fehlt.
   */
  _flagBlocked() {
    const r = this._blockReason();
    this._invalid = r;
    if (!r) { this.renderSteps(); return; }
    // Fehlt ein PFLICHTSCHRITT (kein Varianten-Konflikt): „In den Warenkorb" ist das
    // Signal, dass der Kunde fertig konfiguriert hat. Alle davor liegenden, verlassbaren
    // Schritte — insbesondere ein übersprungener optionaler Textschritt — gelten damit als
    // bestätigt. Erst dadurch wird der markierte Schritt zum aktiven Schritt und klappt auf
    // (statt nur rot und zugeklappt zu bleiben, bis der Kunde das Namensfeld berührt).
    // Gleiche Semantik wie der goto-Handler beim Vorwärtstippen; verändert keinen Wert
    // (getippter Text bleibt in state.texts, getProperties liest nie state.done).
    if (!r.variant) {
      for (const d of this._stepDefs()) {
        if (d.key === r.key) break;
        if (this._canLeave(d.key)) this.state.done[d.key] = true;
      }
    }
    this.renderSteps();                       // rendert Markierung + Meldung mit
    // renderSteps() baut die Schritte komplett neu — eine LAUFENDE Motiv-Suche ginge
    // dabei verloren (das Suchfeld rendert ohne value-Attribut, das Grid ungefiltert).
    // Vorher konnte das nicht passieren: der gesperrte Knopf schluckte den Klick.
    // Bewusst ohne den Fokus-Teil von _restoreMotifSearch — der Fokus gehört an die
    // Meldung, nicht zurück ins Suchfeld.
    if (this._motifQuery && this.state.bucket === this._motifQueryBucket) {
      const si = this.refs.steps && this.refs.steps.querySelector('[data-field="motifSearch"]');
      if (si) { si.value = this._motifQuery; this._onMotifSearch(this._motifQuery); }
    }
    if (this.refs.live) this.refs.live.textContent = r.msg;   // aria-live (vorhandener Announcer)
    const card = this.refs.steps && this.refs.steps.querySelector('.ttg-card--invalid');
    if (card) {
      // NICHT die Karte zentrieren: mit aufgeklapptem Motiv-Grid ist sie um ein
      // Vielfaches höher als der Bildschirm, und block:'center' schöbe dann genau den
      // Kartenkopf — mitsamt der Meldung — weit über den oberen Bildrand hinaus. Der
      // Kunde sähe einen unerklärten Sprung mitten ins Grid und gar keine Meldung.
      // Deshalb die Meldung selbst anspringen; den Sticky-Header des Themes hält
      // scroll-margin-top im CSS frei.
      const anchor = card.querySelector('.ttg-card__err') || card;
      try { anchor.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { anchor.scrollIntoView(); }
      anchor.setAttribute('tabindex', '-1');
      try { anchor.focus({ preventScroll: true }); } catch (e) { /* egal */ }
    }
  }
  // Button-Text ist fix ("In den Warenkorb legen"); nur Zustand + Sticht-Sichtbarkeit.
  _updateCta() {
    const ok = this._ready();
    // Der Button bleibt KLICKBAR (kein `disabled`) — sonst kann er keine Meldung
    // geben, und Screenreader überspringen ihn. `aria-disabled` kommuniziert den
    // Zustand, ohne den Klick zu verschlucken; der Klick landet in `_submit()`,
    // das bei unvollständiger Konfiguration `_flagBlocked()` auslöst.
    const alleWeg = this._baseAllesAusverkauft();   // Schema v1.32: kein Warenkorb-Knopf, wenn alles ausverkauft
    [this.refs.addBtn, this.refs.stickyBtn].forEach((b) => {
      if (!b) return;
      b.disabled = false;
      b.setAttribute('aria-disabled', ok ? 'false' : 'true');
      b.classList.toggle('ttg-add--blocked', !ok);
      if (alleWeg) b.hidden = true;
    });
    // Sticky-CTA IMMER sichtbar (Jens 21.07.): ein Knopf, der auf dem Handy
    // auftaucht und verschwindet, irritiert — er gibt jetzt ohnehin Auskunft.
    if (this.refs.sticky) this.refs.sticky.classList.add('is-visible');
  }

  _setQty(n) {
    if (!Number.isFinite(n) || n < 1) n = 1;
    if (n > 999) n = 999;
    this.state.quantity = n;
    if (this.refs.qtyInput && this.refs.qtyInput.value !== String(n)) this.refs.qtyInput.value = String(n);
    this.emit('quantityChanged', n);
  }

  getVariantId() { const v = this.resolveVariant(); return v ? v.id : null; }

  /**
   * defaultBy anwenden (config.printDefaultBy = {optionName, map:{wert→hex}}):
   * setzt die Druckfarbe auf den Map-Wert des aktuell gewählten Optionswerts,
   * solange der Kunde sie nicht selbst gewählt hat (_printTouched). Ohne
   * Map-Treffer fällt sie auf defaults.druckfarbe zurück. changedOption
   * begrenzt den Aufruf auf Wechsel der konfigurierten Option (Aufrufe von
   * anderen Options-Wechseln sind No-Ops); ohne Argument (Konstruktor) wird
   * immer angewendet.
   */
  _applyPrintDefaultBy(changedOption) {
    const db = this.config.printDefaultBy;
    // Eine einzige Palettenfarbe: nichts zu mappen. Ohne diesen Riegel könnte die
    // defaultBy-Map (oder ihr defaults.druckfarbe-Fallback) eine Farbe setzen, die
    // gar nicht in der Palette steht — die Vorschau zeigte dann eine andere Farbe,
    // als gedruckt wird.
    if (this._printSingleOption()) return;
    if (!db || !db.optionName || this._printTouched) return;
    if (this._urlPrintHex) return;                        // ?ttg-druckfarbe hält bis zur Kundenwahl
    if (changedOption && changedOption !== db.optionName) return;
    const val = this._selectedOptionValue(db.optionName);
    // Normalisiert (31.07.): die Maps tragen teils Slugs, teils Hex. Der inline-
    // Zweig der Section löst Slugs zur Renderzeit auf, der Palette-Zweig kann das
    // nicht — ein roher Slug landete sonst als state.druckfarbe und keine
    // Hex-Suche (Property, Maske, Aufpreis) hätte ihn je wiedergefunden.
    // Unbekannt → null → die bisherige Fallback-Kette darunter greift wie zuvor.
    const mapped = (db.map && val != null) ? this._normalizePrintRef(db.map[val]) : null;
    const next = mapped
      || (this.config.defaults && this.config.defaults.druckfarbe)
      || this.state.druckfarbe;
    if (next && next !== this.state.druckfarbe) {
      this.state.druckfarbe = next;
      this.emit('printChanged', next);
    }
  }

  /**
   * Druckfarben-Eintrag zu einem value-String des druckfarbe-Steps auflösen
   * (z. B. "schwarz" → { name: "Schwarz", hex: "#000000", value: "schwarz" }).
   * Die Section emittiert `value` seit 31.07. an jedem printColors-Eintrag; der
   * Wert ist derselbe, den die customizer_config-Option trägt. Kein Mapping und
   * keine Namens-Heuristik: verglichen wird ausschließlich gegen die Farbliste
   * DIESES Produkts. Unbekannt (oder Config noch ohne `value`) → null; der
   * Aufrufer entscheidet dann bewusst, was gilt.
   */
  resolvePrintValue(value) {
    if (!value) return null;
    const v = String(value);
    return (this.config.printColors || []).find((p) => p.value === v) || null;
  }

  /**
   * Druckfarben-Referenz auf EINE interne Form bringen: Hex aus der Farbliste
   * dieses Produkts. Zwei Wertformen sind im Umlauf (Jens 31.07.) — die
   * defaultBy-Maps der Metaobjekte tragen teils Slugs ("weiss"), teils Hex
   * ("#ffffff"), und das crosssell_config nutzt durchgehend Slugs. Ohne
   * gemeinsame Form verglichen, greift die Präzedenz still nicht.
   * Der inline-Zweig der Section löst Slugs zwar schon zur Renderzeit auf, der
   * Palette-Zweig kann das aber NICHT (dort gibt es keine options-Liste) — ein
   * Slug käme dann roh hier an. Genau dagegen steht dieser Normalisierer.
   * Hex außerhalb der Liste bleibt erhalten (die Maske färbt per Hex direkt);
   * ein unbekannter Slug ergibt null, damit der Aufrufer ihn ignorieren kann,
   * statt einen unbrauchbaren Wert in den State zu schreiben.
   */
  _normalizePrintRef(ref) {
    if (ref == null || ref === '') return null;
    const r = String(ref).trim();
    if (!r) return null;
    if (r.charAt(0) === '#') {
      const hit = (this.config.printColors || []).find((p) => String(p.hex).toLowerCase() === r.toLowerCase());
      return hit ? hit.hex : r;
    }
    const byValue = this.resolvePrintValue(r);
    return byValue ? byValue.hex : null;
  }

  /**
   * Hex der produkteigenen defaultBy-Regel für die AKTUELL gewählte Textilfarbe.
   * null, wenn das Ziel für genau diesen Wert keine Regel hat (oder gar keine
   * defaultBy-Map trägt) — dann darf eine festgeschriebene Druckfarbe greifen.
   */
  _printDefaultByHex() {
    const db = this.config.printDefaultBy;
    if (!db || !db.optionName || this._printSingleOption()) return null;
    const val = this._selectedOptionValue(db.optionName);
    if (val == null || !db.map) return null;
    return this._normalizePrintRef(db.map[val]);
  }

  /**
   * Druckfarbe einer Cross-Sell-Karte/-Zeile — VERBINDLICHE Präzedenz (Jens 31.07.):
   *   1. defaultBy des Zielprodukts für die konkret gewählte Textilfarbe
   *   2. feste `druckfarbe` des crosssell_config-Items (value-String)
   *   3. Vererbung vom Hauptprodukt
   * Begründung für Rang 1: t-shirt, hundesportweste-miltec und die Hoodies tragen
   * defaultBy-Maps. Ein fester Wert, der die schlägt, macht Grau/Azalea/Weiß
   * (Shirt), Sahara (Mil-Tec) und Weiß/Grau-Melange (Hoodie) unlesbar. Die drei
   * Warnwesten haben kein defaultBy — dort gewinnt der feste Wert.
   * EINE Quelle für beide Oberflächen: Kartenvorschau und Warenkorb-Property
   * rufen exakt diese Funktion, damit sie nicht auseinanderlaufen können.
   * Erwartet Farbe/Optionen bereits im State (Reihenfolge wie im Konstruktor).
   */
  resolveXsellPrintHex(opts) {
    const o = opts || {};
    const byRule = this._printDefaultByHex();                       // 1
    if (byRule) return byRule;
    if (o.fixed) {                                                  // 2
      const hit = this.resolvePrintValue(o.fixed);
      if (hit) return hit.hex;
      console.warn('[ttg-engine] feste Druckfarbe "' + o.fixed + '" im Ziel unbekannt — Ziel-Default bleibt');
      return this.state.druckfarbe;
    }
    const inh = o.inherited;                                        // 3
    if (inh && (this.config.printColors || []).some((p) => p.hex === inh)) return inh;
    return this.state.druckfarbe;
  }

  /**
   * Sichtbare + versteckte Line-Item-Properties (Schema laut Briefing).
   *
   * `leerBenennen` (Vorgabe an): Ein optionaler Text-Schritt, den der Kunde leer
   * lässt, geht als „Kein Text" hinaus statt zu fehlen — siehe den Kommentar am
   * Text-Zweig unten. Der Cross-Sell schaltet das AUS: dort gibt es keinen
   * Konfigurator, sondern ein einzelnes Feld im Popup. Ein „Kein Text" auf den
   * übrigen Zeilen wäre dort eine Aussage über Felder, die der Kunde nie gesehen
   * hat (die Fußmatte „Hier wohnt" führt vier Textzeilen, das Popup eine).
   */
  getProperties({ leerBenennen = true } = {}) {
    const s = this.state;
    const font = this._fontDef(s.font);
    const print = this.config.printColors.find((p) => p.hex === s.druckfarbe);
    // Whitelist: config.sendProperties (logische Keys) bestimmt, WAS gesendet wird.
    // Fehlt sie → alles wie bisher (Warnweste unberührt). Fixe Werte (z. B. Schrift/
    // Druckfarbe der Fußmatte) lassen sich so aus dem Warenkorb heraushalten.
    const allow = Array.isArray(this.config.sendProperties) ? this.config.sendProperties : null;
    const want = (key) => !allow || allow.indexOf(key) !== -1;
    const props = {};
    // Base-Vorlage-Property nur bei mehreren Vorlagen (produktionsrelevant, z. B. bellt/bellen).
    const baseOpts = this._baseOptions();
    if (want('base') && baseOpts.length > 1) props[this.config.propertyKeys.base || 'Auswahl'] = (baseOpts[s.baseChoice] || baseOpts[0]).label || '';
    // Farb-Property nur, wenn eine Farbe gewählt wurde (Produkte ohne Farboption: weglassen).
    if (want('color') && s.color) props[this.config.propertyKeys.color || 'Westenfarbe'] = s.color;
    // Basis-Achse heißt selbst „Größe“ (Schema v1.34, Geldbörse Groß/Klein): eine leere Größe ohne eigenen
    // Größen-Schritt überschreibt die schon gesetzte Farb-/Basis-Property nicht mit null. Ohne Namensgleichheit unverändert.
    const sizeKey = this.config.propertyKeys.size || 'Größe';
    if (want('size') && !(s.size == null && props[sizeKey] != null)) props[sizeKey] = s.size;
    // Zusätzliche Varianten-Optionen (z. B. Schnitt): eigene Property je Option.
    // Whitelist-Key = Schritt-id ('schnitt'); Property-Name aus der Config.
    for (const xo of this.extraOptions) {
      const xval = s.options[xo.optionName];
      if (want(xo.id) && xval) props[xo.property || xo.optionName] = xval;
    }
    // Motivseite (config.sides): produktionskritische, SICHTBARE Property (wo gedruckt
    // wird). Bewusst NICHT in _ttg_variant_props — sie ist keine Varianten-Dublette,
    // sondern eine echte Angabe, die im Warenkorb stehen bleiben muss.
    if (this.config.sides && want('side') && s.side) {
      props[this.config.sides.property || this.config.sides.optionName || 'Motivseite'] = s.side;
    }
    // Text: der logische Whitelist-Key 'text' deckt ALLE Text-Schritte ab. Jeder Def
    // emittiert sein eigenes property — Ein-Text wie Mehrfach-Text nach derselben
    // Regel (siehe unten). Bis 02.09.2026 liefen die beiden Formen hier auseinander.
    if (want('text')) {
      // strings-Guard: der Zugriff lief frueher NUR im Legacy-Zweig und damit selten;
      // hier oben trifft er jede Config — auch Teil-Configs ohne strings (Tests, Dose).
      const keinText = (this.config.strings || {}).no_text || 'Kein Text';
      for (const def of this.texts) {
        if (this._ohneName(def)) continue;       // Motiv ohne Namen: keine Wunschtext-Property
        const key = def.property || this.config.propertyKeys.text || 'Wunschtext';
        const val = s.texts[def.id] || '';
        const off = !!s.noTexts[def.id];
        // „Ohne Wunschtext bestellt" wird BENANNT statt weggelassen (Jens, 02.09.2026).
        // Vorher hing die Property am Weg: Kästchen angehakt schrieb (nur im Legacy-
        // Pfad) „Kein Text", Feld einfach leer gelassen schrieb NICHTS — beides
        // derselbe Kundenwille, zwei verschiedene Bestellzeilen. Der Admin sah im
        // zweiten Fall nur eine Zeile, an der „Wunschtext" fehlte, und musste aus
        // dieser Abwesenheit schließen. Jetzt entscheidet allein der Zustand:
        // kein Text am Ende → „Kein Text", egal wie der Kunde dorthin kam.
        //
        // Gegattert am Kästchen (_noTextChoiceVisible), nicht an `optional` allein:
        // Nur wo der Kunde die Wahl SEHEN konnte, ist sie auch eine Aussage.
        if (val.trim() && !off) props[key] = val;
        else if (leerBenennen && this._noTextChoiceVisible(def)) props[key] = def.noTextValue || keinText;
        // Pflicht-Text ohne Kästchen (z. B. Fußmatte required:true): unverändert der
        // Leerwert, den der Adapter verwirft — dieser Fall ist ohnehin nicht kaufbar.
        else if (def._legacy) props[key] = off ? keinText : val;
      }
    }
    if (want('motif')) {
      // Motiv-Label + bei mehreren Bildern die eindeutige Variantenkennung (druckkritisch).
      let mval = s.noMotif ? (this.config.strings.no_motif || 'Kein Motiv') : (s.motif ? s.motif.label : '');
      const imgs = s.motif && !s.noMotif ? this._motifImages(s.motif) : [];
      if (imgs.length > 1) {
        const idx = s.motifVariant || 0;
        const img = imgs[idx] || imgs[0];
        const ref = img.id || this._fileNameFromUrl(img.url);
        mval += ` — Variante ${idx + 1}` + (ref ? ` [${ref}]` : '');
      }
      props[this.config.propertyKeys.motif || 'Motiv'] = mval;
    }
    // Schrift-Property nur, wenn der Schrift-Schritt gerade relevant ist (bei
    // komplett leeren Texten ist er übersprungen → keine irreführende Property).
    // Feste Schrift OHNE Schrift-Schritt (Schema v1.17, z. B. Handtuch: text-Step
    // mit font, kein choice-Step "schrift"): Die Property nennt die tatsächlich
    // gerenderte feste Schrift statt des wirkungslosen globalen Defaults — die
    // Fertigung braucht den echten Wert am Line-Item. Produkte MIT Schrift-
    // Schritt und Produkte ohne feste Schrift bleiben byte-identisch.
    let fontProp = font ? font.label : '';
    if (!this._fontStepConfigured()) {
      const fixed = this.texts.find((t) => t.font && !this._ohneTextEbene(t));
      if (fixed) { const fd = this._fontDef(fixed.font); if (fd) fontProp = fd.label; }
    }
    if (want('font') && !(this._fontStepConfigured() && !this._fontRelevant())) props[this.config.propertyKeys.font || 'Schrift'] = fontProp;
    // Druckfarben-Property nur, wenn der Schritt gerade relevant ist (bei einem
    // Vollfarb-Motiv ist er übersprungen → keine irreführende Druckfarbe auf dem
    // Produktionsauftrag). Gleiche Bedingung wie beim Schrift-Schritt darüber.
    // OHNE print-Step (20.10.2026, Jens): keine Druckfarbe am Line-Item — weder
    // sichtbar noch „_… Hex". Vorher landete dort der wirkungslose Default
    // („Druckfarbe: Schwarz" bei Pop-Art-/Weihnachtstasse und -kissen). Kein
    // Verbraucher liest die Properties (Renderer nimmt die Farbe aus dem Vertrag).
    // Ein Swatch-Schritt mit EINER Farbe bleibt print-Step (_printSingleOption
    // blendet nur die Anzeige aus) → dort unverändert.
    if (want('print') && this._printStepConfigured() && this._printRelevant()) {
      const printKey = this.config.propertyKeys.print || 'Druckfarbe';
      props[printKey] = print ? print.name : s.druckfarbe;
      // VERSTECKTE Schwester-Property mit dem Hex-Wert (19.08.2026). Der Kunde
      // sieht weiterhin nur „Druckfarbe: Navy" — Shopify blendet Line-Item-
      // Properties mit führendem „_" in Storefront, Warenkorb und Bestätigung aus
      // und zeigt sie nur im Admin und in Exporten. Genau dort braucht die
      // Fertigung den exakten Ton: „Navy" ist ein Name, #163243 ist die Vorgabe.
      //
      // Quelle ist state.druckfarbe (der Hex der gewählten Option, = swatch der
      // Config), NICHT das cartLabel: das Label ist Anzeigetext und darf sich
      // ändern, ohne dass der Produktionswert mitwandert. Der Regex hält reine
      // Namensfälle heraus — trägt eine Config statt eines Hex einen Farbnamen,
      // stünde in der versteckten Property sonst dasselbe wie in der sichtbaren.
      if (/^#[0-9a-f]{3,8}$/i.test(String(s.druckfarbe || ''))) props['_' + printKey + ' Hex'] = s.druckfarbe;
    }
    // Akzentfarbe (Schema v1.35): eigene sichtbare Property + versteckter Hex, nur mit config.accent
    // und Schritt 'akzent' in der Schrittliste.
    if (s.akzentfarbe && this._stepOrder().indexOf('akzent') !== -1) {
      const ak = this._akzentFarben().find((c) => c.hex === s.akzentfarbe);
      const akKey = (this.config.accent && this.config.accent.property) || 'Akzentfarbe';
      props[akKey] = ak ? ak.name : s.akzentfarbe;
      if (/^#[0-9a-f]{3,8}$/i.test(String(s.akzentfarbe))) props['_' + akKey + ' Hex'] = s.akzentfarbe;
    }
    // versteckt: Motiv-Referenz für die Produktion — an das Motiv-Property gekoppelt.
    if (want('motif')) {
      props['_motiv_id'] = s.motif ? (s.motif.gid || s.motif.id) : '';
      let cur = s.motif && !s.noMotif ? this._currentMotifImage() : null;
      // Rasse-Varianten-Motive: das Bild der GEWÄHLTEN Variante (Ausführung), nicht das Kachelbild.
      if (cur && this._motifAchse()) { const rv = this.resolveVariant(); if (rv && rv.image) cur = { url: rv.image, id: null }; }
      if (cur) {
        props['_motiv_bild'] = cur.id || this._fileNameFromUrl(cur.url);
        // Produktions-Basisname (ohne UUID-Suffix/Endung) — im Admin/Produktions-
        // auftrag lesbar, im Shop-Warenkorb versteckt (Unterstrich-Prefix).
        const basename = this._motifBaseName(cur.url || this._fileNameFromUrl(cur.url));
        if (basename) props['_motiv_datei'] = basename;
      }
    }
    // Farbe/Größe duplizieren die Varianten-Option → im Warenkorb ausgeblendet
    // (Property bleibt fürs Fulfillment erhalten). Die Cart-Anzeige liest diese
    // Liste und überspringt genau diese Property-Keys. Nur Anzeige, nicht Cart-Daten.
    const variantProps = [];
    if (want('color') && s.color) variantProps.push(this.config.propertyKeys.color || 'Westenfarbe');
    if (want('size') && s.size) variantProps.push(this.config.propertyKeys.size || 'Größe');
    for (const xo of this.extraOptions) {
      if (want(xo.id) && s.options[xo.optionName]) variantProps.push(xo.property || xo.optionName);
    }
    if (variantProps.length) props['_ttg_variant_props'] = variantProps.join('|');
    // Blatt-Druckvertrag (Schema v1.26, 07.10.2026, Kissen): config.print ist
    // der generische Druckvertrag OHNE Bindung an einen Foto-Schritt — Motiv-
    // und Textprodukte brauchen ihn genauso wie Foto-Produkte. Ist der Block
    // gesetzt, gehoert ihm der Vertrag allein; der Foto-Zweig darunter schweigt,
    // sonst hingen zwei Vertraege (oder zwei Formen unter einem Namen) an der
    // Zeile. Die Config ist zugleich das Opt-in: kein sendProperties-Key noetig.
    // Ohne config.print aendert sich nichts — alle Bestandsprodukte byte-gleich.
    const printCfg = (this.config.print && typeof this.config.print === 'object') ? this.config.print : null;
    if (printCfg) {
      const roh = printCfg.contractKey;
      if (typeof roh === 'string' && /^_ttg_[a-z0-9_]+_config$/.test(roh.trim())) {
        const bc = this._blattDruckConfig();
        if (bc) props[roh.trim()] = JSON.stringify(bc);
      } else {
        // Kein Default-Name wie beim Foto-Zweig: ein Blatt-Vertrag unter einem
        // geratenen Namen landete auf einer fremden Renderer-Strecke.
        console.warn('[ttg] print.contractKey fehlt oder ist ungueltig (Form _ttg_<name>_config):', roh);
      }
    }
    // Druckvertrag der Foto-Matte (Schema v1.18): NUR mit config.photo, gewähltem
    // Foto UND Server-URL — die Bestellung trägt sonst keinen ladbaren Verweis.
    // Whitelist-Key 'photo' (sendProperties der Foto-Produkte führen ihn).
    if (!printCfg && this.config.photo && want('photo') && this._photoSatisfied()) {
      // Vertragsname aus der Config (Schema v1.20): config.photo.contractKey
      // benennt die Property, unter der der Druckvertrag an der Cart-Linie
      // haengt. Ohne den Schluessel bleibt es _ttg_foto_config — jedes
      // Bestandsprodukt schreibt damit byte-gleich weiter.
      //
      // Streng gefiltert: NUR _ttg_<klein/ziffern/_>_config. Ein Tippfehler
      // darf keine beliebige (womoeglich fuer den Kunden SICHTBARE) Property
      // erzeugen; faellt der Name durch, gilt der Default statt zu raten.
      const roh = this.config.photo.contractKey;
      const key = (typeof roh === 'string' && /^_ttg_[a-z0-9_]+_config$/.test(roh.trim()))
        ? roh.trim() : '_ttg_foto_config';
      if (typeof roh === 'string' && key !== roh.trim()) {
        console.warn('[ttg] contractKey verworfen (Form _ttg_<name>_config erwartet):', roh);
      }
      // Dosen-Vertrag (Schema v1.20) sobald config.photo.blatt gesetzt ist —
      // eigene Geometrie, KEINE Mattenmasse. Ohne blatt unveraendert der
      // Matten-Vertrag.
      const fc = this.config.photo.blatt ? this._dosenDruckConfig() : this._fotoDruckConfig();
      if (fc) props[key] = JSON.stringify(fc);
    }
    // Motiv-Bonus: per ?ttg-xsell=1 markierte Konfiguration → Bonus-Property an
    // die Cart-Linie. Rein deklarativ — rabattiert wird ausschließlich in der
    // Discount Function (server-seitiger Anker-Check), nie im Client.
    if (this._xsellFlag) props['_ttg_xsell'] = '1';
    // Umweg aus dem Popup (Ziel mit Pflichttext): das Quell-Motiv kommt per &ttg-xsrc und landet wie beim
    // Direkt-Add (composeXsellLine) als _ttg_src_motiv an der Zeile. Ohne es suchte die Function einen Anker
    // zur EIGENEN _motiv_id — bei fremdem Katalog (Fußmatte) nie gefunden, 0 % statt Bonus (gemessen 18.10.2026).
    // Rabattiert wird weiterhin nur, wenn eine echte Ankerzeile mit genau diesem Motiv im Korb liegt.
    if (this._xsellFlag && this._xsellSrc) props['_ttg_src_motiv'] = this._xsellSrc;
    // _vorschau (Railway-Snapshot) folgt in späterem Schritt
    return props;
  }

  /**
   * Druckvertrag _ttg_foto_config v1 (Foto-Fußmatte, Schema v1.18).
   *
   * DRITTER Vertrag neben _ttg_family_config und _ttg_fuesse_config — gleicher
   * Grundsatz: der Renderer (ttg-mattenrender) PLATZIERT NUR, er rechnet nichts.
   * Alle Maße in mm im 600×400-Design-Raum (40×60-Matte; 50×75 skaliert der
   * Renderer über denselben Faktor w_px/600 — exakt wie bei Familie/Fuesse).
   *
   * mm-Abbildung: Die Bühne ist quadratisch, die Matte (3:2) liegt „contain"
   * darin → Prozent-Koordinaten der Layer leben im QUADRAT. _layerBoxPx mit
   * W=H=600 liefert deshalb Stage-mm; die Matte beginnt bei y = (600−400)/2 =
   * 100 mm — dieser Offset wird abgezogen. Voraussetzung (Config-Vertrag der
   * Foto-Produkte): das Basisbild IST der 3:2-Druckhintergrund, randlos.
   *
   * Texte: JE ZEILE ein Eintrag {text, size, x, y} — x = Zeilenmitte, y =
   * vertikale ZEILENMITTE (Renderer-Anker middle/middle), size = die vom
   * Einpassen (_fitFontPx, identisch zu Vorschau UND Snapshot) gelieferte
   * Endgröße in mm. Emojis (❤️🐾) bleiben als ZEICHEN im Text — der Renderer
   * ersetzt sie durch seine Glyphen-Stempel in druckfarbe.hex (fester Vorschub
   * 0,95×size, Konvention wie TTG_EMOJI_GLYPHS). Kundenzeilenumbrüche kommen
   * unverändert als getrennte Zeilen an, nie zusammengefaltet.
   */
  _fotoDruckConfig() {
    const cfg = this.config.photo;
    const p = this.state.photo;
    const layout = this._layoutLayers();
    const photoLayer = this._photoLayer(layout);
    if (!cfg || !p || !photoLayer) return null;
    const DW = 600;                                   // Design-Breite mm (Stage-Kante)
    const offY = (DW - (cfg.designHeightMm || 400)) / 2;   // Letterbox oben (Matte 3:2 → 100)
    const r2 = (v) => Math.round(v * 100) / 100;
    // Größe → Renderer-Schlüssel ("40x60cm" → "40x60"); ohne Treffer null → der
    // Renderer lehnt ab (fail-closed), statt eine falsche Größe zu drucken.
    const sm = String(this.state.size || '').match(/(\d+\s*x\s*\d+)/);
    const size = sm ? sm[1].replace(/\s+/g, '') : null;
    const frameBox = this._layerBoxPx(photoLayer, DW, DW);
    // Texte: gleiche Messstrecke wie Snapshot/Vorschau (_fitFontPx) — bei ref=600
    // sind die gelieferten px-Werte mm. Nur Ebenen mit valign:'middle' (die
    // Foto-Layouts setzen das durchgängig; der Vertrag kodiert Zeilen-MITTEN).
    const texte = [];
    const mctx = (typeof document !== 'undefined')
      ? (document.createElement('canvas').getContext('2d') || null) : null;
    for (const def of this.texts) {
      if (this._textAus(def)) continue;
      if (this._ohneTextEbene(def)) continue;
      const layer = this._textLayer(def);
      if (!layer) continue;
      let content = (this.state.texts[def.id] || '').trim();
      if (!content) continue;
      if (layer.transform === 'uppercase') content = content.toUpperCase();
      const font = this._textFont(def);
      const stack = font ? font.stack : 'sans-serif';
      const segs = this._glyphSegments(content, def) || [{ text: content }];
      // Ohne Canvas (Node-Harness) keine Einpassung möglich → konfigurierte
      // Größe ohne Schrumpfung; der echte Browser-Pfad misst immer.
      let px = ((layer.fontSizePercent || 5) / 100) * DW;
      let lines = this._segLines(segs);
      if (mctx) {
        const fit = this._fitFontPx(mctx, segs, stack, layer, DW);
        px = fit.px; lines = fit.lines;
      }
      const box = this._layerBoxPx(Object.assign({ heightPercent: 0 }, layer), DW, DW);
      const lineH = px * this._lineHeightFor(font);
      const n = Math.max(1, lines.length);
      const vmid = layer.valign === 'middle';
      // vmid: box.top ist die BLOCKMITTE; erste Zeilenmitte liegt (n−1)/2 Zeilen höher.
      // sonst: box.top ist die Oberkante; Zeilenmitte eine halbe Zeile tiefer.
      const firstCenter = vmid ? box.top - ((n - 1) * lineH) / 2 : box.top + lineH / 2;
      // Druck-Schriftschlüssel (Schema v1.19): NUR wenn der Font-Eintrag ein
      // `printKey` trägt. Ohne das Feld bleibt der Vertrag byte-gleich, und der
      // Renderer druckt wie bisher mit seiner Standardschrift.
      const printKey = (font && typeof font.printKey === 'string' && font.printKey.trim())
        ? font.printKey.trim() : null;
      // Drehung nur bei echtem Winkel — sonst entstünde in jedem Bestandsvertrag
      // ein neues Feld.
      const rot = this._layerRotateDeg(layer) || 0;
      // Textfarbe (Schema v1.23, 30.08.2026): NUR wenn die Ebene eine feste
      // `color` trägt — dieselbe Quelle, aus der Vorschau (:3420) und Snapshot
      // (:7566) schon immer färben. Der Druck ließ sie bisher fallen und war
      // fest weiß; auf den dunklen Matten der Designs 1–3 fiel das nicht auf,
      // auf dem hellen Curry von Design 4 schon (weiß 2,47:1 gegen schwarz
      // 8,51:1, gemessen am Druckrender).
      //
      // Bewusst NICHT `def.color || druckfarbe` wie in der Vorschau: das würde
      // Ebenen ohne feste Farbe von Weiß auf die Druckfarbe umstellen und damit
      // Bestandsprodukte ändern. Ohne `color` bleibt das Feld weg, und der
      // Renderer druckt weiter weiß.
      const farbe = this._textColorOf(def);
      const hex = farbe ? this._resolveInk(farbe) : null;
      lines.forEach((ls, i) => {
        const text = ls.map((s) => (s.glyph ? s.emoji : s.text)).join('');
        if (!text.trim()) return;
        const z = {
          id: def.id, text,
          size: r2(px), lineH: r2(lineH),
          x: r2(box.cx), y: r2(firstCenter + i * lineH - offY),
          maxW: r2(box.w), align: 'center',
        };
        if (printKey) z.font = printKey;
        if (hex) z.hex = hex;
        if (rot) z.rotate = rot;
        texte.push(z);
      });
    }
    // Deko-Ebenen (Pfoten, Schnörkel): Box + Drehung + WIRKSAMER Hex —
    // 'inherit' ist zur Bestellzeit aufgelöst, der Renderer schlägt nichts nach.
    const elemente = [];
    for (const l of this._decoLayers()) {
      if (!l.url) continue;
      // previewOnly (Schema v1.19): Mockup-Ebenen, die den KUNDEN die spätere
      // Matte sehen lassen — allen voran der Mattenrand. Sie gehören in
      // Vorschau und Warenkorbbild, aber NIEMALS in die Druckdatei: der Rand
      // ist die physische Matte, nicht Teil des Drucks (dieselbe Festlegung wie
      // in der Familien-Strecke, mattenrender/render.py Kopf). Ohne das Flag
      // ändert sich für Bestands-Ebenen nichts.
      if (l.previewOnly === true) continue;
      const box = this._layerBoxPx(l, DW, DW);
      const y = box.y + (this._layerShiftPct(l) / 100) * box.h;
      const e = {
        key: l.id, url: l.url,
        x: r2(box.x), topY: r2(y - offY), w: r2(box.w), h: r2(box.h),
        rotate: this._layerRotateDeg(l) || 0,
        hex: this._resolveInk((l.color == null || l.color === 'inherit') ? this.state.druckfarbe : l.color),
      };
      // Echtfarbig drucken (Schema v1.19) — das Banner trägt Grauton, weiße
      // Innenlinie und schwarze Pfoten in EINER Datei; eingefärbt wäre es eine
      // einfarbige Silhouette. Vorschau und Snapshot kennen `fullColor` längst,
      // nur der Vertrag hat es bisher verschluckt. `hex` bleibt trotzdem
      // gesetzt: das Gate verlangt es, und der Renderer ignoriert es hier.
      if (l.fullColor === true) e.fullColor = true;
      // Ränder der sichtbaren Tinte (% der Box). Das Banner-PNG füllt nur
      // 92,7 % der Breite und 50,6 % der Höhe — ohne diese Angabe prüfte das
      // Druck-Gate die transparente Box und lehnte ein sauber platziertes
      // Banner ab, dessen Tinte längst innerhalb der Matte liegt.
      const ins = l.inkInset;
      if (ins && typeof ins === 'object') {
        const z = (v) => r2(Number(v) || 0);
        e.inkInset = { left: z(ins.left), top: z(ins.top), right: z(ins.right), bottom: z(ins.bottom) };
      }
      elemente.push(e);
    }
    const print = this.config.printColors.find((c) => c.hex === this.state.druckfarbe);
    const fy = frameBox.y + (this._layerShiftPct(photoLayer) / 100) * frameBox.h;
    return {
      v: 1,
      design: cfg.design || null,
      size,
      druckfarbe: { name: print ? print.name : '', hex: this.state.druckfarbe || '' },
      hintergrund: { url: cfg.printBg || this._currentBaseImage() || '' },
      foto: {
        url: p.url,
        srcW: p.srcW, srcH: p.srcH,
        crop: { x: Math.round(p.crop.x), y: Math.round(p.crop.y), w: Math.round(p.crop.w), h: Math.round(p.crop.h) },
        frame: { x: r2(frameBox.x), y: r2(fy - offY), w: r2(frameBox.w), h: r2(frameBox.h) },
        effPx: Math.round(Math.min(p.crop.w, p.crop.h)),
        freistellung: null,
        // randUeberstand (Schema v1.24, 30.08.2026): erlaubt dem Gate einen
        // Ausschnitt, der ueber die Quelle hinausragt — das passiert, sobald
        // der Kunde unter „Rahmen gefuellt" herauszoomt. Nur bei freigestellten
        // Fotos: dort ist der Rand transparent und es bleibt einfach Matte
        // stehen. Bei den drei Rechteck-Matten druckte derselbe Ueberstand
        // transparente Streifen, wo Foto erwartet wird — deshalb bleibt die
        // Pruefung dort scharf.
        //
        // Der bedingte Spread haelt Bestandsvertraege BYTE-GLEICH: ohne
        // freistellen entsteht der Schluessel gar nicht erst.
        ...(cfg.freistellen === true ? { randUeberstand: true } : {}),
      },
      texte,
      elemente,
    };
  }

  /**
   * Druckvertrag _ttg_dose_config v1 (Foto-Leckerlidose, Schema v1.20).
   *
   * VIERTER Vertrag. Gleicher Grundsatz wie die drei davor: der Renderer
   * PLATZIERT NUR, er rechnet nichts.
   *
   * Unterschied zur Matte, und der Grund fuer einen eigenen Vertrag:
   * Bei der Matte IST das Basisbild die Druckflaeche — Buehne und Matte
   * decken sich, deshalb genuegte dort der feste 600x400-Designraum. Bei der
   * Dose zeigt die Buehne das FOTO DER DOSE; gedruckt wird nur ein Blatt
   * daraus. Buehnenmasse sind hier also keine Millimeter.
   *
   * Aufgeloest wird das mit GENAU EINER realen Zahl, nicht mit einer zweiten
   * Geometriequelle: `config.photo.blatt.buehneBreiteMm` sagt, wie breit die
   * BUEHNE in Wirklichkeit ist. Daraus folgt der Massstab
   *     k = buehneBreiteMm / 600
   * und damit JEDE Strecke — Motivbreite, Foto-Rahmen, Textzeilen, Deko. Die
   * Aufteilung (Motiv / Abstand / Text) kommt unveraendert aus
   * customizer_layout und ist im Layout-Editor verschiebbar, ohne Deploy.
   *
   * Der Bezug auf die BUEHNE statt auf die Ankerebene ist der Grund, warum ein
   * Produkt MEHRERE Designs tragen kann: ein Layout-Override darf die
   * Ankerebene beliebig umbauen, k bleibt davon unberuehrt.
   *
   * Ursprung (0,0) ist die linke obere Ecke des BLATTS, also die linke obere
   * Ecke der Passepartout-Ebene minus `randMm`. Alle Masse im Vertrag sind
   * reale Millimeter in diesem Rahmen.
   *
   * `gesamthoeheMm` ist PRUEFWERT, nicht Steuerwert: der Renderer rechnet die
   * Unterkante aus den absoluten Werten nach und lehnt ab, wenn sie darueber
   * hinauslaeuft. Er leitet daraus NICHTS ab.
   *
   * blatt (config.photo.blatt):
   *   originLayer      id der Passepartout-Ebene (type "deco") — sie ankert das Blatt
   *   designOption     optional: Name der Varianten-Option, deren gewaehlter Wert
   *                    zum `design` des Vertrags wird (mehrere Designs je Produkt).
   *                    Ohne den Schluessel gilt photo.design wie bisher.
   *   buehneBreiteMm   reale Breite der GANZEN Buehne (setzt den Massstab)
   *   randMm           umlaufender Rand (z. B. 3.0)
   *   gesamthoeheMm    Motivoberkante bis Textunterkante (75.00), PRUEFWERT
   */
  _dosenDruckConfig() {
    const cfg = this.config.photo;
    const bl = cfg && cfg.blatt;
    const p = this.state.photo;
    const layout = this._layoutLayers();
    const photoLayer = this._photoLayer(layout);
    if (!cfg || !bl || !p || !photoLayer) return null;
    const alleDeco = this._decoLayers();
    const pp = alleDeco.find((l) => l.id === bl.originLayer);
    if (!pp || !pp.url) return null;                  // ohne Anker kein Blatt
    const DW = 600;
    const r2 = (v) => Math.round(v * 100) / 100;
    const rand = Number(bl.randMm) || 0;
    // Massstab DESIGNUNABHAENGIG: buehneBreiteMm sagt, wie breit die ganze
    // Buehne in Wirklichkeit ist. k haengt damit an nichts, was ein
    // Layout-Override verschieben koennte.
    //
    // Die Vorfassung leitete k aus blatt.motivBreiteMm / Buehnenbreite der
    // Ankerebene ab. Das trug genau EIN Design: sobald ein Override die
    // Ankerebene schmaler machte (Pfotendesign 61,82 statt 70,60 %), blieb
    // motivBreiteMm stehen und k sprang von 1/6 auf 0,19034 — der ganze
    // Bogen kam 14,2 % zu gross heraus (gemessen 28.08.2026, vom eigenen
    // Unterkanten-Gate abgefangen). motivBreiteMm ist deshalb ersatzlos weg;
    // die echten Breiten kommen ab jetzt aus der EBENE.
    const buehneB = Number(bl.buehneBreiteMm) || 0;
    const ppBox = this._layerBoxPx(pp, DW, DW);
    if (!(ppBox.w > 0) || !(buehneB > 0)) return null;
    const k = buehneB / DW;                            // reale mm je Buehnen-mm
    // Designname: bei MEHREREN Designs auf EINEM Produkt kommt er aus der
    // Varianten-Option (blatt.designOption nennt ihre Achse) — er wechselt dann
    // mit derselben Wahl, die auch die Layout-Overrides schaltet. Produkte mit
    // genau einem Design lassen den Schluessel weg und behalten photo.design;
    // ihre Vertraege bleiben dadurch byte-gleich.
    const designAusOption = bl.designOption ? this._selectedOptionValue(bl.designOption) : null;
    const design = (designAusOption != null && designAusOption !== '')
      ? designAusOption : (cfg.design || null);
    // valign/offsetY der Ankerebene gelten wie ueberall fuer Bild-Ebenen.
    const ppY = ppBox.y + (this._layerShiftPct(pp) / 100) * ppBox.h;
    // Foto-Tassen (Schema v1.27): blatt.flaeche {breiteMm, hoeheMm, xPercent, yPercent} legt den
    // Ursprung auf die BLATTECKE statt auf die Ankerebene (Tassenblatt 228,86 mm breit, das Herz liegt
    // darin bei x 134 mm). Ohne flaeche wie bisher: Ursprung = Ankerebene, Blattbreite = Motivbreite.
    const fl = (bl.flaeche && Number(bl.flaeche.breiteMm) > 0) ? bl.flaeche : null;
    const ox = fl ? ((Number(fl.xPercent) || 0) / 100) * DW : ppBox.x;
    const oy = fl ? ((Number(fl.yPercent) || 0) / 100) * DW : ppY;
    const X = (sx) => r2((sx - ox) * k + rand);
    const Y = (sy) => r2((sy - oy) * k + rand);
    const L = (s) => r2(s * k);

    // ---- Texte: dieselbe Messstrecke wie Vorschau und Snapshot (_fitFontPx),
    //      danach in reale mm umgerechnet. Zeilen-MITTE wie beim Matten-Vertrag.
    const texte = [];
    const mctx = (typeof document !== 'undefined')
      ? (document.createElement('canvas').getContext('2d') || null) : null;
    for (const def of this.texts) {
      if (this._textAus(def)) continue;
      if (this._ohneTextEbene(def)) continue;
      const layer = this._textLayer(def);
      if (!layer) continue;
      let content = (this.state.texts[def.id] || '').trim();
      if (!content) continue;
      if (layer.transform === 'uppercase') content = content.toUpperCase();
      const font = this._textFont(def);
      const stack = font ? font.stack : 'sans-serif';
      const segs = this._glyphSegments(content, def) || [{ text: content }];
      let px = ((layer.fontSizePercent || 5) / 100) * DW;
      let lines = this._segLines(segs);
      if (mctx) {
        const fit = this._fitFontPx(mctx, segs, stack, layer, DW);
        px = fit.px; lines = fit.lines;
      }
      const box = this._layerBoxPx(Object.assign({ heightPercent: 0 }, layer), DW, DW);
      const lineH = px * this._lineHeightFor(font);
      const n = Math.max(1, lines.length);
      const vmid = layer.valign === 'middle';
      const firstCenter = vmid ? box.top - ((n - 1) * lineH) / 2 : box.top + lineH / 2;
      const printKey = (font && typeof font.printKey === 'string' && font.printKey.trim())
        ? font.printKey.trim() : null;
      const rot = this._layerRotateDeg(layer) || 0;
      lines.forEach((ls, i) => {
        const text = ls.map((s) => (s.glyph ? s.emoji : s.text)).join('');
        if (!text.trim()) return;
        const z = {
          id: def.id, text,
          size: L(px), lineH: L(lineH),
          x: X(box.cx), y: Y(firstCenter + i * lineH),
          maxW: L(box.w), align: 'center',
        };
        if (printKey) z.font = printKey;
        if (rot) z.rotate = rot;
        texte.push(z);
      });
    }

    // ---- Weitere Deko NEBEN dem Passepartout (heute leer: die schwarze Deko
    //      steckt im Passepartout-PNG). Form wie beim Matten-Vertrag.
    const elemente = [];
    for (const l of alleDeco) {
      if (l.id === bl.originLayer || !l.url || l.previewOnly === true) continue;
      const b = this._layerBoxPx(l, DW, DW);
      const y = b.y + (this._layerShiftPct(l) / 100) * b.h;
      const e = {
        key: l.id, url: l.url,
        x: X(b.x), topY: Y(y), w: L(b.w), h: L(b.h),
        rotate: this._layerRotateDeg(l) || 0,
        hex: this._resolveInk((l.color == null || l.color === 'inherit') ? this.state.druckfarbe : l.color),
      };
      if (l.fullColor === true) e.fullColor = true;
      elemente.push(e);
    }

    const fBox = this._layerBoxPx(photoLayer, DW, DW);
    const fY = fBox.y + (this._layerShiftPct(photoLayer) / 100) * fBox.h;
    const motivH = L(ppBox.h);
    // Motivbreite aus der ANKEREBENE, nicht aus einer Config-Zahl — sonst
    // traegt ein Produkt nur eine einzige Motivbreite und der Override wirkt
    // auf alles ausser dieser einen Zahl.
    const motivBmm = ppBox.w * k;
    return {
      v: 1,
      design,
      blatt: {
        breiteMm: r2((fl ? Number(fl.breiteMm) : motivBmm) + 2 * rand),
        hoeheMm: r2((Number(bl.gesamthoeheMm) || 0) + 2 * rand),
        randMm: r2(rand),
      },
      gesamthoeheMm: r2(Number(bl.gesamthoeheMm) || 0),
      motiv: { breiteMm: r2(motivBmm), hoeheMm: motivH },
      passepartout: {
        url: pp.url,
        // druckMaske (Schema v1.21): Formmaske fuer den DRUCK — die url selbst
        // ist seit den v2-Passepartouts eine dosenfarbene VORSCHAU-Ueberdeckung
        // und darf nie mitgedruckt werden (sie stuende als grauer Kasten in der
        // Druckdatei). Der Schluessel lebt an der Ankerebene im
        // customizer_layout und wandert damit per Override mit dem Design.
        // Der Renderer verlangt ihn fail-closed; die schwarze Deko zieht er
        // per Schwellwert aus url (dort ist Schwarz sauber von der Dosenfarbe
        // getrennt — gemessen 28.08.2026, 0 % Zwischenfarben).
        maske: (typeof pp.druckMaske === 'string' && pp.druckMaske.trim()) ? pp.druckMaske.trim() : null,
        x: X(ppBox.x), y: Y(ppY), w: r2(motivBmm), h: motivH,
        fullColor: pp.fullColor === true,
      },
      foto: {
        url: p.url,
        srcW: p.srcW, srcH: p.srcH,
        crop: { x: Math.round(p.crop.x), y: Math.round(p.crop.y), w: Math.round(p.crop.w), h: Math.round(p.crop.h) },
        frame: { x: X(fBox.x), y: Y(fY), w: L(fBox.w), h: L(fBox.h) },
        effPx: Math.round(Math.min(p.crop.w, p.crop.h)),
      },
      texte,
      elemente,
    };
  }

  /**
   * Blatt-Druckvertrag v1 (Schema v1.26, 07.10.2026 — erster Nutzer: Kissen,
   * _ttg_kissen_config). FUENFTER Vertrag, und der erste, der nicht an einem
   * Foto-Schritt haengt: Motiv-, Text- und Foto-Produkte schreiben dieselbe Form.
   * Grundsatz wie bei allen Vertraegen: der Renderer PLATZIERT NUR.
   *
   * config.print:
   *   contractKey   Property-Name (_ttg_<name>_config), Pflicht
   *   blatt.breiteMm / blatt.hoeheMm   das gedruckte Blatt (Kissen 300 x 300)
   *   blatt.buehneBreiteMm             reale Breite der GANZEN Buehne — setzt
   *                                    den Massstab k = buehneBreiteMm / 600
   *   blatt.xPercent / blatt.yPercent  linke obere Ecke der Druckflaeche auf
   *                                    der Buehne (Prozent der Buehnenkante)
   *
   * Ursprung (0,0) = linke obere Blattecke; alle Masse reale mm. Die Buehne
   * ist quadratisch (_layerBoxPx mit W = H = 600, wie Foto- und Dosenvertrag).
   *
   * Ebenen und Reihenfolge wie im Snapshot (Bestell-Vorschaubild):
   *   foto -> motive -> elemente mit behindText -> texte -> uebrige elemente.
   * previewOnly-Ebenen kommen NIE in den Vertrag.
   *
   * Farben: Motiv in der Druckfarbe (Vollfarb-Kategorie: fullColor, hex bleibt
   * informativ). Text: def.color VOR der Druckfarbe — exakt die Regel der
   * Vorschau (_applyTextLayer) und des Snapshots (_drawSnapshotText). Anders als
   * beim Foto-Vertrag gibt es hier keinen Bestand, auf den Ruecksicht noetig waere.
   *
   * Motiv-URL: motif.druck (Feld druck_bild, Schema v1.27) vor dem Anzeigebild.
   * Die Katalog-URL traegt &width=600 (Vorschaugroesse). Gedruckt wird die Datei
   * in Originalgroesse — die Groessenparameter fallen weg. Ob die Aufloesung
   * fuer den Druck reicht, entscheidet der Renderer (150-dpi-Gate).
   *
   * Rueckgabe null (kein Vertrag), wenn das Blatt nicht vermessen ist oder
   * nichts Druckbares vorliegt.
   */
  _blattDruckConfig() {
    const pc = this.config.print;
    const bl = pc && pc.blatt && this._blattNachOption(pc.blatt);
    if (!bl) return null;
    const DW = 600;
    const r2 = (v) => Math.round(v * 100) / 100;
    const breite = Number(bl.breiteMm) || 0;
    const hoehe = Number(bl.hoeheMm) || 0;
    const buehneB = Number(bl.buehneBreiteMm) || 0;
    if (!(breite > 0) || !(hoehe > 0) || !(buehneB > 0)) return null;
    const k = buehneB / DW;
    const ox = ((Number(bl.xPercent) || 0) / 100) * DW;
    const oy = ((Number(bl.yPercent) || 0) / 100) * DW;
    const X = (sx) => r2((sx - ox) * k);
    const Y = (sy) => r2((sy - oy) * k);
    const L = (s) => r2(s * k);
    const layout = this._layoutLayers();
    const ink = (v) => this._resolveInk(v);
    const aussparung = this._aussparungen(layout);

    // ---- Foto (nur mit Foto-Schritt, gewaehltem Foto und Server-URL)
    let foto = null;
    const photoLayer = this.config.photo ? this._photoLayer(layout) : null;
    if (photoLayer) {
      if (!this._photoSatisfied()) return null;      // Foto-Produkt ohne Foto: kein Druck
      const p = this.state.photo;
      const fBox = this._layerBoxPx(photoLayer, DW, DW);
      const fY = fBox.y + (this._layerShiftPct(photoLayer) / 100) * fBox.h;
      foto = {
        url: p.url,
        srcW: p.srcW, srcH: p.srcH,
        crop: { x: Math.round(p.crop.x), y: Math.round(p.crop.y), w: Math.round(p.crop.w), h: Math.round(p.crop.h) },
        frame: { x: X(fBox.x), y: Y(fY), w: L(fBox.w), h: L(fBox.h) },
        effPx: Math.round(Math.min(p.crop.w, p.crop.h)),
      };
    }

    // ---- Motiv(e): jede type-"motif"-Ebene, dasselbe state.motif
    const motive = [];
    if (this.state.motif && !this.state.noMotif) {
      const cur = this._currentMotifImage();
      // Druck-Original vor Anzeigebild (Schema v1.27, 07.10.2026): motif.druck kommt aus dem
      // Motiv-Feld druck_bild (Katalog-Build bzw. Section-Inline) in Originalgroesse. Es gilt
      // fuer die ERSTE Bildvariante — bei Mehrbild-Motiven mit anderer Wahl bleibt das gewaehlte
      // Anzeigebild, und das 150-dpi-Gate des Renderers entscheidet. Vorschau, Snapshot und
      // Galerie lesen weiter bild/bilder; nur dieser Vertrag sieht druck.
      const druck = (typeof this.state.motif.druck === 'string' && this.state.motif.druck.trim()) ? this.state.motif.druck.trim() : '';
      const ersteVariante = !this.state.motifVariant || this._motifImages(this.state.motif).length <= 1;
      const roh = (druck && ersteVariante) ? druck : (cur ? cur.url : this.state.motif.bild);
      const url = this._druckBildUrl(roh);
      const voll = this._isFullColorMotif(this.state.motif);
      for (const ml of this._motifLayers(layout)) {
        if (!url || ml.previewOnly === true) continue;
        if (ml.knockout) continue;   // Aussparung (Schema v1.35): steht am Element, nicht als Motiv
        const b = this._layerBoxPx(ml, DW, DW);
        const y = b.y + (this._layerShiftPct(ml) / 100) * b.h;
        b.x += (this._inkVersatzXPct(ml) / 100) * b.w;   // alignInk:"center", sonst 0
        const m = {
          key: ml.id, url, motiv: this.state.motif.id || null,
          x: X(b.x), y: Y(y), w: L(b.w), h: L(b.h),
          rotate: this._layerRotateDeg(ml) || 0,
          hex: ml.inkSource === 'accent' ? this._ebenenTinte(ml) : ink(this.state.druckfarbe),
        };
        if (ml.mirrorX === true) m.mirrorX = true;
        if (voll) m.fullColor = true;
        motive.push(m);
      }
    }

    // ---- Texte: dieselbe Messstrecke wie Vorschau und Snapshot (_fitFontPx)
    const texte = [];
    const mctx = (typeof document !== 'undefined')
      ? (document.createElement('canvas').getContext('2d') || null) : null;
    for (const def of this.texts) {
      if (this._textAus(def)) continue;
      if (this._ohneTextEbene(def)) continue;
      const layer = this._textLayer(def);
      if (!layer) continue;
      let content = (this.state.texts[def.id] || '').trim();
      if (!content) continue;
      if (layer.transform === 'uppercase') content = content.toUpperCase();
      const font = this._textFont(def);
      const stack = font ? font.stack : 'sans-serif';
      const segs = this._glyphSegments(content, def) || [{ text: content }];
      let px = ((layer.fontSizePercent || 5) / 100) * DW;
      let lines = this._segLines(segs);
      if (mctx) {
        const fit = this._fitFontPx(mctx, segs, stack, layer, DW);
        px = fit.px; lines = fit.lines;
      }
      const box = this._layerBoxPx(Object.assign({ heightPercent: 0 }, layer), DW, DW);
      const lineH = px * this._lineHeightFor(font);
      const n = Math.max(1, lines.length);
      const vmid = layer.valign === 'middle';
      const firstCenter = vmid ? box.top - ((n - 1) * lineH) / 2 : box.top + lineH / 2;
      const printKey = (font && typeof font.printKey === 'string' && font.printKey.trim())
        ? font.printKey.trim() : null;
      const rot = this._layerRotateDeg(layer) || 0;
      const hex = ink(this._textColorOf(def) || this.state.druckfarbe);
      // Linksbündig (Schema v1.36): x ist die linke Kante der Zeile, nicht ihre Mitte; ein Präfix
      // (layer.prefix) bekommt eine eigene Zeile an der Ebenenkante, der Text beginnt prefixGapEm
      // weiter rechts. Zentrierte Ebenen (alle Bestands-Configs) laufen unverändert.
      const links = layer.align === 'left';
      const praefix = this._prefixOf(layer);
      const vorlauf = this._prefixGapEm(layer) * px;
      lines.forEach((ls, i) => {
        const text = ls.map((s) => (s.glyph ? s.emoji : s.text)).join('');
        if (!text.trim()) return;
        const y = Y(firstCenter + i * lineH);
        if (links && praefix && i === 0) {
          const pz = { id: def.id + '-prefix', text: praefix, size: L(px), lineH: L(lineH),
            x: X(box.x), y, maxW: L(vorlauf), align: 'left', hex };
          if (printKey) pz.font = printKey;
          texte.push(pz);
        }
        const z = {
          id: def.id, text,
          size: L(px), lineH: L(lineH),
          x: links ? X(box.x + vorlauf) : X(box.cx), y,
          maxW: links ? L(box.w - vorlauf) : L(box.w), align: links ? 'left' : 'center', hex,
        };
        if (printKey) z.font = printKey;
        if (rot) z.rotate = rot;
        texte.push(z);
      });
    }

    // ---- Deko (ohne previewOnly), behindText steuert die Reihenfolge
    const elemente = [];
    for (const l of this._decoLayers()) {
      if (!l.url || l.previewOnly === true) continue;
      const b = this._layerBoxPx(l, DW, DW);
      const y = b.y + (this._layerShiftPct(l) / 100) * b.h;
      const e = {
        key: l.id, url: l.url,
        x: X(b.x), topY: Y(y), w: L(b.w), h: L(b.h),
        rotate: this._layerRotateDeg(l) || 0,
        hex: ink((l.color == null || l.color === 'inherit') ? this.state.druckfarbe : l.color),
      };
      if (l.fullColor === true) e.fullColor = true;
      if (l.behindText === true) e.behindText = true;
      // Aussparung (Schema v1.35): Motiv-Bildrechteck in Blatt-mm, der Renderer stanzt dessen Alpha aus.
      const ko = aussparung && aussparung[l.id];
      if (ko && this.state.motif && !this.state.noMotif) {
        const cur = this._currentMotifImage();
        const kurl = this._druckBildUrl(cur ? cur.url : this.state.motif.bild);
        const r = this._motifBildRechteck(ko);
        if (kurl) {
          e.aussparung = { url: kurl, motiv: this.state.motif.id || null, x: X(r.x * DW), y: Y(r.y * DW), w: L(r.w * DW), h: L(r.h * DW) };
          if (ko.mirrorX === true) e.aussparung.mirrorX = true;
        }
      }
      elemente.push(e);
    }

    // ---- Leinen (Schema v1.35): Quadratkurve in Blatt-mm, nur mit Leinen-Ebene im Layout
    const linien = [];
    for (const l of this._leinenLayers(layout)) {
      const g = this._leinenGeometrie(l, layout);
      if (!g) continue;
      const li = {
        key: l.id, x1: X(g.x1 * DW), y1: Y(g.y1 * DW), cx: X(g.cx * DW), cy: Y(g.cy * DW),
        x2: X(g.x2 * DW), y2: Y(g.y2 * DW), breite: L(g.w * DW), hex: ink(this.state.druckfarbe),
      };
      if (typeof l.knockout === 'string' && l.knockout) li.aussparungIn = l.knockout;   // wird aus der Deko gestanzt
      linien.push(li);
    }

    if (!foto && !motive.length && !texte.length && !elemente.length) return null;
    const out = {
      v: 1,
      art: 'blatt',
      blatt: { breiteMm: r2(breite), hoeheMm: r2(hoehe) },
      motive,
      texte,
      elemente,
    };
    if (foto) out.foto = foto;
    if (linien.length) out.linien = linien;
    // Motivseite (Nacharbeit 23.10.2026): Produkte mit Seitenwahl tragen die gewählte Seite im Vertrag — Druck und Schnitt
    // müssen wissen, ob Vorder- oder Rückseite. Ohne config.sides entfällt der Schlüssel (Bestand byte-gleich).
    if (this.config.sides) out.seite = this.state.side || this.config.sides.default || 'Vorderseite';
    return out;
  }

  /** Druck-URL einer Katalog-Bild-URL: Groessenparameter (width/height/crop)
   *  entfernen, alles andere (v=…) unveraendert. Die Vorschau laedt 600 px,
   *  gedruckt wird die Originaldatei. Ungueltige URLs kommen unveraendert zurueck.
   *
   *  Protokollrelative URLs (`//host/…`) werden ABSOLUT (`https://host/…`): Liquids
   *  image_url liefert inline (Positivliste, Override, Featured) genau diese Form, und
   *  der Renderer laedt mit urllib — dort scheitert `//…` mit „unknown url type“
   *  (gemessen 07.10.2026 an leckerlidose-pop-art, Live-HTML). Der Vertrag traegt
   *  deshalb immer eine absolute URL; der Renderer rechnet nichts. */
  _druckBildUrl(u) {
    if (typeof u !== 'string' || !u) return '';
    try {
      const url = new URL(u.startsWith('//') ? 'https:' + u : u, 'https://x.invalid');
      for (const p of ['width', 'height', 'crop']) url.searchParams.delete(p);
      return url.toString();
    } catch (_) {
      return u;
    }
  }

  getState() { return Object.assign({}, this.state, { variantId: this.getVariantId(), priceCents: this.currentPriceCents() }); }

  /**
   * Motiv-Bonus / Cross-Sell (ÖFFENTLICHE Engine-Funktion, headless nutzbar):
   * komponiert eine Cart-Position mit dem VOLLSTÄNDIGEN Property-Set — identisch
   * zu dem, was dieser Konfigurator bei einem echten Add-to-Cart schreiben würde
   * (getProperties/getSurcharges auf einer regulären Engine-Instanz mit der
   * ZIEL-Produkt-Config; falsche/fehlende Properties = falscher Druck).
   *
   * Aufrufmuster (ttg-crosssell.js): Ziel-PDP-HTML fetchen → data-ttg-config
   * parsen → `new TTGEngine(cfg, {})` (headless, kein mount) → Motiv im
   * Ziel-Katalog auflösen → composeXsellLine(…). Kein Config-Nachbau im Element.
   *
   * Bewusste Grenzen (Briefing Teil 2):
   * - _preview_image wird NIE gesetzt: ohne echten Engine-Render gäbe es kein
   *   korrektes Composite — die Cart-Anzeige fällt sauber aufs Produktbild
   *   zurück (Template-Fallback), die Produktion arbeitet aus den Properties.
   * - Text wird NIE still gekürzt: charFilter-bereinigt und dann zu lang →
   *   { ok:false, reason:'text-too-long' } — der Aufrufer schickt den Kunden
   *   mit Hinweis in den Konfigurator (Deep-Link), kein stiller Datenverlust.
   * - Pflichttext ohne Text (Klingeln „Name") → { ok:false, reason:'text-required' }.
   *
   * @param {object} opts
   *   motif         Motiv-Eintrag AUS DER ZIEL-CONFIG (config.motifs) — vom
   *                 Aufrufer aufgelöst (gleicher Katalog: identisches Handle;
   *                 Fußmatten: über die rasse-Familie).
   *   motifVariant  Bildvarianten-Index (Mehrbild), default 0.
   *   text          Roher Wunschtext (oder leer/null).
   *   textDefId     Ziel-Text-Def (textTarget aus crosssell_config), sonst
   *                 erstes Def ohne default, sonst erstes Def.
   *   color, size   Varianten-Optionswerte (Namen wie im Shop); size Pflicht,
   *                 wenn das Produkt eine Größenachse hat.
   *   font          Schrift-ID der Erstwahl des Kunden (optional) — greift nur,
   *                 wenn die Ziel-Config die ID kennt; sonst Ziel-Default.
   *   options       { optionName → Wert } für extraOptions (z. B. Schnitt).
   *   groupId       _ttg_group der neuen Position (Aufrufer erzeugt).
   *   ref           Lesbare Referenz für Zuschlags-Zeilen (_ttg_ref), z. B. Zieltitel.
   * @returns {{ok:true, items:Array<{id:number,quantity:number,properties:object}>,
   *            variantId:(number|string), priceCents:number}
   *          |{ok:false, reason:string, def?:object}}
   */
  composeXsellLine(opts) {
    try {
      const o = opts || {};
      const s = this.state;
      // Motiv (Pflicht): Eintrag der ZIEL-Config — nie ein fremdes Objekt raten.
      if (!o.motif || !o.motif.id) return { ok: false, reason: 'motif-missing' };
      s.motif = o.motif;
      s.noMotif = false;
      const imgs = this._motifImages(o.motif);
      const mv = Number(o.motifVariant) || 0;
      s.motifVariant = (mv > 0 && mv < imgs.length) ? mv : 0;

      // Deterministische Text-Basis pro Add — gleiche Begründung wie bei Schrift
      // und Druckfarbe weiter unten: die Ziel-Engine ist zwischengespeichert
      // (targetCache) und wird für mehrere Adds wiederbenutzt. Ohne harten Reset
      // überlebte der Text eines VORHERIGEN Add jede Konstellation, in der der
      // aktuelle Aufruf nichts schreibt — leerer Wunschtext („Kein Text"
      // gewählt) oder eine andere Ziel-Ebene (item.textTarget) beim zweiten Add.
      // Der Kunde bestellte dann einen Text, den er nicht gewählt hat, und zwar
      // bis auf die Druckvorlage. Erst zurücksetzen, dann anwenden.
      for (const t of this.texts) {
        s.texts[t.id] = t.default || '';
        s.noTexts[t.id] = !!t.defaultNoText;
      }

      // Wunschtext ins Ziel-Feld — Validierung EXAKT wie die Live-Eingabe.
      const def = (o.textDefId && this.texts.find((t) => t.id === o.textDefId))
        || this.texts.find((t) => !t.default)
        || this.texts[0];
      const raw = (o.text == null ? '' : String(o.text)).trim();
      if (def) {
        if (raw) {
          const filtered = this._clampLines(this._filterText(raw, def), def);
          if (!filtered.trim()) return { ok: false, reason: 'text-invalid', def };
          // Längenprüfung je Zeile (bei maxLines === 1 ist das die Gesamtlänge und
          // damit die bisherige Prüfung — _clampLines hat dort schon zum
          // Leerzeichen gefaltet, also kann kein Umbruch die Zählung verfälschen).
          if (filtered.split('\n').some((z) => z.length > (def.maxLength || 30))) {
            return { ok: false, reason: 'text-too-long', def };
          }
          // Randbereinigt ablegen: `raw` ist oben zwar schon getrimmt, aber der
          // Zeichenfilter kann ein Zeichen NEBEN einem Leerzeichen entfernen
          // („Mailo ✂" → „Mailo ") und so einen neuen Rand erzeugen. Geprüft
          // wurde bisher getrimmt, gespeichert ungetrimmt — dieselbe Klasse wie
          // in getProperties.
          s.texts[def.id] = ttgTrimEdges(filtered);
          s.noTexts[def.id] = false;
        } else if (!def.optional && !def.default) {
          // Pflichtfeld ohne Text: kein stiller Add — Kunde in den Konfigurator.
          return { ok: false, reason: 'text-required', def };
        } else if (def._legacy) {
          // Ein-Text-Produkte ohne Wunschtext: exakt wie der „Kein Text"-Klick.
          s.noTexts[def.id] = true;
        }
      }

      // Varianten-Optionen: nur setzen, was der Aufrufer wählt — alles andere
      // bleibt auf den Konstruktor-Defaults (wie ein unberührter Schritt).
      if (o.color != null) s.color = o.color;
      if (o.size != null) s.size = o.size;
      if (o.options) {
        for (const xo of this.extraOptions) {
          if (o.options[xo.optionName] != null) s.options[xo.optionName] = o.options[xo.optionName];
        }
      }
      // Deterministische Schrift-Basis pro Add (Jens 20.07., analog zur Druckfarbe
      // unten): die Ziel-Engine ist zwischengespeichert (targetCache) und wird für
      // mehrere Adds wiederbenutzt. Erst hart auf den Ziel-Default zurücksetzen (wie im
      // Konstruktor, ohne den Deep-Link-Teil) — sonst bliebe die Schrift eines
      // VORHERIGEN Add stehen, wenn der aktuelle Anker keine dem Ziel bekannte
      // Schrift-ID hat (die bedingte Übernahme unten wird dann übersprungen). Bewusst
      // OHNE einen _fontTouched-Marker — dieselbe Begründung wie bei der Druckfarbe.
      s.font = (this.config.defaults && this.config.defaults.font)
        || ((this.config.fonts || [])[0] && this.config.fonts[0].id)
        || s.font;
      // Schrift der Erstwahl (Jens 17.07.): übernehmen, WENN das Zielprodukt die
      // Schrift-ID kennt — sonst bleibt der Ziel-Default stehen (sauberer
      // Fallback, nie eine fremde Schrift-ID durchreichen). Damit trägt die
      // Cart-Zeile exakt die Schrift, die die Karte zeigt.
      if (o.font && (this.config.fonts || []).some((f) => f.id === o.font)) s.font = o.font;
      // Deterministische Druckfarben-Basis pro Add: die Ziel-Engine ist zwischen-
      // gespeichert (targetCache) und wird für mehrere Adds wiederbenutzt. Erst hart
      // auf den Ziel-Default zurücksetzen (wie im Konstruktor) — sonst bliebe bei einem
      // Ziel OHNE printDefaultBy die Druckfarbe eines VORHERIGEN Add stehen, wenn der
      // aktuelle Anker keine vom Ziel angebotene Druckfarbe hat (_applyPrintDefaultBy
      // ist dann ein No-Op und setzt nichts zurück).
      // ?ttg-druckfarbe (_applyUrlPrint) gilt nur für die Seiten-Engine — die Ziel-Engine läuft
      // auf derselben URL und darf sie nicht in die Cross-Sell-Zeile tragen.
      this._urlPrintHex = null;
      s.druckfarbe = (this.config.defaults && this.config.defaults.druckfarbe)
        || ((this.config.printColors || [])[0] && this.config.printColors[0].hex)
        || s.druckfarbe;
      // Druckfarben-defaultBy (dunkles Shirt → weißer Druck) folgt der gesetzten
      // Farbe/Option — druckkritisch, deshalb explizit nachziehen (kein Kunde hat
      // die Druckfarbe angefasst → _printTouched bleibt false, Map darf greifen).
      this._applyPrintDefaultBy();
      // Druckfarbe der Erstwahl (Jens 20.07.): dieselbe Regel wie die Schrift oben —
      // die Anker-Druckfarbe übernehmen, WENN das Zielprodukt sie (als Hex) anbietet,
      // sonst bleibt der eben per defaultBy gesetzte Ziel-Default stehen. Bewusst NACH
      // _applyPrintDefaultBy (die Erstwahl gewinnt über den Farb-Default) und OHNE
      // _printTouched zu setzen: die Ziel-Engine wird pro Bonusprodukt zwischen-
      // gespeichert und mehrfach benutzt — ein klebriges _printTouched würde einen
      // späteren Add ohne passende Anker-Druckfarbe auf dem alten Wert einfrieren.
      // Druckfarbe nach der verbindlichen Präzedenz (Jens 31.07.) — defaultBy des
      // Ziels vor fester Item-Druckfarbe vor Vererbung. Anlass: schwarzer Druck
      // erbte auf die schwarze Mil-Tec-Weste und war unlesbar; ein fester Wert
      // allein hätte den Fehler nur auf die hellen Stoffe verschoben (Weiß/Grau/
      // Azalea beim Shirt, Sahara bei Mil-Tec, Weiß/Grau-Melange beim Hoodie).
      // Kein Produkttyp und kein Farbwert im Code — die Steuerung bleibt in der
      // Config. Dieselbe Funktion rendert die Kartenvorschau (ttg-crosssell.js),
      // deshalb können Vorschau und Warenkorb-Property nicht auseinanderlaufen.
      s.druckfarbe = this.resolveXsellPrintHex({ fixed: o.druckfarbeFixed, inherited: o.druckfarbe });
      // Schrift jetzt anfordern: diese Engine ist headless (auf /cart gibt es
      // keine DOM-Nutzung der Familie), der Browser würde den Load sonst nie
      // starten und der Snapshot-Gate liefe in seine Zeitschranke.
      this._warmSnapshotFonts();

      const v = this.resolveVariant();
      if (!v) return { ok: false, reason: 'variant-unresolved' };
      if (v.available === false) return { ok: false, reason: 'variant-unavailable' };

      // Ohne leerBenennen: der Cross-Sell-Add bleibt byte-gleich zu vorher (s. o.).
      const properties = this.getProperties({ leerBenennen: false });
      properties['_ttg_group'] = o.groupId || '';
      // Bonus-Marker: aktiviert die 15 % in der Discount Function — NUR wenn dort
      // der server-seitige Anker-Check (echtes Konfigurator-Produkt ohne _ttg_xsell
      // im Warenkorb) besteht. Client-seitig ist das reine Deklaration.
      properties['_ttg_xsell'] = '1';
      // Quell-Motiv (das der Kunde am Ausgangsprodukt konfiguriert hat) als BEWEIS
      // für die Discount Function: der Bonus greift nur, wenn dieses Motiv auf einer
      // echten Konfigurator-Zeile im Warenkorb liegt. Der Aufrufer (ttg-crosssell.js)
      // reicht es als opts.srcMotivId durch — gleiche Bildung wie _motiv_id oben.
      // Für Fußmatten (abweichende eigene _motiv_id über die Rasse-Familie) ist es
      // die einzige Zeile, über die die Function das legitime Paar erkennt.
      properties['_ttg_src_motiv'] = o.srcMotivId || '';

      const items = [{ id: v.id, quantity: 1, properties }];
      // Zuschlags-Zeilen (Options-/Text-Aufpreise) exakt wie der Theme-Adapter —
      // mit Compose-Defaults normalerweise leer, aber nie stumm verschluckt.
      for (const sc of this.getSurcharges()) {
        const num = String(sc.variantId).match(/(\d+)\s*$/);
        if (!num) continue;
        items.push({
          id: Number(num[1]),
          quantity: 1,
          properties: {
            _ttg_group: o.groupId || '',
            _ttg_role: 'surcharge',
            _ttg_kind: sc.kind || '',
            _ttg_value: sc.choice || '',
            _ttg_ref: (o.ref || '') + ' — ' + (sc.option || 'Option') + ': ' + (sc.choice || ''),
          },
        });
      }
      return { ok: true, items, variantId: v.id, priceCents: this.currentPriceCents() };
    } catch (e) {
      return { ok: false, reason: 'error:' + (e && e.message) };
    }
  }

  /**
   * Gewählte Optionen mit Aufpreis (Schema: surcharge an der choice-Option).
   * Generisch am Options-Objekt: jede GEWÄHLTE Option, die ein .surcharge mit
   * variantId trägt, erzeugt einen Eintrag — der Theme-Adapter legt dafür das
   * Zuschlags-Produkt als eigene Warenkorb-Zeile mit. option/choice dienen der
   * lesbaren Referenz-Property am Zuschlagsartikel.
   */
  getSurcharges() {
    const s = this.state;
    const chosen = [
      { opt: this.config.printColors.find((p) => p.hex === s.druckfarbe),
        option: this.config.propertyKeys.print || 'Druckfarbe', kind: 'color' },
      { opt: this.config.fonts.find((f) => f.id === s.font),
        option: this.config.propertyKeys.font || 'Schrift', kind: 'font' },
    ];
    // Akzentfarbe (Schema v1.35): eigener Aufpreis je gewählter Sonderfarbe (Neon/Silber/Gold).
    if (s.akzentfarbe && this._stepOrder().indexOf('akzent') !== -1) {
      chosen.push({ opt: this._akzentFarben().find((c) => c.hex === s.akzentfarbe),
        option: (this.config.accent && this.config.accent.property) || 'Akzentfarbe', kind: 'color' });
    }
    const out = [];
    // kind kennzeichnet die Aufschlags-Art für das warme Cart-Label
    // ('color' → „Sonderdruckfarbe: …", 'text' → „Zweite Textzeile", 'font' → Fallback).
    chosen.forEach(({ opt, option, kind }) => {
      if (opt && opt.surcharge && opt.surcharge.variantId) {
        out.push({
          variantId: opt.surcharge.variantId,
          priceLabel: opt.surcharge.priceLabel || '',
          option,
          choice: opt.name || opt.label || '',
          kind,
        });
      }
    });
    // Text-Aufschläge (z. B. zweiter Text): gleiche Mechanik wie der Farbaufschlag,
    // Auslöser ist „Feld gefüllt" statt „Option gewählt". Leer/„Kein Text" = kein Zuschlag.
    for (const def of this.texts) {
      const val = (s.texts[def.id] || '').trim();
      if (def.surcharge && val && !this._textAus(def)) {
        out.push({
          variantId: def.surcharge.variantId,
          priceLabel: def.surcharge.priceLabel || '',
          option: def.property || def.label || 'Text',
          choice: val,
          kind: 'text',
        });
      }
    }
    return out;
  }

  /* ------------------------------------------------- Bestell-Vorschaubild
   * Optionaler Snapshot der Live-Vorschau auf ein Canvas (Base + Motiv + Text,
   * wie zusammengesetzt), Upload an einen konfigurierten Endpunkt, URL als
   * Line-Item-Property. Config-getrieben (config.previewUpload) — fehlertolerant:
   * schlägt etwas fehl, landet das Produkt trotzdem im Warenkorb (ohne Bild).
   * Nur Darstellung/Zusatz; die Properties tragen die Bestellung.
   */

  /** Bild per CORS laden (für Canvas-Export ohne Tainting). null bei Fehler. */
  _loadImg(url) {
    // Tassen-Vorschau (Schema v1.27): Live-Zylinder rendert bei jedem Tastendruck — Bilder einmal laden.
    // _bildCache existiert nur, wenn config.print.vorschau gesetzt ist; sonst wie bisher.
    if (this._bildCache && url && this._bildCache.has(url)) return Promise.resolve(this._bildCache.get(url));
    return new Promise((resolve) => {
      if (!url || typeof Image === 'undefined') return resolve(null);
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => { if (this._bildCache) this._bildCache.set(url, img); resolve(img); };
      img.onerror = () => resolve(null);
      img.src = url.indexOf('//') === 0 ? ('https:' + url) : url;
    });
  }
  /** Layer-Box in Pixeln auf einem W×H-Canvas (xPercent = horizontales Zentrum). */
  _layerBoxPx(layer, W, H) {
    const w = ((layer.widthPercent || 0) / 100) * W;
    const h = ((layer.heightPercent != null ? layer.heightPercent : 0) / 100) * H;
    const cx = ((layer.xPercent || 0) / 100) * W;
    const top = ((layer.yPercent || 0) / 100) * H;
    return { x: cx - w / 2, y: top, w, h, cx, top };
  }
  /** Bild „contain" in eine Box zeichnen (Seitenverhältnis erhalten, zentriert). */
  _drawContain(ctx, img, box) {
    if (!img.width || !img.height || box.w <= 0 || box.h <= 0) return;
    const ir = img.width / img.height, br = box.w / box.h;
    let dw, dh;
    if (ir > br) { dw = box.w; dh = box.w / ir; } else { dh = box.h; dw = box.h * ir; }
    ctx.drawImage(img, box.x + (box.w - dw) / 2, box.y + (box.h - dh) / 2, dw, dh);
  }
  /** Ctx um die MITTE der Box drehen — Canvas-Pendant zum rotate() der Live-Vorschau
   *  (dort dreht transform-origin:50% 50% um die Ebenen-Mitte, nachdem translate die
   *  Mitte gesetzt hat). Die Box selbst bleibt unverändert, nur das Koordinatensystem
   *  dreht sich → die Mitte wandert nicht. Ohne rotate kein Eingriff (0 zurück).
   *  Aufrufer muss ctx.save()/restore() klammern. Rückgabe: Grad (für den Schatten). */
  _ctxRotateAboutBox(ctx, layer, box) {
    const deg = this._layerRotateDeg(layer);
    if (!deg) return 0;
    const cx = box.x + box.w / 2, cy = box.y + box.h / 2;
    ctx.translate(cx, cy);
    ctx.rotate((deg * Math.PI) / 180);
    ctx.translate(-cx, -cy);
    return deg;
  }
  /** Spiegelung (mirrorX) im Snapshot — exakt wie die Live-Vorschau: scaleX(-1)
   *  um die Box-Mitte, INNERHALB einer evtl. Drehung (nach _ctxRotateAboutBox
   *  aufrufen; Canvas wendet spätere Transformationen zuerst auf die Zeichnung
   *  an — wie das rechteste Glied der CSS-Kette). Ohne Flag: no-op. */
  _ctxMirrorAboutBox(ctx, layer, box) {
    if (!layer || layer.mirrorX !== true) return;
    const cx = box.x + box.w / 2;
    ctx.translate(cx, 0);
    ctx.scale(-1, 1);
    ctx.translate(-cx, 0);
  }
  /** Schlagschatten einer Bild-Ebene setzen. Canvas-Schattenoffsets ignorieren die CTM
   *  (Spec) — anders als CSS drop-shadow, das mit der Ebene mitdreht. Damit Vorschau und
   *  Druckbild gleich aussehen, wird der Offset-Vektor (0, sh) hier SELBST um deg gedreht.
   *  deg=0 → (0, sh) = exakt das bisherige Verhalten. */
  _setLayerShadow(ctx, deg, W) {
    const sh = Math.max(1, W / 400);
    const rad = (deg * Math.PI) / 180;
    ctx.shadowColor = 'rgba(0,0,0,0.55)';
    ctx.shadowOffsetX = -sh * Math.sin(rad);
    ctx.shadowOffsetY = sh * Math.cos(rad);
    ctx.shadowBlur = 2 * sh;
  }
  /** Masken-Motiv: Bild als Alphamaske in Druckfarbe einfärben (wie CSS-Maske). */
  _drawTintedContain(ctx, img, box, color) {
    const ow = Math.max(1, Math.ceil(box.w)), oh = Math.max(1, Math.ceil(box.h));
    const off = document.createElement('canvas'); off.width = ow; off.height = oh;
    const octx = off.getContext('2d');
    if (!octx) return;
    this._drawContain(octx, img, { x: 0, y: 0, w: ow, h: oh });
    octx.globalCompositeOperation = 'source-in';
    octx.fillStyle = color || '#000';
    octx.fillRect(0, 0, ow, oh);
    ctx.drawImage(off, box.x, box.y);
  }
  /** Text-Layer zeichnen (Druckfarbe, Schrift-Stack, an Layer-Breite eingepasst).
   *  Mit aktivem charFilter werden erlaubte Emojis als einfarbige Glyphen (Path2D,
   *  Druckfarbe) gezeichnet — identisch zur Live-Vorschau. Ohne Glyphen-Segmente
   *  ist das Ergebnis pixelgleich zum bisherigen Verhalten (ein Text-Segment). */
  /**
   * Die Familien, die dieser Snapshot tatsächlich zeichnen wird — als
   * CSS-Kurzform für document.fonts (Gewicht 700, passend zu `ctx.font` in
   * _drawSnapshotText). Nur Ebenen mit echtem Inhalt zählen; generische
   * Fallbacks (sans-serif, cursive …) werden verworfen, weil sie immer „da"
   * sind und die Prüfung sonst wertlos machen.
   */
  _snapshotFontSpecs() {
    const specs = new Map();
    for (const def of this.texts) {
      if (this._textAus(def)) continue;
      if (this._ohneTextEbene(def)) continue;     // Grafik statt Schrift
      const raw = this.state.texts[def.id];
      if (!raw || !String(raw).trim()) continue;
      // _fontDef statt reiner ID-Suche: eine feste Familien-Schrift (Schema
      // v1.17) muss das Gate genauso durchlaufen — sonst druckte ein Tippfehler
      // im Familiennamen still in der Ersatzschrift.
      const font = this._textFont(def);
      if (!font || !font.stack) continue;
      // Erste Familie des Stacks; document.fonts.load() würde sonst den ganzen
      // Stack inkl. Generics anfragen.
      const first = String(font.stack).split(',')[0].trim().replace(/^['"]|['"]$/g, '');
      if (!first || /^(serif|sans-serif|cursive|monospace|fantasy|system-ui|inherit)$/i.test(first)) continue;
      specs.set(first, `700 100px "${first}"`);
    }
    return [...specs.entries()].map(([family, spec]) => ({ family, spec }));
  }

  /**
   * Schriften für den Snapshot AKTIV laden und das Ergebnis prüfen.
   *
   * Warum aktiv: Canvas löst keinen @font-face-Load aus, und
   * `document.fonts.ready` wartet nur auf Ladevorgänge, die BEREITS laufen —
   * eine registrierte, nie benutzte Schrift lädt nie, `ready` löst dann sofort
   * auf. Genau das trifft den Cross-Sell-Pfad auf /cart: dort benutzt die
   * headless Zweitengine die Familie nie im DOM. Ohne aktives Laden druckt der
   * Browser still die nächste Familie des Stacks — und weil die Stacks echte
   * Fallbacks führen ('Segoe Script', cursive), sieht das Ergebnis plausibel
   * aus. Falsche Metriken verschieben zusätzlich die Auto-Verkleinerung.
   *
   * @returns {Promise<{ok: boolean, missing: string[]}>}
   */
  async _ensureSnapshotFonts(timeoutMs) {
    const specs = this._snapshotFontSpecs();
    if (!specs.length) return { ok: true, missing: [] };
    // Umgebungen ohne Font Loading API (altes Safari, Node-Testharness):
    // Verhalten wie bisher — nie blockieren, nie fälschlich abbrechen.
    if (typeof document === 'undefined' || !document.fonts || !document.fonts.load) return { ok: true, missing: [] };
    const ms = timeoutMs != null ? timeoutMs : 1500;
    try {
      await Promise.race([
        Promise.all(specs.map((s) => document.fonts.load(s.spec).catch(() => null))),
        new Promise((r) => setTimeout(r, ms)),
      ]);
    } catch (e) { /* Ergebnis zählt die Prüfung unten, nicht der Ladeweg */ }
    // Vertrauen ersetzt die Prüfung nicht: load() löst auch auf, wenn nichts
    // passte. check() sagt, ob die Familie WIRKLICH zeichenbereit ist.
    const missing = [];
    for (const s of specs) {
      let ok = false;
      try { ok = document.fonts.check(s.spec); } catch (e) { ok = true; }
      if (!ok) missing.push(s.family);
    }
    return { ok: missing.length === 0, missing };
  }

  /**
   * Vorwärmen ohne zu warten. Wird beim Mount und bei jedem Schriftwechsel
   * angestoßen, damit der Gate im Snapshot im Normalfall 0 ms kostet und die
   * bestehenden Zeitschranken beim Add-to-Cart (1,5 s) bzw. im Cross-Sell
   * (2,5 s) unangetastet bleiben können.
   */
  _warmSnapshotFonts() {
    if (typeof document === 'undefined' || !document.fonts || !document.fonts.load) return;
    for (const s of this._snapshotFontSpecs()) {
      try { document.fonts.load(s.spec); } catch (e) { /* egal */ }
    }
  }

  async _drawSnapshotText(ctx, content, layer, W, H, def) {
    const box = this._layerBoxPx(Object.assign({ heightPercent: 0 }, layer), W, H);
    // Versalsatz + vertikale Ausrichtung pro Ebene — identisch zur Live-Vorschau
    // (Vorschau = Druckbild). transform:"uppercase" versal; valign:"middle" zentriert
    // die Zeile vertikal auf yPercent (textBaseline 'middle' statt 'top').
    if (layer && layer.transform === 'uppercase') content = String(content).toUpperCase();
    const vmid = !!(layer && layer.valign === 'middle');
    // Schrift/Farbe pro Ebene (wie die Live-Vorschau): fixe Def-Werte gewinnen.
    // _fontDef löst ID oder Familiennamen (Schema v1.17) auf.
    const font = this._textFont(def);
    const stack = font ? font.stack : 'sans-serif';
    // (Das frühere `await document.fonts.ready` stand hier je Textebene und war
    //  wirkungslos: es wartet nur auf bereits laufende Ladevorgänge. Die
    //  Absicherung sitzt jetzt einmal zentral in _renderSnapshot.)
    ctx.textBaseline = vmid ? 'middle' : 'top';
    ctx.fillStyle = this._resolveInk(this._textColorOf(def) || this.state.druckfarbe);
    // Glyphe belegt eine Em-Breite (quadratische 24×24-Glyphen, ~0.95em wie in der Vorschau).
    const segs = this._glyphSegments(content, def) || [{ text: content }];
    // Exakt dieselbe Einpassung wie die Live-Vorschau (_fitFontPx, Bezugsbreite = W,
    // availW = widthPercent/100·W = box.w) → gedruckte Zeilengröße == Vorschau.
    let { px, lines, lineWidths } = this._fitFontPx(ctx, segs, stack, layer, W);
    // Breitenumbruch wie in der Vorschau (_fitText) — nur mehrzeilige Ebenen ohne nowrap.
    if (this._umbruchNachBreite(layer, def)) ({ lines, widths: lineWidths } = this._breitenZeilen(ctx, lines, px, box.w));
    const align = layer.align || 'center';
    // Ausrichtung JE ZEILE (nicht einmal für den Gesamttext): bei zentriertem
    // Satz muss jede Zeile für sich mittig stehen, sonst hinge die kürzere Zeile
    // am linken Rand der längeren. Einzeilig ist lineWidths[0] === total, die
    // Formel liefert damit exakt den bisherigen startX.
    // Präfix (Schema v1.36): der Text beginnt prefixGapEm × px rechts der Ebenenkante, das Präfix an ihr.
    const praefix = this._prefixOf(layer);
    const vorlaufPx = this._prefixGapEm(layer) * px;
    const startXFuer = (w) => align === 'left' ? box.x + vorlaufPx : align === 'right' ? box.x + box.w - w : box.cx - w / 2;
    ctx.textAlign = 'left';
    // Drehung (seit 05.08.2026 auch für Text). Der DOM-Kasten hat KEINE gesetzte Höhe:
    // er ist genau eine Zeile hoch (TEXT_LINE_HEIGHT × Schriftgröße, gesetzt in
    // _fitText) und dreht um transform-origin 50% 50%, also um die Mitte DIESER Höhe.
    // Die Snapshot-Box kommt dagegen mit heightPercent:0 — ihre Mitte läge auf der
    // Oberkante. Deshalb hier eine Ersatzbox mit der DOM-Zeilenhöhe; nur sie geht in
    // die Drehung, gezeichnet wird unverändert an box.top.
    //   valign:"middle" → translateY(-50%) im DOM, die Mitte liegt auf yPercent.
    //   sonst           → Oberkante auf yPercent, die Mitte eine halbe Zeile tiefer.
    // Mehrzeilig wächst die Ersatzhöhe auf den ganzen Zeilenblock; bei einer Zeile
    // ist sie unverändert lineH und die Drehung damit identisch zu vorher.
    // Dieselbe Zeilenhöhe wie im DOM (_fitText) — sonst dreht der Druck um einen
    // anderen Punkt als die Vorschau. Ohne lineHeightFactor an der Schrift ist der
    // Wert unverändert TEXT_LINE_HEIGHT.
    const lineH = px * this._lineHeightFor(font);
    const blockH = lineH * Math.max(1, lines.length);
    const rotBox = { x: box.x, y: vmid ? box.top - blockH / 2 : box.top, w: box.w, h: blockH };
    // Vertikaler Versatz der ERSTEN Zeile: bei valign:"middle" liegt die MITTE des
    // Blocks auf yPercent, die erste Zeile also um (n−1)/2 Zeilen höher. Bei einer
    // Zeile ist der Versatz 0 → Zeichenposition byte-gleich zu vorher.
    const yOff = vmid ? -((Math.max(1, lines.length) - 1) * lineH) / 2 : 0;
    ctx.save();
    const rot = this._ctxRotateAboutBox(ctx, layer, rotBox);
    const drawPass = () => {
      lines.forEach((ls, i) => {
        const y = box.top + yOff + i * lineH;
        if (praefix && i === 0) ctx.fillText(praefix, box.x, y);
        let x = startXFuer(lineWidths[i]);
        for (const s of ls) {
          if (s.glyph) {
            const size = px * 0.95;
            const scale = size / 24;
            ctx.save();
            // emojiColor:'print' (Schema v1.18): Glyphe in der Druckfarbe — identisch
            // zur Live-Vorschau (_renderTextContent). Ohne das Feld unverändert die
            // Text-/Druckfarbe des Laufs (fillStyle von oben, per save/restore erhalten).
            if (def && def.emojiColor === 'print') ctx.fillStyle = this._resolveInk(this.state.druckfarbe);
            // valign middle: Glyphe auf der Zeilenmitte zentrieren (Oberkante = y − halbe Glyphe);
            // sonst wie bisher innerhalb der Zeile (Oberkanten-Bezug).
            ctx.translate(x, vmid ? (y - size / 2) : (y + (px - size) / 2 + px * 0.06));
            ctx.scale(scale, scale);
            ctx.fill(new Path2D(s.glyph));
            ctx.restore();
            x += size;
          } else {
            ctx.fillText(s.text, x, y);
            x += ctx.measureText(s.text).width;
          }
        }
      });
    };
    if (def && def.shadow) {
      // Lesbarkeits-Kontur wie in der Live-Vorschau (text-shadow-Äquivalent,
      // zwei Schatten-Pässe). CSS-Pixel der Vorschau (~400px breit) auf die
      // Canvas-Breite skaliert; Shadow-Offsets sind CTM-unabhängig, Glyphen-
      // Skalierung bläht den Schatten also nicht auf.
      const sh = Math.max(1, W / 400);
      ctx.save();
      // Erster Pass: versetzter Schatten. Canvas-Schattenoffsets ignorieren die CTM —
      // bei gedrehtem Text bliebe ein fester Offset senkrecht stehen, während die
      // Glyphen kippen. _setLayerShadow dreht den Offset gegen, exakt wie bei den
      // Deko-Ebenen; bei 0° liefert es unverändert (0, sh).
      this._setLayerShadow(ctx, rot, W);
      drawPass();
      // Zweiter Pass: reiner Hof ohne Versatz — hier ist nichts zu drehen, aber das
      // X aus dem ersten Pass muss zurück auf 0 (vorher stand es dort nie).
      ctx.shadowColor = 'rgba(0,0,0,0.5)'; ctx.shadowOffsetX = 0; ctx.shadowOffsetY = 0; ctx.shadowBlur = sh;
      drawPass();
      ctx.restore();
    } else {
      drawPass();
    }
    ctx.restore();
  }
  /** Rendert die aktuelle Vorschau auf ein (quadratisches) Canvas.
   *  @param {object} [info] optional: bekommt bei einem Ausstieg ohne Canvas den
   *    Grund in info.grund (Vorschau-Grund an der Warenkorbzeile, 03.10.2026,
   *    Anlass #1006008). Aufrufer ohne info verhalten sich wie bisher. */
  // ---------------------------------------------------------------------------
  // Tassen (Schema v1.27, 14.10.2026): Zylinder-Vorschau und zweiseitiges Warenkorbbild leben
  // in assets/ttg-tasse.js (CLAUDE.md §3, Muster ttg-foto.js), geladen von der Section nur bei
  // config.print.vorschau.art === 'tasse'. Hier nur der Schalter und die Naht.
  // ---------------------------------------------------------------------------
  _tasseAktiv() { return !!this._tasseQuelle(); }
  /** Vorschau-Angaben + Blatt der Tasse: aus config.print (Blatt-Vertrag) oder — für Foto-Tassen mit
   *  Dosen-Vertrag — aus config.photo.blatt {vorschau, flaeche, buehneBreiteMm}. Sonst null. */
  _tasseQuelle() {
    const p = this.config.print;
    if (p && p.vorschau && p.vorschau.art === 'tasse' && p.blatt && p.blatt.breiteMm && p.blatt.buehneBreiteMm) return { vorschau: this._tasseVorschau(p.vorschau), blatt: p.blatt };
    const fb = this.config.photo && this.config.photo.blatt;
    if (fb && fb.vorschau && fb.vorschau.art === 'tasse' && fb.flaeche && fb.flaeche.breiteMm && fb.buehneBreiteMm) {
      return { vorschau: this._tasseVorschau(fb.vorschau), blatt: Object.assign({ buehneBreiteMm: fb.buehneBreiteMm }, fb.flaeche) };
    }
    return null;
  }
  /** Schema v1.28: vorschau.overrides[<Option>][<Wert>] — Teilwerte je gewählter Variante (Farbe → blanko/koerper,
   *  Design → seiten/textKopie), gleiche Form und Auflösung wie layout.overrides (_overrideValue, auch '_motif').
   *  Ein Teilwert null entfernt den Schlüssel (z. B. textKopie für „Oval“). Ohne overrides: dasselbe Objekt. */
  _tasseVorschau(v) {
    const ov = v && v.overrides;
    if (!ov || typeof ov !== 'object') return v;
    let out = null;
    for (const optName in ov) {
      const val = this.state ? this._overrideValue(optName) : undefined;
      const teil = (val != null && ov[optName]) ? ov[optName][val] : null;
      if (!teil || typeof teil !== 'object') continue;
      if (!out) out = Object.assign({}, v);
      for (const k in teil) { if (teil[k] === null) delete out[k]; else out[k] = teil[k]; }
    }
    return out || v;
  }
  /** Naht zu window.TTG_TASSE (planen | snapshot). Ist das Modul noch nicht geladen, merkt sich die
   *  Engine vor (window.__ttgTasseWartet) — das Modul zeichnet sie beim Laden nach. */
  _tasseNaht(fn, info) {
    if (typeof window === 'undefined') return null;
    const T = window.TTG_TASSE;
    if (T && typeof T[fn] === 'function') return T[fn](this, info);
    if (fn === 'planen') (window.__ttgTasseWartet = window.__ttgTasseWartet || new Set()).add(this);
    return null;
  }
  /** Verkleinerte Fassung eines großen Bilds (einmal je Bild, im Tassen-Bild-Zwischenspeicher): Live-Vorschau
   *  zeichnet sonst bei jedem Tastendruck z. B. ein 4.267-px-Druckmotiv herunter (gemessen 21 ms bei 4-facher Drosselung). */
  _verkleinert(img, maxSeite) {
    const g = Math.max(img.width || 0, img.height || 0);
    if (!g || g <= maxSeite || !this._bildCache) return img;
    if (!this._kleinCache) this._kleinCache = new WeakMap();
    const alt = this._kleinCache.get(img);
    if (alt) return alt;
    const f = maxSeite / g, c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(img.width * f)); c.height = Math.max(1, Math.round(img.height * f));
    const x = c.getContext('2d'); x.imageSmoothingQuality = 'high'; x.drawImage(img, 0, 0, c.width, c.height);
    this._kleinCache.set(img, c);
    return c;
  }
  async _renderSnapshot(info, opts) {
    if (typeof document === 'undefined') return null;
    // Tassen (Schema v1.27): Warenkorbbild = beide Tassenseiten nebeneinander (1000 × 1000).
    // opts.ohneBasis ist der interne Aufruf für das flache Druckblatt — ohne opts wie bisher.
    if (this._tasseAktiv() && !(opts && opts.ohneBasis)) {
      const bild = await this._tasseNaht('snapshot', info);
      if (!bild && info && !info.grund) info.grund = 'tasse:modul';     // Modul (noch) nicht geladen → kein Bild
      return bild || null;
    }
    const layout = this._layoutLayers();
    const pu = this.config.previewUpload || {};
    const preview = this.refs.base && this.refs.base.parentElement;
    // Bühne ist quadratisch (aspect-ratio 1/1) → Canvas quadratisch.
    const W = (opts && opts.W) || Math.max(200, Math.round(pu.maxWidth || 1000));
    const H = W;
    const canvas = document.createElement('canvas');
    canvas.width = W; canvas.height = H;
    const ctx = canvas.getContext('2d');
    if (!ctx) { if (info) info.grund = 'dataurl:kein-canvas'; return null; }
    // Schrift-Gate VOR dem ersten Zeichenbefehl — hier, weil alle drei
    // Verbraucher der Druckvorlage durch _renderSnapshot laufen
    // (_renderSnapshotDataUrl beim Add-to-Cart, _uploadPreview zum Railway-
    // Speicher und die headless Cross-Sell-Engine auf /cart). Der Gate liegt
    // zugleich vor allen measureText-Aufrufen, damit auch die automatische
    // Verkleinerung mit den echten Metriken rechnet.
    // Definiertes Verhalten, wenn die Schrift NICHT kommt: KEIN Bild. Ein
    // Snapshot in der Fallback-Schrift wäre der schlechteste Ausgang, weil er
    // korrekt aussieht und so in den Druck ginge; ohne Bild greift der
    // Produktbild-Fallback im Warenkorb und die fehlende Vorlage fällt auf.
    const fontGate = await this._ensureSnapshotFonts(pu.fontTimeoutMs);
    if (!fontGate.ok) {
      console.warn('[ttg] Vorschaubild übersprungen — Schrift nicht geladen:', fontGate.missing.join(', '));
      if (info) info.grund = 'font:' + fontGate.missing.join(',');
      return null;
    }
    // Hintergrund = Bühnenfarbe (Letterbox-Bereich des „contain"-Base).
    let bg = '#f2efe9';
    try { if (preview) bg = getComputedStyle(preview).backgroundColor || bg; } catch (e) { /* egal */ }
    if (opts && opts.ohneBasis) bg = '#ffffff';          // Tassen-Druckblatt: Weiß wird nicht gedruckt
    ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
    // 1) Base-Foto (object-fit: contain)
    const baseImg = (opts && opts.ohneBasis) ? null : await this._loadImg(this._currentBaseImage());
    if (baseImg) this._drawContain(ctx, baseImg, { x: 0, y: 0, w: W, h: H });
    // 1b) Kundenfoto (Schema v1.18): Quell-Ausschnitt (crop) deckend in die
    //     Rahmen-Box — identisch zur Live-Vorschau (_applyPhotoLayer). Quelle ist
    //     die lokale Objekt-URL (CORS-frei fürs Canvas); Fallback Server-URL
    //     (gleicher Origin-Anspruch wie Motive: crossOrigin='anonymous').
    const photoLayer = this.config.photo ? this._photoLayer(layout) : null;
    // Tassen-Vorschau (Schema v1.28, nur opts.beispielFoto aus ttg-tasse.js, Live-Vorschau): Beispielfoto
    // (config.photo.sampleUrl) VOR dem Upload, deckend in den Rahmen. Nie im Warenkorbbild/Vertrag —
    // ttg-tasse.js übergibt es nur beim Zeichnen der Live-Vorschau; state.photo bleibt null.
    const beispiel = !(this.state.photo && this.state.photo.crop) && opts && opts.beispielFoto ? { url: opts.beispielFoto } : null;
    if (photoLayer && ((this.state.photo && this.state.photo.crop) || beispiel)) {
      const p = beispiel || this.state.photo;
      const pimg = await this._loadImg(p.localUrl || p.url);
      if (pimg) {
        const box = this._layerBoxPx(photoLayer, W, H);
        // valign:'middle' wie bei Motiv (:8074) und Deko (:8121) — _layerBoxPx
        // liefert immer die Oberkante. Ohne den Versatz lag das Foto der
        // Banner-Matte (photo valign:'middle', yPercent 50, heightPercent 60)
        // im Warenkorbbild 30 % der Bühne zu tief (#1005926, 18.09.2026),
        // während Vorschau (_layerBoxStyle) und Druckvertrag (_fotoDruckConfig,
        // fy) längst verschoben haben. Layouts ohne valign: Shift 0, byte-gleich.
        box.y += (this._layerShiftPct(photoLayer) / 100) * box.h;
        // Tassen-Vorschau (Schema v1.27, nur opts.fotoMaske aus ttg-tasse.js): Foto nur innerhalb der
        // Druckmaske des Passepartouts (Herz/Oval) — wie der Renderer druckt. Ohne opts wie bisher.
        const fm = opts && opts.fotoMaske;
        const mimgF = fm ? await this._loadImg(fm.url) : null;
        const zctx = mimgF ? (() => { const t = document.createElement('canvas'); t.width = W; t.height = H; return t.getContext('2d'); })() : ctx;
        zctx.save();
        zctx.beginPath();
        zctx.rect(box.x, box.y, box.w, box.h);
        zctx.clip();
        let crop = p.crop;
        if (!crop) {   // Beispielfoto: object-fit cover auf die Rahmen-Box
          const r = box.w / box.h, iw = pimg.width, ih = pimg.height;
          crop = (iw / ih > r) ? { x: (iw - ih * r) / 2, y: 0, w: ih * r, h: ih } : { x: 0, y: (ih - iw / r) / 2, w: iw, h: iw / r };
        }
        zctx.drawImage(pimg, crop.x, crop.y, crop.w, crop.h, box.x, box.y, box.w, box.h);
        zctx.restore();
        if (mimgF) {
          const mb = this._layerBoxPx(fm.layer, W, H);
          mb.y += (this._layerShiftPct(fm.layer) / 100) * mb.h;
          zctx.globalCompositeOperation = 'destination-in';
          zctx.drawImage(mimgF, mb.x, mb.y, mb.w, mb.h);
          ctx.drawImage(zctx.canvas, 0, 0);
        }
      }
    }
    // 2) Motiv — ALLE type-"motif"-Ebenen, jede mit eigener Box/Drehung/
    //    Spiegelung (Doppelmotiv: dasselbe Bild links gespiegelt + rechts).
    //    Ein Bild-Load für alle Ebenen; Einzel-Motiv rendert exakt wie bisher.
    const motifLayers = this._motifLayers(layout);
    if (motifLayers.length && this.state.motif && !this.state.noMotif) {
      const cur = this._currentMotifImage();
      let mimg = await this._loadImg(cur ? cur.url : this.state.motif.bild);
      if (mimg && opts && opts.maxSeite) mimg = this._verkleinert(mimg, opts.maxSeite);   // nur Tassen-Live-Vorschau
      if (mimg) {
        for (const motifLayer of motifLayers) {
          if (motifLayer.knockout) continue;   // Aussparung (Schema v1.35): zeichnet die Deko
          const box = this._layerBoxPx(motifLayer, W, H);
          // valign/offsetY/rotate gelten generisch für Bild-Ebenen — ein Motiv ohne die
          // Flags rendert exakt wie bisher (Shift 0, keine Drehung).
          box.y += (this._layerShiftPct(motifLayer) / 100) * box.h;
          box.x += (this._inkVersatzXPct(motifLayer) / 100) * box.w;   // alignInk:"center", sonst 0
          ctx.save();
          this._ctxRotateAboutBox(ctx, motifLayer, box);
          this._ctxMirrorAboutBox(ctx, motifLayer, box);
          if (this._isFullColorMotif(this.state.motif)) this._drawContain(ctx, mimg, box);
          else this._drawTintedContain(ctx, mimg, box, motifLayer.inkSource === 'accent' ? this._ebenenTinte(motifLayer) : this._resolveInk(this.state.druckfarbe));
          ctx.restore();
        }
      }
    }
    // 2a) Leinen (Schema v1.35) — dieselbe Geometrie wie die Vorschau (_leinenGeometrie).
    for (const l of this._leinenLayers(layout)) {
      if (l.knockout) continue;   // Aussparungs-Leine: stanzt _drawSnapshotDeco aus
      const g = this._leinenGeometrie(l, layout);
      if (!g) continue;
      ctx.save();
      ctx.strokeStyle = this._resolveInk(this.state.druckfarbe);
      ctx.lineWidth = g.w * W;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo(g.x1 * W, g.y1 * H);
      ctx.quadraticCurveTo(g.cx * W, g.cy * H, g.x2 * W, g.y2 * H);
      ctx.stroke();
      ctx.restore();
    }
    // 2b) Deko MIT `behindText` (Schema v1.19) — vor den Texten, damit der Name
    //     auf dem Banner steht statt darunter. Dieselbe Reihenfolge wie in der
    //     Vorschau (_overlayLayersHtml) und im Drucker. Ohne das Flag ist die
    //     Schleife leer und der Snapshot bleibt Pixel für Pixel der bisherige.
    await this._drawSnapshotDeco(ctx, W, H, (l) => l.behindText === true);
    // 3) Text-Ebenen (alle Text-Defs, jede mit eigener Ebene/Schrift/Farbe)
    for (const def of this.texts) {
      if (this._textAus(def)) continue;
      if (this._ohneTextEbene(def)) continue;     // Grafik zeichnet der deco-Block
      const textLayer = this._textLayer(def);
      if (!textLayer) continue;
      // KEIN Platzhalter-Fallback: Das Bestell-Vorschaubild IST die Druckvorlage.
      // Der Platzhalter ist eine Bildschirm-Hilfe („hier stünde dein Text"), kein
      // Inhalt. Bis jetzt konnte das niemand auslösen, weil der Text-Schritt den
      // Kauf blockierte — der Kunde musste tippen oder „Kein Text" wählen. Seit
      // der optionale Schritt kein Gate mehr ist, ist der Weg offen, und alle 16
      // Konfigurationen hätten das Wort „Wunschtext" auf das Produkt gedruckt.
      const content = (this.state.texts[def.id] || '').trim();
      if (content) await this._drawSnapshotText(ctx, content, textLayer, W, H, def);
    }
    // 4) Deko-Ebenen (statische Bilder/Pfoten) — Maske+Tinte wie Motiv (oder Vollbild).
    //    Muss ins Bestell-Vorschaubild, sonst fehlt die Pfote im Druck-Backoffice.
    await this._drawSnapshotDeco(ctx, W, H, (l) => l.behindText !== true);
    return canvas;
  }
  /** Deko-Ebenen auf den Snapshot zeichnen. `nimm` wählt die Teilmenge — der
   *  Aufrufer zeichnet damit erst die Ebenen UNTER dem Text, später den Rest.
   *  Der Rumpf ist unverändert der bisherige. */
  async _drawSnapshotDeco(ctx, W, H, nimm) {
    const aussparung = this._aussparungen();
    const leinenAus = this._leinenAussparungen();
    for (const l of this._decoLayers()) {
      if (!l.url) continue;
      if (nimm && !nimm(l)) continue;
      const dimg = await this._loadImg(l.url);
      if (!dimg) continue;
      const box = this._layerBoxPx(l, W, H);
      // valign/offsetY wie in der Live-Vorschau (Vorschau = Druckbild): _layerBoxPx
      // liefert immer die Oberkante, der Versatz kommt hier dazu (% der Box-Höhe).
      box.y += (this._layerShiftPct(l) / 100) * box.h;
      const ink = this._resolveInk((l.color == null || l.color === 'inherit') ? this.state.druckfarbe : l.color);
      ctx.save();
      // rotate/mirrorX wie in der Live-Vorschau (um die Ebenen-Mitte); der Schatten dreht mit.
      const rot = this._ctxRotateAboutBox(ctx, l, box);
      this._ctxMirrorAboutBox(ctx, l, box);
      if (l.shadow) this._setLayerShadow(ctx, rot, W);
      const ko = aussparung && aussparung[l.id];
      if (ko && !l.fullColor && this.state.motif && !this.state.noMotif) {
        // Aussparung (Schema v1.35): Deko eingefärbt auf eigener Fläche, Motiv-Alpha herausgestanzt.
        const cur = this._currentMotifImage();
        const mimg = await this._loadImg(cur ? cur.url : this.state.motif.bild);
        const off = document.createElement('canvas'); off.width = W; off.height = H;
        const octx = off.getContext('2d');
        this._drawTintedContain(octx, dimg, box, ink);
        if (mimg) {
          const r = this._motifBildRechteck(ko);
          octx.globalCompositeOperation = 'destination-out';
          octx.save();
          if (ko.mirrorX === true) { octx.translate((2 * r.x + r.w) * W, 0); octx.scale(-1, 1); }   // um die Rechteck-Mitte
          octx.drawImage(mimg, r.x * W, r.y * H, r.w * W, r.h * H);
          octx.restore();
        }
        for (const lk of (leinenAus && leinenAus[l.id]) || []) {
          const g = this._leinenGeometrie(lk);
          if (!g) continue;
          octx.globalCompositeOperation = 'destination-out';
          octx.lineWidth = g.w * W; octx.lineCap = 'round'; octx.strokeStyle = '#000';
          octx.beginPath(); octx.moveTo(g.x1 * W, g.y1 * H); octx.quadraticCurveTo(g.cx * W, g.cy * H, g.x2 * W, g.y2 * H); octx.stroke();
        }
        ctx.drawImage(off, 0, 0);
      } else if (l.fullColor) this._drawContain(ctx, dimg, box);
      else this._drawTintedContain(ctx, dimg, box, ink);
      ctx.restore();
    }
  }
  /** Canvas → Blob (Promise). */
  _canvasToBlob(canvas, type, quality) {
    return new Promise((resolve) => {
      if (!canvas.toBlob) return resolve(null);
      canvas.toBlob((b) => resolve(b), type, quality);
    });
  }
  /**
   * Snapshot rendern → JPEG-dataURL (String). Für den NICHT-blockierenden Weg:
   * das Bild wird beim Add sofort gerendert (schnell) und an den Theme-Adapter
   * übergeben, der eigentliche Upload passiert nach dem Add im Hintergrund.
   * Wirft nie — bei jedem Fehler wird ohne Bild fortgefahren (Produktbild-Fallback).
   * info (optional): bekommt bei null den Grund in info.grund — 'font:<Familie>'
   * oder 'dataurl:<Fehlername>' (max. 40 Zeichen). Siehe _submit, _preview_grund.
   */
  async _renderSnapshotDataUrl(pu, info) {
    pu = pu || this.config.previewUpload || {};
    try {
      const canvas = await this._renderSnapshot(info);
      if (!canvas || !canvas.toDataURL) {
        if (info && !info.grund) info.grund = 'dataurl:kein-canvas';
        return null;
      }
      return canvas.toDataURL(pu.format || 'image/jpeg', pu.quality != null ? pu.quality : 0.85);
    } catch (e) {
      console.warn('[ttg] Snapshot-dataURL übersprungen:', e && e.message);
      if (info) info.grund = 'dataurl:' + String((e && (e.name || e.message)) || 'Fehler').slice(0, 40);
      return null;
    }
  }
  /**
   * Snapshot rendern + an config.previewUpload.url hochladen → Bild-URL (oder null).
   * Wirft nie: bei jedem Fehler/Timeout wird der Kauf ohne Bild fortgesetzt.
   */
  async _uploadPreview() {
    const pu = this.config.previewUpload || {};
    if (!pu.enabled || !pu.url) return null;
    const canvas = await this._renderSnapshot();
    if (!canvas) return null;
    const blob = await this._canvasToBlob(canvas, pu.format || 'image/jpeg', pu.quality != null ? pu.quality : 0.85);
    if (!blob) return null;
    const maxBytes = pu.maxUploadBytes || 500 * 1024;
    if (blob.size > maxBytes) { console.warn('[ttg] Snapshot > Limit, Upload übersprungen:', blob.size); return null; }
    const controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    const timer = controller ? setTimeout(() => controller.abort(), pu.timeoutMs || 8000) : null;
    try {
      const res = await fetch(pu.url, {
        method: 'POST', body: blob, mode: 'cors',
        headers: { 'Content-Type': blob.type || 'image/jpeg' },
        signal: controller ? controller.signal : undefined,
      });
      if (!res.ok) return null;
      const data = await res.json();
      return (data && typeof data.url === 'string') ? data.url : null;
    } finally { if (timer) clearTimeout(timer); }
  }

  async _submit() {
    if (this._submitting) return;
    // Erst übernehmen, dann prüfen: ein gefülltes Textfeld ist erledigt, auch wenn der
    // Kunde es nie bestätigt hat. Sonst wies der Knopf einen vollständig ausgefüllten
    // Konfigurator ab (Jens 21.07.).
    this._commitFilledTexts();
    // Vorbelegte Schritte, die seit dem letzten Render neu in _stepDefs() stehen
    // (Schrift nach Wunschtext), gelten als erledigt — VOR _ready(), damit der
    // Klick nicht am Render-Zeitpunkt hängt (Jens 21.09.2026).
    this._markPreSatisfiedSteps();
    // Sicherheitsnetz für den Rand-Trim: Wer den Kaufknopf klickt, ohne das
    // Textfeld je zu verlassen, hat _confirmText nie ausgelöst. Hier — VOR
    // getProperties() UND vor dem Snapshot — bereinigen, damit Druckvorlage
    // und Bestellzeile denselben Text tragen. Bei Änderung neu zeichnen, damit
    // auch die eingepasste Schriftgröße (_fitText) zum bereinigten Text passt.
    if (this._trimTextState()) this.renderPreview();
    // Zweites Gate (neben _updateCta): Der CTA ist jetzt klickbar, also MUSS der
    // unvollständige Fall hier abgefangen werden — sonst passierte still gar nichts.
    if (!this._ready()) { this._flagBlocked(); return; }
    this._invalid = null;
    this._submitting = true;
    this._setSubmitBusy(true);
    try {
      const properties = this.getProperties();
      // Vorschaubild NICHT-blockierend: Der Upload (ggf. Sekunden bei Railway-
      // Cold-Start) darf das Add-to-Cart nicht aufhalten. Wir rendern den
      // Snapshot hier nur SOFORT (schnell, ~Millisekunden) und reichen ihn als
      // dataURL an den Theme-Adapter durch. Der eigentliche Upload + das
      // Nachtragen von _preview_image an die Warenkorb-Zeile passiert nach dem
      // Add im Hintergrund (ttg-preview-uploader). Schlägt irgendetwas fehl,
      // bleibt der Artikel ohne _preview_image → Produktbild-Fallback greift.
      let previewPending = null;
      // Grund, wenn KEIN Snapshot entsteht (03.10.2026, Anlass #1006008): der
      // Theme-Adapter schreibt ihn als _preview_grund an die Hauptzeile. Werte:
      // 'timeout' | 'font:<Familie>' | 'dataurl:<Fehlername>' (den Wert 'stash'
      // setzt der Adapter selbst). Snapshot da → bleibt null, nichts wird gesetzt.
      let previewGrund = null;
      const pu = this.config.previewUpload;
      if (pu && pu.enabled && pu.url) {
        // Snapshot-Render kappen: ein (selten) hängendes Bild-Request darf das
        // Add-to-Cart NIE blockieren → nach 1,5 s ohne Bild fortfahren.
        const info = {};
        let zeitgrenze = false;
        let timer = null;
        const dataUrl = await Promise.race([
          this._renderSnapshotDataUrl(pu, info),
          new Promise((r) => { timer = setTimeout(() => { zeitgrenze = true; r(null); }, 1500); }),
        ]);
        clearTimeout(timer);
        if (dataUrl) {
          previewPending = {
            dataUrl,
            url: pu.url,
            property: pu.property || '_preview_image',
            maxUploadBytes: pu.maxUploadBytes || 500 * 1024,
          };
        } else if (zeitgrenze) {
          // Bis 03.10.2026 der einzige stille Ausstieg (#1006008).
          console.warn('[ttg] Vorschaubild übersprungen — Zeitgrenze 1500 ms beim Add überschritten');
          previewGrund = 'timeout';
        } else {
          previewGrund = info.grund || 'dataurl:unbekannt';
        }
      }
      const payload = { variantId: this.getVariantId(), quantity: this.state.quantity || 1, properties, surcharges: this.getSurcharges(), state: this.getState(), previewPending, previewGrund };
      // Zusatzartikel (Schema v1.31) nur, wenn gewählt — ohne Auswahl bleibt der Payload wie bisher.
      const zusatz = this.getAddons();
      if (zusatz.length) payload.addons = zusatz;
      if (typeof this.hooks.onSubmit === 'function') {
        this._clearSubmitError();
        await Promise.resolve(this.hooks.onSubmit(payload));
        this.emit('cartAdded', payload);
        // Warenkorb-Wächter (21.09.2026): liegt die Zeile wirklich im Warenkorb?
        // Läuft NACH dem cartAdded-Emit (Cross-Sell-Stash muss vor einer
        // /cart-Navigation liegen) und hält den Kaufknopf so lange gesperrt.
        await this._verifyCartAdd(payload);
      } else {
        console.warn('[ttg] kein onSubmit-Hook (Theme-Adapter fehlt)');
      }
    } catch (e) {
      console.error('[ttg] onSubmit', e);
    } finally {
      this._submitting = false;
      this._setSubmitBusy(false);
    }
  }
  /** Add-to-Cart-Buttons während des (ggf. Upload-)Submits sperren. */
  _setSubmitBusy(busy) {
    [this.refs.addBtn, this.refs.stickyBtn].forEach((b) => { if (b) b.disabled = busy; });
    if (!busy) this._updateCta();
  }

  /* ------------------------------------------------- Warenkorb-Wächter (21.09.2026) */
  /**
   * Nach dem Add prüfen, ob die Zeile WIRKLICH im Warenkorb liegt (GET /cart.js).
   *
   * Anlass (Diagnose Conversion-Lecks Teil 2, 21.09.2026): Die Armex-Firewall
   * (App-Block) hüllt window.fetch für /cart/add, /cart/add.js und /cart/change.js
   * ein und antwortet bei Bot-Verdikt mit einer FALSCHEN {"status":"ok"} (HTTP 200).
   * Der Artikel landet dann nie im Warenkorb, und weder Theme noch Kunde erfahren
   * es. Dieser Wächter ist Shopify-generisch (AJAX-API) und theme-frei; er greift nur
   * nach dem eigenen Submit und verändert den Add-Weg nicht.
   *
   * Ablauf: /cart.js im Takt abfragen (alle 0,5 s, höchstens 6 s je Versuch — laenger als jeder gemessene Add inkl. Armex-Vorabfrage, damit ein langsamer Add keinen doppelten Retry ausloest), bis
   * eine Zeile mit der erwarteten variant_id und ALLEN gesendeten (nicht leeren)
   * Properties liegt (seit 16.10.2026: oder die die _ttg_group dieses Adds trägt; Werte
   * angeglichen verglichen, _normPropWert). Fehlt sie: EIN erneuter Submit über denselben onSubmit-Hook
   * mit derselben Gruppe,
   * dann erneut prüfen. Fehlt sie wieder: sichtbare Meldung am Kaufknopf (Text aus
   * strings.err_cart_verify) + Logeintrag (Konsole, Ereignis `cartVerified`,
   * `_lastCartVerify`). Ergebnisse: ok · ok-gruppe (Zeile mit der Gruppe des ersten
   * Adds vor dem Wiederholversuch gefunden, 16.10.2026) · retry-ok · spaet-ok (Wiederholversuch
   * ausgelassen, erster Add kam spät an) · fehlgeschlagen · nicht-pruefbar
   * (kein /cart.js lesbar, z. B. weil die Seite gerade zur /cart navigiert — dann
   * gibt es bewusst weder Retry noch Meldung: ein Fehlschlag der PRÜFUNG ist kein
   * Fehlschlag des ADDS, und ein blinder Retry könnte die Zeile doppeln).
   *
   * Der Logeintrag trägt: Zeitstempel, Produkt-Handle, Ergebnis, Versuche und
   * window._ec_recorded (Armex-Verdikt: 0 ausstehend, 1 geblockt, 2 frei; null ohne
   * Armex). Keine IP, kein Kundentext, keine Personendaten. Ein Server-Endpunkt, der
   * den Eintrag annimmt, fehlt (Stand 21.09.2026: /ttg-metrics kennt nur seine
   * Allowlist) — Vorschlag im Bericht; bis dahin Konsole + Ereignis.
   */
  _verifyCartAdd(payload) {
    if (!payload || payload.variantId == null) return Promise.resolve(null);
    if (this._verifyRunning) return Promise.resolve(null);
    this._verifyRunning = true;
    const done = (rec) => { this._verifyRunning = false; this._logCartVerify(rec); return rec; };
    return (async () => {
      let ergebnis = await this._pollCartLine(payload);
      if (ergebnis === 'da') return done(this._verifyRecord('ok', 1));
      if (ergebnis !== 'fehlt') return done(this._verifyRecord('nicht-pruefbar', 1));
      // Vor dem Wiederholversuch (16.10.2026, Anlass #1006070/#1006054): Steht schon
      // eine Zeile mit der Gruppe des ersten Adds im Korb, ist er angekommen — kein
      // zweiter Add. Frisch gelesen, die letzte Abfrage der Schleife kann alt sein.
      try {
        const items = await this._readCartItems();
        if (this._gruppeImKorb(items, payload)) return done(this._verifyRecord('ok-gruppe', 1));
      } catch (e) { return done(this._verifyRecord('nicht-pruefbar', 1)); }
      // Einmal neu versuchen — über denselben Weg wie der erste Add, mit DERSELBEN
      // Gruppe (payload.groupId, vom Adapter gesetzt) und ohne neuen Snapshot oder
      // Vorschau-Auftrag: Der Auftrag des ersten Versuchs bleibt gültig. Vorher bekam
      // der zweite Add eine neue Gruppe und einen zweiten Auftrag; auf /cart lief dann
      // zuerst der Auftrag ohne Zeile und hielt die bestellte Zeile ~4 s auf.
      let wieder = null;
      try { wieder = await Promise.resolve(this.hooks.onSubmit(Object.assign({}, payload, { retry: true }))); }
      catch (e) { console.error('[ttg] cart-verify retry', e); }
      // Der Adapter lässt den Wiederholversuch aus, solange der erste Add noch läuft
      // (gleiche Gruppe + gleiche Properties hieße sonst Menge 2 auf derselben Zeile).
      const versuche = (wieder && wieder.ausgelassen) ? 1 : 2;
      ergebnis = await this._pollCartLine(payload);
      if (ergebnis === 'da') return done(this._verifyRecord(versuche === 1 ? 'spaet-ok' : 'retry-ok', versuche));
      if (ergebnis !== 'fehlt') return done(this._verifyRecord('nicht-pruefbar', versuche));
      const S = this.config.strings || {};
      this._showSubmitError(S.err_cart_verify || 'Das hat nicht geklappt – bitte noch einmal versuchen oder uns schreiben.');
      return done(this._verifyRecord('fehlgeschlagen', versuche));
    })();
  }
  /** Warteschleife auf die Zeile: 'da' | 'fehlt' | 'fehler' (kein /cart.js lesbar). */
  async _pollCartLine(payload) {
    const poll = this._verifyPollMs || 500;
    const max = this._verifyMaxMs || 6000;
    const t0 = Date.now();
    let lesbar = false;
    for (;;) {
      let items = null;
      try { items = await this._readCartItems(); lesbar = true; } catch (e) { items = null; }
      if (Array.isArray(items) && items.some((it) => this._cartLineMatches(it, payload))) return 'da';
      if (Date.now() - t0 + poll > max) break;
      await new Promise((r) => setTimeout(r, poll));
    }
    return lesbar ? 'fehlt' : 'fehler';
  }
  /** GET /cart.js (Shopify AJAX-API, gleiche Origin, ohne Cache). Wirft bei Netz-/Parse-Fehler. */
  async _readCartItems() {
    const root = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const cart = await res.json();
    return Array.isArray(cart && cart.items) ? cart.items : [];
  }
  /**
   * Passt eine Warenkorb-Zeile zum Submit? Variante gleich UND jede gesendete,
   * nicht leere Property mit gleichem Wert (der Adapter ergänzt nur _ttg_group;
   * leere Werte schickt er gar nicht). Strenger als ein reiner Varianten-Vergleich:
   * ein Kunde kann dieselbe Variante zweimal mit anderem Text im Korb haben.
   */
  _cartLineMatches(item, payload) {
    if (!item || String(item.variant_id) !== String(payload.variantId)) return false;
    // Die Gruppe des Adds ist eindeutig: trägt die Zeile sie, ist es diese Zeile.
    if (this._gruppeImKorb([item], payload)) return true;
    const props = payload.properties || {};
    const lp = item.properties || {};
    for (const k of Object.keys(props)) {
      const v = props[k];
      if (v == null || v === '') continue;
      if (!(k in lp) || this._normPropWert(lp[k]) !== this._normPropWert(v)) return false;
    }
    return true;
  }
  /** Zeile mit der _ttg_group dieses Adds im Korb? (payload.groupId setzt der Adapter.) */
  _gruppeImKorb(items, payload) {
    const g = payload && payload.groupId;
    if (!g || !Array.isArray(items)) return false;
    return items.some((it) => it && String(it.variant_id) === String(payload.variantId)
      && it.properties && it.properties._ttg_group === g && it.properties._ttg_role !== 'surcharge');
  }
  /**
   * Wert NUR für den Vergleich angleichen (16.10.2026), gesendet wird unverändert:
   * Zahl gegen Text (String), \r\n und \r gegen \n — der Browser schickt das Formular
   * als multipart und macht aus jedem Umbruch \r\n (gemessen: „Noa on\nTrail“ kommt
   * aus /cart.js als „Noa on\r\nTrail“ zurück) —, JSON-Inhalte nach dem Parsen.
   * Der Umbruch im Wunschtext gehört dem Kunden und wird nirgends verändert.
   */
  _normPropWert(v) {
    if (v == null) return '';
    const s = String(v).replace(/\r\n?/g, '\n');
    const t = s.trim();
    if ((t[0] === '{' && t[t.length - 1] === '}') || (t[0] === '[' && t[t.length - 1] === ']')) {
      try {
        const ordne = (x) => Array.isArray(x) ? x.map(ordne)
          : (x && typeof x === 'object') ? Object.keys(x).sort().reduce((o, k) => { o[k] = ordne(x[k]); return o; }, {})
            : (typeof x === 'string') ? x.replace(/\r\n?/g, '\n') : x;
        return 'json:' + JSON.stringify(ordne(JSON.parse(t)));
      } catch (e) { /* kein JSON — als Text vergleichen */ }
    }
    return s;
  }
  _verifyRecord(result, attempts) {
    return {
      at: new Date().toISOString(),
      handle: this._productHandle(),
      result,
      attempts,
      ec: (typeof window !== 'undefined' && typeof window._ec_recorded === 'number') ? window._ec_recorded : null,
    };
  }
  /** Produkt-Handle aus dem Pfad (/products/<handle>, auch unter /collections/…). */
  _productHandle() {
    if (typeof window === 'undefined' || !window.location) return null;
    const m = String(window.location.pathname).match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  _logCartVerify(rec) {
    this._lastCartVerify = rec;
    try { console.info('[ttg] cart-verify', JSON.stringify(rec)); } catch (e) { /* egal */ }
    this.emit('cartVerified', rec);
  }
  /** Sichtbare Meldung am Kaufknopf (Haupt- und Sticky-Knopf), vorgelesen über den Announcer. */
  _showSubmitError(msg) {
    if (this.refs.live) this.refs.live.textContent = msg;
    if (typeof document === 'undefined') return;
    // Haupt-Kaufblock (.ttg__buy ist eine Flex-Zeile Menge|Knopf): Meldung als
    // Geschwister DAVOR; Sticky-Leiste (Blocklayout): Meldung direkt über dem Knopf.
    [this.refs.buy, this.refs.sticky].forEach((host) => {
      if (!host || !host.querySelector) return;
      const sibling = host === this.refs.buy;
      const scope = sibling ? (host.parentNode || host) : host;
      let el = scope.querySelector(':scope > .ttg__submit-err');
      if (!el) {
        el = document.createElement('p');
        el.className = 'ttg__submit-err';
        el.setAttribute('role', 'alert');
        if (sibling && host.parentNode) host.parentNode.insertBefore(el, host);
        else { const btn = host.querySelector('[data-ttg="add"]'); if (btn && btn.parentNode) btn.parentNode.insertBefore(el, btn); else host.appendChild(el); }
      }
      el.textContent = msg;
    });
  }
  _clearSubmitError() {
    if (typeof document === 'undefined') return;
    [this.refs.buy, this.refs.sticky].forEach((host) => {
      if (!host) return;
      const scope = host === this.refs.buy ? (host.parentNode || host) : host;
      if (scope.querySelectorAll) scope.querySelectorAll('.ttg__submit-err').forEach((el) => el.remove());
    });
  }

  _announce() {
    if (!this.refs.live) return;
    const s = this.state;
    const parts = [];
    if (s.done.color) parts.push((this.config.strings.step_color || 'Farbe') + ': ' + s.color);
    if (s.done.motif) parts.push((this.config.strings.step_motif || 'Motiv') + ': ' + this._summary('motif'));
    if (s.done.size) parts.push((this.config.strings.step_size || 'Größe') + ': ' + s.size);
    this.refs.live.textContent = parts.join(', ');
  }
}

export default TTGEngine;
